"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var i11n_exports = {};
__export(i11n_exports, {
  translate: () => translate,
  useTranslations: () => useTranslations
});
module.exports = __toCommonJS(i11n_exports);

// src/translate.ts
var import_lodash = __toESM(require("lodash.get"));

// src/locales/es/es.json
var es_exports = {};
__export(es_exports, {
  "/autoinspector-inspections": () => _autoinspector_inspections,
  "/catalog": () => _catalog,
  "/claims": () => _claims,
  "/companies": () => _companies,
  "/complaints": () => _complaints,
  "/customer-organizations": () => _customer_organizations,
  "/document-types": () => _document_types,
  "/fraud-investigations": () => _fraud_investigations,
  "/geo": () => _geo,
  "/integrations": () => _integrations,
  "/metrics": () => _metrics,
  "/metrics/experimental": () => _metrics_experimental,
  "/metrics/performance": () => _metrics_performance,
  "/orders": () => _orders,
  "/provider-invitations": () => _provider_invitations,
  "/providers": () => _providers,
  "/recordings": () => _recordings,
  "/release-notes": () => _release_notes,
  "/reviews": () => _reviews,
  "/users": () => _users,
  actions: () => actions,
  activity: () => activity,
  agreementRules: () => agreementRules,
  agreementSettings: () => agreementSettings,
  agreementSignatureRules: () => agreementSignatureRules,
  agreementTemplates: () => agreementTemplates,
  agreementVariables: () => agreementVariables,
  autoinspectorInspections: () => autoinspectorInspections,
  backends: () => backends,
  backofficeCustomerOrganizations: () => backofficeCustomerOrganizations,
  backofficeOrders: () => backofficeOrders,
  backofficeProviders: () => backofficeProviders,
  backofficeReleaseNotes: () => backofficeReleaseNotes,
  bid: () => bid,
  branches: () => branches,
  breadcrumb: () => breadcrumb,
  catalog: () => catalog,
  chart: () => chart,
  circulation: () => circulation,
  claim: () => claim,
  "claim.address.label": () => claim_address_label,
  "claim.city.label": () => claim_city_label,
  "claim.country.label": () => claim_country_label,
  "claim.cuit.label": () => claim_cuit_label,
  "claim.first_name.label": () => claim_first_name_label,
  "claim.identification.label": () => claim_identification_label,
  "claim.identification_type.label": () => claim_identification_type_label,
  "claim.last_name.label": () => claim_last_name_label,
  "claim.properties.damage.driver.first_name": () => claim_properties_damage_driver_first_name,
  "claim.properties.damage.driver.last_name": () => claim_properties_damage_driver_last_name,
  "claim.properties.damage.hasInsurance": () => claim_properties_damage_hasInsurance,
  "claim.properties.damage.type": () => claim_properties_damage_type,
  "claim.properties.driver.owner": () => claim_properties_driver_owner,
  "claim.properties.driver.ownership": () => claim_properties_driver_ownership,
  "claim.properties.driver.ownership.owner": () => claim_properties_driver_ownership_owner,
  "claim.properties.insurance.coverage": () => claim_properties_insurance_coverage,
  "claim.properties.insurance.coverage.third_full": () => claim_properties_insurance_coverage_third_full,
  "claim.properties.insurance.insurer": () => claim_properties_insurance_insurer,
  "claim.properties.insurance.policy_number": () => claim_properties_insurance_policy_number,
  "claim.properties.vehicle.category": () => claim_properties_vehicle_category,
  "claim.properties.vehicle.category.with_license_plate": () => claim_properties_vehicle_category_with_license_plate,
  "claim.properties.vehicle.chassis": () => claim_properties_vehicle_chassis,
  "claim.properties.vehicle.document_type": () => claim_properties_vehicle_document_type,
  "claim.properties.vehicle.document_type.title": () => claim_properties_vehicle_document_type_title,
  "claim.properties.vehicle.engine": () => claim_properties_vehicle_engine,
  "claim.properties.vehicle.license_plate": () => claim_properties_vehicle_license_plate,
  "claim.properties.vehicle.make": () => claim_properties_vehicle_make,
  "claim.properties.vehicle.model": () => claim_properties_vehicle_model,
  "claim.properties.vehicle.type": () => claim_properties_vehicle_type,
  "claim.properties.vehicle.type.car": () => claim_properties_vehicle_type_car,
  "claim.properties.vehicle.use": () => claim_properties_vehicle_use,
  "claim.properties.vehicle.version": () => claim_properties_vehicle_version,
  "claim.properties.vehicle.year": () => claim_properties_vehicle_year,
  "claim.social_reason.label": () => claim_social_reason_label,
  "claim.state.label": () => claim_state_label,
  "claim.type.label": () => claim_type_label,
  "claim.victim_relationship.label": () => claim_victim_relationship_label,
  "claim.victim_relationship.own": () => claim_victim_relationship_own,
  "claim.zip_code.label": () => claim_zip_code_label,
  claimCurrentOrder: () => claimCurrentOrder,
  claimOrderTracking: () => claimOrderTracking,
  claimSharedDocuments: () => claimSharedDocuments,
  claim_ownership_transfer: () => claim_ownership_transfer,
  claim_status_locked_by_derivation: () => claim_status_locked_by_derivation,
  claimantPendingActions: () => claimantPendingActions,
  claimant_victim_violation: () => claimant_victim_violation,
  claimants: () => claimants,
  claims: () => claims,
  claims_table: () => claims_table,
  company: () => company,
  "company-enums.agencies": () => company_enums_agencies,
  "company-enums.claim_public_status": () => company_enums_claim_public_status,
  "company-enums.claim_reference": () => company_enums_claim_reference,
  "company-enums.claim_stage": () => company_enums_claim_stage,
  "company-enums.claim_status": () => company_enums_claim_status,
  "company-enums.claim_status_order_rule": () => company_enums_claim_status_order_rule,
  "company-enums.claim_type": () => company_enums_claim_type,
  "company-enums.complaint_public_status": () => company_enums_complaint_public_status,
  "company-enums.complaint_reference": () => company_enums_complaint_reference,
  "company-enums.complaint_stage": () => company_enums_complaint_stage,
  "company-enums.complaint_status": () => company_enums_complaint_status,
  "company-enums.complaint_status_order_rule": () => company_enums_complaint_status_order_rule,
  "company-enums.ramos": () => company_enums_ramos,
  "company-service": () => company_service,
  complaint: () => complaint,
  contact: () => contact,
  contract: () => contract,
  cost: () => cost,
  coverages: () => coverages,
  currencies: () => currencies,
  customerAccountSettings: () => customerAccountSettings,
  customerClaims: () => customerClaims,
  customer_organization_invitation: () => customer_organization_invitation,
  customer_signin_as: () => customer_signin_as,
  damages: () => damages,
  "damages.material.real_property": () => damages_material_real_property,
  "damages.material.vehicle": () => damages_material_vehicle,
  default: () => es_default,
  delta: () => delta,
  demoempleo: () => demoempleo,
  distribution: () => distribution,
  document: () => document,
  documentAnalysis: () => documentAnalysis,
  documentTypes: () => documentTypes,
  documents: () => documents,
  "driver-ownership": () => driver_ownership,
  engagements: () => engagements,
  entities: () => entities,
  entrypoint: () => entrypoint,
  entrypoints: () => entrypoints,
  errors: () => errors,
  "estimates-definition": () => estimates_definition,
  events: () => events,
  "exported-report": () => exported_report,
  field_adjuster_registration: () => field_adjuster_registration,
  field_mapping_config: () => field_mapping_config,
  fileRequest: () => fileRequest,
  file_types: () => file_types,
  filters: () => filters,
  filtersPanel: () => filtersPanel,
  fractures: () => fractures,
  fraud: () => fraud,
  "fraud-investigation-case": () => fraud_investigation_case,
  fraud_investigations: () => fraud_investigations,
  frequency: () => frequency,
  gamma: () => gamma,
  geo: () => geo,
  home: () => home,
  idCardScan: () => idCardScan,
  "identification-type": () => identification_type,
  "inhouse-lawyer": () => inhouse_lawyer,
  injuries: () => injuries,
  inspection: () => inspection,
  integrations: () => integrations,
  legalPersonType: () => legalPersonType,
  legal_person: () => legal_person,
  license: () => license,
  load_balance_rule: () => load_balance_rule,
  "local-insured-relationships": () => local_insured_relationships,
  materialDamage: () => materialDamage,
  message_template: () => message_template,
  metrics: () => metrics,
  network: () => network,
  notifications: () => notifications,
  occurrence: () => occurrence,
  offer: () => offer,
  offerAgreement: () => offerAgreement,
  onboarding: () => onboarding,
  openai_decision: () => openai_decision,
  operators: () => operators,
  orderClaimStatusMappings: () => orderClaimStatusMappings,
  orderDocumentRequirements: () => orderDocumentRequirements,
  orders: () => orders,
  parents: () => parents,
  "payment-method": () => payment_method,
  permissions: () => permissions,
  person: () => person,
  productImport: () => productImport,
  products: () => products,
  professions: () => professions,
  providerAccountSettings: () => providerAccountSettings,
  providerGroups: () => providerGroups,
  providerInvitations: () => providerInvitations,
  provider_registration: () => provider_registration,
  provider_signin_as: () => provider_signin_as,
  real_property: () => real_property,
  recordings: () => recordings,
  "release-notes": () => release_notes,
  resources: () => resources,
  review: () => review,
  reviews: () => reviews,
  rfp: () => rfp,
  role: () => role,
  severities: () => severities,
  sex: () => sex,
  sidebar: () => sidebar,
  sinister: () => sinister,
  sla: () => sla,
  stats: () => stats,
  "style-config": () => style_config,
  "target-group": () => target_group,
  "team-management": () => team_management,
  teams: () => teams,
  test_environment: () => test_environment,
  "trigger-mappings": () => trigger_mappings,
  type: () => type,
  use_cases: () => use_cases,
  user: () => user,
  "validation-pattern": () => validation_pattern,
  validations: () => validations,
  variable: () => variable,
  vehicle: () => vehicle,
  "victim-injuries-roles": () => victim_injuries_roles,
  victim_relationship: () => victim_relationship,
  webhook: () => webhook,
  "working-days": () => working_days,
  zod: () => zod
});
var claim_status_locked_by_derivation = "El estado no puede cambiarse mientras el reclamo est\xE9 derivado. Devolv\xE9 la derivaci\xF3n primero.";
var autoinspectorInspections = {
  title: "Inspecciones Autoinspector",
  description: "Diagn\xF3stico interno: todas las inspecciones creadas desde Piramid.",
  entityLabel: "inspecciones",
  filters: {
    dateFrom: "Desde",
    dateTo: "Hasta",
    status: "Estado",
    result: "Resultado",
    company: "Compa\xF1\xEDa",
    template: "Plantilla",
    useCase: "Caso de uso",
    search: "ID externo o de entidad (prefijo)",
    clear: "Limpiar",
    all: "Todos"
  },
  stats: {
    total: "Inspecciones",
    byStatus: "Por estado",
    byResult: "Por resultado global",
    files: "Archivos enviados"
  },
  status: {
    created: "Creada",
    started: "Iniciada",
    blocked: "Bloqueada",
    processing: "Procesando",
    completed: "Completada"
  },
  result: {
    approved: "Aprobada",
    disapproved: "Desaprobada",
    error: "Error",
    none: "Sin resultado"
  },
  verdicts: {
    approved: "aprobados",
    needs_review: "a revisar",
    disapproved: "desaprobados",
    no_result: "sin resultado"
  },
  columns: {
    date: "Fecha",
    company: "Compa\xF1\xEDa / plantilla",
    useCase: "Caso de uso",
    correlation: "Entidad",
    externalId: "ID externo",
    status: "Estado",
    result: "Resultado",
    files: "Archivos",
    body: "Body"
  },
  deletedTemplate: "(eliminada)",
  body: {
    view: "Ver",
    title: "Cuerpos de la inspecci\xF3n",
    request: "Enviado a Autoinspector",
    response: "\xDAltimo payload recibido",
    copy: "Copiar",
    empty: "Sin body registrado"
  }
};
var documentAnalysis = {
  approved: "Documentaci\xF3n validada por Autoinspector",
  needsReview: "Autoinspector recomienda revisi\xF3n",
  disapproved: "Autoinspector detect\xF3 irregularidades",
  noResult: "Enviado a Autoinspector, resultado pendiente",
  inferences: {
    ia_detectada_images: "Creaci\xF3n o alteraci\xF3n con IA",
    similitud_web_images: "Imagen similar en la web",
    pdf_forgery_verdict: "Documento PDF alterado",
    pdf_forgery_trust_score: "Baja confianza de integridad del PDF",
    unknown: "Irregularidad detectada"
  }
};
var providerInvitations = {
  title: "Invitaciones a proveedores",
  description: "Todas las invitaciones enviadas por las aseguradoras",
  search_placeholder: "Buscar por email o nombre..."
};
var backofficeCustomerOrganizations = {
  title: "Organizaciones",
  description: "Organizaciones que agrupan usuarios reclamantes (call centers, centros de toma de denuncias, etc.)",
  entityLabel: "organizaciones",
  search_placeholder: "Buscar por nombre o CUIT...",
  create: "Crear organizaci\xF3n",
  create_title: "Nueva organizaci\xF3n",
  create_description: "Los usuarios de la organizaci\xF3n comparten la gesti\xF3n de todos sus reclamos.",
  created: "Organizaci\xF3n creada correctamente",
  columns: {
    id: "ID",
    name: "Nombre organizaci\xF3n",
    ein: "CUIT",
    users: "Usuarios",
    claims: "Reclamos",
    createdAt: "Fecha alta",
    actions: "Acciones"
  },
  view_detail: "Ver detalle",
  fields: {
    name: "Nombre",
    ein: "CUIT",
    email: "Email",
    first_name: "Nombre",
    last_name: "Apellido",
    phone: "Tel\xE9fono",
    contact_email: "Email de contacto",
    address: "Direcci\xF3n",
    tenant: "Aseguradora"
  },
  placeholders: {
    name: "Nombre de la organizaci\xF3n",
    ein: "CUIT de la organizaci\xF3n",
    email: "Email del usuario",
    first_name: "Nombre del usuario",
    last_name: "Apellido del usuario",
    phone: "Tel\xE9fono de contacto",
    contact_email: "contacto@organizacion.com",
    address: "Direcci\xF3n de la organizaci\xF3n",
    tenant: "Busc\xE1 la aseguradora..."
  },
  detail: {
    edit: "Editar",
    edit_title: "Editar organizaci\xF3n",
    edit_description: "Modific\xE1 el nombre o el CUIT de la organizaci\xF3n.",
    save: "Guardar cambios",
    updated: "Organizaci\xF3n actualizada correctamente",
    logo_title: "Logo",
    logo_description: "Se muestra en el men\xFA lateral del portal del cliente para los usuarios de la organizaci\xF3n.",
    logo_updated: "Logo actualizado correctamente",
    users_title: "Usuarios",
    users_description: "Todos los usuarios comparten los reclamos de la empresa",
    add_user: "Crear con contrase\xF1a temporal",
    add_user_title: "Nuevo usuario",
    add_user_description: "Se crea un usuario reclamante dentro de la empresa con una contrase\xF1a temporal. Prefer\xED la invitaci\xF3n por email: la contrase\xF1a temporal hay que comunicarla a mano.",
    link_user: "Vincular existente",
    link_user_title: "Vincular usuario existente",
    link_user_description: "El usuario debe ser un reclamante sin empresa. Sus reclamos previos siguen siendo personales y no se comparten con la empresa.",
    link_user_search: "Buscar",
    link_user_confirm: "Confirmar vinculaci\xF3n",
    link_user_found: "Usuario encontrado",
    link_user_personal_claims: "Reclamos personales (no se comparten): {{count}}",
    link_user_already_linked: "Este usuario ya pertenece a {{organization}} y no puede vincularse.",
    link_user_not_third: "Este usuario no es un reclamante y no puede vincularse.",
    linked: "Usuario vinculado correctamente",
    unlink_user: "Desvincular",
    unlink_user_title: "Desvincular usuario",
    unlink_user_description: "Los reclamos de la organizaci\xF3n que este usuario tenga a su nombre se reasignan a otro miembro; sus reclamos personales se van con \xE9l.",
    unlink_user_transfer_to: "Reasignar reclamos a",
    unlink_user_transfer_placeholder: "Eleg\xED un miembro",
    unlink_user_transfer_none: "No hay otros miembros para reasignar",
    unlink_user_owns_claims: "El usuario tiene {{count}} reclamo(s) de la organizaci\xF3n a su nombre: eleg\xED a qui\xE9n reasignarlos.",
    unlink_user_confirm: "Confirmar desvinculaci\xF3n",
    unlinked: "Usuario desvinculado correctamente",
    unlinked_with_claims: "Usuario desvinculado; se reasignaron {{count}} reclamo(s)",
    user_created: "Usuario creado correctamente",
    invite_user: "Invitar usuario",
    invite_user_title: "Invitar usuario",
    invite_user_description: "Recibe un email con un enlace para crear su propia contrase\xF1a en el portal de la aseguradora elegida. El enlace vence en 7 d\xEDas.",
    invite_user_confirm: "Enviar invitaci\xF3n",
    invited: "Invitaci\xF3n enviada correctamente",
    invitations_title: "Invitaciones",
    invitations_description: "Invitaciones enviadas que a\xFAn no fueron aceptadas",
    invitations_empty: "No hay invitaciones pendientes",
    tenant_empty: "No se encontraron aseguradoras",
    sign_in_as: "Sign in",
    sign_in_as_title: "Iniciar sesi\xF3n como el usuario",
    sign_in_as_description: "Se abre el portal del cliente de la aseguradora elegida en una pesta\xF1a nueva, con la sesi\xF3n de este usuario.",
    sign_in_as_confirm: "Abrir sesi\xF3n",
    invitation_status: {
      pending: "Pendiente",
      accepted: "Aceptada",
      cancelled: "Cancelada",
      expired: "Vencida"
    },
    resend_invitation: "Reenviar",
    resent: "Invitaci\xF3n reenviada correctamente",
    cancel_invitation: "Cancelar",
    cancel_invitation_title: "Cancelar invitaci\xF3n",
    cancel_invitation_description: "El enlace enviado deja de funcionar. Pod\xE9s volver a invitar al mismo email m\xE1s adelante.",
    cancel_invitation_confirm: "Cancelar invitaci\xF3n",
    invitation_cancelled: "Invitaci\xF3n cancelada",
    invitation_columns: {
      user: "Usuario",
      tenant: "Aseguradora",
      status: "Estado",
      expires_at: "Vence",
      sent_count: "Env\xEDos",
      actions: "Acciones"
    },
    credentials_title: "Credenciales temporales",
    credentials_description: "Guardalas ahora: la contrase\xF1a no vuelve a mostrarse. El usuario inicia sesi\xF3n con su email y esta contrase\xF1a en el portal del cliente.",
    credentials_email: "Email",
    credentials_password: "Contrase\xF1a",
    verified: "Verificado",
    pending_verification: "Pendiente"
  }
};
var backofficeReleaseNotes = {
  title: "Novedades",
  description: "Qu\xE9 alcance tuvo cada nota en una compa\xF1\xEDa, qui\xE9n la ley\xF3 y qu\xE9 hizo despu\xE9s.",
  "pick-company": "Eleg\xED una compa\xF1\xEDa para ver sus lecturas.",
  empty: "Todav\xEDa no hay notas cargadas.",
  status: {
    draft: "Borrador",
    published: "Publicada"
  },
  unavailable: "No disponible",
  "unavailable-hint": "La compa\xF1\xEDa no tiene la flag que pide la nota.",
  hidden: "Oculta",
  "hidden-hint": "Los usuarios no la ven hasta que se vuelva a hacer visible.",
  unpublished: "Sin publicar",
  visibility: {
    label: "Visible",
    hint: "Apagalo para que los usuarios de todas las compa\xF1\xEDas dejen de verla, sin despublicarla.",
    shown: "Nota visible para los usuarios",
    hidden: "Nota oculta para los usuarios"
  },
  columns: {
    note: "Nota",
    published: "Publicada",
    visible: "Visible",
    recipients: "Destinatarios",
    reach: "Alcance",
    others: "Otros lectores",
    demos: "Probaron una demo",
    feedback: "\xDAtil / no \xFAtil",
    user: "Usuario",
    role: "Rol",
    teams: "Equipos",
    recipient: "Destinatario",
    "first-read": "Primera lectura",
    "last-read": "\xDAltima lectura",
    "read-time": "Tiempo de lectura",
    items: "Novedades vistas",
    "demo-interactions": "Acciones en demos",
    type: "Evento",
    when: "Cu\xE1ndo",
    target: "Sobre",
    data: "Datos",
    "last-notice": "\xDAltimo aviso"
  },
  reach: "{{readers}} de {{audience}}",
  "not-sent": "Sin enviar",
  "recipient-yes": "S\xED",
  "recipient-no": "No",
  send: {
    button: "Enviar a la compa\xF1\xEDa",
    "add-button": "Agregar roles",
    title: "Enviar \xAB{{title}}\xBB",
    description: "Eleg\xED los roles de la compa\xF1\xEDa que reciben la nota. Sus usuarios pasan a ser los destinatarios: contra ellos se mide el alcance.",
    roles: "Roles",
    "role-users": "{{users}} usuarios",
    already: "Ya enviada a {{count}} destinatarios; los roles nuevos se suman.",
    notify: "Avisar por mail a los destinatarios nuevos",
    confirm: "Enviar",
    cancel: "Cancelar",
    sent: "Enviada a {{added}} destinatarios nuevos ({{notified}} avisados por mail)",
    nothing: "Esos roles no suman destinatarios nuevos.",
    "no-roles": "La compa\xF1\xEDa no tiene roles con usuarios."
  },
  kpi: {
    reach: "Alcance",
    "reach-hint": "{{readers}} de {{audience}} destinatarios la abrieron",
    "days-to-read": "Tiempo hasta leerla",
    "days-to-read-hint": "Mediana desde la publicaci\xF3n",
    "read-time": "Tiempo de lectura",
    "read-time-hint": "Mediana con la nota en pantalla",
    demos: "Probaron una demo",
    "demos-hint": "{{users}} lectores",
    feedback: "Les result\xF3 \xFAtil",
    "feedback-hint": "{{helpful}} s\xED \xB7 {{unhelpful}} no",
    "feedback-help": "{{unanswered}} de {{readers}} lectores no contestaron si les result\xF3 \xFAtil.",
    none: "\u2014"
  },
  tabs: {
    preview: "Vista previa",
    readers: "Lectores",
    pending: "Pendientes",
    adoption: "Adopci\xF3n",
    events: "Eventos"
  },
  format: {
    copy: "Copiar formato",
    copied: "Copiado",
    "copy-error": "No se pudo copiar el formato.",
    "note-hint": "Copi\xE1 el formato y pedile a tu agente que adapte la release note a ese JSON antes de subirlo."
  },
  help: "C\xF3mo se calcula",
  adoption: {
    empty: "Esta nota no define m\xE9tricas de adopci\xF3n.",
    window: "Valores semanales: {{before}} semanas antes del lanzamiento, en gris, y desde el lanzamiento hasta hoy, en naranja. El n\xFAmero grande resume las semanas desde el lanzamiento y \xABAntes\xBB las previas; cada valor dice cu\xE1ntos casos tiene detr\xE1s. La nota se envi\xF3 a {{recipients}} destinatarios de la compa\xF1\xEDa.",
    "no-data": "Sin datos",
    cases: "{{cases}} casos",
    before: "Antes: {{value}}",
    "before-none": "Antes: sin datos",
    summary: {
      weekly_average: "promedio por semana",
      share: "sobre el total del per\xEDodo",
      median: "mediana de todos los casos",
      latest: "\xFAltima lectura"
    },
    direction: {
      up: "\u2191 subir",
      down: "\u2193 bajar",
      flat: "observar"
    },
    units: {
      minutes: "{{value}} min",
      hours: "{{value}} h",
      days: "{{value}} d"
    }
  },
  "readers-empty": "Nadie la abri\xF3 todav\xEDa.",
  "pending-empty": "Todos los destinatarios la abrieron.",
  "pending-count": "{{count}} destinatarios todav\xEDa no la abrieron.",
  "events-empty": "Sin eventos registrados.",
  "events-all": "Todos los eventos",
  "load-more": "Cargar m\xE1s",
  notify: {
    button: "Avisar por mail a los pendientes",
    title: "\xBFEnviar el aviso por mail?",
    description: "Se env\xEDa un mail a los {{count}} destinatarios que todav\xEDa no abrieron la nota, con el link para leerla.",
    confirm: "Enviar",
    cancel: "Cancelar",
    sent: "Aviso enviado a {{count}} personas",
    none: "No hab\xEDa nadie a quien avisar."
  },
  "view-note": "Ver la nota",
  back: "Volver a Novedades",
  days: "{{days}} d",
  minutes: "{{minutes}} min",
  "items-of": "{{viewed}} de {{total}}",
  preview: {
    hint: "As\xED la ven los usuarios de la compa\xF1\xEDa. Las demos interactivas s\xF3lo se ven en la app.",
    draft: "Borrador: todav\xEDa no la ve nadie. Revisala ac\xE1 y publicala cuando est\xE9 lista."
  },
  import: {
    button: "Importar nota",
    title: "Importar una nota",
    description: "Un archivo JSON con el formato de las notas, el mismo que escribe el comando /release-note. Entra como borrador: se revisa en la vista previa y despu\xE9s se publica.",
    file: "Archivo",
    "invalid-json": "El archivo no es un JSON v\xE1lido.",
    invalid: "El archivo no tiene el formato de una nota:",
    summary: "{{slug}} \xB7 {{items}} novedades",
    confirm: "Importar",
    cancel: "Cancelar",
    created: "Nota importada como borrador",
    replaced: "Borrador actualizado"
  },
  publish: {
    button: "Publicar",
    title: "\xBFPublicar \xAB{{title}}\xBB?",
    description: "Desde ahora la ven los usuarios de las compa\xF1\xEDas con las flags que pide. Despu\xE9s hay que enviarla a cada compa\xF1\xEDa para fijar destinatarios y avisar por mail.",
    confirm: "Publicar",
    cancel: "Cancelar",
    done: "Nota publicada"
  },
  delete: {
    button: "Eliminar borrador",
    title: "\xBFEliminar el borrador \xAB{{title}}\xBB?",
    description: "Se borra la nota con sus novedades. Se puede volver a importar.",
    confirm: "Eliminar",
    cancel: "Cancelar",
    done: "Borrador eliminado"
  }
};
var backofficeProviders = {
  title: "Proveedores",
  description: "Empresas proveedoras registradas (datos de la empresa y del proveedor)",
  entityLabel: "proveedores",
  search_placeholder: "Buscar por raz\xF3n social, email o CUIT...",
  columns: {
    legalName: "Raz\xF3n social",
    email: "Email",
    ein: "CUIT",
    phone: "Tel\xE9fono",
    source: "Origen",
    onboarding: "Onboarding",
    country: "Pa\xEDs",
    createdAt: "Alta"
  },
  source: {
    invited: "Invitado",
    csv: "CSV",
    marketplace: "Auto-registro"
  },
  onboarding: {
    completed: "Completo",
    pending: "Pendiente"
  },
  detail: "Detalle",
  detail_title: "Detalle del proveedor",
  detail_description: "Datos del proveedor, sus sucursales y sus usuarios",
  sections: {
    branches: "Sucursales",
    users: "Usuarios"
  },
  branches: {
    name: "Nombre",
    address: "Direcci\xF3n",
    locality: "Localidad",
    phones: "Tel\xE9fonos",
    emails: "Emails",
    central: "Central",
    empty: "Este proveedor no tiene sucursales cargadas."
  },
  users: {
    name: "Nombre",
    type: "Tipo",
    status: "Estado",
    createdAt: "Registro",
    verified: "Verificado",
    pending_verification: "Pendiente",
    sign_in_as: "Sign in",
    popup_blocked: "El navegador bloque\xF3 la pesta\xF1a nueva. Habilit\xE1 las ventanas emergentes para este sitio y volv\xE9 a intentar.",
    empty: "Este proveedor no tiene usuarios."
  }
};
var customer_signin_as = {
  loading: "Iniciando sesi\xF3n...",
  error_title: "Error de autenticaci\xF3n",
  error_description: "No pudimos iniciar la sesi\xF3n. El enlace puede haber vencido: ped\xED uno nuevo desde el Backoffice.",
  go_to_login: "Ir al login"
};
var customer_organization_invitation = {
  title: "Sumate a {{organization}}",
  description: "{{organization}} te invit\xF3 a gestionar sus reclamos en el portal de {{tenant}}. Cre\xE1 tu contrase\xF1a para activar tu cuenta.",
  email_label: "Email",
  password_label: "Contrase\xF1a",
  password_confirmation_label: "Confirmar contrase\xF1a",
  submit: "Activar mi cuenta",
  expired_title: "Esta invitaci\xF3n venci\xF3",
  expired_description: "Pedile a quien te invit\xF3 que la reenv\xEDe para recibir un enlace nuevo.",
  invalid_title: "Esta invitaci\xF3n no es v\xE1lida",
  invalid_description: "El enlace ya fue usado o cancelado. Si cre\xE9s que es un error, ped\xED que te reenv\xEDen la invitaci\xF3n."
};
var provider_registration = {
  title: "Complet\xE1 tu registro en Piramid.",
  description: "Cre\xE1 tu cuenta de proveedor para sumarte a la red.",
  invitedBy: "{{company}} te invit\xF3 a su red.",
  emailLabel: "Email",
  emailPlaceholder: "proveedor@empresa.com",
  emailDescription: "Este email ser\xE1 utilizado para acceder a la plataforma.",
  firstNameLabel: "Nombre",
  firstNamePlaceholder: "Tu nombre",
  lastNameLabel: "Apellido",
  lastNamePlaceholder: "Tu apellido",
  passwordLabel: "Contrase\xF1a",
  passwordPlaceholder: "M\xEDnimo 8 caracteres",
  confirmPasswordLabel: "Confirmar contrase\xF1a",
  confirmPasswordPlaceholder: "Repet\xED la contrase\xF1a",
  passwordsDontMatch: "Las contrase\xF1as no coinciden",
  legalNameLabel: "Raz\xF3n social",
  legalNamePlaceholder: "Nombre legal de la empresa",
  einLabel: "CUIT",
  einPlaceholder: "CUIT de la empresa (sin guiones)",
  einDescription: "El CUIT es necesario para la verificaci\xF3n de la empresa.",
  phoneLabel: "Tel\xE9fono (opcional)",
  phonePlaceholder: "Ej. 11 5555 5555",
  submit: "Crear cuenta",
  invalidTokenTitle: "Invitaci\xF3n inv\xE1lida o vencida",
  invalidTokenDescription: "El enlace de invitaci\xF3n no es v\xE1lido o ya expir\xF3. Ped\xED a la aseguradora que te reenv\xEDe la invitaci\xF3n.",
  backToLogin: "Volver al inicio de sesi\xF3n"
};
var engagements = {
  title: "Compa\xF1\xEDas vinculadas",
  description: "Consult\xE1 las compa\xF1\xEDas vinculadas a tu empresa y respond\xE9 las invitaciones pendientes.",
  entityLabel: "compa\xF1\xEDas",
  columns: {
    insurer: "Compa\xF1\xEDa",
    ein: "CUIT",
    status: "Estado",
    createdAt: "Fecha invitaci\xF3n",
    actions: "Acciones"
  },
  actions: {
    accept: "Aceptar invitaci\xF3n",
    accepted: "Invitaci\xF3n aceptada",
    reject: "Rechazar invitaci\xF3n",
    rejected: "Invitaci\xF3n rechazada",
    cancel: "Cancelar",
    confirm: {
      accept: {
        title: "\xBFAceptar la invitaci\xF3n?",
        description: "Vas a aceptar la relaci\xF3n comercial con {{insurer}}. Podr\xE1s empezar a recibir su trabajo.",
        action: "S\xED, aceptar"
      },
      reject: {
        title: "\xBFRechazar la invitaci\xF3n?",
        description: "Vas a rechazar la relaci\xF3n comercial con {{insurer}}. Esta acci\xF3n no se puede deshacer.",
        action: "S\xED, rechazar"
      }
    }
  }
};
var branches = {
  title: "Registro de sucursales",
  description: "Administr\xE1 las sucursales de tu empresa con su ubicaci\xF3n precisa en el mapa.",
  entityLabel: "sucursales",
  create: "Crear sucursal",
  viewMap: "Ver mapa",
  columns: {
    name: "Nombre",
    locality: "Localidad",
    address: "Direcci\xF3n",
    central: "Central",
    centralYes: "Central"
  },
  type: {
    central: "Central",
    regular: "Sucursal"
  },
  detail: {
    locality: "Localidad",
    address: "Direcci\xF3n",
    phones: "Tel\xE9fonos",
    emails: "Emails",
    empty: "\u2014"
  },
  map: {
    title: "Sucursales en el mapa",
    empty: "No hay sucursales para mostrar."
  },
  actions: {
    edit: "Editar",
    delete: "Eliminar",
    deleted: "Sucursal eliminada",
    confirm: {
      delete: {
        title: "\xBFEliminar la sucursal?",
        description: 'Vas a eliminar la sucursal "{{name}}". Esta acci\xF3n no se puede deshacer.',
        cancel: "Cancelar",
        action: "S\xED, eliminar"
      }
    }
  },
  form: {
    createTitle: "Nueva sucursal",
    editTitle: "Editar sucursal",
    name: "Nombre",
    namePlaceholder: "Ej: Casa central",
    locality: "Localidad",
    localityPlaceholder: "Busc\xE1 una localidad...",
    noResults: "Sin resultados",
    address: "Direcci\xF3n",
    addressPlaceholder: "Av. San Mart\xEDn 123",
    location: "Ubicaci\xF3n en el mapa",
    mapHint: "Hac\xE9 click en el mapa para marcar la ubicaci\xF3n exacta. Pod\xE9s arrastrar el pin para ajustarlo.",
    mapSelectLocalityHint: "Seleccion\xE1 una localidad para ubicar la sucursal en el mapa.",
    phones: "Tel\xE9fonos",
    phonePlaceholder: "Tel\xE9fono",
    addPhone: "Agregar tel\xE9fono",
    emails: "Emails",
    emailPlaceholder: "Email",
    addEmail: "Agregar email",
    isCentral: "Marcar como sucursal principal",
    cancel: "Cancelar",
    save: "Guardar",
    created: "Sucursal creada",
    updated: "Sucursal actualizada",
    errors: {
      nameRequired: "El nombre es obligatorio",
      localityRequired: "La localidad es obligatoria",
      locationRequired: "Marc\xE1 la ubicaci\xF3n en el mapa",
      invalidEmail: "Email inv\xE1lido"
    }
  }
};
var network = {
  entityLabel: "proveedores",
  searchPlaceholder: "Buscar por nombre o email...",
  viewInvitations: "Invitaciones",
  viewMap: "Mapa",
  map: {
    title: "Sucursales de la red",
    description: "Sucursales de los proveedores activos de tu red.",
    empty: "Todav\xEDa no hay sucursales geolocalizadas en tu red.",
    error: "No pudimos cargar las sucursales de tu red.",
    central: "Central",
    branchCount: "{{count}} sucursales",
    truncated: "Mostrando las primeras {{limit}} sucursales de tu red."
  },
  columns: {
    provider: "Proveedor",
    email: "Email proveedor",
    phone: "Tel\xE9fono",
    status: "Estado",
    code: "C\xF3digo",
    name: "Nombre proveedor",
    createdAt: "Fecha alta",
    invitedAt: "Invitado el",
    respondedAt: "Respondido el",
    insurerCompany: "Aseguradora",
    invitedBy: "Invitado por"
  },
  status: {
    pending: "Pendiente",
    active: "Activo",
    rejected: "Rechazado",
    paused: "Pausado",
    suspended: "Suspendido"
  },
  invitationStatus: {
    pending: "Pendiente",
    registered: "Registrado",
    rejected: "Rechazada",
    cancelled: "Anulada",
    expired: "Expirada"
  },
  invite: {
    button: "Invitar proveedor",
    dialogTitle: "Invitar proveedor",
    dialogDescription: "Ingres\xE1 el email del proveedor que quer\xE9s sumar a tu red. El enlace de invitaci\xF3n ser\xE1 v\xE1lido por 7 d\xEDas.",
    emailLabel: "Email",
    emailPlaceholder: "proveedor@empresa.com",
    nameLabel: "Nombre (opcional)",
    namePlaceholder: "Nombre de referencia del proveedor",
    submit: "Enviar invitaci\xF3n",
    successTitle: "Invitaci\xF3n enviada",
    successDescription: "Se envi\xF3 la invitaci\xF3n al proveedor"
  },
  actions: {
    updated: "Estado actualizado",
    active: "Reactivar",
    paused: "Pausar",
    suspended: "Suspender"
  },
  externalId: {
    action: "C\xF3digo interno",
    title: "C\xF3digo interno del proveedor",
    description: "C\xF3digo con el que tu empresa identifica a este proveedor. Dejalo vac\xEDo para quitarlo.",
    label: "C\xF3digo",
    placeholder: "COD-1234",
    save: "Guardar",
    success: "C\xF3digo actualizado"
  },
  invitations: {
    entityLabel: "invitaciones",
    searchPlaceholder: "Buscar por nombre o email...",
    cancel: "S\xED, anular",
    cannotCancel: "Solo se puede anular una invitaci\xF3n pendiente",
    cancelled: "Invitaci\xF3n anulada",
    cancelConfirmTitle: "\xBFAnular invitaci\xF3n?",
    cancelConfirmDescription: "La invitaci\xF3n quedar\xE1 anulada y el proveedor no podr\xE1 utilizarla para sumarse a tu red. Deber\xE1s enviarle una nueva invitaci\xF3n.",
    cancelConfirmBack: "Volver"
  },
  detail: {
    back: "Proveedores",
    identity: {
      ein: "CUIT",
      email: "Email",
      contactEmail: "Email de contacto",
      phone: "Tel\xE9fono",
      address: "Direcci\xF3n",
      locality: "Localidad",
      code: "C\xF3digo interno",
      joinedNetwork: "En tu red desde",
      registeredAt: "Alta en Piramid",
      onboardingComplete: "Onboarding completo",
      noDescription: "El proveedor todav\xEDa no carg\xF3 una descripci\xF3n.",
      onboardingIncomplete: "Onboarding incompleto"
    },
    stats: {
      title: "Desempe\xF1o",
      total: "\xD3rdenes derivadas",
      totalHint: "{{count}} en los \xFAltimos 30 d\xEDas",
      open: "Abiertas",
      openHint: "Pendientes y en curso",
      completed: "Completadas",
      dropped: "Rechazadas o anuladas",
      acceptanceRate: "Tasa de aceptaci\xF3n",
      acceptanceRateHint: "Sobre las \xF3rdenes que el proveedor respondi\xF3",
      timesTitle: "Tiempos y atenci\xF3n",
      avgToAccept: "Tiempo medio hasta aceptaci\xF3n",
      avgToComplete: "Tiempo medio de ciclo",
      avgToCompleteHint: "Desde que el proveedor acepta hasta que finaliz\xE1s la orden. Incluye tu propio tiempo de revisi\xF3n.",
      awaitingProvider: "Esperan al proveedor",
      awaitingInsurer: "Te esperan a vos",
      oldestWait: "Espera m\xE1s antigua del proveedor",
      billed: "Facturado",
      billedHint: "Suma de las \xF3rdenes completadas.",
      trend: "Derivaciones por mes",
      trendHint: "\xDAltimos 12 meses, por mes de derivaci\xF3n",
      trendTotal: "Derivadas",
      trendCompleted: "Completadas",
      trendDropped: "Rechazadas o anuladas",
      empty: "Todav\xEDa no derivaste trabajo a este proveedor.",
      error: "No pudimos cargar las m\xE9tricas del proveedor.",
      noValue: "Sin datos",
      duration: {
        minutes: "{{value}} min",
        hours: "{{value}} h",
        days: "{{value}} d\xEDas"
      }
    },
    branches: {
      title: "Sucursales",
      central: "Central",
      mapEmptyHint: "El proveedor todav\xEDa no carg\xF3 sucursales"
    },
    capabilities: {
      title: "Capacidades",
      description: "Servicios que el proveedor declar\xF3 que puede realizar.",
      allGoods: "Todos los bienes",
      empty: "El proveedor todav\xEDa no declar\xF3 capacidades."
    },
    orders: {
      title: "\xD3rdenes derivadas",
      description: "Todo el trabajo que derivaste a este proveedor.",
      viewAll: "Ver todas",
      searchPlaceholder: "Buscar por N\xB0 de orden, descripci\xF3n o reclamo",
      allStatuses: "Todos los estados",
      empty: "Todav\xEDa no hay \xF3rdenes derivadas a este proveedor.",
      error: "No pudimos cargar las \xF3rdenes del proveedor."
    }
  }
};
var use_cases = {
  infer_file_data: "Clasificacion de archivo e inferencia atributos",
  vehicle_id_card_ocr: "Extracci\xF3n de datos de la c\xE9dula de identidad del veh\xEDculo"
};
var field_mapping_config = {
  entities: {
    claim: {
      label: "Reclamo"
    }
  },
  fields: {
    external_claim_request_id: {
      label: "N\xFAmero de tramite"
    },
    ref_id: {
      label: "ID de referencia"
    }
  }
};
var message_template = {
  roles: {
    automatic_response: "Respuesta autom\xE1tica del chat"
  },
  context_path: {
    claim: {
      ref_id: "ID de referencia",
      external_claim_id: "ID Reclamo Externo",
      id: "ID Reclamo",
      owner: {
        first_name: "Nombre Reclamante Usuario",
        last_name: "Apellido Reclamante Usuario",
        email: "Email Reclamante Usuario"
      },
      sinister: {
        selected_external_complaint: {
          external_id: "N\xFAmero de siniestro"
        },
        policyholder_license_plate: "Patente Asegurado"
      }
    },
    file_request_placeholder_list: "Lista de archivos solicitados",
    file_request_message: "Mensaje de solicitud de archivos"
  },
  scope: {
    offer: "Ofrecimiento",
    communication: "Comunicaci\xF3n"
  }
};
var stats = {
  modules: {
    claim: "Reclamos",
    complaint: "Denuncias"
  }
};
var chart = {
  frequencies: {
    daily: "Diario",
    weekly: "Semanal",
    monthly: "Mensual"
  }
};
var distribution = {
  categories: {
    worst: "peor",
    best: "mejor"
  }
};
var trigger_mappings = {
  actions: {
    file_request: "Solicitud de archivo",
    authorize_complaint: "Autorizar denuncia",
    approve_complaint: "Aprobar denuncia",
    reject_complaint: "Rechazar denuncia",
    derive_to_fraud: "Derivar a fraude"
  },
  status: "Estado",
  columns: {
    position: "Orden"
  },
  moveUp: "Subir",
  moveDown: "Bajar",
  statusRole: "Rol: {{role}}"
};
var sla = {
  form: {
    types: {
      stage: {
        title: "Etapas"
      },
      reference: {
        title: "Referencias"
      },
      status: {
        title: "Estados"
      }
    }
  },
  columns: {
    sla_expected_time_to_resolution: "Tiempo estipulado",
    sla_current_time_to_resolution: "Tiempo transcurrido",
    sla_type: "Tipo de SLA",
    sla_name: "Nombre de SLA",
    sla_elapsed_duration_criteria: "Criterio de duraci\xF3n",
    sla_version: "Versi\xF3n de SLA",
    relation_type_responsible: "Responsable",
    relation_type_coordinator: "Coordinador",
    relation_type_id: "{{relationTypeLabel}} ID",
    started_at: "Fecha inicio",
    deadline: "Fecha l\xEDmite",
    completed_at: "Fecha finalizaci\xF3n",
    status: "Estado",
    compliance: "Cumplimiento",
    progress: "Progreso",
    sla_objective_reference_name: "Nombre de objetivo"
  },
  metrics: {
    avg: "Promedio",
    max: "M\xE1ximo",
    min: "M\xEDnimo",
    median: "Mediana",
    percentile_25: "Percentil 25",
    percentile_50: "Percentil 50",
    percentile_75: "Percentil 75",
    percentile_80: "Percentil 80",
    percentile_90: "Percentil 90",
    trendline: "Tendencia"
  },
  commitments: {
    time: {
      singular: {
        days: "D\xEDa",
        hours: "Hora"
      },
      plural: {
        days: "D\xEDas",
        hours: "Horas"
      }
    },
    elapsed_duration_criteria: {
      singular: {
        working_days: "h\xE1bil",
        working_hours: "h\xE1bil"
      },
      plural: {
        working_days: "h\xE1biles",
        working_hours: "h\xE1biles"
      }
    }
  },
  virtual_metric: {
    time_to_first_response: {
      name: "Tiempo para primera respuesta",
      description: "Tiempo que se tarda en responder al primer mensaje recibido"
    },
    avg_response_time: {
      name: "Tiempo promedio de respuesta",
      description: "Tiempo promedio de respuesta luego del primer mensaje respondido"
    }
  },
  status: {
    completed: "Completado",
    active: "Activo",
    effective: "Vigente",
    planned: "Planificado",
    expired: "Expirado",
    deactivated: "Desactivado"
  },
  report: {
    status: {
      active: "Activo",
      completed: "Completado"
    },
    compliance: {
      on_time: "A tiempo",
      expired: "Vencido"
    }
  },
  elapsed_duration_criteria: {
    elapsed_days: "D\xEDas corridos",
    working_days: "D\xEDas h\xE1biles",
    elapsed_hours: "Horas corridas",
    working_hours: "Horas h\xE1biles"
  },
  scopes: {
    claim: "Reclamo",
    complaint: "Denuncia"
  },
  types: {
    stage: "Etapa",
    status: "Estado",
    reference: "Referencia",
    chat: "Mensajes"
  }
};
var working_days = {
  days: {
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Mi\xE9rcoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "S\xE1bado",
    sunday: "Domingo"
  }
};
var payment_method = {
  cash: "Contado",
  credit: "Cr\xE9dito"
};
var estimates_definition = {
  strategies: {
    coverage: "Por cobertura"
  },
  scopes: {
    complaint: "Denuncia"
  }
};
var person = {
  type: {
    natural_person: "Persona f\xEDsica",
    legal_person: "Persona jur\xEDdica"
  }
};
var entrypoint = {
  special_permissions: {
    sinister_date_limit: "Sin l\xEDmite de fecha de siniestro",
    vehicle_id_card_ocr: "Forzar carga de c\xE9dula del veh\xEDculo",
    recovery_claim: "Forzar carga de reclamo de recuperos"
  },
  environments: {
    production: "Producci\xF3n",
    sandbox: "Sandbox"
  },
  backends: {
    tajy: "Sebaot",
    demoempleo: "Demo Empleo",
    gamma: "Gamma"
  },
  specifications: {
    rivadavia_v2: "Rivadavia V2",
    demoempleo: "Demo Empleo",
    gamma: "Gamma"
  }
};
var demoempleo = {
  fields: {
    doc_identity_card: "C\xE9dula de identidad",
    doc_income_verification: "Certificado de cotizaciones (AFP)",
    doc_accounting_certificate: "Finiquito",
    doc_policy_insurance: "Constancia / P\xF3liza de cesant\xEDa"
  }
};
var gamma = {
  welcome: {
    title: "Nuevo reclamo",
    description: "Complet\xE1 la informaci\xF3n solicitada para registrar el reclamo en Gamma.",
    start: "Comenzar"
  },
  step: {
    title: "Nuevo reclamo",
    description: "Complet\xE1 todos los datos del reclamo. Se asignar\xE1 N\xB0 de reclamo Piramid al confirmar el ingreso."
  },
  sections: {
    derivation: {
      title: "Datos del siniestro",
      description: "Datos del siniestro en la aseguradora de origen."
    },
    insured: {
      title: "Datos del asegurado",
      description: "Datos de la persona responsable original del reclamo."
    },
    vehicle: {
      title: "Datos del veh\xEDculo",
      description: "Veh\xEDculo afectado por el da\xF1o."
    },
    damage: {
      title: "Datos del da\xF1o",
      description: "Servicio a realizar sobre el veh\xEDculo."
    },
    occurrence: {
      title: "Datos de la ocurrencia del siniestro",
      description: "Cu\xE1ndo y d\xF3nde ocurri\xF3 el hecho."
    },
    franchise: {
      title: "Franquicia",
      description: "Franquicia aplicable seg\xFAn la p\xF3liza."
    },
    documentation: {
      title: "Documentaci\xF3n",
      description: "Adjunt\xE1 la documentaci\xF3n del siniestro. Es opcional; pod\xE9s completarla luego."
    }
  },
  fields: {
    insurer: "Aseguradora",
    origin_sinister_number: "N\xB0 de siniestro/reclamo externo",
    policy_number: "N\xB0 de p\xF3liza (opcional)",
    plan: "Plan (opcional)",
    coverage_amount: "Monto de cobertura (opcional)",
    full_name: "Nombre y apellido",
    identification: "DNI / CUIT",
    birth_date: "Fecha de nacimiento (opcional)",
    marital_status: "Estado civil (opcional)",
    cellphone: "Tel\xE9fono",
    email: "Email",
    address: "Domicilio (opcional)",
    locality: "Localidad (opcional)",
    make: "Marca",
    model: "Modelo",
    year: "A\xF1o",
    version: "Versi\xF3n (opcional)",
    license_plate: "Patente",
    service: "Servicio a realizar",
    good: "Bien afectado",
    repair_locality: "Localidad o zona del servicio",
    damage_description: "Descripci\xF3n del da\xF1o (opcional)",
    date: "Fecha del hecho",
    time: "Hora aproximada",
    place: "Lugar del hecho",
    state: "Provincia del hecho",
    city: "Ciudad",
    zip_code: "C\xF3digo postal",
    story: "Relato del siniestro",
    report_sinister: "Completar informaci\xF3n del siniestro",
    doc_vehicle_id_card_front: "C\xE9dula verde (frente)",
    doc_vehicle_id_card_back: "C\xE9dula verde (dorso)",
    doc_victim_dni_front: "DNI del damnificado (frente)",
    doc_victim_dni_back: "DNI del damnificado (dorso)",
    doc_damage_photos: "Fotos del da\xF1o (veh\xEDculo)",
    documentation: "Documentaci\xF3n"
  },
  documents_status: {
    none: "No cargada",
    partial: "Carga parcial",
    complete: "Carga completa"
  },
  steps: {
    sinister: {
      title: "Datos de la ocurrencia del siniestro",
      description: "Datos de la derivaci\xF3n y del siniestro de origen."
    },
    documents: {
      title: "Documentaci\xF3n",
      description: "Adjunt\xE1 la documentaci\xF3n del siniestro. Es opcional; pod\xE9s completarla luego."
    }
  },
  confirmation: {
    title: "Env\xEDo de reclamo",
    description: "Revis\xE1 que los datos ingresados sean correctos. Si necesit\xE1s corregirlos, pod\xE9s volver hacia atr\xE1s."
  }
};
var target_group = {
  scopes: {
    derivation: "Derivaci\xF3n",
    assignment: "Asignaci\xF3n"
  }
};
var actions = {
  show: "Mostrar"
};
var operators = {
  equals: "="
};
var delta = {
  actions: {
    change: "Actualizaci\xF3n",
    remove: "Eliminaci\xF3n",
    create: "Definici\xF3n"
  }
};
var offer = {
  status: {
    expired: "Expirada",
    rejected: "Rechazado",
    archived: "Archivada",
    draft: "Borrador",
    pending: "Pendiente",
    started: "Iniciada",
    completed: "Completada",
    canceled: "Anulada",
    cancelled: "Anulada",
    accepted: "Aceptado"
  },
  agreement: {
    status: {
      expired: "Expirada",
      rejected: "Rechazado",
      archived: "Archivada",
      draft: "Borrador",
      pending: "Pendiente",
      started: "Iniciada",
      completed: "Completada",
      cancelled: "Anulada",
      canceled: "Anulada",
      failed: "Env\xEDo fallido"
    },
    groups: {
      company: "Compa\xF1\xEDa",
      claim: "Reclamo",
      victim: "Damnificado",
      claimant: "Reclamante",
      lawyer: "Abogado",
      heirs: "Herederos",
      insured: "Asegurado",
      insured_vehicle: "Veh\xEDculo asegurado",
      sinister: "Siniestro",
      damage_material: "Da\xF1o material",
      damage_person: "Da\xF1o a la persona",
      damage_recovery: "Recupero",
      offer: "Ofrecimiento",
      payment: "Pago",
      acceptance: "Aceptaci\xF3n",
      document: "Documento"
    },
    variables: {
      company: {
        name: "Nombre de la compa\xF1\xEDa",
        tax_id: "CUIT de la compa\xF1\xEDa"
      },
      claim: {
        ref_id: "N\xFAmero de reclamo",
        external_claim_id: "N\xFAmero de reclamo en la aseguradora",
        external_claim_request_id: "N\xFAmero de tr\xE1mite en la aseguradora",
        type: "Tipo de reclamo",
        damages: {
          types: "Tipos de da\xF1o",
          material: {
            kind: "Tipo de bien da\xF1ado",
            description: "Descripci\xF3n del da\xF1o material",
            summary: "Bien da\xF1ado (resumen)",
            vehicle: {
              description: "Veh\xEDculo da\xF1ado",
              make: "Marca del veh\xEDculo da\xF1ado",
              model: "Modelo del veh\xEDculo da\xF1ado",
              version: "Versi\xF3n del veh\xEDculo da\xF1ado",
              year: "A\xF1o del veh\xEDculo da\xF1ado",
              license_plate: "Patente del veh\xEDculo da\xF1ado",
              chassis: "Chasis del veh\xEDculo da\xF1ado",
              engine: "Motor del veh\xEDculo da\xF1ado",
              type: "Tipo de veh\xEDculo da\xF1ado",
              use: "Uso del veh\xEDculo da\xF1ado"
            },
            driver: {
              full_name: "Conductor del veh\xEDculo da\xF1ado"
            },
            insurance: {
              insurer: "Aseguradora del bien da\xF1ado",
              policy_number: "P\xF3liza del bien da\xF1ado",
              coverage: "Cobertura del bien da\xF1ado"
            },
            real_property: {
              type: "Tipo de inmueble da\xF1ado",
              ownership: "Tenencia del inmueble da\xF1ado",
              address: "Domicilio del inmueble da\xF1ado",
              city: "Localidad del inmueble da\xF1ado",
              state: "Provincia del inmueble da\xF1ado",
              zip_code: "C\xF3digo postal del inmueble da\xF1ado"
            }
          },
          person: {
            kind: "Tipo de da\xF1o a la persona",
            victim_role: "Rol del damnificado en el siniestro",
            policyholder_relationship: "Relaci\xF3n del damnificado con el asegurado",
            treatment_medical_institution: "Instituci\xF3n m\xE9dica",
            health_insurance_fund: "Obra social",
            treatment_worker_compensation_insurer: "ART",
            surgery_description: "Cirug\xEDa",
            injuries: "Lesiones (detalle y gravedad)"
          },
          recovery: {
            institution: {
              full_name: "Instituci\xF3n que recupera",
              identification: "CUIT de la instituci\xF3n",
              type: "Tipo de instituci\xF3n"
            },
            claimant_relationship: "V\xEDnculo del reclamante con la instituci\xF3n"
          }
        }
      },
      victim: {
        full_name: "Nombre completo del damnificado",
        first_name: "Nombre del damnificado",
        last_name: "Apellido del damnificado",
        identification_type: "Tipo de documento del damnificado",
        identification: "Documento del damnificado",
        address: "Domicilio del damnificado",
        city: "Localidad del damnificado",
        state: "Provincia del damnificado",
        zip_code: "C\xF3digo postal del damnificado",
        email: "Email del damnificado",
        phone: "Tel\xE9fono del damnificado",
        birth_date: "Fecha de nacimiento del damnificado",
        is_minor: "Damnificado menor de edad",
        is_deceased: "Damnificado fallecido",
        parents: {
          father: {
            full_name: "Nombre del padre del damnificado",
            identification: "Documento del padre del damnificado"
          },
          mother: {
            full_name: "Nombre de la madre del damnificado",
            identification: "Documento de la madre del damnificado"
          }
        },
        representatives: "Representantes del damnificado"
      },
      claimant: {
        full_name: "Nombre completo del reclamante",
        first_name: "Nombre del reclamante",
        last_name: "Apellido del reclamante",
        identification_type: "Tipo de documento del reclamante",
        identification: "Documento del reclamante",
        address: "Domicilio del reclamante",
        city: "Localidad del reclamante",
        state: "Provincia del reclamante",
        zip_code: "C\xF3digo postal del reclamante",
        email: "Email del reclamante",
        phone: "Tel\xE9fono del reclamante",
        relationship: "V\xEDnculo del reclamante con el damnificado",
        relationship_other: "Otro v\xEDnculo del reclamante",
        is_victim: "El reclamante es el damnificado"
      },
      lawyer: {
        full_name: "Nombre completo del abogado",
        first_name: "Nombre del abogado",
        last_name: "Apellido del abogado",
        identification_type: "Tipo de documento del abogado",
        identification: "Documento del abogado",
        address: "Domicilio del abogado",
        city: "Localidad del abogado",
        state: "Provincia del abogado",
        zip_code: "C\xF3digo postal del abogado",
        email: "Email del abogado",
        phone: "Tel\xE9fono del abogado",
        kind: "Tipo de abogado",
        cuit: "CUIT del abogado"
      },
      heirs: {
        count: "Cantidad de herederos",
        list: "Herederos (nombre, v\xEDnculo y documento)",
        names: "Nombres de los herederos"
      },
      insured: {
        full_name: "Nombre del asegurado",
        identification: "Documento del asegurado",
        address: "Domicilio del asegurado",
        city: "Localidad del asegurado",
        state: "Provincia del asegurado",
        policy_number: "N\xFAmero de p\xF3liza"
      },
      insured_vehicle: {
        license_plate: "Patente del veh\xEDculo asegurado",
        description: "Veh\xEDculo asegurado",
        make: "Marca del veh\xEDculo asegurado",
        model: "Modelo del veh\xEDculo asegurado",
        year: "A\xF1o del veh\xEDculo asegurado"
      },
      sinister: {
        number: "N\xFAmero de siniestro",
        date: "Fecha del siniestro",
        date_long: "Fecha del siniestro en letras",
        address: "Lugar del siniestro",
        city: "Localidad del siniestro",
        state: "Provincia del siniestro"
      },
      offer: {
        amount: "Importe ofrecido",
        amount_in_words: "Importe ofrecido en letras",
        amount_in_words_declared: "Importe en letras declarado en el ofrecimiento",
        installments: "Cantidad de cuotas",
        fee_percentage: "Porcentaje de honorarios",
        payment_days: "Plazo de pago (d\xEDas)",
        public_reason: "Motivo del ofrecimiento",
        sent_at: "Fecha de env\xEDo del ofrecimiento",
        accepted_at: "Fecha de aceptaci\xF3n"
      },
      payment: {
        fees_amount: "Importe de honorarios",
        fees_amount_in_words: "Importe de honorarios en letras",
        total_amount: "Importe total a pagar",
        installment_amount: "Importe de cada cuota",
        installment_amount_in_words: "Importe de cada cuota en letras"
      },
      acceptance: {
        payment_method: "Medio de pago",
        cbu: "CBU del tercero",
        cuit: "CUIT del tercero",
        lawyer_cbu: "CBU del letrado",
        lawyer_cuit: "CUIT del letrado",
        identification: "Documento declarado al aceptar"
      },
      document: {
        date: "Fecha del documento",
        date_short: "Fecha del documento (corta)"
      }
    },
    lawyer_kind: {
      attorney_in_fact: "Abogado apoderado",
      attorney_representative: "Abogado patrocinante"
    },
    boolean: {
      yes: "S\xED",
      no: "No"
    },
    parents: {
      father: "Padre",
      mother: "Madre"
    },
    person_damage_kind: {
      injury: "Lesiones",
      death: "Fallecimiento"
    },
    victim_role: {
      pedestrian: "Peat\xF3n",
      driver: "Conductor del veh\xEDculo tercero",
      rider: "Transportado en el veh\xEDculo tercero",
      policyholder_rider: "Transportado en el veh\xEDculo asegurado"
    },
    material_damage_summary: {
      vehicle: "veh\xEDculo {{description}}",
      vehicle_with_plate: "veh\xEDculo {{description}}, dominio {{license_plate}}",
      real_property: "inmueble sito en {{address}}",
      real_property_with_city: "inmueble sito en {{address}}, {{city}}"
    },
    reasons: {
      empty_field: "Dato vac\xEDo",
      no_selected_external_complaint: "Sin denuncia seleccionada",
      acceptance_unknown: "Sin aceptaci\xF3n",
      not_provided: "No informado al aceptar",
      invalid_value: "Valor inv\xE1lido",
      out_of_range: "Fuera de rango",
      unsupported_currency: "Moneda no soportada",
      unknown_state_code: "Provincia desconocida",
      no_claimant: "Sin reclamante",
      lawyer_identification_not_cuit: "El abogado no tiene CUIT cargado",
      birth_date_missing: "Sin fecha de nacimiento",
      representative_unknown: "Sin representante cargado",
      legal_person: "Persona jur\xEDdica",
      no_lawyer: "Sin abogado",
      no_parents: "Sin padres cargados",
      not_represented: "No requiere representaci\xF3n",
      no_heirs: "Sin herederos",
      no_installments: "Sin cuotas",
      no_fees: "Sin honorarios",
      no_binding: "Sin variable vinculada",
      ambiguous_binding: "M\xE1s de una variable coincide",
      hidden_by_condition: "Oculta por condici\xF3n",
      unprintable: "No imprimible (archivo)",
      draft_offer: "Ofrecimiento en borrador",
      no_material_damage: "Sin da\xF1o material",
      no_person_damage: "Sin da\xF1o a la persona",
      no_recovery_damage: "Sin recupero",
      no_vehicle: "El da\xF1o material no es un veh\xEDculo",
      no_real_property: "El da\xF1o material no es un inmueble",
      no_driver: "Sin conductor cargado",
      no_insurance: "Sin seguro cargado",
      no_injury_details: "Sin detalle de lesiones",
      not_policyholder_rider: "No viajaba en el veh\xEDculo asegurado",
      not_requested: "No se le pide al reclamante",
      no_public_reason: "El ofrecimiento se envi\xF3 sin motivo",
      no_offer: "El reclamo no tiene ofrecimiento",
      no_claim_type: "El reclamo no tiene tipo asignado"
    },
    warnings: {
      multiple_principal_claimants: "Hay m\xE1s de un reclamante principal",
      principal_fallback_positional: "Reclamante principal elegido por orden de carga",
      multiple_lawyers: "Hay m\xE1s de un abogado",
      heirs_without_death: "Hay herederos sin fallecimiento",
      parents_without_minor: "Padres cargados con damnificado mayor",
      owner_not_a_claimant: "El due\xF1o del reclamo no coincide con ning\xFAn reclamante",
      claimant_victim_mismatch: "El reclamante principal y el damnificado no coinciden en DNI o email (reclamo en nombre propio)",
      relationship_null: "Reclamante sin v\xEDnculo",
      relationship_other_free_text: "V\xEDnculo en texto libre",
      sinister_date_mismatch: "La fecha del siniestro difiere de la ocurrencia",
      invalid_cbu_format: "CBU con formato inv\xE1lido",
      invalid_cuit_checksum: "CUIT con d\xEDgito verificador inv\xE1lido",
      bank_fields_swapped: "CBU y CUIT parecen intercambiados",
      amount_in_words_mismatch: "El importe en letras declarado no coincide con el calculado",
      currency_differs_from_company_default: "La moneda difiere de la de la compa\xF1\xEDa",
      binding_matched_by_normalization: "Variable vinculada por nombre normalizado",
      ambiguous_binding: "Vinculaci\xF3n ambigua",
      definitions_not_snapshotted: "El ofrecimiento no tiene definiciones de variables",
      unknown_select_option: "Opci\xF3n no reconocida",
      dynamic_key_collision: "Dos variables generan la misma clave",
      multiple_damages_of_same_type: "Hay m\xE1s de un da\xF1o del mismo tipo: se usa el primero cargado",
      multiple_rules_matched: "M\xE1s de una regla coincide con el reclamo: se aplic\xF3 la de mayor prioridad",
      external_complaint_inferred: "La denuncia del asegurado se tom\xF3 del siniestro por la patente del reclamo",
      external_complaint_unmatched: "El siniestro tiene denuncias con asegurado pero ninguna coincide con la patente del reclamo",
      claim_type_damages_mismatch: "Los da\xF1os cargados no coinciden con la composici\xF3n del tipo de reclamo"
    },
    claimant_victim_identity: {
      identification_mismatch: "El DNI del reclamante principal no coincide con el del damnificado (reclamo en nombre propio)",
      email_mismatch: "El email del reclamante principal no coincide con el del damnificado (reclamo en nombre propio)",
      identification_and_email_mismatch: "El DNI y el email del reclamante principal no coinciden con los del damnificado (reclamo en nombre propio)",
      identification_missing_on_victim: "Falta el DNI del damnificado (reclamo en nombre propio)",
      identification_missing_on_claimant: "Falta el DNI del reclamante principal (reclamo en nombre propio)",
      identification_missing_on_both: "Falta el DNI del damnificado y del reclamante principal (reclamo en nombre propio)",
      email_missing_on_victim: "Falta el email del damnificado (reclamo en nombre propio)",
      email_missing_on_claimant: "Falta el email del reclamante principal (reclamo en nombre propio)",
      email_missing_on_both: "Falta el email del damnificado y del reclamante principal (reclamo en nombre propio)"
    },
    claim_classification: {
      material: "Da\xF1os materiales",
      material_vehicle_with_license_plate: "Veh\xEDculo con patente",
      material_vehicle_without_license_plate: "Veh\xEDculo sin patente",
      person_injury: "Lesiones",
      material_and_person_injury: "Da\xF1os materiales y lesiones",
      person_death: "Fallecimiento",
      material_real_property: "Inmueble",
      claimant_worker_compensation_insurer: "Reclamo de ART",
      material_and_person_death: "Da\xF1os materiales y fallecimiento",
      recovery: "Recupero"
    },
    person_kind: {
      natural_person: "Persona f\xEDsica",
      legal_person: "Persona jur\xEDdica"
    },
    currency: {
      ARS: "Pesos",
      USD: "D\xF3lares",
      EUR: "Euros",
      PYG: "Guaran\xEDes"
    },
    sub_damage_type: {
      vehicle: "Veh\xEDculo",
      real_property: "Inmueble",
      injury: "Lesiones",
      death: "Fallecimiento",
      recovery: "Recupero"
    },
    entity_damaged_category: {
      with_license_plate: "con patente",
      without_license_plate: "sin patente"
    },
    signatureMethods: {
      digital: "Firma digital",
      in_person: "Firma presencial"
    },
    signatureOutcomes: {
      selected: "M\xE9todo de firma decidido",
      undetermined: "M\xE9todo de firma pendiente",
      unresolved: "Sin m\xE9todo de firma"
    },
    attributeGroups: {
      claim: "Reclamo",
      offer: "Ofrecimiento",
      acceptance: "Aceptaci\xF3n"
    },
    attributes: {
      claim: {
        claim_type_id: "Tipo de reclamo",
        classification: "Clasificaci\xF3n del reclamo",
        damage_types: "Tipos de da\xF1o",
        person_damage_types: "Tipos de da\xF1o a la persona",
        material_damage_types: "Tipos de da\xF1o material",
        victim_kind: "Tipo de damnificado",
        victim_is_minor: "El damnificado es menor",
        victim_is_deceased: "El damnificado falleci\xF3",
        victim_has_parents: "El damnificado tiene padres cargados",
        claimants_count: "Cantidad de reclamantes",
        claimant_relationship: "V\xEDnculo del reclamante principal",
        claimant_relationships: "V\xEDnculos de los reclamantes",
        claimant_is_victim: "El reclamante es el damnificado",
        has_lawyer: "Tiene abogado",
        lawyer_kind: "Tipo de abogado",
        lawyer_count: "Cantidad de abogados",
        heirs_count: "Cantidad de sucesores",
        has_external_complaint: "Tiene denuncia del asegurado",
        team_id: "Grupo responsable",
        responsible_user_id: "Responsable"
      },
      offer: {
        message_template_id: "Plantilla del ofrecimiento",
        amount: "Importe ofrecido",
        currency: "Moneda",
        installments: "Cantidad de cuotas",
        fee_percentage: "Porcentaje de honorarios",
        payment_days: "Plazo de pago en d\xEDas",
        has_installments: "Se ofrece en cuotas",
        has_fees: "Incluye honorarios",
        variable: "Variable del ofrecimiento"
      },
      acceptance: {
        complete: "La aceptaci\xF3n est\xE1 completa",
        payment_method: "M\xE9todo de pago",
        has_lawyer_bank_data: "Tiene datos bancarios del abogado",
        variable: "Variable de la aceptaci\xF3n"
      }
    },
    operators: {
      eq: "es igual a",
      ne: "es distinto de",
      in: "es alguno de",
      not_in: "no es ninguno de",
      gt: "es mayor que",
      gte: "es mayor o igual que",
      lt: "es menor que",
      lte: "es menor o igual que",
      contains_any: "incluye alguno de",
      contains_all: "incluye todos",
      contains_none: "no incluye ninguno de",
      is_empty: "est\xE1 vac\xEDo",
      exists: "existe"
    },
    planOutcomes: {
      selected: "Conformidad seleccionada",
      blocked: "Regla sin documento",
      no_match: "Ninguna regla aplica",
      undetermined: "Falta informaci\xF3n",
      disabled: "Automatizaci\xF3n apagada"
    },
    planReasons: {
      automation_disabled: "La conformidad autom\xE1tica est\xE1 apagada para esta compa\xF1\xEDa",
      no_rules_configured: "La compa\xF1\xEDa todav\xEDa no tiene reglas habilitadas",
      no_rule_matched: "Ninguna regla habilitada coincide con el reclamo",
      pending_acceptance: "Se decide cuando el reclamante acepte el ofrecimiento",
      missing_context_data: "Falta un dato del reclamo para evaluar una regla",
      template_not_published: "La plantilla de la regla no tiene una versi\xF3n publicada",
      template_deleted: "La plantilla de la regla fue eliminada",
      pending_offer: "Se decide cuando exista el ofrecimiento"
    },
    conditionResults: {
      true: "Se cumple",
      false: "No se cumple",
      undetermined: "Indeterminada"
    },
    ruleResults: {
      match: "Coincide",
      no_match: "No coincide",
      undetermined: "Indeterminada"
    },
    undeterminedReasons: {
      unknown_value: "El reclamo no tiene ese dato cargado",
      pending_acceptance: "Depende de la aceptaci\xF3n, que todav\xEDa no ocurri\xF3",
      unknown_variable: "Ninguna plantilla del ofrecimiento define esa variable",
      pending_offer: "Depende del ofrecimiento, que todav\xEDa no existe"
    },
    recipientReasons: {
      no_claimant: "El reclamo no tiene reclamante cargado",
      no_lawyer: "El reclamo no tiene abogado",
      no_heirs: "El reclamo no tiene tantos sucesores",
      no_name: "La persona no tiene nombre cargado",
      no_email: "La persona no tiene email y la firma es digital",
      company_sender_unavailable: "La cuenta remitente de la compa\xF1\xEDa todav\xEDa no se configura"
    },
    gapKinds: {
      variable: "Variable",
      signer: "Recuadro de firma",
      signature: "M\xE9todo de firma"
    },
    gapClasses: {
      pending: "Lo completa el reclamante al aceptar",
      absent: "Falta en el reclamo",
      not_applicable: "No corresponde a este caso",
      unknown_key: "Variable desconocida"
    },
    placeholder: {
      pending: "{{label}} (lo completa el reclamante)",
      absent: "{{label}} (faltante)",
      unknown_key: "{{key}} (variable desconocida)"
    },
    templateKinds: {
      agreement: "Conformidad",
      offer_message: "Mensaje de ofrecimiento"
    },
    termsSources: {
      typed: "T\xE9rminos tipados del ofrecimiento",
      bindings: "Variables de la plantilla por nombre",
      none: "Sin ofrecimiento"
    },
    messagePreview: {
      title: "As\xED lo ver\xE1 el reclamante"
    },
    wizardModes: {
      guided: "Guiado por reglas",
      legacy: "Plantilla manual"
    },
    legacyReasons: {
      automation_disabled: "La automatizaci\xF3n est\xE1 apagada para esta compa\xF1\xEDa",
      offer_message_missing: "La compa\xF1\xEDa todav\xEDa no eligi\xF3 su mensaje de ofrecimiento",
      offer_message_not_published: "El mensaje de ofrecimiento no tiene versi\xF3n publicada"
    },
    ruleIssues: {
      template_not_published: "La plantilla no tiene versi\xF3n publicada",
      template_deleted: "La plantilla fue eliminada",
      unknown_condition_variable: "Una condici\xF3n usa una variable que ya no existe",
      unknown_condition_option: "Una condici\xF3n usa un tipo de reclamo, plantilla, grupo o responsable que ya no existe",
      unknown_scope_template: "El alcance nombra una plantilla eliminada"
    },
    dispatch: {
      transaction_name: "Conformidad \xB7 Reclamo {{ref}}",
      transaction_description: "Transacci\xF3n de firma de la conformidad",
      notification: "No se pudo enviar a firmar la conformidad {{name}}: {{reason}}",
      failure: {
        signature_disabled: "La firma digital de la compa\xF1\xEDa est\xE1 apagada. Cuando se vuelva a encender, se puede reintentar.",
        claim_closed: "El reclamo est\xE1 cerrado.",
        sender_unavailable: "El tramitador que la enviaba ya no est\xE1 en la compa\xF1\xEDa. Otro tramitador puede reintentar con su cuenta de AutoSign.",
        sender_connection_missing: "El remitente no tiene su cuenta de AutoSign conectada.",
        sender_connection_reconnect_required: "La cuenta de AutoSign del remitente dej\xF3 de funcionar: hay que volver a conectarla.",
        document_unavailable: "El documento final no est\xE1 listo para enviarse.",
        document_mismatch: "El PDF guardado no coincide con el que se imprimi\xF3, as\xED que no se env\xEDa.",
        document_too_large: "El PDF supera el tama\xF1o que acepta AutoSign.",
        recipient_unresolved: "Un recuadro de firma obligatorio no tiene a qui\xE9n envi\xE1rselo.",
        recipient_without_email: "Un firmante obligatorio no tiene un email v\xE1lido.",
        anchor_missing: "El PDF no trae el lugar de una firma obligatoria.",
        no_signers: "El documento no tiene recuadros de firma para enviar.",
        notification_endpoint_too_long: "La direcci\xF3n de avisos para AutoSign supera el largo permitido.",
        provider_rejected: "AutoSign rechaz\xF3 el pedido.",
        provider_document_failed: "AutoSign no pudo procesar el PDF.",
        provider_start_unconfirmed: "AutoSign no confirm\xF3 si la solicitud sali\xF3 desde la cuenta anterior. Solo esa cuenta puede comprobarlo, as\xED que el reintento tiene que hacerse desde ella.",
        provider_unavailable: "AutoSign no respondi\xF3. Se reintenta solo.",
        provider_document_processing: "AutoSign sigue procesando el PDF. Se reintenta solo.",
        provider_transaction_missing: "La solicitud ya no existe en AutoSign. Se arma otra en el pr\xF3ximo intento.",
        unexpected_error: "Algo fall\xF3 al enviar. Se reintenta solo."
      }
    },
    signatureOrigin: {
      label: "Firma del reclamante",
      piramid_after_acceptance: "En Piramid, al aceptar el ofrecimiento",
      piramid_signing_cta: "En Piramid, desde el reclamo",
      external: "Fuera de Piramid"
    }
  },
  acceptancePayee: {
    cases: {
      victim: "Los datos de cobro deben corresponder al damnificado del reclamo.",
      minor_victim: "El damnificado es menor de edad. La cuenta de cobro debe corresponder al padre o a la madre.",
      deceased_victim: "La cuenta de cobro debe corresponder a uno de los herederos.",
      legal_person_victim: "Los datos de cobro deben corresponder a la empresa damnificada."
    },
    attorney_case: "El reclamo corresponde al damnificado con DNI {{document}}.",
    account_subtitle: "Cuenta donde se depositar\xE1 la indemnizaci\xF3n",
    payee_block_title: "Datos del damnificado",
    payee_block_hint: "D\xF3nde vas a recibir la transferencia.",
    lawyer_block_title: "Datos del letrado",
    lawyer_block_hint: "Cuenta de tu abogado. Los honorarios se transfieren por separado.",
    prefilled_hint: "Este dato viene del reclamo. Si es incorrecto, contact\xE1 al tramitador.",
    submit: "Enviar datos y aceptar el ofrecimiento",
    lawyer: {
      unnamed: "Abogado del reclamo",
      kinds: {
        attorney_in_fact: "Abogado apoderado",
        attorney_representative: "Abogado patrocinante"
      }
    },
    placeholders: {
      identification: "Ingres\xE1 el documento",
      cbu: "Ingres\xE1 el CBU",
      cuit: "Ingres\xE1 el CUIT",
      lawyer_cbu: "Ingres\xE1 el CBU del letrado",
      lawyer_cuit: "Ingres\xE1 el CUIT del letrado"
    },
    errors: {
      exact_length: "Tiene que tener {{length}} d\xEDgitos.",
      length_range: "Tiene que tener entre {{min}} y {{max}} d\xEDgitos.",
      interbanking: "No pudimos validar la cuenta. Asegurate de que el CUIT y el CBU sean correctos y pertenezcan a la misma persona."
    },
    relations: {
      victim: "Damnificado",
      father: "Padre",
      mother: "Madre",
      heir: "Heredero",
      tutor_curator: "Tutor o curador",
      legal_representative: "Representante legal"
    },
    issues: {
      payee_cuit_invalid: "El CUIT ingresado no es v\xE1lido. Revis\xE1 los d\xEDgitos.",
      payee_cuit_does_not_match_identification: "El CUIT no corresponde al DNI ingresado.",
      payee_identification_not_a_candidate: "El DNI ingresado no corresponde a ninguna de las personas que pueden cobrar este reclamo.",
      payee_cuit_not_a_candidate: "El CUIT ingresado no corresponde a ninguna de las personas que pueden cobrar este reclamo.",
      payee_unresolved: "No podemos validar los datos de cobro de este reclamo. Contact\xE1 a la aseguradora.",
      payee_cuit_not_attorney: "La indemnizaci\xF3n se deposita en la cuenta del abogado apoderado: el CUIT tiene que ser el suyo.",
      lawyer_cuit_does_not_match: "El CUIT ingresado no corresponde al abogado asociado al reclamo.",
      lawyer_cuit_unavailable: "El abogado registrado en tu reclamo no tiene CUIT cargado. Contact\xE1 a la aseguradora.",
      lawyer_identification_not_cuit: "El abogado registrado en tu reclamo no tiene CUIT cargado. Contact\xE1 a la aseguradora."
    },
    blockers: {
      payee_unresolved: "El reclamo no permite determinar qui\xE9n puede cobrar. Revis\xE1 el damnificado: su documento y su fecha de nacimiento, y si es menor o falleci\xF3, que est\xE9n cargados el padre y la madre o los herederos.",
      lawyer_cuit_unavailable: "El abogado del reclamo no tiene CUIT cargado. Sin CUIT el reclamante no va a poder completar los datos del letrado.",
      payee_cuit_invalid: "El CUIT declarado no es v\xE1lido.",
      payee_cuit_does_not_match_identification: "El CUIT declarado no corresponde al DNI.",
      payee_identification_not_a_candidate: "El DNI declarado no corresponde a nadie del reclamo.",
      payee_cuit_not_a_candidate: "El CUIT declarado no corresponde a nadie del reclamo.",
      payee_cuit_not_attorney: "El CUIT declarado no es el del abogado apoderado.",
      lawyer_cuit_does_not_match: "El CUIT del letrado no corresponde al abogado del reclamo."
    }
  },
  embeddedSigning: {
    notice: "Al aceptar vas a poder firmar la conformidad en esta misma pantalla.",
    accepted: "Aceptaste el ofrecimiento",
    preparing: {
      title: "Estamos preparando tu conformidad",
      description: "En unos segundos vas a poder revisarla y firmarla ac\xE1 mismo. No cierres esta p\xE1gina.",
      slow: "Est\xE1 tardando un poco m\xE1s de lo habitual. Seguimos trabajando.",
      stages: {
        document: "Generando el documento",
        dispatch: "Prepar\xE1ndolo para la firma"
      }
    },
    ready: {
      title: "Revis\xE1 y firm\xE1 tu conformidad",
      description: "Le\xE9 el documento y firmalo al final. Cuando termines, haz click en Enviar y esta pantalla se actualizar\xE1 sola.",
      frameTitle: "Firma de la conformidad"
    },
    signed: {
      title: "\xA1Listo! Firmaste la conformidad",
      description: "Te vamos a avisar cuando la firmen todas las partes."
    },
    fallback: {
      description: "Te vamos a mandar un email de AutoSign para que firmes la conformidad."
    }
  },
  agreementSigning: {
    cta: "Firmar conformidad",
    back: "Volver a los ofrecimientos",
    unavailable: {
      title: "No pod\xE9s firmar la conformidad desde ac\xE1",
      description: "Pod\xE9s firmarla desde el email que te mand\xF3 AutoSign.",
      otherSigner: "Esta conformidad la firma otra persona. Si sos vos, ingres\xE1 con el email al que te lleg\xF3 la solicitud de firma de AutoSign."
    }
  },
  paymentMethods: {
    transfer: "transferencia"
  },
  providers: {
    autosign: "Autosign"
  }
};
var orders = {
  status: {
    pending: "Pendiente",
    in_progress: "En curso",
    completed: "Finalizada",
    rejected: "Rechazada",
    canceled: "Anulada"
  },
  progress: {
    title: "Progreso de la orden",
    stage: {
      created: "Solicitud",
      accepted: "Respuesta",
      scheduling: "Coordinaci\xF3n turno",
      work_proof: "Inspecci\xF3n",
      documentation: "Documentaci\xF3n",
      completed: "Finalizada"
    },
    status: {
      done: "Completada",
      awaiting_provider: {
        insurer: "Espera al proveedor",
        provider: "Es tu turno",
        customer: "En curso"
      },
      awaiting_insurer: {
        insurer: "Tenes que revisar",
        provider: "En revisi\xF3n",
        customer: "En revisi\xF3n"
      },
      in_progress: "En proceso",
      rejected: "Rechazada",
      blocked: "Bloqueada",
      unreachable: "No corresponde",
      canceled: "Anulada"
    },
    statusByStage: {
      scheduling: {
        done: "Coordinado",
        awaiting_provider: "Falta coordinar"
      },
      work_proof: {
        rejected: "No completada",
        awaiting_insurer: "Falta crearla"
      },
      documentation: {
        done: "Completa",
        rejected: "Con rechazos"
      }
    },
    verdict: {
      approved: "Aprobada",
      disapproved: "Desaprobada",
      error: "Sin veredicto"
    },
    openAttempt: {
      pending_capture: {
        insurer: "Nuevo intento pendiente de captura",
        provider: "Ten\xE9s un nuevo intento para capturar",
        customer: "Nuevo intento en curso"
      },
      capturing: {
        insurer: "Nuevo intento en captura",
        provider: "Est\xE1s capturando un nuevo intento",
        customer: "Nuevo intento en curso"
      },
      processing: {
        insurer: "Nuevo intento en an\xE1lisis",
        provider: "Nuevo intento en an\xE1lisis",
        customer: "Nuevo intento en curso"
      }
    },
    scheduledFor: "Trabajo previsto: {{at}}",
    waitingOn: {
      provider: "Depende del proveedor",
      insurer: "Depende de la aseguradora",
      external: "Depende de Autoinspector"
    },
    next: {
      accepted: {
        awaiting_provider: {
          insurer: "Esperando que el proveedor acepte la orden.",
          provider: "Ten\xE9s que aceptar o rechazar la orden."
        }
      },
      scheduling: {
        awaiting_provider: {
          insurer: "Esperando que el proveedor coordine cu\xE1ndo se realiza el trabajo.",
          provider: "Ten\xE9s que coordinar cu\xE1ndo se realiza el trabajo antes de hacerlo."
        }
      },
      work_proof: {
        awaiting_provider: {
          insurer: "Esperando que el proveedor capture la inspecci\xF3n.",
          provider: "Te falta capturar la inspecci\xF3n."
        },
        awaiting_insurer: {
          insurer: "La orden requiere prueba de trabajo y todav\xEDa no hay inspecci\xF3n: creala para poder finalizar.",
          provider: "La aseguradora todav\xEDa tiene que crear la inspecci\xF3n."
        },
        rejected: {
          insurer: "La inspecci\xF3n no se complet\xF3 (bloqueada o vencida): cre\xE1 una nueva para poder finalizar.",
          provider: "La inspecci\xF3n no se complet\xF3: la aseguradora tiene que generar una nueva."
        },
        in_progress: "La inspecci\xF3n se est\xE1 analizando."
      },
      documentation: {
        awaiting_provider: {
          insurer: "Esperando que el proveedor cargue la documentaci\xF3n requerida.",
          provider: "Te falta cargar documentaci\xF3n requerida de la orden."
        },
        awaiting_insurer: {
          insurer: "Ten\xE9s documentaci\xF3n requerida por cargar o revisar.",
          provider: "Est\xE1s esperando que la aseguradora complete o revise la documentaci\xF3n."
        },
        rejected: {
          insurer: "Rechazaste un documento: esperando que el proveedor suba una nueva versi\xF3n.",
          provider: "Un documento fue rechazado: ten\xE9s que subir una nueva versi\xF3n."
        }
      },
      completed: {
        awaiting_insurer: {
          insurer: "Todo listo: pod\xE9s finalizar la orden.",
          provider: "Todo listo: falta que la aseguradora finalice la orden."
        }
      }
    },
    outcome: {
      completed: "La orden est\xE1 finalizada.",
      rejected: "El proveedor rechaz\xF3 la orden.",
      canceled: "La aseguradora anul\xF3 la orden.",
      idle: "No hay acciones pendientes por el momento."
    },
    version: "Versi\xF3n {{ version }}",
    by: "por {{ actor }}"
  },
  actions: {
    accept: "Aceptar orden",
    reject: "Rechazar orden",
    cancel: "Anular",
    cancelTooltip: "Anular orden",
    complete: "Finalizar orden",
    reopen: "Reabrir orden",
    confirm: {
      accept: {
        title: "Aceptar orden de trabajo",
        description: "\xBFConfirm\xE1s que acept\xE1s esta orden? Pasar\xE1 a estar en curso.",
        action: "Aceptar orden"
      },
      reject: {
        title: "Rechazar orden de trabajo",
        description: "El rechazo es definitivo: no podr\xE1s revertirlo.",
        action: "Rechazar orden",
        label: "Motivo de rechazo"
      },
      cancel: {
        title: "Anular orden de trabajo",
        description: "La anulaci\xF3n es definitiva: no podr\xE1s revertirla.",
        action: "Anular orden",
        label: "Motivo de anulaci\xF3n"
      },
      complete: {
        title: "Finalizar orden de trabajo",
        description: "La orden se marcar\xE1 como finalizada. Pod\xE9s reabrirla despu\xE9s si hace falta corregir algo.",
        action: "Finalizar orden",
        workProof: {
          title: "Revis\xE1 la prueba de trabajo",
          disapproved: "La inspecci\xF3n que complet\xF3 la prueba de trabajo fue desaprobada por Autoinspector. Revis\xE1 la evidencia en la pesta\xF1a Inspecciones antes de finalizar.",
          error: "La inspecci\xF3n que complet\xF3 la prueba de trabajo termin\xF3 sin veredicto de Autoinspector. Revis\xE1 la evidencia en la pesta\xF1a Inspecciones antes de finalizar.",
          openAttempt: "Hay un nuevo intento de inspecci\xF3n todav\xEDa sin completar."
        }
      },
      reopen: {
        title: "Reabrir orden de trabajo",
        description: "La orden volver\xE1 a estar en curso para poder corregir su documentaci\xF3n o coordinaci\xF3n.",
        action: "Reabrir orden"
      }
    },
    reasonLabel: "Motivo",
    reasonPlaceholder: "Escrib\xED el motivo",
    back: "Volver",
    acceptSuccess: "Orden aceptada",
    rejectSuccess: "Orden rechazada",
    cancelSuccess: "Orden anulada",
    completeSuccess: "Orden finalizada",
    reopenSuccess: "Orden reabierta",
    refreshProgress: "Recalcular avance",
    refreshProgressSuccess: "Avance recalculado",
    refreshProgressUnchanged: "El avance ya estaba actualizado",
    downloadPdf: "Descargar PDF"
  },
  review: {
    actions: {
      accept: "Aceptar",
      reject: "Rechazar",
      undo: "Deshacer",
      back: "Volver"
    },
    reasonLabel: "Motivo de rechazo",
    reasonPlaceholder: "Escrib\xED el motivo del rechazo",
    gate: {
      orderNotInProgress: "La orden debe estar en curso para subir entregables.",
      workProofNotCompleted: "Falta una inspecci\xF3n de Autoinspector completada para poder finalizar la orden.",
      notScheduled: "Falta registrar la coordinaci\xF3n del trabajo: sin eso la orden no puede finalizarse.",
      documentationIncomplete: "Falta documentaci\xF3n requerida (cargarla o aprobarla): sin eso la orden no puede finalizarse.",
      mechanismIsInspection: "Esta orden demuestra el trabajo con una inspecci\xF3n de Autoinspector: no admite reportes.",
      mechanismIsReport: "Esta orden demuestra el trabajo con un reporte: no admite inspecciones."
    },
    document: {
      accept: {
        title: "Aprobar documento",
        description: "El documento quedar\xE1 como cumplido para la finalizaci\xF3n de la orden.",
        success: "Documento aprobado"
      },
      reject: {
        title: "Rechazar documento",
        description: "Para rechazar este documento, ingres\xE1 el motivo. El proveedor podr\xE1 subir una nueva versi\xF3n.",
        success: "Documento rechazado"
      },
      undo: {
        title: "Deshacer revisi\xF3n del documento",
        description: "El documento volver\xE1 a estado pendiente de revisi\xF3n.",
        success: "Revisi\xF3n deshecha"
      }
    }
  },
  "sub-types": {
    assessment: "Peritaci\xF3n",
    repair: "Reparaci\xF3n",
    investigation: "Investigaci\xF3n",
    parts: "Repuestos"
  },
  types: {
    purchase: "Compra",
    service: "Servicio"
  },
  derive: {
    trigger: "Crear orden",
    title: "Derivar orden de trabajo a un proveedor",
    description: "Eleg\xED el trabajo a realizar y la ubicaci\xF3n, y seleccion\xE1 un proveedor de tu red.",
    vertical: "Rubro",
    verticalPlaceholder: "Seleccion\xE1 un rubro",
    service: "Servicio",
    servicePlaceholder: "Seleccion\xE1 un servicio",
    good: "Bien",
    goodPlaceholder: "Seleccion\xE1 un bien",
    locality: "Localidad",
    localityPlaceholder: "Busc\xE1 una ubicaci\xF3n",
    groupFilter: "Grupo",
    groupPlaceholder: "Todos los grupos",
    clearGroup: "Quitar filtro",
    allGroups: "Todos",
    noGroups: "No se encontraron grupos",
    available: "Proveedores con cobertura en la zona",
    nearby: "Otros proveedores que realizan el trabajo",
    nearbyHint: "Estos proveedores no declararon cobertura en la zona seleccionada.",
    recommended: "Proveedores recomendados",
    distanceHint: "Ordenados por cercan\xEDa. Las distancias son aproximadas y se calculan en l\xEDnea recta al centro de la localidad base.",
    searchPlaceholder: "Busc\xE1 a tu proveedor",
    showNearbyPrompt: "\xBFNo encontr\xE1s al proveedor que busc\xE1s? Prob\xE1 buscar alguno con cobertura en otras zonas",
    hideNearby: "Ocultar",
    loadingCandidates: "Buscando proveedores...",
    noCandidates: "No se encontraron proveedores para esa selecci\xF3n.",
    selectedProvider: "Proveedor seleccionado",
    currentOrderNotice: {
      title: "Orden de trabajo vigente",
      cancel: "Cancelar",
      continue: "Continuar",
      becomes_current: "Tu empresa le muestra al reclamante el resumen de la orden de trabajo vigente (la m\xE1s reciente). Al crearla, esta orden pasar\xE1 a ser la vigente.",
      replaces_current: "Este reclamo ya tiene una orden de trabajo vigente y es la que ve el reclamante. Si cre\xE1s esta orden, pasar\xE1 a ser la vigente y reemplazar\xE1 a la actual."
    },
    nameLabel: "Descripci\xF3n de la orden",
    namePlaceholder: "Ej.: Parabrisas FIAT CRONOS 2022 (AC123DD)",
    descriptionLabel: "Informaci\xF3n adicional",
    descriptionPlaceholder: "Detall\xE1 cualquier tipo de informaci\xF3n adicional que sea relevante para el trabajo",
    notesLabel: "Notas",
    filesLabel: "Adjuntos",
    documentationStep: "Documentaci\xF3n",
    documentationOptional: "Documentaci\xF3n (opcional)",
    attachFromClaim: "Documentaci\xF3n del reclamo",
    attachFromComplaint: "Documentaci\xF3n de la denuncia",
    attachedCount: "Documentaci\xF3n compartida",
    skip: "Omitir",
    next: "Siguiente",
    review: "Siguiente",
    back: "Atr\xE1s",
    submit: "Crear orden",
    noResults: "No se encontraron resultados",
    successTitle: "Orden creada",
    successDescription: "La orden fue derivada al proveedor con \xE9xito."
  },
  items: {
    title: "Detalle de la orden",
    addLine: "Agregar \xEDtem",
    emptyPrefix: "No agregaste \xEDtems. Pod\xE9s dejar la orden sin \xEDtems, sumar",
    addProducts: "productos",
    emptyOr: "o cargar un",
    addCustom: "detalle personalizado",
    product: "Producto",
    productPlaceholder: "Busc\xE1 un producto",
    noProducts: "No se encontraron productos",
    description: "Descripci\xF3n",
    descriptionPlaceholder: "Detalle del \xEDtem",
    quantity: "Cantidad",
    unitPrice: "Precio unitario",
    subtotal: "Subtotal",
    amount: "Importe",
    priceOverridden: "Modificado \xB7 lista {{price}} \xB7 Restaurar",
    removeLine: "Quitar \xEDtem"
  },
  coverage: {
    title: "Cobertura",
    totalAmount: "Importe",
    coverageAmount: "Cobertura ",
    amountToCharge: "Importe neto",
    taxesPercent: "IVA",
    taxOptionNone: "Sin IVA",
    taxOptionLabel: "{{percent}}%",
    taxesAmount: "IVA ({{percent}}%)",
    totalWithTaxes: "Total"
  },
  scheduling: {
    tab: "Coordinaci\xF3n turno",
    title: "Coordinaci\xF3n turno",
    description: "Cu\xE1ndo est\xE1 previsto realizar el trabajo. Se acuerda antes de realizarlo, y la orden no puede finalizarse sin esta informaci\xF3n.",
    status: {
      scheduled: "Coordinado",
      pending: "Sin coordinar"
    },
    empty: "Todav\xEDa nadie registr\xF3 cu\xE1ndo se realiza el trabajo.",
    recordedBy: "Registrado por {{actor}} el {{at}}",
    saveSuccess: "Coordinaci\xF3n turno registrado",
    action: {
      create: "Registrar turno",
      edit: "Modificar",
      cancel: "Anular turno"
    },
    blocked: {
      order_not_accepted: "La orden todav\xEDa no fue aceptada: no hay nada que coordinar.",
      invalid_order_status: "La orden ya no est\xE1 en curso: no se puede modificar la coordinaci\xF3n.",
      claim_not_open: "El reclamo no admite cambios.",
      no_branches: "El proveedor no tiene sucursales cargadas: no hay lugar al que citar al reclamante.",
      not_scheduled: "No hay un turno coordinado para anular."
    },
    branch: {
      directions: "C\xF3mo llegar"
    },
    form: {
      date: "Fecha",
      time: "Hora",
      branch: "Sucursal",
      branchPlaceholder: "Eleg\xED a qu\xE9 sucursal debe ir el reclamante",
      note: "Nota (opcional)",
      notePlaceholder: "Franja horaria acordada, con qui\xE9n se habl\xF3, condiciones\u2026",
      notifyInsured: "Notificar al reclamante ({{email}})",
      notifyInsuredNoEmail: "El reclamante no tiene email cargado: no se le puede avisar.",
      submit: "Guardar"
    },
    insured: {
      title: "Datos del reclamante",
      empty: "No hay datos de contacto cargados."
    },
    history: {
      title: "Historial",
      status: {
        active: "Turno vigente para el {{at}}",
        superseded: "Turno del {{at}}, reemplazado por otro",
        canceled: "Turno del {{at}}, anulado"
      },
      atBranch: "En {{branch}} ({{provider}})",
      insuredNotified: "se avis\xF3 al reclamante",
      canceledBy: "Anulado por {{actor}} \u2014 {{at}}"
    },
    cancel: {
      title: "Anular el turno",
      description: "El turno del {{at}} queda sin efecto y la orden vuelve a quedar sin coordinar. Si ya se le avis\xF3 al reclamante, se le va a informar la anulaci\xF3n.",
      reason: "Motivo",
      reasonPlaceholder: "Por qu\xE9 se anula el turno\u2026",
      confirm: "Anular turno"
    },
    cancelSuccess: "Turno anulado"
  },
  workProof: {
    tab: "Inspecciones",
    title: "Inspecci\xF3n #{{id}}",
    listTitle: "Inspecciones realizadas",
    listDescription: "Inspecci\xF3n(es) de Autoinspector que validan el trabajo realizado. La orden puede finalizarse una vez que exista al menos una completada, aprobada o no.",
    config: {
      templateConfigured: "Plantilla configurada para prueba de trabajo",
      missingTitle: "Falta configurar la integraci\xF3n de Autoinspector",
      missingApiKey: "La compa\xF1\xEDa no tiene configurada la integraci\xF3n con Autoinspector.",
      missingTemplate: 'No hay una plantilla asignada al caso de uso "Prueba de trabajo".'
    },
    checkboxTemplate: "Plantilla configurada: {{name}}",
    blockedReason: {
      not_required: "Esta orden demuestra el trabajo con un reporte: la decisi\xF3n se toma al crearla y no se puede cambiar.",
      order_not_accepted: "El proveedor todav\xEDa no acept\xF3 la orden: la inspecci\xF3n se crea autom\xE1ticamente cuando la acepte.",
      not_configured: "La compa\xF1\xEDa no tiene configurada integraci\xF3n con Autoinspector.",
      template_not_assigned: 'No hay una plantilla asignada al caso de uso "Prueba de trabajo".',
      inspection_in_progress: "Ya hay una inspecci\xF3n en curso. Esper\xE1 su resultado para solicitar otra.",
      inspection_approved: "La prueba de trabajo ya est\xE1 aprobada.",
      invalid_order_status: "La orden ya est\xE1 cerrada: no se pueden solicitar inspecciones.",
      claim_not_open: "El reclamo no est\xE1 abierto."
    },
    status: {
      pending_capture: "Pendiente",
      capturing: "En curso",
      processing: "En an\xE1lisis",
      approved: "Aprobada",
      disapproved: "Desaprobada",
      error: "Ocurri\xF3 un error",
      blocked: "Bloqueada"
    },
    createdAt: "Creada",
    completedAt: "Analizada",
    empty: {
      insurer: 'No hay ninguna inspecci\xF3n para esta orden: la creaci\xF3n autom\xE1tica no se complet\xF3. Pod\xE9s crearla con "Crear inspecci\xF3n".',
      provider: "Todav\xEDa no hay ninguna inspecci\xF3n para esta orden. La aseguradora tiene que crearla.",
      awaitingAcceptanceInsurer: "La inspecci\xF3n se crear\xE1 autom\xE1ticamente cuando el proveedor acepte la orden.",
      awaitingAcceptanceProvider: "La inspecci\xF3n se crear\xE1 cuando aceptes la orden.",
      notRequired: "Esta orden demuestra el trabajo realizado con un reporte, as\xED que no lleva inspecciones."
    },
    refresh: "Actualizar",
    refreshSuccess: "Estado actualizado",
    viewDetail: "Ver inspecci\xF3n",
    detailTitle: "Detalle de la inspecci\xF3n",
    detailDescription: "Detalle provisto por Autoinspector.",
    openInspection: "Abrir inspecci\xF3n",
    copyLink: "Copiar link",
    linkCopied: "Link copiado",
    qrHint: "Escane\xE1 el c\xF3digo para capturar la evidencia desde tu tel\xE9fono.",
    accessCode: "C\xF3digo de acceso",
    history: "Historial de inspecciones",
    create: {
      trigger: "Crear inspecci\xF3n",
      title: "Crear inspecci\xF3n",
      description: "Se crear\xE1 una nueva inspecci\xF3n en Autoinspector y el proveedor deber\xE1 capturar la evidencia.",
      action: "Crear inspecci\xF3n",
      cancel: "Cancelar",
      success: "Inspecci\xF3n creada"
    },
    report: {
      trigger: "Ver informe",
      title: "Informe de la inspecci\xF3n",
      description: "Informe en PDF de la inspecci\xF3n realizada.",
      openInNewTab: "Abrir en una pesta\xF1a nueva",
      retry: "Reintentar",
      loadError: "No pudimos consultar el estado del informe. Volv\xE9 a intentarlo en unos minutos.",
      status: {
        unavailable: "Todav\xEDa no hay informe para mostrar de esta inspecci\xF3n.",
        generating: "Estamos generando el informe. Puede tardar unos segundos.",
        failed: "No pudimos generar el informe de esta inspecci\xF3n. La aseguradora puede volver a pedirlo desde su panel."
      }
    }
  },
  vehicle: {
    make: "Marca",
    model: "Modelo",
    version: "Versi\xF3n",
    year: "A\xF1o",
    licensePlate: "Patente"
  },
  table: {
    title: "\xD3rdenes de trabajo",
    description: "Lista de \xF3rdenes de trabajo derivadas a tu empresa",
    entityLabel: "\xF3rdenes",
    searchPlaceholder: "Buscar por N\xB0 de orden o descripci\xF3n",
    searchTooltip: "Busca por n\xFAmero de orden o descripci\xF3n de la orden",
    insurerSearchPlaceholder: "Buscar por N\xB0 de orden, descripci\xF3n o reclamo",
    insurerSearchTooltip: "Busca por n\xFAmero de orden, descripci\xF3n de la orden o n\xFAmero de reclamo",
    columns: {
      reference: "Orden",
      derivedAt: "Fecha derivaci\xF3n",
      completedAt: "Fecha finalizaci\xF3n",
      claimRef: "N\xB0 reclamo",
      externalClaimRef: "N\xB0 reclamo externo",
      provider: "Proveedor",
      name: "Descripci\xF3n de la orden",
      service: "Servicio",
      good: "Bien",
      company: "Empresa",
      derivedBy: "Derivado por",
      status: "Estado",
      stage: "Etapa",
      nextAction: "Pr\xF3xima acci\xF3n",
      acceptedAt: "Fecha aceptaci\xF3n",
      totalAmount: "Importe",
      totalWithTaxes: "Importe final"
    }
  },
  mechanism: {
    checkboxLabel: "Incluir prueba de trabajo con Autoinspector",
    autoNotice: "Esta orden incluir\xE1 la prueba de trabajo con Autoinspector. Para finalizarla, el proveedor tiene que completar la inspecci\xF3n.",
    autoNoticeHint: "La inspecci\xF3n se crea cuando el proveedor acepta la orden, y la orden puede finalizarse una vez que la inspecci\xF3n est\xE9 completada.",
    reportNotice: "Esta orden va a demostrar el trabajo con un reporte del proveedor",
    checkboxHint: "La inspecci\xF3n se crea cuando el proveedor acepta la orden, y la orden puede finalizarse una vez completada. Sin ella, el trabajo se demuestra con un reporte del proveedor.",
    summary: "Prueba del trabajo",
    report: {
      label: "Reporte del proveedor"
    },
    inspection: {
      label: "Inspecci\xF3n con Autoinspector"
    },
    notice: {
      report: "Esta orden demuestra el trabajo realizado con un reporte, as\xED que no usa inspecciones. Esta secci\xF3n queda solo para consulta.",
      inspection: "Esta orden demuestra el trabajo realizado con una inspecci\xF3n de Autoinspector, as\xED que no usa reportes. Esta secci\xF3n queda solo para consulta."
    }
  },
  pendingSide: {
    provider: "Proveedor",
    insurer: "Aseguradora"
  },
  inbox: {
    title: "\xD3rdenes que requieren tu atenci\xF3n",
    count: "{{count}} pendientes",
    awaitingProvider: "{{count}} esperando al proveedor",
    empty: "No hay \xF3rdenes esperando una acci\xF3n tuya.",
    seeAll: "Ver todas las \xF3rdenes"
  }
};
var variable = {
  value: {
    reference: {
      judicial_amount_times_percentage_of_liability: "Monto Judicial x % de Responsabilidad"
    },
    type: {
      reference: "Referencia",
      literal: "Literal"
    }
  },
  types: {
    text: "Texto",
    numeric: "Num\xE9rico",
    select: "Selecci\xF3n",
    file: "Archivo"
  },
  determination: {
    compile_time: "Compilaci\xF3n",
    runtime: "En tiempo de ejecuci\xF3n"
  }
};
var inhouse_lawyer = {
  status: {
    pending: "Pendiente",
    registered: "Registrado"
  },
  name: "Nombre",
  email: "Correo",
  create: {
    trigger: "Agregar abogado interno",
    title: "Agregar abogado interno",
    description: "Completa la informaci\xF3n del abogado interno que deseas vincular a tu empresa",
    submit: "Crear abogado interno",
    success_title: "Abogado interno creado",
    success_description: "El abogado interno {{name}} ha sido creado con \xE9xito"
  },
  edit: {
    trigger: "Editar",
    title: "Editar abogado interno",
    description: "Al cambiar el correo tambi\xE9n se actualiza el que usa para iniciar sesi\xF3n y el que se informa como negociador a la aseguradora",
    submit: "Guardar cambios",
    success_title: "Abogado interno actualizado",
    success_description: "El abogado interno {{name}} ha sido actualizado con \xE9xito"
  }
};
var load_balance_rule = {
  paths: {
    desired_support_location_state_municipality: "Partido",
    ramo: "Secci\xF3n",
    desired_support_location_state: "Estado",
    claim_type: "Tipo de reclamo",
    occurrence: {
      city: "Ciudad"
    },
    user_type: "Tipo de usuario",
    is_claimant_and_victim_same_insurer: "Tercero socio",
    sinister_object: "Objeto del siniestro"
  },
  types: {
    claim: "Reclamo",
    complaint: "Denuncia"
  }
};
var document = {
  group: {
    vehicle_damages: "da\xF1os al veh\xEDculo",
    documentation: "documentaci\xF3n"
  },
  reference: "Referencia",
  generated_at: "Emitido el",
  tax_id: "CUIT",
  agreement: {
    name: "Conformidad",
    filename: "conformidad",
    watermark: {
      preview: "BORRADOR",
      sample: "DOCUMENTO DE PRUEBA"
    },
    signature: {
      date: "Fecha",
      name: "Aclaraci\xF3n",
      identification: "Tipo y N\xB0 documento"
    },
    footer: 'Documento {{id}} \xB7 versi\xF3n {{version}} de la plantilla "{{template}}"'
  },
  generated_note: "Generado en Piramid el {{date}} por {{email}} \xB7 Documento {{document_id}}",
  generated_note_system: "Generado en Piramid el {{date}} \xB7 Documento {{document_id}}",
  footer_disclaimer: "Documento generado autom\xE1ticamente por {{company}}.",
  download: {
    generating_title: "Generando el PDF",
    generating_description: "Estamos generando el documento. Puede demorar unos segundos.",
    ready_title: "El PDF est\xE1 listo",
    ready_description: "Se abre en una pesta\xF1a nueva.",
    open: "Abrir PDF"
  },
  sample: {
    name: "Documento de ejemplo",
    filename: "documento-de-ejemplo",
    summary: "Resumen",
    issued_by: "Emitido por",
    total: "Total",
    notes: "Observaciones",
    items: {
      title: "Detalle",
      description: "Descripci\xF3n",
      quantity: "Cantidad",
      unit_amount: "Precio unitario",
      total_amount: "Importe"
    }
  },
  order_report: {
    name: "Orden de trabajo",
    filename: "orden-de-trabajo",
    number: "ORDEN N\xB0",
    claim_number: "Reclamo N\xB0",
    created_at: "Fecha orden",
    insurer: "Aseguradora",
    provider: "Taller",
    insured: "Reclamante",
    phone: "Tel\xE9fono",
    email: "Correo",
    address: "Direcci\xF3n",
    vehicle: "Veh\xEDculo",
    license_plate: "Patente",
    observation: "Observaci\xF3n",
    details_title: "Detalle de la orden",
    items: {
      quantity: "Cant",
      description: "Descripci\xF3n",
      unit_price: "Precio unitario",
      subtotal: "Importe"
    },
    total_amount: "Importe total",
    amount_to_charge: "A cargo del reclamante",
    coverage_amount: "L\xEDmite de cobertura",
    no_coverage_limit: "SIN L\xCDMITE",
    taxes_amount: "Impuestos ({{percent}}%)",
    total_with_taxes: "Total",
    signature: "Firma reclamante",
    clarification: "Aclaraci\xF3n",
    identification: "Documento N\xB0",
    date: "Fecha y hora",
    work_proof: {
      title: "Prueba de trabajo",
      qr_hint: "Escane\xE1 el c\xF3digo QR para completar la inspecci\xF3n.",
      private_notice: "Uso exclusivo del prestador. No compartir.",
      unavailable_title: "Inspecci\xF3n no disponible",
      not_created: "Todav\xEDa no se cre\xF3 la inspecci\xF3n."
    }
  }
};
var circulation = {
  direction: {
    one_way: "\xDAnico",
    two_way: "Doble"
  }
};
var license = {
  category: {
    car: "Auto",
    motorcycle: "Moto",
    foreign: "Extranjero",
    other: "Otro"
  }
};
var contract = {
  status: {
    open: "Abierto",
    close: "Cerrado"
  }
};
var cost = {
  type: {
    one_time: "Un solo pago",
    monthly: "Mensual",
    yearly: "Anualmente"
  }
};
var bid = {
  line: {
    unit: {
      hour: "Hora",
      day: "Dia",
      unit: "Piezas",
      km: "Kil\xF3metros"
    },
    type: {
      labor: "Mano de obra",
      auto_part: "Auto-parte",
      material: "Material",
      shipping: "Env\xEDo"
    }
  }
};
var rfp = {
  status: {
    open: "Abierto",
    closed: "Cerrado",
    canceled: "Cancelado"
  },
  tab: {
    detail: "Detalle",
    localization: "Zona",
    vendors: "Proveedores",
    files: "Archivos"
  },
  mode: {
    streaming: "En cualquier momento",
    batch: "Al cierre"
  }
};
var contact = {
  type: {
    field_adjuster: "Liquidador/Perito",
    vendor: "Proveedor"
  },
  searchUser: "Buscar usuario existente",
  searchUserPlaceholder: "Buscar por correo electr\xF3nico",
  noUsersFound: "No se encontraron usuarios",
  linkedUserMessage: "Usuario vinculado - los campos se completaron autom\xE1ticamente y no son editables",
  registration: {
    invited: "Invitaci\xF3n enviada",
    pending_verification: "Registro sin confirmar",
    registered: "Registrado",
    label: "Estado",
    unreachableAccount: "El email ya pertenece a un usuario de otro tipo: no puede acceder al portal de proveedores."
  },
  resendInvitation: {
    action: "Reenviar invitaci\xF3n",
    confirmTitle: "\xBFReenviar la invitaci\xF3n?",
    confirmDescription: "Se enviar\xE1 nuevamente el correo de invitaci\xF3n al contacto.",
    confirmBack: "Cancelar",
    confirmAction: "Reenviar",
    success: "Invitaci\xF3n reenviada"
  }
};
var filters = {
  stage: "Etapa",
  system_status: "Condici\xF3n",
  fraud_status: "Estado de fraude",
  company: "Empresa",
  claimed_amount: "Monto reclamado",
  zone: "Zona",
  coordinator: "Coordinador",
  collaborator: "Colaborador",
  team: "Equipo",
  relationship: "V\xEDnculo",
  ramo: "Ramo",
  sub_status: "Sub-Estado",
  responsible: "Responsable",
  reference: "Referencia",
  type: "Tipo",
  status: "Estado",
  claim_damage: "Da\xF1os",
  is_claimant_and_victim_same_insurer: "Tercero socio",
  customer_organization: "Empresa Customer",
  sinister_object: "Objeto del siniestro",
  good: "Bien",
  service: "Servicio",
  derivation_date: "Fecha de derivaci\xF3n",
  provider: "Proveedor",
  derived_by: "Derivado por",
  clear: "Limpiar",
  order_stage: "Paso",
  pending: "Acci\xF3n pendiente de",
  order_date: "Fecha"
};
var filtersPanel = {
  trigger: "Filtros",
  clearAll: "Limpiar todo",
  done: "Listo",
  search: "Buscar...",
  empty: "Ning\xFAn resultado"
};
var legal_person = {
  type: {
    hospital: "Hospital",
    worker_compensation_insurer: "ART",
    health_insurance_fund: "Obra social",
    insurer: "Aseguradora"
  }
};
var user = {
  availability: {
    schedule_action: "Programar inactividad",
    restore_action: "Finalizar inactividad",
    schedule_title: "Programar inactividad",
    schedule_description: "Defin\xED el per\xEDodo de inactividad de {{name}}. Durante ese lapso no se le asignar\xE1n nuevos reclamos.",
    period_label: "Per\xEDodo",
    period_required: "El rango de fechas es requerido",
    confirm: "Confirmar",
    cancel: "Cancelar",
    schedule_success_title: "Inactividad programada",
    schedule_success_description: "{{name}} no recibir\xE1 nuevos reclamos entre el {{from}} y el {{to}}",
    cancel_action: "Cancelar inactividad",
    cancel_title: "Cancelar inactividad",
    cancel_description: "\xBFConfirm\xE1s cancelar la inactividad de {{name}} programada del {{from}} al {{to}}? No se le va a aplicar.",
    cancel_confirm: "Cancelar inactividad",
    cancel_success_title: "Inactividad cancelada",
    cancel_success_description: "{{name}} ya no tiene una inactividad programada",
    restore_title: "Finalizar inactividad",
    restore_description: "\xBFConfirm\xE1s finalizar la inactividad de {{name}}? Volver\xE1 a recibir reclamos seg\xFAn lo que permita su rol.",
    restore_confirm: "Finalizar",
    restore_success_title: "Inactividad finalizada",
    restore_success_description: "{{name}} vuelve a recibir reclamos",
    unavailable_until: "Inactividad hasta el {{to}}",
    unavailable_between: "Inactividad del {{from}} al {{to}}",
    scheduled_banner_title: "Inactividad programada",
    scheduled_banner_description: "Vas a estar inactivo desde el {{from}} y volv\xE9s el {{to}}",
    return_banner_title: "Fin de la inactividad",
    return_banner_description: "A partir del {{date}} volv\xE9s a estar activo y a recibir reclamos nuevos."
  },
  override_permission: {
    can_create_judicial_amount: "Crear Monto Judicial",
    can_update_judicial_amount: "Actualizar Monto Judicial",
    can_create_administrative_amount: "Crear Monto Admin.",
    can_update_administrative_amount: "Actualizar Monto Admin.",
    can_create_percentage_of_liability: "Crear % de Responsabilidad",
    can_update_percentage_of_liability: "Actualizar % de Responsabilidad"
  },
  type: {
    system: "Sistema",
    third: "Tercero",
    insurer: "Aseguradora",
    policyholder: "Asegurado",
    backoffice: "Backoffice",
    inhouse_lawyer: "Abogado Interno",
    field_adjuster: "Liquidador/Perito",
    vendor: "Proveedor"
  },
  delegation: {
    action: "Delegar reclamos",
    dialog_title: "Reclamos de {{name}}",
    dialog_description: "Deleg\xE1 los reclamos de los que es responsable entre su equipo, o recuper\xE1 los que ya tiene delegados.",
    restore_all_action: "Recuperar todos",
    restore_all_title: "\xBFRecuperar los {{count}} reclamos delegados?",
    restore_all_description: "Los usuarios a quienes fueron delegados dejar\xE1n de verlos. Los que est\xE9n derivados a un tercero se quedan con quien los tiene y vuelven a esta lista cuando se los devuelvan.",
    restore_all_confirm: "Continuar",
    restore_all_cancel: "Cancelar",
    restore_all_empty_title: "No hay reclamos para recuperar",
    restore_all_empty_description: "No quedan reclamos delegados pendientes.",
    restore_all_queued_title: "Procesando en segundo plano",
    restore_all_queued_description: "{{count}} reclamo(s) en proceso de recuperaci\xF3n. Pod\xE9s ver el progreso al lado del t\xEDtulo."
  }
};
var zod = {
  errors: {
    missing_variable_definition: "El mensaje contiene una referencia una variable inexistente",
    invalid_type: "Se esperaba {{expected}}, se recibi\xF3 {{received}}",
    invalid_type_received_undefined: "Requerido",
    invalid_literal: "Valor literal inv\xE1lido, se esperaba {{expected}}",
    unrecognized_keys: "Llave(s) no reconocida(s) en el objeto: {{- keys}}",
    invalid_union: "Entrada inv\xE1lida",
    invalid_union_discriminator: "Valor discriminador inv\xE1lido. Se esperaba {{- options}}",
    invalid_enum_value: "Valor inv\xE1lido. Se esperaba {{- options}}, se recibi\xF3 '{{received}}'",
    invalid_arguments: "Argumentos de funci\xF3n inv\xE1lidos",
    invalid_return_type: "Tipo de retorno de funci\xF3n inv\xE1lido",
    invalid_date: "Fecha inv\xE1lida",
    custom: "Entrada inv\xE1lida",
    invalid_intersection_types: "Valores de intersecci\xF3n no pudieron ser mezclados",
    not_multiple_of: "N\xFAmero debe ser m\xFAltiplo de {{multipleOf}}",
    not_finite: "N\xFAmero no puede ser infinito",
    invalid_string: {
      email: "{{validation}} inv\xE1lido",
      url: "{{validation}} inv\xE1lido",
      uuid: "{{validation}} inv\xE1lido",
      cuid: "{{validation}} inv\xE1lido",
      regex: "Inv\xE1lido",
      datetime: "{{validation}} inv\xE1lida",
      startsWith: 'Entrada inv\xE1lida: debe comenzar con "{{startsWith}}"',
      endsWith: 'Entrada inv\xE1lida: debe finalizar con "{{endsWith}}"'
    },
    too_small: {
      array: {
        exact: "La lista debe contener exactamente {{minimum}} elemento(s)",
        inclusive: "La lista debe contener al menos {{minimum}} elemento(s)",
        not_inclusive: "La lista debe contener m\xE1s de {{minimum}} elemento(s)"
      },
      string: {
        exact: "El texto debe contener exactamente {{minimum}} car\xE1cter(es)",
        inclusive: "El texto debe contener al menos {{minimum}} car\xE1cter(es)",
        not_inclusive: "El texto debe contener m\xE1s de {{minimum}} car\xE1cter(es)"
      },
      number: {
        exact: "El n\xFAmero debe ser exactamente {{minimum}}",
        inclusive: "El n\xFAmero debe ser mayor o igual a {{minimum}}",
        not_inclusive: "El n\xFAmero debe ser mayor que {{minimum}}"
      },
      set: {
        exact: "Entrada inv\xE1lida",
        inclusive: "Entrada inv\xE1lida",
        not_inclusive: "Entrada inv\xE1lida"
      },
      date: {
        exact: "La fecha debe ser exactamente {{- minimum, datetime}}",
        inclusive: "La fecha debe ser mayor o igual al {{- minimum, datetime}}",
        not_inclusive: "La fecha debe ser mayor que el {{- minimum, datetime}}"
      }
    },
    too_big: {
      array: {
        exact: "La lista debe contener exactamente {{maximum}} elemento(s)",
        inclusive: "La lista debe contener como m\xE1ximo {{maximum}} elemento(s)",
        not_inclusive: "La lista debe contener menos que {{maximum}} elemento(s)"
      },
      string: {
        exact: "El texto debe contener exactamente {{maximum}} car\xE1cter(es)",
        inclusive: "El texto debe contener como m\xE1ximo {{maximum}} car\xE1cter(es)",
        not_inclusive: "El texto debe contener menos de {{maximum}} car\xE1cter(es)"
      },
      number: {
        exact: "El n\xFAmero debe ser exactamente {{maximum}}",
        inclusive: "El n\xFAmero debe ser menor o igual a {{maximum}}",
        not_inclusive: "El n\xFAmero debe ser menor que {{maximum}}"
      },
      set: {
        exact: "Entrada inv\xE1lida",
        inclusive: "Entrada inv\xE1lida",
        not_inclusive: "Entrada inv\xE1lida"
      },
      date: {
        exact: "La fecha debe ser exactamente {{- maximum, datetime}}",
        inclusive: "La fecha debe ser menor o igual al {{- maximum, datetime}}",
        not_inclusive: "La fecha debe ser menor que el {{- maximum, datetime}}"
      }
    }
  },
  validations: {
    email: "correo",
    url: "enlace",
    uuid: "uuid",
    cuid: "cuid",
    regex: "expresi\xF3n regular",
    datetime: "fecha"
  },
  types: {
    function: "funci\xF3n",
    number: "n\xFAmero",
    string: "texto",
    nan: "valor no n\xFAmerico",
    integer: "entero",
    float: "decimal",
    boolean: "booleano",
    date: "fecha",
    bigint: "entero grande",
    undefined: "indefinido",
    symbol: "s\xEDmbolo",
    null: "nulo",
    array: "lista",
    object: "objeto",
    unknown: "desconocido",
    promise: "promesa",
    void: "void",
    never: "nunca",
    map: "mapa",
    set: "conjunto"
  }
};
var inspection = {
  verdict: {
    approved: "Aprobado",
    disapproved: "Desaprobado",
    not_defined: "No definido",
    not_provided: "Sin resultado"
  },
  type: {
    bike: "Bicicleta",
    car: "Auto",
    moto: "Moto",
    people: "Persona",
    goods: "Bienes",
    machinery: "Maquinaria",
    custom: "Personalizado"
  },
  status: {
    created: "Creado",
    started: "Empezado",
    completed: "Completado",
    blocked: "Bloqueado",
    processing: "Procesando"
  },
  consumer_type: {
    policyholder: "Asegurado",
    claimant: "Tercero"
  }
};
var professions = {
  lawyer: "Abogado",
  other: "Otro"
};
var exported_report = {
  types: {
    sla_complaint: "sla-denuncias",
    sla_claim: "sla-reclamos",
    claim: "reclamos",
    event: "eventos",
    order: "ordenes-de-trabajo",
    backoffice_order: "ordenes-de-trabajo-global"
  },
  "event-columns": {
    user: "Usuario",
    email: "Email",
    event: "Evento",
    metadata: "Metadata",
    sinister_id: "ID Siniestro",
    selected_external_complaint: "N\xBA Siniestro",
    claim_id: "ID Reclamo",
    external_claim_request_id: "N\xBA Reclamo",
    remote_ip: "Direcci\xF3n IP",
    user_agent: "User Agent",
    date: "Fecha"
  },
  "order-columns": {
    company_name: "Empresa",
    ref_id: "N\xB0 Orden",
    created_at: "Fecha de derivaci\xF3n",
    status: "Estado de la orden",
    claim_ref_id: "N\xB0 Reclamo",
    claim_external_id: "N\xB0 Reclamo externo",
    claim_created_at: "Fecha de alta del reclamo",
    claim_status: "Estado del reclamo",
    claim_owner_name: "Responsable del reclamo",
    insurer_name: "Aseguradora origen",
    claimant_name: "Damnificado",
    claimant_identification: "Documento del damnificado",
    vehicle_make: "Marca del veh\xEDculo",
    vehicle_model: "Modelo del veh\xEDculo",
    vehicle_version: "Versi\xF3n del veh\xEDculo",
    vehicle_year: "A\xF1o del veh\xEDculo",
    vehicle_license_plate: "Patente del veh\xEDculo",
    service_name: "Servicio",
    good_name: "Bien",
    name: "T\xEDtulo",
    items_quantity: "Cantidad de productos",
    items_detail: "Productos",
    currency: "Moneda",
    total_amount: "Importe",
    coverage_amount: "Cobertura",
    amount_to_charge: "Importe neto",
    taxes_percent: "IVA (%)",
    taxes_amount: "IVA",
    total_with_taxes: "Total",
    provider_legal_name: "Proveedor",
    provider_ein: "CUIT del proveedor",
    provider_external_id: "C\xF3digo interno del proveedor",
    derived_by_name: "Derivado por",
    scheduled_for: "Turno coordinado",
    scheduled_branch: "Sucursal del turno",
    workflow_stage: "Etapa",
    description: "Descripci\xF3n",
    items_brands: "Marcas",
    vertical_name: "Vertical",
    accepted_at: "Fecha de aceptaci\xF3n",
    completed_at: "Fecha de finalizaci\xF3n",
    rejected_at: "Fecha de rechazo",
    rejected_reason: "Motivo de rechazo",
    canceled_at: "Fecha de anulaci\xF3n",
    canceled_reason: "Motivo de anulaci\xF3n",
    work_proof_mechanism: "Prueba de trabajo",
    work_proof_status: "Estado de la inspecci\xF3n",
    provider_email: "Email del proveedor",
    derived_by_email: "Email de quien deriv\xF3",
    locality_name: "Localidad",
    department_name: "Departamento",
    province_name: "Provincia",
    sinister_external_id: "N\xB0 Siniestro origen",
    claim_system_status: "Condici\xF3n del reclamo",
    claim_ramo: "Ramo",
    occurrence_sinister_date: "Fecha del siniestro",
    claimant_email: "Email del damnificado",
    claimant_phone: "Tel\xE9fono del damnificado",
    claimant_address: "Domicilio del damnificado",
    policyholder_policy_number: "N\xB0 de p\xF3liza",
    policyholder_license_plate: "Patente del asegurado",
    insurance_coverage: "Cobertura de la p\xF3liza",
    insurance_policy_number: "N\xB0 de p\xF3liza del da\xF1o",
    insurance_franchise_amount: "Franquicia"
  },
  columns_count: "Columnas ({{count}})"
};
var claims = {
  offer: {
    status: {
      pending: "Pendiente",
      accepted: "Aceptado",
      rejected: "Rechazado",
      canceled: "Anulado",
      expired: "Expirado"
    }
  },
  export: {
    select_all: "Seleccionar todas",
    deselect_all: "Deseleccionar todas"
  },
  columns: {
    external_claim_id: "N. Reclamo Externo",
    complaint_registered_by: "Nombre Creador Denuncia",
    responsible_email: "Email Responsable",
    responsible_name: "Nombre Responsable",
    claimed_amount: "Monto reclamado",
    complaint_agency: "Agencia Denuncia",
    complaint_external_id: "N. Siniestro de Denuncia",
    complaint_external_status: "Estado Denuncia",
    complaint_handler_email: "Email Tramitador Denuncia",
    complaint_handler_name: "Nombre Tramitador Denuncia",
    complaint_location: "Ubicaci\xF3n Denuncia",
    complaint_occurrence_date: "Fecha Ocurrencia Denuncia",
    complaint_registered_at: "Fecha Registro Denuncia",
    created_at: "Fecha Creaci\xF3n Reclamo",
    created_by_email: "Email Creador Reclamo",
    created_by_name: "Nombre Creador Reclamo",
    declared_damages: "Da\xF1os Declarados",
    desired_support_location: "Ubicaci\xF3n Reclamo",
    fraud_close_motive: "Motivo Cierre Investigaci\xF3n Fraude",
    fraud_created_at: "Fecha Creaci\xF3n Investigaci\xF3n Fraude",
    fraud_description: "Descripci\xF3n Investigaci\xF3n Fraude",
    fraud_sinister_number: "N. Siniestro Investigaci\xF3n Fraude",
    fraud_external_status: "Estado Investigaci\xF3n Fraude",
    fraud_instance: "Instancia Investigaci\xF3n Fraude",
    fraud_reason: "Motivo Investigaci\xF3n Fraude",
    fraud_report_accepted_by_email: "Email Aceptador Reporte Investigaci\xF3n Fraude",
    fraud_report_accepted_by_name: "Nombre Aceptador Reporte Investigaci\xF3n Fraude",
    fraud_report_conclusion: "Conclusi\xF3n Reporte Investigaci\xF3n Fraude",
    fraud_report_lab: "Estudio Reporte Investigaci\xF3n Fraude",
    fraud_responsible_email: "Email Responsable Investigaci\xF3n Fraude",
    fraud_responsible_name: "Nombre Responsable Investigaci\xF3n Fraude",
    fraud_result: "Resultado Investigaci\xF3n Fraude",
    fraud_sinister_type: "Tipo Siniestro Investigaci\xF3n Fraude",
    fraud_external_id: "N. Investigaci\xF3n Fraude",
    id: "N. Reclamo",
    occurrence_address: "Direcci\xF3n Ocurrencia",
    occurrence_city: "Ciudad Ocurrencia",
    occurrence_state: "Provincia Ocurrencia",
    occurrence_country: "Pa\xEDs Ocurrencia",
    occurrence_description: "Descripci\xF3n Ocurrencia",
    occurrence_sinister_date: "Fecha Ocurrencia",
    occurrence_zip_code: "C\xF3digo Postal Ocurrencia",
    policyholder_license_plate: "Patente Asegurado",
    policyholder_policy_number: "N. P\xF3liza Asegurado",
    ramo: "Ramo",
    reference: "Referencia",
    status: "Condici\xF3n",
    victim_type: "Tipo de v\xEDctima",
    victim_city: "Ciudad V\xEDctima",
    victim_identification_type: "Tipo de documento V\xEDctima",
    victim_identification_value: "N. Documento V\xEDctima",
    victim_name: "Nombre V\xEDctima",
    claim_status: "Estado del Reclamo",
    team: "Grupo",
    closed_at: "Fecha Baja Reclamo",
    offers_count: "Cantidad de Ofrecimientos",
    latest_offer_amount: "Importe \xDAltimo Ofrecimiento",
    latest_offer_status: "Estado \xDAltimo Ofrecimiento",
    latest_offer_sent_at: "Fecha \xDAltimo Ofrecimiento",
    current_pretension: "Pretensi\xF3n Actual",
    material_judicial_amount: "Monto Judicial Da\xF1os Materiales",
    person_judicial_amount: "Monto Judicial Da\xF1os Corporales",
    material_administrative_amount: "Monto Administrativo Da\xF1os Materiales",
    person_administrative_amount: "Monto Administrativo Da\xF1os Corporales",
    percentage_of_liability: "% Responsabilidad",
    person_percentage_of_judicial_risk: "% Riesgo Judicial",
    estimates_updated_at: "Fecha Actualizaci\xF3n Estimaciones"
  },
  "delegate-strategies": {
    users: "Usuarios",
    team: "Equipo"
  },
  "derive-strategies": {
    user: "Usuario",
    team: "Equipo"
  },
  "return-responsibility": {
    "reason-hint": "Indica el motivo del retorno del reclamo",
    "inactive-deriver-hint": "Si el tramitador que deleg\xF3 se encuentra inactivo, el reclamo ser\xE1 derivado a un tramitador del mismo equipo."
  }
};
var notifications = {
  scopes: {
    unread: "Sin leer",
    read: "Le\xEDdo",
    all: "Todas"
  },
  view: {
    true: "Le\xEDdo"
  }
};
var fraud = {
  conclusions: {
    positive: "Positivo",
    negative: "Negativo"
  },
  results: {
    resignation: "Resignaci\xF3n",
    surrender: "Desistimiento",
    negative: "Negativo",
    fraud: "Fraude",
    positive: "Positivo",
    elements_for_rejection: "Elementos para rechazo",
    in_extension: "En ampliaci\xF3n",
    canceled: "Cancelado",
    possible_prescription: "Posible prescripci\xF3n",
    without_result: "Sin Definir",
    not_defined: "Sin definir",
    not_derived: "No se deriva",
    canceled_by_management: "De baja por gerencia"
  },
  claimResults: {
    fraud: "Fraude",
    not_fraud: "Sin fraude",
    not_defined: "Sin definir"
  },
  internalStatus: {
    not_assigned: "No asignado",
    in_progress: "En curso",
    closed: "Cerrado"
  },
  status: {
    not_assigned: "Sin asignar",
    in_progress: "En curso",
    derived_to_lab: "Derivado a estudio",
    in_extension: "En ampliaci\xF3n",
    without_result: "Sin resultado",
    closed: "Cerrada"
  },
  attributes: {
    status: "Estado",
    kach_status: "Estado en Kach"
  },
  automatic_derivation: "Derivaci\xF3n autom\xE1tica",
  case_created_in_kach: "Cre\xF3 el caso en Kach \xB7 derivaci\xF3n autom\xE1tica"
};
var breadcrumb = {
  contract: "Contratos",
  request: "Licitaciones",
  fraud: "Investigaci\xF3n de fraude",
  complaint: "Denuncia",
  sinister: "Siniestro",
  claim: "Reclamos",
  inspection: "Inspecci\xF3n"
};
var complaint = {
  attributes: {
    is_recoverable: {
      label: "Recuperable",
      value: {
        true: "S\xED",
        false: "No"
      }
    },
    requires_spare_parts: {
      label: "Requiere repuestos",
      value: {
        true: "S\xED",
        false: "No"
      }
    }
  },
  "system-status": {
    open: "Abierto",
    closed: "Cerrado"
  },
  reference: {
    on_claim: "Generaci\xF3n de Reclamo",
    technical_analysis: "An\xE1lisis T\xE9cnico",
    inspection: "Inspecci\xF3n",
    responsibility_analysis: "An\xE1lisis de Responsabilidad",
    negotiation: "Negociaci\xF3n",
    payment_process: "En proceso de Pago",
    homologation: "Homologaci\xF3n",
    demand_transfer: "Traslado Demanda",
    canceled: "Anulado",
    rejected: "Rechazado (luego del An\xE1lisis)",
    settlement_payment: "Liquidaci\xF3n y Pago",
    mediation: "Mediaci\xF3n",
    judgment: "Juicio",
    fraud: "Indicio de Fraude"
  },
  role: {
    none: "Sin rol",
    default: "Default",
    documentation_completed: "Documentaci\xF3n completa",
    documentation_request: "Documentaci\xF3n requerida",
    criminal_case_request: "Solicitud causa penal",
    offer_flow: "Ofrecimiento",
    not_response: "Sin respuesta",
    claim_rejected: "Rechazo",
    additional_management: "Gestiones adicionales"
  },
  types: {
    vehicle: "Veh\xEDculo",
    building: "Edificio",
    glass: "Cristales",
    medical_assistance_accident: "Asistencia medica por accidente",
    electronic_equipment: "Equipos electr\xF3nicos",
    theft: "Robo",
    other: "Otro"
  },
  tabs: {
    orders: "Ordenes",
    estimates: "Estimaciones",
    offers: "Ofrecimiento",
    "evaluation/reports": "Evaluacion",
    rfps: "Licitaciones",
    activity: "Actividad",
    documents: "Documentaci\xF3n",
    detail: "Detalle",
    inspections: "Inspecciones",
    inspection: "Inspecciones"
  },
  steps: {
    "vehicle-identification-key": "\xBFEl veh\xEDculo cuenta con N\xFAmero de Chapa?",
    "policyholder-type": "\xBFEs usted una persona f\xEDsica o jur\xEDdica?",
    "policyholder-info": "Informaci\xF3n del asegurado",
    "ask-police-intervention": "\xBFHubo intervenci\xF3n policial?",
    "complaint-type": "Tipo de denuncia",
    "occurrence-sinister": "Datos del siniestro",
    "third-party-info": "Datos del tercero involucrado",
    "is-third-party-involved": "\xBFHay un tercero involucrado?",
    "has-damage-budget": "\xBFYa cuentas con alg\xFAn presupuesto?",
    "did-third-party-flee": "\xBFEl tercero se dio a la fuga?",
    "vehicle-driver-info": "Datos del conductor",
    "policyholder-vehicle-info": "Datos vehiculares del asegurado",
    "current-email": "Email actual",
    welcome: "Bienvenido \u{1F44B}",
    "insured-info": "Informaci\xF3n del asegurado",
    "driver-detail": "Detalle del conductor",
    "insured-type": "Tipo de asegurado",
    "third-party-exists": "\xBFExiste un tercero?",
    "third-party-vehicle-type": "Tipo de veh\xEDculo del tercero",
    "third-party-detail": "Detalle del tercero",
    occurrence: "Siniestro",
    "complaint-confirmation": "Resumen",
    "complaint-other-details": "Detalle del riesgo",
    "doc-load": "Carga de documentos"
  },
  status: {
    role: {
      default: "Default"
    },
    open: "Abierto",
    closed: "Cerrado",
    reference: {
      claimant_disinterest: "Desinter\xE9s del Reclamante",
      not_successful: "No Prosper\xF3",
      reconciled: "Conciliado",
      in_closing_process: "En proceso de Cierre",
      derivation: "Derivaci\xF3n",
      analysis: "An\xE1lisis del reclamo",
      on_claim: "Generaci\xF3n de Reclamo",
      technical_analysis: "An\xE1lisis T\xE9cnico",
      inspection: "Inspecci\xF3n",
      responsibility_analysis: "An\xE1lisis de Responsabilidad",
      negotiation: "Negociaci\xF3n",
      payment_process: "En proceso de Pago",
      homologation: "Homologaci\xF3n",
      demand_transfer: "Traslado Demanda",
      canceled: "Anulado",
      rejected: "Rechazado (luego del An\xE1lisis)",
      settlement_payment: "Liquidaci\xF3n y Pago",
      mediation: "Mediaci\xF3n",
      judgment: "Juicio",
      fraud: "Indicio de Fraude"
    }
  },
  "delegate-strategies": {
    users: "Usuarios",
    team: "Equipo"
  }
};
var validation_pattern = {
  extractors: {
    rivadavia: "Rivadavia",
    tajy: "Tajy"
  },
  columns: {
    policy_number: "N\xFAmero de p\xF3liza",
    external_claim_id: "ID Reclamo Externo"
  }
};
var frequency = {
  monthly: "Mensual",
  daily: "Diario"
};
var claimants = {
  natural_person: "Persona f\xEDsica",
  legal_person: "Persona jur\xEDdica"
};
var claim = {
  summary: {
    intake: {
      title: "Datos de la derivaci\xF3n",
      insurer: "Aseguradora de origen",
      service: "Servicio a realizar",
      good: "Bien afectado",
      repair_locality: "Localidad o zona del servicio",
      empty: "Sin datos",
      saved: "Datos de la derivaci\xF3n actualizados"
    }
  },
  responsible: {
    group: {
      current_team_membership: "Miembros del equipo",
      prev_responsible: "Responsables anteriores",
      team_coordinator: "Equipos derivables"
    }
  },
  "new-claim-block": {
    inactive: "Inactivo",
    paused: "No disponible",
    overloaded: "Sobrepasado",
    hints: {
      inactive: "Est\xE1 inactivo: no puede recibir el reclamo.",
      "inactive-until": "Est\xE1 inactivo y vuelve el {{date}}: no puede recibir el reclamo.",
      paused: "No est\xE1 recibiendo reclamos nuevos.",
      overloaded: "Ya tiene m\xE1s carga que la habitual de su equipo. Pod\xE9s asign\xE1rselo igual."
    }
  },
  sinisterTypes: {
    policyholder: {
      text: "Siniestro sin veh\xEDculo involucrado",
      description: "Utiliz\xE1 esta opci\xF3n **SOLO** si tu siniestro no fue contra un veh\xEDculo automotor."
    },
    policyholder_vehicle: {
      text: "Siniestro con un veh\xEDculo asegurado en {{companyName}}",
      description: "Complet\xE1 la patente del asegurado, la fecha y hora del hecho. Nosotros identificamos su p\xF3liza autom\xE1ticamente."
    }
  },
  "system-status": {
    open: "Abierto",
    closed: "Cerrado"
  },
  attributes: {
    intake: {
      label: "Datos de la derivaci\xF3n",
      insurer: {
        label: "Aseguradora de origen"
      },
      service: {
        label: "Servicio a realizar"
      },
      good: {
        label: "Bien afectado"
      },
      repair_locality: {
        label: "Localidad o zona del servicio"
      }
    },
    damages: {
      fixed: {
        label: "\xBFFue arreglado?"
      },
      label: "Da\xF1os",
      material: {
        insurance: {
          label: "Seguro",
          has_insurance: {
            label: "\xBFPosee seguro?",
            hint: "Si ten\xE9s seguro pero no encontr\xE1s tu aseguradora en el listado, eleg\xED S\xED y seleccion\xE1 OTRAS ASEGURADORAS",
            value: {
              true: "S\xED",
              false: "No"
            }
          },
          coverage: {
            label: "Cobertura",
            value: {
              civil_responsibility: "Responsabilidad Civil",
              third_robbery_fire: "Tercero, Robo e incendio",
              third_full: "Tercero Completo",
              all_risks_without_franchise: "Todo Riesgo sin Franquicia",
              all_risks_with_franchise: "Todo Riesgo con Franquicia"
            }
          },
          insurer: {
            label: "Aseguradora",
            hint: "Si no encontr\xE1s tu aseguradora en el listado, seleccion\xE1 OTRAS ASEGURADORAS"
          },
          policy_number: {
            label: "N\xFAmero de p\xF3liza"
          },
          franchise_amount: {
            label: "Monto de franquicia"
          }
        },
        label: "Materiales",
        vehicle: {
          type: {
            label: "Tipo",
            value: {
              bike: "Bicicleta",
              machinery: "Maquinaria",
              skateboard: "Monopat\xEDn",
              other: "Otro",
              car: "Auto",
              moto: "Moto"
            }
          },
          make: {
            label: "Marca del veh\xEDculo"
          },
          model: {
            label: "Modelo del veh\xEDculo"
          },
          year: {
            label: "A\xF1o del veh\xEDculo"
          },
          version: {
            label: "Versi\xF3n del veh\xEDculo"
          },
          market_value: {
            label: "Valor venal"
          },
          use: {
            label: "Uso del veh\xEDculo",
            value: {
              private: "Particular",
              public: "P\xFAblico",
              taxi: "Taxi",
              remis: "Remis",
              rental: "Alquiler de Autos",
              ambulance: "Ambulancia",
              police: "Patrullero",
              school: "Escuela",
              specialService: "Sev. Especial Plataforma Electron",
              special_service: "Sev. Especial Plataforma Electron",
              goods: "Transporte de mercader\xEDas",
              persons: "Transporte de personas",
              special_school_pickup: "Servicios Especiales y Escolares (Pick Up)",
              goods_transport: "Transporte de Bienes",
              local: "Locales",
              route_service: "Ruteros",
              school_transport: "Escolares",
              electronic_platform: "Servicio Especial Plataforma Electr\xF3nica",
              delivery_service: "Servicio de Reparto y Mensajer\xEDa",
              agency: "Agencias (Con/Sin Chofer c/ chapa Particular)"
            }
          },
          category: {
            label: "Categor\xEDa",
            value: {
              with_license_plate: "Veh\xEDculo con patente (Auto o Moto)",
              without_license_plate: "Veh\xEDculo sin patente (Bicicleta, Monopatines, Maquinaria, etc)"
            }
          },
          license_plate: {
            label: "Patente"
          },
          chassis: {
            label: "Chassis"
          },
          engine: {
            label: "Motor"
          },
          label: "Veh\xEDculo",
          driver: {
            ownership: {
              label: "Conductor Propiedad",
              value: {
                owner: "Due\xF1o",
                third: "Tercero"
              }
            },
            label: "Conductor",
            first_name: {
              label: "Conductor Nombre"
            },
            last_name: {
              label: "Conductor Apellido"
            },
            cellphone: {
              label: "Conductor Celular"
            }
          }
        }
      },
      person: {
        health_insurance_fund: {
          label: "Obra social"
        },
        surgery_description: {
          label: "Intervenci\xF3n quir\xFArgica"
        },
        treatment_medical_institution: {
          label: "Instituci\xF3n M\xE9dica"
        },
        treatment_worker_compensation_insurer: {
          label: "ART"
        },
        policyholder_relationship_other: {
          label: "Otro v\xEDnculo"
        },
        policyholder_relationship: {
          label: "Relaci\xF3n con el asegurado"
        },
        label: "Persona",
        victim_role: {
          label: "Condici\xF3n de",
          value: {
            pedestrian: "Peat\xF3n",
            driver: "Conductor del veh\xEDculo tercero",
            rider: "Transportado en el veh\xEDculo tercero",
            policyholder_rider: "Transportado en el veh\xEDculo asegurado en {{insurerName}}"
          }
        }
      }
    },
    claimants: {
      label: "Reclamante",
      role: {
        label: "Rol",
        value: {
          claimant: "Reclamante",
          heir: "Heredero"
        }
      },
      ownership_history: {
        label: "Transferencias de reclamo"
      },
      victim_relationship_other: {
        label: "Otro v\xEDnculo"
      },
      victim_relationship: {
        label: "V\xEDnculo con damnificado",
        value: {
          label: "Relaci\xF3n con el asegurado",
          mother: "Madre",
          father: "Padre",
          other_family_member: "Otro familiar",
          tutor_curator: "Tutor/Curador",
          attorney_in_fact: "Abogado apoderado",
          legal_representative: "Apoderado legal",
          attorney_representative: "Abogado patrocinante",
          other: "Otro",
          brother: "Hermano",
          producer: "Productor",
          workshopper: "Tallerista",
          own: "Reclamo en nombre propio",
          particular_victim: "Damnificado particular",
          son: "Hijo/a",
          spouse: "C\xF3nyuge",
          concubine: "Concubino/a",
          grandparent: "Abuelo/a"
        }
      },
      natural_person: {
        parents: {
          label: "Padres",
          first_name: {
            label: "Nombre"
          },
          last_name: {
            label: "Apellido"
          },
          identification: {
            label: "Documento"
          },
          type: {
            label: "Tipo",
            value: {
              father: "Padre",
              mother: "Madre"
            }
          }
        },
        label: "Persona F\xEDsica",
        first_name: {
          label: "Nombre"
        },
        last_name: {
          label: "Apellido"
        },
        birth_date: {
          label: "Fecha de nacimiento"
        },
        sex: {
          label: "G\xE9nero"
        },
        identification_type: {
          label: "Tipo de documento"
        },
        identification_value: {
          label: "Documento"
        },
        nationality: {
          label: "Nacionalidad"
        },
        state: {
          label: "Provincia"
        },
        city: {
          label: "Ciudad"
        },
        address: {
          label: "Direcci\xF3n"
        },
        zip_code: {
          label: "C\xF3digo postal"
        },
        email: {
          label: "Correo electr\xF3nico"
        }
      }
    },
    victim: {
      label: "Damnificado",
      natural_person: {
        cellphone: {
          label: "Celular"
        },
        marital_status: {
          label: "Estado civil",
          value: {
            single: "Soltero/a",
            married: "Casado/a",
            widowed: "Viudo/a",
            divorced: "Divorciado/a",
            common_law: "Uni\xF3n de hecho",
            separated: "Separado/a"
          }
        },
        parents: {
          label: "Padres",
          first_name: {
            label: "Nombre"
          },
          last_name: {
            label: "Apellido"
          },
          identification: {
            label: "Documento"
          },
          type: {
            label: "Tipo",
            value: {
              father: "Padre",
              mother: "Madre"
            }
          }
        },
        label: "Persona F\xEDsica",
        first_name: {
          label: "Nombre"
        },
        last_name: {
          label: "Apellido"
        },
        birth_date: {
          label: "Fecha de nacimiento"
        },
        sex: {
          label: "G\xE9nero",
          value: {
            male: "Masculino",
            female: "Femenino",
            other: "Otro"
          }
        },
        identification_type: {
          label: "Tipo de documento",
          value: {
            national_id_document: "DNI",
            enrollment_book: "Libreta Enrolamiento",
            civil_registry_card: "Libreta C\xEDvica",
            passport: "Pasaporte",
            cuil: "CUIL",
            cuit: "CUIT"
          }
        },
        identification_value: {
          label: "Documento"
        },
        nationality: {
          label: "Nacionalidad"
        },
        state: {
          label: "Provincia"
        },
        city: {
          label: "Ciudad"
        },
        address: {
          label: "Direcci\xF3n"
        },
        address_street: {
          label: "Calle"
        },
        address_number: {
          label: "N\xFAmero"
        },
        address_apartment: {
          label: "Departamento"
        },
        zip_code: {
          label: "C\xF3digo postal"
        },
        email: {
          label: "Correo electr\xF3nico"
        }
      },
      victim_relationship: {
        label: ""
      }
    },
    owner: {
      label: "Usuario reclamante",
      username: {
        label: "Nombre de usuario"
      },
      email: {
        label: "Correo"
      },
      first_name: {
        label: "Nombre"
      },
      last_name: {
        label: "Apellido"
      },
      cellphone: {
        label: "Celular"
      },
      identification: {
        label: "Identificaci\xF3n"
      },
      sex: {
        label: "G\xE9nero"
      }
    },
    created_by: {
      label: "Usuario creador",
      username: {
        label: "Nombre de usuario"
      },
      email: {
        label: "Correo"
      },
      first_name: {
        label: "Nombre"
      },
      last_name: {
        label: "Apellido"
      },
      cellphone: {
        label: "Celular"
      },
      identification: {
        label: "Identificaci\xF3n"
      },
      sex: {
        label: "G\xE9nero"
      }
    },
    sinister: {
      label: "Siniestro",
      date: {
        label: "Fecha del siniestro"
      },
      license_plate: {
        label: "Patente del asegurado"
      },
      external_complaint: {
        label: "Denuncia",
        date: {
          label: "Fecha"
        },
        agency: {
          label: "Agencia"
        },
        external_id: {
          label: "N\xFAmero de siniestro"
        },
        external_status: {
          label: "Estado"
        },
        occurrence_date: {
          label: "Fecha de la denuncia"
        },
        registered_by: {
          label: "Registrado por"
        },
        policyholder: {
          label: "Asegurado",
          policy_number: {
            label: "N\xFAmero de p\xF3liza"
          },
          agency: {
            label: "Agencia"
          },
          order: {
            label: "Orden"
          },
          cuil: {
            label: "CUIL"
          },
          address: {
            label: "Direcci\xF3n"
          },
          city: {
            label: "Ciudad"
          },
          country: {
            label: "Pa\xEDs"
          },
          make: {
            label: "Marca"
          },
          model: {
            label: "Modelo"
          },
          identification: {
            label: "Identificaci\xF3n"
          },
          first_name: {
            label: "Nombre"
          },
          last_name: {
            label: "Apellido"
          },
          sex: {
            label: "G\xE9nero"
          },
          landline_phone: {
            label: "Tel\xE9fono"
          },
          marital_status: {
            label: "Estado civil"
          },
          license_plate: {
            label: "Patente"
          },
          plan: {
            label: "Plan"
          },
          use: {
            label: "Uso"
          },
          yer: {
            label: "A\xF1o"
          },
          zip_code: {
            label: "C\xF3digo postal"
          }
        }
      }
    },
    license_plate: {
      label: "Patente del asegurado"
    },
    occurrence: {
      label: "Ocurrencia",
      address: {
        label: "Direcci\xF3n"
      },
      time: {
        label: "Hora"
      },
      witnesses_info: {
        label: "Informaci\xF3n de los testigos"
      },
      police_intervention: {
        label: "Intervenci\xF3n Policial"
      },
      police_station: {
        label: "Estaci\xF3n policial"
      },
      criminal_case_number: {
        label: "N\xFAmero causa penal"
      },
      judicial_department: {
        label: "Departamento judicial"
      },
      clerks_office: {
        label: "N\xFAmero de Secretaria"
      },
      court: {
        label: "N\xFAmero de Juzgado"
      },
      country: {
        label: "Pa\xEDs"
      },
      city: {
        label: "Ciudad"
      },
      zip_code: {
        label: "C\xF3digo Postal"
      },
      description: {
        label: "Descripci\xF3n"
      },
      state: {
        label: "Provincia"
      },
      damage_description: {
        label: "Descripci\xF3n de los da\xF1os"
      },
      sinister_date: {
        label: "Fecha del siniestro"
      }
    }
  },
  negotiation: {
    title: "Negociaci\xF3n",
    stages: {
      estimates: "Estimaci\xF3n",
      estimates_hint: "Montos estimados y responsabilidad",
      offers: "Ofrecimiento",
      offers_hint: "Propuesta econ\xF3mica al reclamante.",
      agreement: "Conformidad",
      agreement_hint: "Firma del reclamante",
      state: {
        done: "Completada",
        in_progress: "En curso",
        attention: "Requiere atenci\xF3n",
        pending: "Pendiente",
        agreement_pending: "Sin conformidad vigente"
      }
    },
    offer_summary: {
      sent_at: "Fecha de env\xEDo",
      amount: "Importe del ofrecimiento"
    },
    reject: {
      title: "Rechazar ofrecimiento",
      description: "Registr\xE1s el rechazo en nombre del reclamante. Va a quedar indicado que lo cargaste vos.",
      reason_label: "Motivo del rechazo",
      reason_placeholder: "Lo que expres\xF3 el reclamante",
      pretension_label: "Pretensi\xF3n del reclamante (opcional)",
      pretension_placeholder: "Monto que pretende",
      submit: "Rechazar",
      success_title: "Ofrecimiento rechazado",
      success_description: "Se registr\xF3 el rechazo en nombre del reclamante"
    },
    cancel: {
      title: "Anular ofrecimiento",
      description: "El ofrecimiento realizado al reclamante ser\xE1 anulado.",
      internal_reason_label: "Motivo interno",
      internal_reason_placeholder: "Queda registrado, no se comparte con el tercero",
      public_reason_label: "Motivo para el reclamante (opcional)",
      public_reason_placeholder: 'Si queda vac\xEDo, el reclamante recibe: "El ofrecimiento previo ha sido dejado sin efecto"',
      submit: "Anular",
      success_title: "Ofrecimiento anulado",
      success_description: "El ofrecimiento fue anulado correctamente",
      internal_reason_display: "Motivo interno",
      public_reason_display: "Motivo p\xFAblico",
      agreement_notice: {
        cancels_signature_request: {
          title: "Tambi\xE9n se cancela la solicitud de firma",
          description: "La conformidad est\xE1 en proceso de firma en AutoSign. Al anular el ofrecimiento se cancela la solicitud: quienes todav\xEDa no firmaron ya no podr\xE1n hacerlo."
        },
        keeps_signed_document: {
          title: "Este ofrecimiento tiene una conformidad firmada",
          description: "Anularlo no elimina ni revierte las firmas: el documento firmado se conserva."
        }
      },
      agreement_provider_cancel_requested: "Ofrecimiento anulado. Estamos cancelando la solicitud de firma en AutoSign."
    },
    offer_card: {
      offered_amount: "Importe ofrecido",
      installments_title: "Cuotas",
      installments_value: "{{count}} cuotas de {{amount}}",
      single_payment: "Pago \xFAnico",
      payment_days_title: "D\xEDas a pagar",
      days_value: "{{count}} d\xEDas",
      fees_title: "Honorarios",
      fees_value: "{{percentage}} %",
      no_fees: "Sin honorarios",
      sent_at: "Enviado el",
      sent_by: "por {{name}}",
      internal_badge: "No visible para el reclamante",
      reason_internal: "Motivo interno",
      reason_public: "Motivo para el reclamante",
      offer_reasons: "Motivos del ofrecimiento",
      offer_reason: "Motivo del ofrecimiento",
      canceled_reasons: "Motivos de la anulaci\xF3n",
      canceled_reason: "Motivo de la anulaci\xF3n",
      rejection_reason: "Rechazo del reclamante",
      rejection_on_behalf_title: "Rechazo registrado en nombre del reclamante",
      rejection_on_behalf_title_claimant: "Rechazo registrado en tu nombre",
      rejected_on_behalf_by: "Registrado por {{name}}",
      rejected_on_behalf_by_company: "Registrado por la compa\xF1\xEDa",
      pretension: "Pretensi\xF3n",
      agreement: {
        title: "Conformidad",
        name: "Nombre",
        provider: "Proveedor",
        transaction: "Transacci\xF3n",
        status: "Estado",
        canceled_at: "Cancelado el",
        expired_at: "Expirado el",
        canceled_reason: "Motivo cancelaci\xF3n",
        rejected_at: "Rechazado el",
        rejected_reason: "Motivo de rechazo",
        completed_at: "Completado el",
        signed_documents: "Documentos firmados"
      }
    },
    context: {
      days_since_last_offer: "d\xEDas al \xFAltimo ofrecimiento",
      day_since_last_offer: "d\xEDa al \xFAltimo ofrecimiento",
      less_than_one_day: "Menos de un d\xEDa",
      since_last_offer: "al \xFAltimo ofrecimiento",
      first_offer: "Primer ofrecimiento",
      first_offer_hint: "Todav\xEDa no se envi\xF3 ning\xFAn ofrecimiento",
      escalated: "del mismo tercero en Mediaci\xF3n/Juicio",
      escalated_tooltip: "Reclamos del mismo tercero",
      round: "{{round}}\xB0 ofrecimiento",
      stage_mediation: "En mediaci\xF3n",
      stage_judgment: "En juicio"
    },
    bar: {
      administrative: "Base Admin",
      type_average: "Acept. General",
      claimer_average: "Acept. Reclamante",
      pretension: "Pretensi\xF3n Tercero",
      cap: "TOPE",
      judicial: "Judicial",
      hint: "Arrastr\xE1 el selector sobre la barra o us\xE1 los campos para definir el ofrecimiento.",
      simulated: "Ofrecimiento simulado"
    },
    simulator: {
      amount_label: "Importe del ofrecimiento ($)",
      percentage_label: "Porcentaje del judicial (%)",
      distance_to_cap: "Distancia al TOPE",
      distance_to_pretension: "Distancia a pretensi\xF3n",
      probability: "Probabilidad de aceptaci\xF3n",
      not_computable: "No calculable",
      not_computable_probability_hint: "Defin\xED la responsabilidad en Estimaci\xF3n para calcular la probabilidad",
      above: "{{value}}% por encima",
      below: "{{value}}% por debajo",
      general_info: "Informaci\xF3n general",
      missing_estimates_title: "Sin estimaci\xF3n cargada",
      missing_estimates_description: "Carg\xE1 el monto judicial en Estimaci\xF3n para simular el ofrecimiento. Pod\xE9s continuar y completar el env\xEDo manualmente.",
      band: {
        high: "Alta",
        medium: "Media",
        low: "Baja"
      },
      tooltip: {
        title: "Probabilidad estimada",
        base: "Base",
        total: "Total",
        with_clip: "{{total}} \u2192 {{probability}}% (con ajuste)",
        factor: {
          cap_offered: "TOPE ofrecido: {{value}}%",
          liability_percentage: "Responsabilidad: {{value}}%",
          third_party_expectation: "Vs. pretensi\xF3n del tercero: {{value}}",
          type_average: "Vs. aceptaci\xF3n promedio del tipo: {{value}}",
          claimer_average: "Vs. aceptaci\xF3n promedio del reclamante: {{value}}",
          mediation_judgment_floor: "Vs. piso Mediaci\xF3n/Juicio del tipo: {{value}}",
          previous_rejection: "Rechazo previo con prob. {{value}}%"
        }
      }
    },
    wizard: {
      title: "Nuevo ofrecimiento",
      step_simulate: "Simul\xE1 el ofrecimiento",
      step_complete: "Complet\xE1 el ofrecimiento",
      continue: "Continuar",
      back: "Volver",
      cancel: "Cancelar",
      submit: "Confirmar y enviar",
      send: "Enviar ofrecimiento",
      summary_amount: "Importe total",
      summary_of_judicial: "{{value}}% del judicial",
      summary_of_cap: "{{value}}% del tope",
      amount_in_words: "Importe en letras",
      amount_in_words_hint: "Se genera autom\xE1ticamente a partir del importe",
      public_reason_label: "Motivo para el reclamante (opcional)",
      public_reason_placeholder: "Se comunica al tercero junto con el ofrecimiento",
      internal_reason_label: "Motivo interno",
      internal_reason_placeholder: "Queda registrado, no se comparte con el tercero",
      payment_conditions: "Condiciones de pago",
      installment: "{{count}} cuota",
      installments: "{{count}} cuotas",
      day: "{{count}} d\xEDa",
      days: "{{count}} d\xEDas",
      payment_days_label: "Cantidad de d\xEDas a pagar",
      single_payment_hint: "Pago \xFAnico de {{amount}}",
      installments_hint: "{{count}} cuotas de {{amount}}",
      installments_hint_with_fees: " \xB7 los honorarios se pagan aparte",
      fees_hint: "Honorarios {{fees}} en un pago",
      days_to_pay: "{{count}} d\xEDas",
      template_label: "Plantilla",
      template_placeholder: "Seleccion\xE1 una plantilla",
      select_option: "Selecciona una opci\xF3n",
      unsupported_variable_type: "Este tipo de variable no se completa desde este formulario",
      amount_locked_hint: "Definido en el simulador. Volv\xE9 al paso anterior para cambiarlo.",
      no_amount_variable_warning: 'La plantilla elegida no tiene la variable "Importe": el monto simulado no se aplicar\xE1 autom\xE1ticamente.',
      success_title: "Ofrecimiento creado",
      success_description: "Se ha creado el ofrecimiento de indemnizaci\xF3n correctamente",
      step_terms: "Condiciones del ofrecimiento",
      step_agreement: "Conformidad",
      single_payment: "Pago \xFAnico",
      installments_label: "Forma de pago",
      fees_label: "Honorarios del letrado",
      fees_required_hint: "El reclamo tiene abogado: el porcentaje es obligatorio",
      payee_label: "\xBFQui\xE9n cobra la indemnizaci\xF3n?",
      payee_hint: "El reclamo tiene abogado apoderado",
      payee_options: {
        victim: "Damnificado",
        attorney_in_fact: "Apoderado"
      },
      message_preview_title: "Mensaje de ofrecimiento (as\xED lo ver\xE1 el reclamante)",
      message_preview_hint: "Eleg\xED las condiciones de pago para ver el mensaje",
      message_preview_loading: "Preparando el mensaje\u2026",
      message_syntax_error: "La plantilla del mensaje tiene un error de sintaxis. Avis\xE1 al administrador.",
      message_blocking_title: "Faltan datos del reclamo para completar el mensaje",
      message_blocking_hint: "Completalos en el reclamo y volv\xE9 a intentar: el ofrecimiento no se puede enviar con huecos.",
      acceptance_title: "Qu\xE9 le vamos a pedir al reclamante",
      acceptance_file: "archivo",
      acceptance_optional: "opcional",
      acceptance_blocking_title: "Falta informaci\xF3n del reclamo para que el reclamante pueda cobrar",
      agreement_template: "Plantilla de conformidad",
      signature_undetermined: "Se define al aceptar",
      signature_unresolved: "Sin regla de firma: avis\xE1 al administrador",
      signers_title: "Firmantes de la conformidad",
      signers_empty: "La plantilla no declara recuadros de firma",
      signer_optional: "opcional",
      disclaimer: "Confirmo que revis\xE9 los datos del ofrecimiento y el modelo de conformidad que se va a enviar, y que los datos registrados son correctos.",
      pending_data_title: "Lo completa el reclamante al aceptar",
      absent_data_title: "Datos opcionales del reclamo que faltan",
      absent_data_hint: "No impiden enviar: las partes de la conformidad que los usan no se imprimen.",
      legacy_notice: "Este reclamo sigue el flujo manual: {{reason}}",
      agreement_plan_changed_notice: "La configuraci\xF3n cambi\xF3 desde la vista previa. Revis\xE1 el mensaje y la conformidad antes de enviar.",
      warnings_title: "Avisos sobre los datos del reclamo",
      blocking_issues_title: "Revis\xE1 los datos del reclamo para continuar con la conformidad",
      blocking_issues_hint: "Correg\xED los datos en el reclamo y actualiz\xE1 la vista previa. El ofrecimiento no se puede enviar as\xED.",
      blocking_issues_refresh: "Actualizar",
      blocking_signer: "{{label}}: {{reason}}",
      agreement_blocking_issues_notice: "Los datos del reclamo no permiten generar la conformidad ({{keys}}). Corregilos y actualiz\xE1 la vista previa.",
      agreement_review_required_notice: "Este reclamo lleva conformidad: revis\xE1 el documento y confirm\xE1 el deslinde antes de enviar.",
      offer_message_not_configured_notice: "La carta de ofrecimiento dej\xF3 de estar disponible. Avis\xE1 al administrador y volv\xE9 a intentar.",
      message_incomplete_notice: "El mensaje tiene datos del reclamo faltantes ({{keys}}). Completalos antes de enviar.",
      preview_error: "No pudimos evaluar la conformidad para este reclamo.",
      preview_error_fallback: "El ofrecimiento se env\xEDa igual, por el flujo de siempre: eleg\xED la plantilla y complet\xE1 sus datos.",
      preview_loading: "Preparando el ofrecimiento\u2026",
      retry: "Reintentar",
      blocking_variable: "Falta {{label}} en el reclamo",
      blocking_condition: "Una cl\xE1usula depende de un dato que falta en el reclamo: {{attribute}}",
      signature_dispatch_from: "Al aceptarse, la conformidad sale a firmar desde tu cuenta de AutoSign ({{email}}).",
      signature_dispatch_blocked_title: "Todav\xEDa no se puede enviar a firmar",
      signature_dispatch_blockers: {
        sender_connection_missing: "Conect\xE1 tu cuenta de AutoSign desde Integraciones: la conformidad sale a firmar desde ella.",
        sender_connection_reconnect_required: "Tu cuenta de AutoSign tiene que volver a conectarse desde Integraciones.",
        signer_email_missing: "La firma se decide al aceptar y estos firmantes no tienen email: {{keys}}.",
        signer_email_shared: "Los firmantes deben tener correos electr\xF3nicos diferentes: {{shared}} usan el mismo correo."
      },
      agreement_signature_dispatch_blocked_notice: "El ofrecimiento no se envi\xF3: la conformidad sale a firmar por AutoSign y falta tu cuenta conectada, falta el email de un firmante o dos firmantes comparten el mismo correo.",
      amount_exceeds_cap: "El monto no debe superar el tope.",
      offer_amount_exceeds_cap_notice: "La estimaci\xF3n del reclamo cambi\xF3 y el monto supera el tope vigente. Revis\xE1 el monto antes de enviar.",
      offer_cap_not_computable_notice: "El reclamo ya no tiene un tope calculable. Carg\xE1 la responsabilidad y la estimaci\xF3n judicial antes de ofrecer.",
      cap_not_computable_reason: "Carg\xE1 la responsabilidad y la estimaci\xF3n judicial para calcular el tope del ofrecimiento",
      cap_zero_reason: "El tope del ofrecimiento es $0: actualiz\xE1 la estimaci\xF3n para poder ofrecer",
      derived_claim_reason: "El reclamo est\xE1 derivado: devolv\xE9 o cancel\xE1 la derivaci\xF3n para poder ofrecer"
    },
    panel: {
      title: "Contexto hist\xF3rico (\xFAltimos 12 meses)",
      claimer_average: "Aceptaci\xF3n promedio del reclamante",
      claimer_average_hint: "Promedio de lo que acept\xF3 este mismo reclamante, como % del tope, en otros reclamos del mismo tipo. Cuenta la \xFAltima aceptaci\xF3n vigente de cada reclamo. \xDAltimos 12 meses.",
      type_average: "Aceptaci\xF3n promedio general",
      type_average_hint: "Promedio de todos los reclamos de la compa\xF1\xEDa con ofrecimiento aceptado en este tipo de reclamo, como % del tope. \xDAltimos 12 meses.",
      mediation_judgment: "Piso Mediaci\xF3n/Juicio",
      mediation_judgment_hint: "Mediana del \xFAltimo ofrecimiento rechazado de cada reclamo que igual termin\xF3 en Mediaci\xF3n o Juicio, como % del tope: son montos que no alcanzaron para acordar. Mismo tipo de reclamo, \xFAltimos 12 meses.",
      cases: "{{count}} casos",
      no_data: "Sin data suficiente",
      of_cap: "del tope",
      on_this_claim: "en este reclamo",
      cases_tooltip: "Reclamos considerados (no incluye el actual)",
      cases_tooltip_more: "y {{count}} m\xE1s"
    },
    table: {
      sent: "Fecha ofrecimiento",
      sent_by: "Enviado por",
      amount: "Importe",
      distance_to_cap: "Porc. del tope",
      probability: "Prob. acept.",
      status: "Estado",
      of_cap: "{{value}}% del tope",
      empty_title: "No se encontraron ofrecimientos",
      empty_description: "De momento no se realizaron ofrecimientos de indemnizaci\xF3n al tercero involucrado",
      of_judicial: "{{value}}% del judicial",
      context_title: "Contexto del ofrecimiento",
      context_offer: "Este ofrecimiento",
      context_claimer_average: "Prom. reclamante",
      context_type_average: "Prom. general",
      context_mediation_judgment: "Piso Med./Juicio",
      context_cases: "{{count}} casos",
      context_cap: "Tope",
      context_liability: "resp. {{value}}%",
      context_pretension: "Pretensi\xF3n",
      view_agreement: "Ver conformidad",
      detail_title: "Detalle del ofrecimiento",
      view_previous_agreement: "Ver conformidad (anterior)",
      agreement: "Conformidad"
    },
    agreement_document: {
      status_code: {
        missing_data: "Faltan datos obligatorios del reclamo, as\xED que no se imprimi\xF3.",
        syntax_error: "Un bloque de la plantilla no compila, as\xED que no se imprimi\xF3.",
        undetermined_condition: "Una cl\xE1usula depende de un dato que falta en el reclamo, as\xED que no se imprimi\xF3.",
        missing_anchors: "El PDF no trae el lugar de una firma obligatoria: sirve para firmar en papel, no digitalmente.",
        render_failed: "El generador de PDF no respondi\xF3. Se reintenta solo; si sigue fallando, us\xE1 Reintentar.",
        pdf_unreadable: "No se pudo leer el PDF generado para ubicar las firmas.",
        abandoned: "La generaci\xF3n se interrumpi\xF3 y se volvi\xF3 a intentar."
      },
      skip_reason: {
        offer_not_accepted: "El ofrecimiento ya no est\xE1 aceptado.",
        automation_disabled: "La conformidad autom\xE1tica de la compa\xF1\xEDa est\xE1 apagada.",
        plan_not_found: "No se encontr\xF3 la conformidad que se eligi\xF3 al enviar.",
        plan_not_selected: "El ofrecimiento se envi\xF3 sin conformidad.",
        resolution_failed: "No se pudieron leer los datos del reclamo o del ofrecimiento."
      },
      missing_title: "Datos que faltan",
      download: "Descargar PDF",
      dispatch: {
        sender: "Remitente: {{name}} ({{email}})",
        dispatched_at: "Enviada el {{date}}",
        connect_hint: "Para reintentar el env\xEDo con tu cuenta, conect\xE1 AutoSign desde Integraciones.",
        retry_account_required: "Solo se puede reintentar desde la cuenta de AutoSign {{email}}: la solicitud pudo haber salido desde ella.",
        retry: "Reintentar env\xEDo desde {{email}}"
      },
      signing: {
        sync: "Sincronizar",
        sync_success: "Estado actualizado con AutoSign",
        signed: "Firm\xF3",
        signed_at: "Firm\xF3 el {{date}}",
        pending: "Pendiente de firma",
        documents_pending: "La firma se complet\xF3, pero los documentos firmados todav\xEDa no llegaron desde AutoSign.",
        synced_at: "\xDAltima novedad de AutoSign: {{date}}"
      }
    },
    agreement: {
      title: "Conformidad",
      context: {
        accepted: "aceptado el {{date}}",
        sent: "enviado el {{date}}",
        sent_by: "enviado por {{name}}",
        view_offer: "Ver ofrecimiento"
      },
      phase: {
        awaiting_acceptance: "Esperando aceptaci\xF3n",
        generating: "Generando documento",
        skipped: "No se gener\xF3",
        generation_failed: "Fall\xF3 la generaci\xF3n",
        invalid: "No se pudo imprimir",
        ready_offline: "Lista para firmar",
        dispatching: "Enviando a AutoSign",
        dispatch_failed: "Env\xEDo detenido",
        signing: "En firma",
        completed: "Firmada",
        rejected: "Rechazada",
        expired: "Vencida",
        canceled_by_provider: "Cancelada en AutoSign",
        canceled: "Anulada"
      },
      summary: {
        awaiting_acceptance: "La conformidad se genera cuando el reclamante acepte el ofrecimiento.",
        generating: "Se est\xE1 generando el documento de la conformidad.",
        skipped: "La conformidad no se gener\xF3 para esta aceptaci\xF3n.",
        generation_failed: "No se pudo generar el documento de la conformidad.",
        invalid: "El documento no se imprimi\xF3: el reclamo no ten\xEDa todo lo necesario cuando se envi\xF3 el ofrecimiento.",
        ready_offline: "El documento est\xE1 listo. Esta conformidad se firma por fuera de AutoSign: descargalo y gestion\xE1 la firma.",
        dispatching: "Se est\xE1 enviando la conformidad a firmar por AutoSign.",
        dispatch_failed: "El env\xEDo a AutoSign se detuvo.",
        signing: "Esperando firmas: {{signed}} de {{total}}.",
        signing_next: "Le toca firmar a {{name}}.",
        completed: "La conformidad est\xE1 firmada por todas las partes.",
        rejected: "Un firmante rechaz\xF3 la conformidad en AutoSign.",
        expired: "La conformidad venci\xF3 sin que se completaran las firmas.",
        canceled_by_provider: "La conformidad se cancel\xF3 desde el panel de AutoSign.",
        canceled: "La conformidad se anul\xF3 junto con su ofrecimiento."
      },
      guidance: {
        fix_with_new_offer: "Para corregirlo, anul\xE1 el ofrecimiento y envi\xE1 uno nuevo.",
        continue_with_new_offer: "Para avanzar, anul\xE1 el ofrecimiento y envi\xE1 uno nuevo.",
        go_to_offers: "Ir a Ofrecimiento"
      },
      status: {
        rejected_reason: "Motivo del rechazo: {{reason}}",
        transaction: "Transacci\xF3n en AutoSign",
        cancel_in_autosign: "La solicitud puede seguir activa en AutoSign: cancelala desde el panel de AutoSign buscando \xAB{{name}}\xBB (transacci\xF3n {{id}}).",
        provider_cancel: {
          in_progress: "Estamos cancelando la solicitud de firma en AutoSign.",
          canceled: "La solicitud de firma tambi\xE9n se cancel\xF3 en AutoSign.",
          signed_before: "AutoSign registr\xF3 todas las firmas antes de la cancelaci\xF3n: el documento firmado est\xE1 en AutoSign."
        },
        retry_generation: "Reintentar generaci\xF3n",
        transaction_name: "Nombre: {{name}}",
        canceled_reason: "Motivo de la cancelaci\xF3n: {{reason}}"
      },
      steps: {
        acceptance: "Aceptaci\xF3n",
        document: "Documento",
        dispatch: "Env\xEDo",
        signature: "Firma",
        signature_count: "Firma {{signed}}/{{total}}",
        signature_in_person: "Firma presencial",
        signature_offline: "Firma fuera de AutoSign",
        title: "Avance de la conformidad",
        completed: "Finalizada",
        current: {
          acceptance: "Esperando respuesta",
          document: "Generando",
          dispatch: "Enviando",
          signature: "Esperando firmas",
          completed: "En curso",
          offline: "Por fuera de AutoSign"
        },
        state: {
          done: "Completado",
          current: "En curso",
          upcoming: "Pendiente",
          error: "Con problemas"
        }
      },
      signers: {
        title: "Firmantes",
        planned: "Previstos al enviar el ofrecimiento.",
        empty: "La plantilla no tiene recuadros de firma.",
        no_email: "Sin email",
        next: "Le toca firmar",
        waiting: "En espera",
        offline: "Firma fuera de AutoSign",
        upcoming: "Se env\xEDa a firmar al aceptar"
      },
      document: {
        title: "Documento de conformidad",
        template: "Plantilla \xAB{{name}}\xBB \xB7 versi\xF3n {{version}}",
        template_rule: "Elegida por la regla \xAB{{name}}\xBB.",
        signature_digital: "Firma digital por AutoSign",
        signature_digital_off: "Firma digital por fuera de Piramid: el env\xEDo a AutoSign estaba apagado cuando se envi\xF3 el ofrecimiento",
        signature_in_person: "Firma presencial",
        signature_undecided: "M\xE9todo de firma sin definir",
        unsigned: "Conformidad para firmar",
        generated_at: "Generada el {{date}}",
        signed: "Conformidad firmada",
        signed_hint: "Tambi\xE9n est\xE1 en la Documentaci\xF3n del reclamo.",
        pending_generation: "El documento se genera cuando el reclamante acepte el ofrecimiento.",
        not_available: "Todav\xEDa no hay un documento generado.",
        view: "Ver",
        download: "Descargar",
        open_in_new_tab: "Abrir en una pesta\xF1a nueva",
        original: "Documento original (sin firmar)",
        origin: {
          action: "Ver c\xF3mo se cre\xF3 esta conformidad",
          title: "C\xF3mo se cre\xF3 esta conformidad",
          template: "Plantilla",
          signature: "Modalidad de firma",
          signature_rule: "Decidida por la regla \xAB{{name}}\xBB."
        }
      },
      history: {
        title: "Historial de eventos",
        empty: "Todav\xEDa no hay movimientos de esta conformidad.",
        error: "No pudimos cargar el historial."
      },
      empty: {
        title: "Este reclamo no tiene una conformidad vigente"
      },
      manual: {
        description: "Este ofrecimiento se envi\xF3 sin una conformidad generada por Piramid. Carg\xE1 el PDF de la conformidad gestionada externamente.",
        uploaded_hint: "Cargada a mano. Tambi\xE9n est\xE1 en la Documentaci\xF3n del reclamo.",
        upload: "Cargar PDF",
        replace: "Reemplazar",
        cancel: "Cancelar",
        upload_success: "Conformidad cargada",
        replace_hint: "El PDF anterior queda en la Documentaci\xF3n del reclamo."
      },
      errors: {
        load: "No pudimos cargar la conformidad.",
        offers: "No pudimos cargar los ofrecimientos del reclamo.",
        retry: "Reintentar"
      },
      vigency: {
        current: "Vigente",
        current_hint: "Es la conformidad actual del reclamo.",
        previous: "Anterior",
        previous_canceled: "No es la vigente: se anul\xF3 junto con su ofrecimiento el {{date}}.",
        previous_superseded: "No es la vigente: la reemplaz\xF3 \xAB{{name}}\xBB, enviado el {{date}}."
      }
    },
    offer_detail: {
      tabs: {
        offer: "Ofrecimiento",
        agreement: "Conformidad"
      },
      legacy_badge: "Circuito anterior"
    }
  },
  estimates: {
    empty_value: "Sin valor",
    vehicle_market_value: "Valor Venal",
    person_percentage_of_judicial_risk: "Riesgo Judicial",
    administrative_amount: "Administrativo",
    judicial_amount: "Judicial",
    percentage_of_liability: "Responsabilidad",
    material_judicial_amount: "Judicial",
    person_judicial_amount: "Judicial",
    material_administrative_amount: "Administrativo",
    person_administrative_amount: "Administrativo",
    groups: {
      general: "General",
      material: "Da\xF1os materiales",
      person: "Da\xF1os corporales"
    },
    activity: {
      percentage_of_liability: "la responsabilidad",
      person_percentage_of_judicial_risk: "el riesgo judicial",
      administrative_amount: "el monto administrativo",
      material_judicial_amount: "el monto judicial de da\xF1os materiales",
      person_judicial_amount: "el monto judicial de da\xF1os corporales",
      material_administrative_amount: "el monto administrativo de da\xF1os materiales",
      person_administrative_amount: "el monto administrativo de da\xF1os corporales"
    },
    validation: {
      group_out_of_range: "El total {{ scope }} ({{ members }}) debe quedar entre {{ from }} y {{ to }}. Hoy es {{ current }}.",
      group_limit_exceeded: "El total {{ scope }} ({{ members }}) no debe superar {{ limit }}. Con este cambio quedar\xEDa en {{ total }}.",
      out_of_range: "Debe estar en el rango de {{ from }} a {{ to }}",
      limit_exceeded: "No debe superar {{ limit }}",
      missing_permission: "No ten\xE9s permiso para realizar esta acci\xF3n"
    },
    offer_cap: {
      label: "Tope ofrecimiento:",
      not_computable: "No calculable",
      not_computable_hint: "Falta responsabilidad o monto judicial",
      formula_title: "C\xF3mo se calcula",
      formula: "(Da\xF1os materiales judicial + Da\xF1os corporales judicial) \xD7 Responsabilidad",
      formula_hint: "Los montos administrativos y el valor venal no intervienen."
    },
    update_result: {
      updated_title: "Estimaci\xF3n actualizada",
      updated_description: "El cambio qued\xF3 registrado correctamente",
      unchanged_title: "Sin cambios para registrar",
      unchanged_description: "El valor enviado es el que ya estaba registrado"
    }
  },
  type: {
    material_vehicle_with_license_plate: "Da\xF1os Materiales de veh\xEDculos con patente",
    material: "Da\xF1os Materiales",
    material_vehicle_without_license_plate: "Da\xF1os Materiales de veh\xEDculos sin patente",
    person_injury: "Lesiones",
    material_and_person_injury: "Combinado con Lesiones",
    person_death: "Fallecidos",
    material_real_property: "Da\xF1os materiales a inmuebles",
    claimant_worker_compensation_insurer: "ART",
    material_and_person_death: "Da\xF1os Materiales y Fallecidos",
    recovery: "Recupero"
  },
  status: {
    open: "Abierto",
    closed: "Cerrado",
    reference: {
      claimant_disinterest: "Desinter\xE9s del Reclamante",
      not_successful: "No Prosper\xF3",
      reconciled: "Conciliado",
      in_closing_process: "En proceso de Cierre",
      derivation: "Derivaci\xF3n",
      analysis: "An\xE1lisis del reclamo",
      on_claim: "Generaci\xF3n de Reclamo",
      technical_analysis: "An\xE1lisis T\xE9cnico",
      inspection: "Inspecci\xF3n",
      responsibility_analysis: "An\xE1lisis de Responsabilidad",
      negotiation: "Negociaci\xF3n",
      payment_process: "En proceso de Pago",
      homologation: "Homologaci\xF3n",
      demand_transfer: "Traslado Demanda",
      canceled: "Anulado",
      rejected: "Rechazado (luego del An\xE1lisis)",
      settlement_payment: "Liquidaci\xF3n y Pago",
      mediation: "Mediaci\xF3n",
      judgment: "Juicio",
      fraud: "Fraude"
    },
    role: {
      none: "Sin rol",
      default: "Por defecto",
      default_no_complaint: "Por defecto - (sin denuncia)",
      documentation_completed: "Documentaci\xF3n completa",
      documentation_request: "Documentaci\xF3n requerida",
      criminal_case_request: "Solicitud causa penal",
      offer_flow: "Ofrecimiento",
      not_response: "Sin respuesta",
      claim_rejected: "Rechazo",
      additional_management: "Gestiones adicionales",
      default_missing_documentation: "Por defecto - Documentaci\xF3n faltante",
      default_missing_documentation_no_complaint: "Por defecto - Documentaci\xF3n faltante (sin denuncia)",
      claim_derived_user_strategy: "Reclamo derivado a usuario",
      claim_derived_team_strategy: "Reclamo derivado a grupo de destino",
      offer_agreement_completed: "Conformidad completada",
      offer_accepted: "Ofrecimiento aceptado",
      offer_rejected: "Ofrecimiento rechazado",
      offer_created: "Ofrecimiento creado",
      claim_derived_target_group_strategy: "Reclamo derivado a grupo de destino",
      sinister_derived_fraud: "Siniestro derivado a fraude",
      fraud: "Fraude",
      mediation: "Mediaci\xF3n",
      lawsuit: "Juicio",
      reconciled: "Conciliado",
      offer_canceled: "Ofrecimiento anulado",
      offer_expired: "Ofrecimiento expirado",
      offer_agreement_started: "Conformidad digital pendiente de firma",
      order_created: "Orden de trabajo creada",
      order_accepted: "Orden de trabajo aceptada",
      order_rejected: "Orden de trabajo rechazada por el proveedor",
      order_canceled: "Orden de trabajo anulada",
      order_completed: "Orden de trabajo finalizada",
      order_work_proof_completed: "Inspecci\xF3n de trabajo completada",
      order_work_proof_approved: "Inspecci\xF3n de trabajo aprobada",
      order_work_proof_disapproved: "Inspecci\xF3n de trabajo desaprobada"
    }
  },
  tabs: {
    detail: "Detalle",
    documents: "Documentaci\xF3n",
    claims: "Reclamos",
    activity: "Actividad",
    fraud: "Fraude",
    complaints: "Denuncias"
  },
  steps: {
    "doc-proof_of_ownership_document": "Certificado de propiedad",
    "doc-vehicle_title": "T\xEDtulo del veh\xEDculo",
    "doc-victim_national_identity_card_back": "DNI (dorso)",
    "doc-victim_national_identity_card_front": "DNI (frente)",
    "doc-material_victim_national_identity_card_back": "DNI (dorso)",
    "doc-material_victim_national_identity_card_front": "DNI (frente)",
    "doc-policy_insurance": "Copia completa de la p\xF3liza",
    "doc-repair_bill": "Factura de reparaci\xF3n",
    "doc-damage_budget": "Presupuesto de los da\xF1os",
    "doc-real_property": "Fotos de la propiedad",
    "doc-vehicle": "Fotos del veh\xEDculo",
    "doc-rental_agreement": "Contrato de alquiler",
    "doc-deed": "Escritura",
    "doc-subrogation_certificate": "Constancia de subrogaci\xF3n",
    "doc-expense_receipt": "Factura/Comprobante por gastos medicos",
    "doc-medical_report": "Dictamen m\xE9dico de ART",
    "doc-medical_discharge": "Alta m\xE9dica de ART",
    "doc-accounting_certificate": "Certificado contable",
    "doc-policy_deductible_letter": "Carta de franquicia",
    "doc-policy_coverage_certificate": "Certificado de cobertura",
    "doc-inspection_photo": "Foto de Inspecci\xF3n",
    "doc-orion_report": "Informe Orion",
    "doc-sinister_video": "Video del siniestro",
    "doc-sinister_photo": "Foto del siniestro",
    "doc-vehicle_id_card_back": "C\xE9dula verde (dorso)",
    "doc-vehicle_id_card_front": "C\xE9dula verde (frente)",
    "doc-mother_national_id_document_front": "DNI de la madre (frente)",
    "doc-mother_national_id_document_back": "DNI de la madre (dorso)",
    "doc-father_national_id_document_back": "DNI del padre (dorso)",
    "doc-father_national_id_document_front": "DNI del padre (frente)",
    "doc-income_verification": "Acreditaci\xF3n de ingresos",
    "doc-occupancy_report": "Informe de ocupaci\xF3n",
    "doc-death_certificate": "Acta de defunci\xF3n",
    "doc-birth_certificate": "Partida de nacimiento",
    "doc-certificate_medical_treatment": "Certificado atenci\xF3n m\xE9dica",
    "doc-affidavit_of_no_insurance": "Declaraci\xF3n jurada de no seguro",
    "doc-insurance_complaint": "Denuncia del siniestro realizada en tu aseguradora",
    "doc-complaint": "Denuncia",
    "doc-load": "Carga de documentos",
    "doc-claim-note": "Escrito de reclamo",
    "claim-created": "Reclamo creado",
    "claimant-list": "Lista de reclamantes",
    "medical-institution-info": "Datos de la instituci\xF3n m\xE9dica",
    "worker-compensation-insurer-info": "Datos de la ART",
    "health-insurance-info": "Datos de la obra social",
    "was-treated-by-medical-institution": "Atenci\xF3n M\xE9dica",
    "had-surgery": "Intervenci\xF3n quir\xFArgica",
    "surgery-description": "Intervenci\xF3n quir\xFArgica",
    "was-treated-by-worker-compensation-insurer": "Servicio de ART",
    "has-health-insurance": "Obra social",
    "victim-minor-mother-info": "Datos de la madre",
    "victim-minor-father-info": "Datos del padre",
    "victim-injuries-details": "Detalles de lesiones",
    "victim-injuries-rol": "Datos del damnificado",
    "victim-injuries-rol-material": "Datos del damnificado de da\xF1os materiales",
    "vehicle-ownership-document-choose": "Acreditaci\xF3n de titularidad del bien",
    "real-property-info": "Informaci\xF3n del Inmueble",
    "real-property-location": "Ubicaci\xF3n del Inmueble",
    "match-real-property-victim-address": "Coincidencia de domicilio",
    "location-info": "Ubicaci\xF3n del reclamo",
    "claimed-amount": "Monto reclamado",
    "sinister-info": "Datos del siniestro",
    "sinister-type": "Ingres\xE1 tu reclamo",
    "vehicle-driver-info": "Datos del conductor",
    "material-damage-insurer-info": "Datos del seguro",
    "vehicle-info": "Datos del veh\xEDculo",
    "legal-person-reimbursements-info": "Datos de la instituci\xF3n reclamante",
    "vehicle-driver-ownership": "Propiedad del veh\xEDculo",
    "victim-natural-person-info": "Datos del Damnificado (persona f\xEDsica)",
    "victim-natural-person-address-info": "Domicilio Damnificado (persona f\xEDsica)",
    "victim-relationship": "V\xEDnculo con el damnificado",
    "victim-legal-person-info": "Damnificado (persona jur\xEDdica)",
    "recovery-institution-info": "Instituci\xF3n Reclamante",
    "own-claim-choose": "\xBFReclama en nombre propio?",
    "own-material-claim-choose": "Da\xF1os materiales, \xBFReclama en nombre propio?",
    "victim-type-choose": "Damnificado due\xF1o del bien",
    "damage-declaration": "Selecciona los da\xF1os que deseas declarar.",
    "damage-material-type": "\xBFQue tipo de da\xF1o material sufri\xF3?",
    "special-branch-info": "Reporte del siniestro",
    "is-local-insured-involved": "\xBFEl siniestro involucr\xF3 un veh\xEDculo asegurado por {{companyName}}?",
    "vehicle-category": "Tipo de veh\xEDculo",
    "claim-confirmation": "Env\xEDo de reclamo",
    welcome: "Bienvenido",
    "insured-info": "Siniestro con un veh\xEDculo asegurado en {{companyName}}",
    "claimant-info": "Reclamante",
    "has-insurance": "\xBFPose\xEDa seguro al momento del siniestro?",
    "has-income-verification": "\xBFPosee la acreditaci\xF3n de ingresos del damnificado?",
    "occurrence-optional-info": "Intervenci\xF3n policial",
    "injured-identity-card": "Documentaci\xF3n de la persona damnificada",
    "material-damage-documents": "Documentaci\xF3n del titular del bien",
    "same-damage-victim": "\xBFLa persona lesionada es la titular del veh\xEDculo?",
    "same-damage-victim-real-property": "\xBFLa persona lesionada es la titular del inmueble?",
    "material-victim-natural-person-info": "Datos del titular del bien",
    "material-victim-natural-person-address-info": "Domicilio del titular del bien",
    "material-victim-minor-father-info": "Datos del padre del titular del bien",
    "material-victim-minor-mother-info": "Datos de la madre del titular del bien",
    "material-claimant-info": "Reclamante de da\xF1os materiales",
    "material-claimant-address-info": "Domicilio del reclamante de da\xF1os materiales",
    "material-victim-relationship": "V\xEDnculo con el titular del bien",
    v2: {
      "victim-relationship": "V\xEDnculo con la persona lesionada",
      "victim-death-relationship": "V\xEDnculo con la persona fallecida",
      "victim-natural-person-info": "Datos de la persona lesionada",
      "victim-natural-person-address-info": "Domicilio de la persona lesionada",
      "victim-death-info": "Datos de la persona fallecida",
      "victim-death-address-info": "Domicilio de la persona fallecida",
      "victim-injuries-rol": "Condici\xF3n al momento del siniestro",
      "injured-identity-card": "Documentaci\xF3n de la persona lesionada",
      "own-claim-choose": "Lesiones, \xBFReclama en nombre propio?",
      "victim-type-choose": "El titular del veh\xEDculo",
      "victim-type-choose-real-property": "El titular del inmueble"
    },
    "recovery-institution-relationship": "V\xEDnculo con el damnificado",
    "recovery-claimant-info": "Reclamante",
    "recovery-claimant-address-info": "Reclamante",
    "recovery-injured-person-info": "Datos del beneficiario de las prestaciones",
    "recovery-asset-owner-info": "Datos del beneficiario de las prestaciones",
    "recovery-damage-type": "Da\xF1o que origina el recupero"
  },
  draft: {
    restored: {
      title: "Recuperamos lo que hab\xEDas cargado",
      description: "Segu\xEDs desde donde lo dejaste."
    },
    documents_restored: {
      title: "Recuperamos los archivos que hab\xEDas subido",
      description: "El formulario cambi\xF3 desde tu \xFAltima visita, as\xED que ten\xE9s que volver a completar los datos."
    },
    expired_documents: "Algunos archivos vencieron y hay que volver a subirlos.",
    continue: "Seguir",
    start_over: "Empezar de cero",
    saved_at: "Guardado el {{date}} a las {{time}}",
    license_plate: "Patente {{plate}}",
    elsewhere: {
      title: "Ten\xE9s un reclamo sin terminar en otra pesta\xF1a",
      description: "Pod\xE9s seguirlo ac\xE1 o empezar uno nuevo."
    },
    continue_here: "Continuar ac\xE1",
    start_new: "Empezar uno nuevo",
    maybe_submitted: {
      title: "Puede que este reclamo ya se haya enviado",
      description: "Se cort\xF3 mientras lo enviabas. Revis\xE1 tus reclamos antes de mandarlo de nuevo."
    },
    see_claims: "Ver mis reclamos",
    taken: {
      title: "Este reclamo se abri\xF3 en otra pesta\xF1a",
      description: "Para no mezclar datos, seguilo en la otra pesta\xF1a. Si quer\xE9s cargar otro reclamo, recarg\xE1 esta.",
      reload: "Recargar"
    }
  },
  notices: {
    "minor-material-victim": "La fecha ingresada indica que el titular del bien es menor de edad. Si es correcto, continu\xE1. Si fue un error, correg\xED la fecha.",
    "minor-victim": "La fecha ingresada indica que el damnificado es menor de edad. Si es correcto, continu\xE1. Si fue un error, correg\xED la fecha."
  },
  document: {
    police_report: "Parte policial",
    identity_card: "C\xE9dula de identidad",
    incident_damage_photo: "Foto del incidente",
    vehicle_roof: "Veh\xEDculo Parte Techo",
    vehicle_side_right: "Veh\xEDculo Parte Acompa\xF1ante",
    vehicle_side_left: "Veh\xEDculo Parte Conductor",
    vehicle_front: "Veh\xEDculo Parte Frontal",
    vehicle_back: "Veh\xEDculo Parte Trasera",
    vehicle_damage_photo_bonnet: "Veh\xEDculo - Da\xF1o Capot",
    vehicle_damage_photo_boot: "Veh\xEDculo - Da\xF1o Trasero",
    vehicle_damage_photo_door_left: "Veh\xEDculo - Da\xF1o Puerta Izquierda",
    vehicle_damage_photo_door_right: "Veh\xEDculo - Da\xF1o Puerta Derecha",
    vehicle_damage_photo_roof: "Veh\xEDculo - Da\xF1o Techo",
    vehicle_qualification: "Veh\xEDculo - Habilitacion",
    policy_holder_vehicle_identity_card_front: "C\xE9dula verde (frente)",
    policy_holder_vehicle_identity_card_back: "C\xE9dula verde (dorso)",
    policy_holder_identity_card_front: "C\xE9dula de identidad (frente)",
    policy_holder_identity_card_back: "C\xE9dula de identidad (dorso)",
    vehicle_authorization_document: "Veh\xEDculo - Habilitaci\xF3n",
    vehicle_authorization_document_front: "Veh\xEDculo - Habilitaci\xF3n (frente)",
    vehicle_authorization_document_back: "Veh\xEDculo - Habilitaci\xF3n (dorso)",
    vehicle_registration_card: "C\xE9dula del veh\xEDculo",
    vehicle_registration_card_front: "C\xE9dula del veh\xEDculo (frente)",
    vehicle_registration_card_back: "C\xE9dula del veh\xEDculo (dorso)",
    driver_license: "C\xE9dula de conducir",
    policy_holder_driver_license_front: "C\xE9dula de conducir (frente)",
    policy_holder_driver_license_back: "C\xE9dula de conducir (dorso)",
    policy_coverage_certificate: "Certificado de cobertura",
    policy_deductible_letter: "Carta de franquicia",
    accounting_certificate: "Certificado contable",
    medical_discharge: "Alta m\xE9dica de ART",
    medical_report: "Dictamen m\xE9dico de ART",
    expense_receipt: "Factura/Comprobante por gastos medicos",
    subrogation_certificate: "Nota de subrogaci\xF3n",
    deed: "Escritura",
    appraisal_invoice: "Factura del liquidador/perito",
    contract_invoice: "Factura del contratista",
    rental_agreement: "Contrato de alquiler",
    vehicle: "Fotos del veh\xEDculo",
    real_property: "Fotos de la propiedad",
    damage_budget: "Presupuesto de los da\xF1os",
    repair_bill: "Factura de reparaci\xF3n",
    policy_insurance: "Copia completa de la p\xF3liza",
    victim_national_identity_card_front: "DNI del damnificado (frente)",
    victim_national_identity_card_back: "DNI del damnificado (dorso)",
    material_victim_national_identity_card_front: "DNI del damnificado (frente)",
    material_victim_national_identity_card_back: "DNI del damnificado (dorso)",
    vehicle_title: "T\xEDtulo del veh\xEDculo",
    proof_of_ownership_document: "Certificado de propiedad",
    complaint: "Denuncia Policial",
    insurance_complaint: "Denuncia del siniestro realizada en tu aseguradora",
    affidavit_of_no_insurance: "Declaraci\xF3n jurada de no seguro",
    certificate_medical_treatment: "Certificado atenci\xF3n m\xE9dica",
    birth_certificate: "Partida de nacimiento",
    death_certificate: "Acta de defunci\xF3n",
    occupancy_report: "Informe de ocupaci\xF3n",
    income_verification: "Acreditaci\xF3n de ingresos",
    father_national_id_document_front: "DNI del padre (frente)",
    father_national_id_document_back: "DNI del padre (dorso)",
    mother_national_id_document_front: "DNI de la madre (frente)",
    mother_national_id_document_back: "DNI de la madre (dorso)",
    vehicle_id_card_front: "C\xE9dula verde (frente)",
    vehicle_id_card_back: "C\xE9dula verde (dorso)",
    sinister_photo: "Foto del siniestro",
    sinister_video: "Video del siniestro",
    orion_report: "Informe Orion",
    inspection_photo: "Foto de Inspecci\xF3n",
    expert_appraisal_photo: "Foto de Peritaci\xF3n",
    offer_agreement: "Ofrecimiento de Indemnizaci\xF3n",
    appraisal_report: "Informe de evaluaci\xF3n",
    contract_report: "Reporte de contrato",
    appraisal_updates_file: "Novedades de la evaluaci\xF3n",
    contract_updates_file: "Novedades del contrato",
    rfp_bid_file: "Licitaci\xF3n Proveedor Documento",
    rfp_contract_file: "Reporte Licitaci\xF3n Contrato",
    order_report: "Reporte de orden",
    order_invoice: "Factura de orden",
    vehicle_side_left_damage: "Da\xF1os en el lado conductor",
    vehicle_side_right_damage: "Da\xF1os en el lado acompa\xF1ante",
    vehicle_back_damage: "Da\xF1os en la parte trasera",
    vehicle_front_damage: "Da\xF1os en la parte frontal",
    vehicle_roof_damage: "Da\xF1os en el techo",
    signature: "Firma",
    claim_note: "Escrito de reclamo",
    power_of_attorney: "Poder",
    service_bill: "Factura de servicio/impuesto",
    expense_detail_sheet: "Planilla de erogaciones",
    work_incapacity_payment_receipt: "Comprobantes de pago ILT/ILP",
    permanent_work_incapacity_documentation: "Documentaci\xF3n de ILP",
    medical_record: "Historia cl\xEDnica"
  },
  document_group: {
    title: "Documentaci\xF3n que podemos pedirte",
    subtitle: "Revis\xE1 qu\xE9 papeles tener a mano antes de empezar",
    description: "No necesit\xE1s tenerla ahora para crear el reclamo, pero algunas son necesarias para que podamos avanzar con la tramitaci\xF3n.",
    vehicle: "Da\xF1os a un veh\xEDculo",
    real_property: "Da\xF1os a un inmueble",
    injury: "Lesiones",
    death: "Fallecimiento",
    recovery: "Recupero de gastos",
    representation: "Si reclam\xE1s en representaci\xF3n de otra persona",
    other: "Otra documentaci\xF3n"
  },
  document_merged: {
    vehicle_ownership: "T\xEDtulo del veh\xEDculo o C\xE9dula verde",
    national_identity_card: "DNI del damnificado"
  }
};
var events = {
  complaint_collaborator_assigned: "Colaborador asignado",
  claim_collaborator_assigned: "Colaborador asignado",
  claim_activity_view: "Vista de actividad de reclamo",
  complaint_documentation_list_view: "Vista de documentaci\xF3n de denuncia",
  fraud_news_requested: "Solicitud de novedades en investigaci\xF3n de fraude",
  fraud_news_answered: "Novedades en investigaci\xF3n de fraude",
  fraud_investigation_case_created: "Investigaci\xF3n de fraude creada",
  fraud_reopened: "Investigaci\xF3n de fraude reabierta",
  fraud_claim_result_updated: "Resultado de reclamo actualizado",
  complaint_responsible_assigned: "Responsable asignado",
  claim_responsible_assigned: "Responsable asignado",
  sinister_complaints_view: "Vista de denuncias",
  sinister_fraud_investigation_cases_view: "Vista de casos de investigaci\xF3n de fraude",
  sinister_expert_appraisals_view: "Vista de peritaciones",
  claim_form_step_completed: "Paso de formulario de reclamo completado",
  claim_form_step_view: "Vista de paso de formulario de reclamo",
  claim_form_vehicle_id_card_extracted: "Lectura de c\xE9dula del veh\xEDculo",
  claim_form_navigation: "Navegaci\xF3n en formulario de reclamo",
  sinister_list_view: "Vista de siniestros",
  settings_profile_view: "Vista de perfil",
  documentation_filter: "Filtro de documentaci\xF3n",
  settings_distribution_view: "Vista de distribuci\xF3n",
  team_created: "Equipo creado",
  team_detail_view: "Vista de detalle de grupo de destino",
  load_balance_rule_created: "Regla de distribuci\xF3n creada",
  load_balance_rule_detail_view: "Vista de detalle de regla de distribuci\xF3n",
  teams_view: "Vista de equipos",
  invitations_view: "Vista de invitaciones",
  roles_view: "Vista de roles",
  load_balance_rules_view: "Vista de reglas de distribuci\xF3n",
  users_invited: "Usuarios invitados",
  forwarded_invitation: "Invitaci\xF3n reenviada",
  role_detail_view: "Vista de detalle de rol",
  claim_created: "Reclamo creado",
  documentation_search: "B\xFAsqueda de documentaci\xF3n",
  file_requested: "Solicitud de documentaci\xF3n creada",
  file_request_placeholder_cancelled: "Solicitud de documentaci\xF3n cancelada",
  file_view: "Vista de documento",
  load_balance_rule_deleted: "Regla de distribuci\xF3n eliminada",
  load_balance_rule_updated: "Regla de distribuci\xF3n actualizada",
  login: "Inicio de sesi\xF3n",
  logout: "Cierre de sesi\xF3n",
  settings_notifications_view: "Vista de notificaciones",
  settings_team_view: "Vista de equipo",
  sinister_activity_view: "Vista de actividad de siniestro",
  files_requested: "Documentaci\xF3n solicitada",
  sinister_complaint_chat_message_send: "Denuncia - Mensaje de chat enviado",
  sinister_claim_chat_message_send: "Reclamo - Mensaje de chat enviado",
  sinister_claim_chat_view: "Vista de chat de reclamo",
  sinister_claim_detail_view: "Vista de detalle de reclamo",
  sinister_claim_view: "Vista del detalle de un reclamo",
  sinister_claims_view: "Vista de reclamos",
  sinister_collaborator_assigned: "Colaborador asignado",
  sinister_collaborator_unassigned: "Colaborador removido",
  sinister_document_view: "Vista de documento de siniestro",
  sinister_documentation_list_view: "Vista de documentaci\xF3n de siniestro",
  sinister_filter: "Filtro de siniestros",
  sinister_responsible_assigned: "Responsable asignado",
  sinister_responsible_unassigned: "Responsable removido",
  sinister_search: "B\xFAsqueda de siniestros",
  sinister_table_view: "Vista de tabla de siniestros",
  sinister_view: "Vista de siniestro",
  team_deleted: "Equipo eliminado",
  team_updated: "Equipo actualizado",
  upload_files: "Subida de archivos",
  claim_responsible_unassigned: "Responsable removido",
  claim_status_updated: "Estado de reclamo actualizado",
  claim_status_communication_sent: "Comunicaci\xF3n autom\xE1tica enviada",
  claim_documentation_requested: "Documentacion solicitada",
  claim_documentation_completed: "Documentacion completa",
  contract_created: "Contrato creado",
  contract_report_created: "Reporte de contrato creado",
  contract_report_accepted: "Reporte de contrato aceptado",
  contract_report_rejected: "Reporte de contrato rechazado",
  offer_expired: "Ofrecimiento expirado",
  offer_rejected: "Ofrecimiento rechazado",
  offer_accepted: "Ofrecimiento aceptado",
  offer_canceled: "Ofrecimiento anulado",
  fraud_closed: "Fraude cerrado",
  resource_type: {
    claim: "reclamo",
    complaint: "denuncia"
  },
  complaint_form_step_view: "Vista de formulario de denuncia",
  rfp_bid_winner_selected: "Ganador de la oferta de licitaci\xF3n seleccionado",
  rfp_bid_submitted: "Oferta de licitaci\xF3n presentada",
  rfp_created: "Licitaci\xF3n creada",
  contract_updates_published: "Novedades de contrato publicadas",
  contract_updates_requested: "Novedades de contrato solicitadas",
  contract_invoice_uploaded: "Factura de contrato cargada",
  appraisal_invoice_uploaded: "Factura de peritaje cargada",
  appraisal_updates_published: "Novedades de peritaje publicadas",
  appraisal_updates_requested: "Novedades de peritaje solicitadas",
  appraisal_report_rejected: "Informe de evaluaci\xF3n rechazado",
  appraisal_report_created: "Informe de evaluaci\xF3n creado",
  appraisal_report_accepted: "Informe de evaluaci\xF3n aceptado",
  field_adjuster_assigned: "Liquidador/Perito asignado",
  fraud_updated: "Investigaci\xF3n de fraude actualizada",
  fraud_investigation_report_accepted: "Informe de investigaci\xF3n de fraude aceptado",
  complaint_file_request_uploaded: "Solicitud de documentaci\xF3n de denuncia cargada",
  file_request_uploaded: "Solicitud de documentaci\xF3n cargada",
  sinister_created: "Siniestro creado",
  sinister_third_party_complaints_view: "Vista de denuncias de terceros",
  complaint_created: "Denuncia creada",
  claim_document_view: "Vista de documento de reclamo",
  external_complaint_documentation_list_view: "Vista de documentaci\xF3n de denuncia externa",
  claim_documentation_list_view: "Vista de documentaci\xF3n de reclamo",
  fraud_activity_view: "Vista de actividad de fraude",
  complaint_activity_view: "Vista de actividad de denuncia",
  complaint_collaborator_unassigned: "Colaborador removido",
  claim_collaborator_unassigned: "Colaborador removido",
  complaint_status_updated: "Estado de denuncia actualizado",
  pending_sinister_complaint: "Denuncia de siniestro pendiente",
  pending_file_request_upload: "Solicitud de carga de documentaci\xF3n pendiente",
  criminal_case_request: "Solicitud de causa penal",
  claim_not_response: "Reclamo sin respuesta",
  claim_offer_flow: "Ofrecimiento de reclamo",
  claim_rejected: "Reclamo rechazado",
  claim_additional_management: "Gestiones adicionales de reclamo",
  claim_ownership_transfer_requested: "Solicitud de transferencia de propiedad de reclamo",
  claim_ownership_transfer_accepted: "Transferencia de propiedad de reclamo aceptada",
  claim_ownership_transfer_rejected: "Transferencia de propiedad de reclamo rechazada",
  claim_ownership_assigned: "Propiedad de reclamo asignada",
  claim_estimates_updated: "Estimaciones de reclamo actualizadas",
  pending_offer_response: "Respuesta de conformidad",
  pending_offer_agreement_response: "Respuesta acuerdo de conformidad pendiente",
  offer_agreement_completed: "Conformidad completada",
  offer_agreement_rejected: "Conformidad rechazada",
  offer_agreement_expired: "Conformidad expirada",
  offer_agreement_cancelled: "Conformidad anulada",
  pending_offer_response_internal: "Respuesta de oferta interna pendiente",
  pending_offer_agreement_response_internal: "Respuesta acuerdo de conformidad interna pendiente",
  claim_updated: "Reclamo actualizado",
  complaint_updated: "Denuncia actualizada",
  complaint_sinister_cause_updated: "Causa de siniestro de denuncia actualizada",
  external_complaint_selected: "Definir denuncia principal",
  claim_derived: "Reclamo derivado",
  claim_derived_returned: "Reclamo derivado devuelto",
  claim_responsibility_returned: "Responsabilidad de reclamo devuelta",
  pending_complaint_created: "Denuncia de oficio creada",
  pending_complaint_requested: "Denuncia de oficio solicitada",
  pending_complaint_creation_failed: "Error en creaci\xF3n de denuncia de oficio",
  external_complaint_selection_failed: "Error en selecci\xF3n de denuncia principal",
  rfp_expired: "Licitaci\xF3n expirada",
  external_complaint_created: "Denuncia creada en el sistema tercero",
  complaint_authorized: "Denuncia autorizada",
  external_complaint_authorized: "Denuncia autorizada en el sistema tercero",
  complaint_approved: "Denuncia aprobada",
  external_complaint_approved: "Denuncia aprobada en el sistema tercero",
  complaint_rejected: "Denuncia rechazada",
  external_complaint_rejected: "Denuncia rechazada en el sistema tercero",
  complaint_estimates_updated: "Estimaciones de denuncia actualizadas",
  order_created: "Orden creada",
  order_report_created: "Reporte de orden creado",
  order_report_accepted: "Reporte de orden aceptado",
  order_report_rejected: "Reporte de orden rechazado",
  order_updates_published: "Mensajes de orden enviados",
  order_updates_requested: "Mensajes de orden solicitados",
  order_invoice_uploaded: "Factura de orden cargada",
  order_scheduled: "Trabajo de orden coordinado",
  order_rescheduled: "Trabajo de orden recoordinado",
  order_schedule_canceled: "Turno de orden anulado",
  alert_sla_objective_progress: "Alerta de progreso de objetivo de SLA",
  alert_sla_total_progress: "Alerta de progreso total de SLA",
  sinister_external_status_updated: "Estado externo de siniestro actualizado",
  complaint_confirmation_signature: "Denuncia firmada",
  tags_view: "Vista de etiquetas",
  tag_created: "Etiqueta creada",
  tag_updated: "Etiqueta actualizada",
  tag_deleted: "Etiqueta eliminada",
  claim_file_uploaded: "Documento de reclamo cargado",
  claim_comment_created: "Comentario en reclamo creado",
  claim_confirmation_signature: "Firma de reclamo",
  offer_agreement_created: "Conformidad creada",
  offer_created: "Ofrecimiento creado",
  target_group_created: "Grupo creado",
  target_group_deleted: "Grupo eliminado",
  target_group_updated: "Grupo actualizado",
  target_groups_view: "Vista de grupos",
  target_group_detail_view: "Vista de detalle de grupo",
  rfp_canceled: "Licitaci\xF3n cancelada",
  claim_created_documents_missing: "Reclamo creado con documentaci\xF3n faltante",
  offer_agreement_dispatch_failed: "Env\xEDo a firmar fallido",
  user_assignments_paused: "Usuario marcado como no disponible",
  user_assignments_resumed: "Usuario marcado como disponible",
  team_claims_reassigned: "Reclamos del equipo reasignados",
  team_claims_delegated: "Reclamos delegados por inactividad",
  user_inactivity_started: "Usuario pas\xF3 a inactivo",
  user_inactivity_ended: "Usuario volvi\xF3 a activo",
  user_inactivity_scheduled: "Inactividad de usuario programada",
  user_inactivity_rescheduled: "Inactividad de usuario modificada",
  user_inactivity_return_changed: "Fecha de regreso de usuario modificada",
  user_inactivity_cancelled: "Inactividad de usuario cancelada",
  team_claims_recovered: "Reclamos delegados recuperados por su due\xF1o",
  user_delegated_claims_recovered: "Reclamos delegados recuperados",
  user_delegated_claims_returned: "Reclamos delegados retornados",
  user_derived_claims_returned: "Reclamos derivados retornados desde Gesti\xF3n de equipo",
  user_derived_claims_recovered: "Reclamos derivados recuperados desde Gesti\xF3n de equipo"
};
var fileRequest = {
  cancelPlaceholderTitle: "Cancelar solicitud de documento",
  cancelPlaceholderDescription: "Escribe el motivo por el cual cancelas la solicitud de este documento",
  cancelPlaceholderSuccess: "Solicitud cancelada",
  cancelPlaceholderSuccessDescription: "La solicitud de documento fue cancelada correctamente",
  cancelled: "Cancelado",
  reason: "Motivo"
};
var entities = {
  vehicle_id_card_back: {
    label: "C\xE9dula (dorso)",
    owner_name: "Nombre",
    owner_address: "Direcci\xF3n",
    owner_identity_number: "Documento"
  },
  vehicle_id_card_front: {
    label: "C\xE9dula (frente)",
    license_plate: "Patente",
    id_card_number: "Documento",
    chassis_number: "Chasis",
    model: "Modelo",
    make: "Marca",
    type: "Tipo",
    use: "Uso",
    motor: "Motor",
    expiration_date: "Fecha de expiraci\xF3n"
  },
  death_certificate: {
    label: "Certificado de defunci\xF3n",
    day: "Dia",
    hour: "Hora",
    year: "A\xF1o",
    reason: "Motivo"
  },
  medical_certificate: {
    label: "Certificado m\xE9dico",
    doctor_full_name: "Medico",
    doctor_license_number: "Matricula",
    date: "Fecha",
    diagnosis: "Diagn\xF3stico"
  },
  coverage_certificate: {
    label: "Certificado de cobertura",
    effective_date_from: "Vigencia desde",
    effective_date_to: "Vigencia hasta"
  },
  vehicle: {
    label: "Veh\xEDculo",
    license_plate: "Patente"
  },
  national_identity_card: {
    label: "DNI",
    first_name: "Nombre",
    last_name: "Apellido",
    birth_date: "Fecha de nacimiento",
    issued_date: "Fecha de emision",
    sex: "G\xE9nero",
    expiration_date: "Fecha de expiraci\xF3n",
    document_number: "Documento"
  }
};
var validations = {
  document_number: "N\xFAmero de documento",
  full_name: "Nombre",
  address: "Direcci\xF3n/Domicilio",
  make: "Marca",
  model: "Modelo",
  license_plate: "Patente/Dominio",
  birth_date: "Fecha de nacimiento",
  victim_national_identity_card_birth_date: "Fecha de nacimiento",
  medical_certificate_sinister_date: "Dias h\xE1biles",
  health_insurance_fund: "Obra social",
  doctor_stamp_visible: "Sello del m\xE9dico",
  doctor_license_number_visible: "Matr\xEDcula del m\xE9dico",
  diagnosis_visible: "Diagn\xF3stico",
  vehicle_license_plate: "Patente",
  vehicle_ownership: "Propiedad del veh\xEDculo",
  policy_period: "Vigencia de la p\xF3liza",
  death_certificate_fields: "Certificado de defunci\xF3n",
  national_identity_card_fields: "DNI",
  worker_compensation_insurer: "ART"
};
var entrypoints = {
  claim: "Reclamo",
  complaint: "Denuncia"
};
var backends = {
  rivadavia: "Rivadavia Seguros",
  tajy: "Tajy Seguros",
  demoempleo: "Demo Empleo",
  gamma: "Gamma Distribuidora"
};
var file_types = {
  other: "Otro",
  pdf: "PDF",
  audio: "Audio",
  image: "Imagen",
  document: "Documento",
  video: "Video",
  any: "Cualquier archivo"
};
var sinister = {
  tabs: {
    documents: "Documentaci\xF3n",
    claims: "Reclamos",
    activity: "Actividad"
  },
  status: {
    pending: "Pendiente",
    open: "Abierto",
    closed: "Cerrado",
    rejected: "Rechazado",
    in_process: "En proceso"
  }
};
var errors = {
  not_found_trigger_mapping: {
    title: "Equivalencia no encontrada",
    description: "La equivalencia ya no existe. Actualiz\xE1 la p\xE1gina."
  },
  trigger_mapping_move_out_of_bounds: {
    title: "No se puede mover la equivalencia",
    description: "La equivalencia ya est\xE1 en el extremo de la lista."
  },
  ownership_transfer_superseded: {
    title: "La invitaci\xF3n ya no es v\xE1lida",
    description: "El reclamo cambi\xF3 de reclamante despu\xE9s de que se envi\xF3 esta invitaci\xF3n."
  },
  victim_email_must_differ_from_owner: {
    title: "El email del damnificado no puede ser el tuyo",
    description: "Est\xE1s cargando el reclamo en representaci\xF3n de otra persona, as\xED que el damnificado tiene que quedar con su propio email."
  },
  claimant_email_must_differ_from_victim: {
    title: "El damnificado y el reclamante no pueden compartir el email",
    description: "El reclamo no se carga en nombre propio, as\xED que el damnificado tiene que quedar con un email distinto al del reclamante."
  },
  claimant_identification_must_match_victim: {
    title: "El documento no es el del damnificado",
    description: "Elegiste reclamar en nombre propio, pero el documento de tu cuenta no es el que figura como damnificado. Si est\xE1s reclamando por otra persona, indic\xE1 el v\xEDnculo que te une a ella."
  },
  claim_owner_already_assigned: {
    title: "Ya es el reclamante",
    description: "Ese usuario ya es el due\xF1o del reclamo."
  },
  agreement_template_not_found: {
    title: "No se encontr\xF3 la plantilla",
    description: "La plantilla no existe o no pertenece a esta compa\xF1\xEDa."
  },
  agreement_template_version_not_found: {
    title: "No se encontr\xF3 la versi\xF3n",
    description: "La versi\xF3n no existe o no pertenece a esta plantilla."
  },
  agreement_template_name_already_exists: {
    title: "Nombre repetido",
    description: "Ya existe una plantilla con ese nombre en la compa\xF1\xEDa."
  },
  agreement_template_draft_already_exists: {
    title: "Ya hay un borrador",
    description: "La plantilla ya tiene un borrador en edici\xF3n. Publicalo o segu\xED edit\xE1ndolo."
  },
  agreement_template_version_not_draft: {
    title: "La versi\xF3n no es un borrador",
    description: "Solo se puede editar un borrador. Cre\xE1 una versi\xF3n nueva para cambiar el texto."
  },
  agreement_template_version_not_published: {
    title: "La versi\xF3n no est\xE1 publicada",
    description: "Solo se puede deprecar una versi\xF3n publicada."
  },
  agreement_template_syntax_error: {
    title: "Error de sintaxis en un bloque",
    description: "Un bloque tiene una condici\xF3n mal cerrada o una sintaxis inv\xE1lida: {{message}}"
  },
  agreement_template_unknown_variable: {
    title: "Variables desconocidas",
    description: "El texto referencia variables que no existen en el cat\xE1logo: {{keys}}"
  },
  agreement_clone_target_company_not_found: {
    title: "Compa\xF1\xEDa destino inexistente",
    description: "La compa\xF1\xEDa a la que se quiere clonar no existe."
  },
  agreement_clone_same_company: {
    title: "Es la misma compa\xF1\xEDa",
    description: "Para copiar dentro de la misma compa\xF1\xEDa us\xE1 Duplicar."
  },
  agreement_clone_unresolved_references: {
    title: "Faltan referencias por resolver",
    description: "Estas referencias no tienen equivalente elegido en la compa\xF1\xEDa destino: {{references}}"
  },
  agreement_clone_missing_variables: {
    title: "Variables que el destino no tiene",
    description: "El texto usa variables que la compa\xF1\xEDa destino no define: {{keys}}"
  },
  agreement_template_unknown_condition_option: {
    title: "Condici\xF3n hacia algo que la compa\xF1\xEDa no tiene",
    description: "El bloque {{block_id}} est\xE1 condicionado a valores que esta compa\xF1\xEDa no tiene, as\xED que nunca se imprimir\xEDa: {{values}}"
  },
  agreement_template_invalid_signers: {
    title: "Recuadros de firma inconsistentes",
    description: "Hay bloques de firmas que referencian recuadros inexistentes o recuadros que ning\xFAn bloque imprime: {{keys}}"
  },
  agreement_template_version_unchanged: {
    title: "Sin cambios",
    description: "El contenido es id\xE9ntico al de la versi\xF3n publicada."
  },
  agreement_template_has_published_version: {
    title: "La plantilla tiene una versi\xF3n publicada",
    description: "Deprec\xE1 la versi\xF3n publicada antes de eliminar la plantilla."
  },
  agreement_document_not_found: {
    title: "No se encontr\xF3 el documento",
    description: "El documento de conformidad no existe o no pertenece a esta compa\xF1\xEDa."
  },
  agreement_document_render_failed: {
    title: "No se pudo generar el PDF",
    description: "El renderizado fall\xF3 y el documento qued\xF3 registrado como fallido: {{reason}}"
  },
  agreement_claim_not_found: {
    title: "No se encontr\xF3 el reclamo",
    description: "El reclamo no existe o no pertenece a esta compa\xF1\xEDa."
  },
  agreement_offer_not_found: {
    title: "El reclamo no tiene ofrecimiento",
    description: "No encontramos el ofrecimiento indicado para este reclamo. Sin ofrecimiento no hay variables que resolver."
  },
  agreement_offer_type_unsupported: {
    title: "Ofrecimiento no soportado",
    description: "Las conformidades solo aplican a ofrecimientos de reclamos."
  },
  agreement_message_template_not_found: {
    title: "No se encontr\xF3 la plantilla",
    description: "La plantilla de ofrecimiento no existe o no pertenece a esta compa\xF1\xEDa."
  },
  agreement_acceptance_values_invalid: {
    title: "Valores de aceptaci\xF3n inv\xE1lidos",
    description: "Los valores de la aceptaci\xF3n deben ser un objeto indexado por el guid de cada variable."
  },
  non_corporate_integration_account: {
    title: "Cuenta no corporativa",
    description: "Conect\xE1 la integraci\xF3n con tu cuenta de correo corporativa."
  },
  unexpected_error: {
    title: "Ocurri\xF3 un error",
    description: "No pudimos completar la acci\xF3n. Por favor, intent\xE1 nuevamente en unos minutos."
  },
  customer_organization_already_exists: {
    title: "Nombre en uso",
    description: "Ya existe una organizaci\xF3n con ese nombre."
  },
  customer_organization_not_found: {
    title: "Organizaci\xF3n no encontrada",
    description: "La organizaci\xF3n no existe o fue eliminada."
  },
  customer_organization_user_not_linkable: {
    title: "No se puede vincular",
    description: "Solo se puede vincular un reclamante que no pertenezca a otra organizaci\xF3n."
  },
  customer_organization_user_not_member: {
    title: "Usuario no pertenece a la organizaci\xF3n",
    description: "El usuario indicado no es miembro de esta organizaci\xF3n."
  },
  customer_organization_user_owns_claims: {
    title: "Reclamos pendientes de reasignar",
    description: "El usuario tiene reclamos de la organizaci\xF3n a su nombre: eleg\xED a qui\xE9n reasignarlos."
  },
  customer_organization_invitation_not_found: {
    title: "Invitaci\xF3n no encontrada",
    description: "La invitaci\xF3n no existe o no pertenece a esta organizaci\xF3n."
  },
  customer_organization_invitation_already_exists: {
    title: "Invitaci\xF3n pendiente",
    description: "Ya hay una invitaci\xF3n vigente para ese email en esta organizaci\xF3n. Pod\xE9s reenviarla desde la tabla de invitaciones."
  },
  customer_organization_invitation_not_resendable: {
    title: "No se puede reenviar",
    description: "Solo se pueden reenviar invitaciones pendientes o vencidas."
  },
  customer_organization_invitation_not_cancellable: {
    title: "No se puede cancelar",
    description: "Solo se pueden cancelar invitaciones pendientes o vencidas."
  },
  customer_organization_invitation_invalid_tenant: {
    title: "Aseguradora inv\xE1lida",
    description: "Eleg\xED una aseguradora con portal habilitado para enviar la invitaci\xF3n."
  },
  customer_organization_sign_in_invalid_tenant: {
    title: "Aseguradora inv\xE1lida",
    description: "Eleg\xED una aseguradora con portal habilitado para iniciar sesi\xF3n."
  },
  customer_organization_transfer_not_allowed: {
    title: "Transferencia no disponible",
    description: "Los reclamos de una organizaci\xF3n pertenecen a la organizaci\xF3n: sus miembros no pueden transferirlos ni recibir transferencias."
  },
  order_document_requirement_name_already_exists: {
    title: "Nombre repetido",
    description: "Esta compa\xF1\xEDa ya tiene un documento con ese nombre."
  },
  order_document_requirement_not_found: {
    title: "Documento no encontrado",
    description: "El documento ya no existe o fue eliminado."
  },
  claim_status_without_equivalence: {
    title: "Estado sin equivalencia",
    description: "El estado elegido no tiene una equivalencia configurada. Definila primero para que la sincronizaci\xF3n pueda derivar la etapa y la referencia del reclamo."
  },
  status_linked_to_order_claim_mapping: {
    title: "Estado vinculado a una sincronizaci\xF3n",
    description: "Este estado est\xE1 siendo usado por una sincronizaci\xF3n orden - reclamo. Elimin\xE1 esa sincronizaci\xF3n antes de eliminar el estado."
  },
  order_claim_status_mapping_not_found: {
    title: "Sincronizaci\xF3n no encontrada",
    description: "La sincronizaci\xF3n ya no existe o fue eliminada."
  },
  autoinspector_not_configured: {
    title: "Autoinspector no est\xE1 configurado",
    description: "La compa\xF1\xEDa todav\xEDa no carg\xF3 su API Key de Autoinspector."
  },
  autoinspector_already_configured: {
    title: "Autoinspector ya est\xE1 configurado",
    description: "Ya hay una API Key cargada. Si quer\xE9s cambiarla, us\xE1 la opci\xF3n de actualizar."
  },
  autoinspector_invalid_credentials: {
    title: "API Key inv\xE1lida",
    description: "Autoinspector rechaz\xF3 la clave. Verific\xE1 que la copiaste completa y que sigue activa."
  },
  autoinspector_subscription_inactive: {
    title: "Suscripci\xF3n inactiva",
    description: "La cuenta de Autoinspector tiene la suscripci\xF3n vencida o una factura impaga."
  },
  autoinspector_quota_exceeded: {
    title: "L\xEDmite del plan alcanzado",
    description: "La cuenta de Autoinspector lleg\xF3 al l\xEDmite de inspecciones de su plan."
  },
  autoinspector_wrong_environment: {
    title: "Clave de otro entorno",
    description: "Est\xE1s usando una clave de prueba contra un recurso productivo, o al rev\xE9s."
  },
  autoinspector_invalid_request: {
    title: "Autoinspector rechaz\xF3 la solicitud",
    description: "Los datos enviados no cumplen con lo que espera Autoinspector."
  },
  autoinspector_inspection_not_found: {
    title: "Inspecci\xF3n no encontrada",
    description: "La inspecci\xF3n no existe en Autoinspector."
  },
  autoinspector_unavailable: {
    title: "Autoinspector no est\xE1 disponible",
    description: "No pudimos comunicarnos con Autoinspector. Intent\xE1 nuevamente en unos minutos."
  },
  kach_unavailable: {
    title: "Kach no est\xE1 disponible",
    description: "No pudimos comunicarnos con Kach. Intent\xE1 nuevamente en unos minutos."
  },
  integration_connection_not_found: {
    title: "Integraci\xF3n no configurada",
    description: "Tu compa\xF1\xEDa todav\xEDa no tiene configurada la integraci\xF3n con Kach. Pedile a tu administrador que la active."
  },
  kach_insufficient_permissions: {
    title: "Tu rol en Kach no lo permite",
    description: "Tu cuenta de Kach est\xE1 conectada, pero tu rol no permite esta acci\xF3n. Pedile a un administrador de Kach que revise tus permisos."
  },
  kach_machine_client_incomplete: {
    title: "Falta el cliente de m\xE1quina",
    description: "Para usar la credencial de m\xE1quina carg\xE1 el ID y el secreto del cliente de Kach."
  },
  kach_machine_credential_rejected: {
    title: "Kach rechaz\xF3 la credencial de la compa\xF1\xEDa",
    description: "Revis\xE1 el cliente de m\xE1quina de Kach en el backoffice o desactiv\xE1 la credencial de m\xE1quina."
  },
  kach_connection_required: {
    title: "Conect\xE1 tu cuenta de Kach",
    description: "Para continuar necesit\xE1s conectar o reconectar tu cuenta de Kach desde este mismo di\xE1logo."
  },
  kach_connection_not_found: {
    title: "No hay una cuenta de Kach conectada",
    description: "Todav\xEDa no conectaste tu cuenta de Kach."
  },
  kach_oauth_disabled: {
    title: "Conexi\xF3n con Kach no habilitada",
    description: "Tu aseguradora todav\xEDa no habilit\xF3 la conexi\xF3n de cuentas con Kach."
  },
  kach_oauth_not_configured: {
    title: "Conexi\xF3n con Kach sin configurar",
    description: "Falta configurar la conexi\xF3n con Kach para tu aseguradora. Avisale a soporte."
  },
  kach_oauth_state_invalid: {
    title: "La conexi\xF3n expir\xF3",
    description: "El intento de conexi\xF3n venci\xF3 o ya se us\xF3. Volv\xE9 a intentarlo desde Piramid."
  },
  kach_oauth_denied: {
    title: "Kach no autoriz\xF3 la conexi\xF3n",
    description: "No se complet\xF3 la autorizaci\xF3n en Kach. Volv\xE9 a intentarlo."
  },
  kach_company_mismatch: {
    title: "La cuenta de Kach es de otra aseguradora",
    description: "Inici\xE1 sesi\xF3n en Kach con la cuenta de tu aseguradora y volv\xE9 a intentarlo."
  },
  kach_email_mismatch: {
    title: "La cuenta de Kach no coincide",
    description: "Conect\xE1 la cuenta de Kach que usa tu mismo correo electr\xF3nico."
  },
  unauthorized_oauth_query: {
    title: "No se pudo completar la conexi\xF3n",
    description: "El proveedor rechaz\xF3 el c\xF3digo de autorizaci\xF3n. Volv\xE9 a intentarlo."
  },
  autoinspector_webhook_deletion_failed: {
    title: "No pudimos borrar el webhook",
    description: "Autoinspector no acept\xF3 eliminar el webhook, as\xED que no borramos las credenciales. Si la cuenta ya no existe, volv\xE9 a intentarlo forzando la eliminaci\xF3n."
  },
  autoinspector_template_not_configured: {
    title: "Falta la plantilla",
    description: "Este caso de uso no tiene ninguna plantilla de Autoinspector asignada."
  },
  autoinspector_template_already_assigned: {
    title: "El caso de uso ya tiene plantilla",
    description: "Hay una sola plantilla por caso de uso. Edit\xE1 la existente o eliminala antes de asignar otra."
  },
  autoinspector_template_not_found: {
    title: "Plantilla no encontrada",
    description: "La asignaci\xF3n que quer\xE9s modificar no existe o pertenece a otra empresa."
  },
  order_work_proof_not_completed: {
    title: "Falta la prueba de trabajo",
    description: "La orden necesita al menos una inspecci\xF3n de Autoinspector completada para poder finalizarse."
  },
  order_work_proof_not_creatable: {
    title: "No se puede crear la inspecci\xF3n",
    description: "Solo se puede solicitar una inspecci\xF3n con la orden en curso y sin otra inspecci\xF3n vigente sin resolver."
  },
  order_work_proof_inspection_not_found: {
    title: "La orden no tiene inspecciones",
    description: "Todav\xEDa no se solicit\xF3 una prueba de trabajo para esta orden."
  },
  order_work_proof_invalid_item_count: {
    title: "No se podr\xE1 crear la prueba de trabajo",
    description: "Esta orden incluye una prueba de trabajo, que exige entre 1 y 10 \xEDtems en total. Cargalos antes de derivarla: despu\xE9s no se pueden modificar."
  },
  order_work_proof_missing_product_brand: {
    title: "No se podr\xE1 crear la prueba de trabajo",
    description: "Esta orden incluye una prueba de trabajo, que necesita la marca de los productos. Us\xE1 \xEDtems del cat\xE1logo con marca cargada antes de derivarla."
  },
  order_work_proof_missing_license_plate: {
    title: "No se podr\xE1 crear la prueba de trabajo",
    description: "Esta orden incluye una prueba de trabajo, que necesita la patente del veh\xEDculo. Cargala en el da\xF1o material del reclamo antes de derivarla."
  },
  order_work_proof_template_mismatch: {
    title: "La plantilla de inspecci\xF3n no coincide",
    description: "La plantilla de Autoinspector ya no expone los datos que la prueba de trabajo necesita ({{assets}}). Revis\xE1 la configuraci\xF3n de la plantilla."
  },
  order_not_scheduled: {
    title: "Falta la coordinaci\xF3n del trabajo",
    description: "Registr\xE1 cu\xE1ndo se realiza el trabajo antes de finalizar la orden."
  },
  order_schedule_not_editable: {
    title: "No se puede coordinar",
    description: "Solo se puede registrar o modificar la coordinaci\xF3n con la orden en curso."
  },
  unknown_autoinspector_use_case: {
    title: "Caso de uso desconocido",
    description: "El caso de uso no est\xE1 en el cat\xE1logo de Autoinspector."
  },
  webhook_signature_invalid: {
    title: "Firma inv\xE1lida",
    description: "La firma del webhook no coincide con la esperada."
  },
  integration_backend_self_managed: {
    title: "Integraci\xF3n autoadministrada",
    description: "Esta integraci\xF3n se configura desde su propia secci\xF3n. Crearla ac\xE1 guardar\xEDa la credencial sin cifrar y sin webhook."
  },
  not_claim_owner: {
    title: "No sos el due\xF1o del reclamo",
    description: "Solo el due\xF1o actual del reclamo puede realizar esta acci\xF3n."
  },
  validation_error: {
    title: "Error de validaci\xF3n",
    description: "El valor ingresado no es v\xE1lido"
  },
  product_sku_already_exists: {
    title: "SKU ya registrado",
    description: "El SKU ingresado ya est\xE1 en uso por otro producto, incluso si fue eliminado."
  },
  product_not_found: {
    title: "Producto no encontrado",
    description: "El producto indicado no existe"
  },
  customer_already_exists: {
    title: "Cliente ya registrado",
    description: "El nombre ingresado ya est\xE1 en uso por otro cliente, incluso si fue eliminado."
  },
  customer_not_found: {
    title: "Cliente no encontrado",
    description: "El cliente indicado no existe"
  },
  engagement_external_id_already_exists: {
    title: "C\xF3digo ya registrado",
    description: "Otro proveedor de tu red ya usa este c\xF3digo interno."
  },
  provider_group_already_exists: {
    title: "Grupo ya registrado",
    description: "Ya existe otro grupo de proveedores con el mismo nombre."
  },
  provider_group_not_found: {
    title: "Grupo no encontrado",
    description: "El grupo de proveedores indicado no existe."
  },
  provider_group_not_empty: {
    title: "El grupo tiene proveedores",
    description: "Para eliminar el grupo, primero quit\xE1 todos sus proveedores."
  },
  provider_not_in_active_network: {
    title: "Proveedor no disponible",
    description: "El proveedor debe tener una relaci\xF3n activa con tu empresa para formar parte de un grupo."
  },
  case_already_closed: {
    title: "El caso no puede derivarse porque ya fue analizado y cerrado.",
    description: "Comunicate con el responsable de la investigaci\xF3n en Kach ({{responsible_name}} - {{responsible_email}}) y pedile que lo reabra."
  },
  kach_case_in_trash: {
    title: "El siniestro #{{sinister_id}} ya existe pero se encuentra en la papelera.",
    description: "No es posible crear un nuevo caso con este n\xFAmero de siniestro. Comun\xEDquese con un usuario con permisos suficientes para restaurar el caso desde la papelera."
  },
  fraud_case_linked_to_another_sinister: {
    title: "El caso ya est\xE1 asociado a otro siniestro",
    description: "El caso de kach ya est\xE1 asociado a la investigaci\xF3n de otro siniestro de Piramid. Deriv\xE1 los reclamos desde ese siniestro."
  },
  not_found_vertical: {
    title: "Vertical no encontrado",
    description: "El vertical indicado no existe"
  },
  engagement_already_exists: {
    title: "Proveedor ya en tu red",
    description: "Este proveedor ya forma parte de tu red"
  },
  provider_invitation_already_exists: {
    title: "Invitaci\xF3n pendiente",
    description: "Ya existe una invitaci\xF3n pendiente para este email. Debes anularla antes de volver a invitar."
  },
  provider_invitation_not_found: {
    title: "Invitaci\xF3n no encontrada",
    description: "La invitaci\xF3n indicada no existe"
  },
  provider_invitation_not_pending: {
    title: "Acci\xF3n no disponible",
    description: "Solo se puede reenviar o anular una invitaci\xF3n pendiente"
  },
  provider_already_exists: {
    title: "Proveedor ya registrado",
    description: "Ya existe un proveedor registrado con este email"
  },
  provider_ein_already_exists: {
    title: "CUIT ya registrado",
    description: "Ya existe un proveedor registrado con este CUIT"
  },
  provider_legal_name_already_exists: {
    title: "Raz\xF3n social ya registrada",
    description: "Ya existe una empresa registrada con esta raz\xF3n social"
  },
  invalid_invitation_token: {
    title: "Invitaci\xF3n inv\xE1lida",
    description: "El enlace de invitaci\xF3n no es v\xE1lido"
  },
  invitation_expired: {
    title: "Invitaci\xF3n vencida",
    description: "La invitaci\xF3n ya expir\xF3. Ped\xED que te reenv\xEDen una nueva."
  },
  engagement_not_pending: {
    title: "Acci\xF3n no disponible",
    description: "Solo se puede aceptar o rechazar una invitaci\xF3n pendiente"
  },
  engagement_invalid_transition: {
    title: "Acci\xF3n no disponible",
    description: "El estado actual del proveedor no permite esta acci\xF3n"
  },
  engagement_not_active: {
    title: "Proveedor no vinculado",
    description: "No hay un v\xEDnculo activo con este proveedor para derivarle trabajo"
  },
  provider_has_active_order: {
    title: "El proveedor ya tiene una orden activa",
    description: "Este proveedor ya tiene una orden pendiente o en curso en este reclamo. An\xFAlala antes de derivar una nueva."
  },
  order_not_in_progress: {
    title: "La orden no est\xE1 en curso",
    description: "La orden debe estar en curso para subir o revisar la documentaci\xF3n requerida."
  },
  order_not_open: {
    title: "La orden ya est\xE1 cerrada",
    description: "Solo se puede gestionar la documentaci\xF3n mientras la orden est\xE1 pendiente o en curso."
  },
  order_file_not_importable: {
    title: "Documentaci\xF3n no disponible",
    description: "Uno o m\xE1s documentos no pertenecen al reclamo o denuncia de esta orden."
  },
  order_document_not_found: {
    title: "Documento no encontrado",
    description: "El documento no est\xE1 adjunto a esta orden o ya fue eliminado."
  },
  order_document_wrong_uploader: {
    title: "Acci\xF3n no disponible",
    description: "Solo pod\xE9s eliminar la documentaci\xF3n que subi\xF3 tu compa\xF1\xEDa."
  },
  deliverable_not_latest: {
    title: "Entregable no vigente",
    description: "Solo se puede revisar el entregable m\xE1s reciente."
  },
  invalid_deliverable_review_transition: {
    title: "Acci\xF3n no disponible",
    description: "No es posible realizar esa acci\xF3n sobre el estado actual del entregable."
  },
  vertical_in_use: {
    title: "Vertical en uso",
    description: "No se puede eliminar: el vertical est\xE1 asignado a una o m\xE1s aseguradoras"
  },
  vertical_slug_already_exists: {
    title: "Slug duplicado",
    description: "Ya existe un vertical con ese slug"
  },
  not_found_good: {
    title: "Bien no encontrado",
    description: "El bien indicado no existe"
  },
  not_found_service: {
    title: "Servicio no encontrado",
    description: "El servicio indicado no existe"
  },
  good_name_already_exists: {
    title: "Bien duplicado",
    description: "Ya existe un bien con ese nombre en el vertical"
  },
  service_name_already_exists: {
    title: "Servicio duplicado",
    description: "Ya existe un servicio con ese nombre en el vertical"
  },
  tenant_slug_already_set: {
    title: "Subdominio ya configurado",
    description: "No puedes cambiar un subdominio ya configurado"
  },
  invalid_verification_code: {
    title: "C\xF3digo de verificaci\xF3n inv\xE1lido",
    description: "El c\xF3digo de verificaci\xF3n ingresado no es v\xE1lido"
  },
  team_name_already_exists: {
    title: "Equipo ya existente",
    description: "Ya existe un equipo con el nombre '{{name}}'"
  },
  invalid_claim_system_status: {
    title: "Reclamo cerrado",
    description: "No puedes realizar modificaciones sobre un reclamo cerrado"
  },
  claim_locked_by_fraud_investigation: {
    title: "Reclamo bloqueado",
    description: "El reclamo se encuentra temporalmente bloqueado y no permite esta acci\xF3n"
  },
  complaint_is_already_closed: {
    title: "Denuncia cerrada",
    description: "La denuncia se encuentra cerrada, por lo que no puedes cambiar al estado deseado"
  },
  status_already_linked: {
    title: "Equivalencia vinculada",
    description: "Este estado se encuentra dentro de una equivalencia, por lo que no puedes eliminarlo"
  },
  existent_trigger_mapping: {
    title: "Opci\xF3n vinculada en equivalencias",
    description: "Esta opci\xF3n se encuentra vinculada a una equivalencia con el estado: {{triggerMappingStatusName}}. Aseg\xFArate de eliminar la equivalencia antes de eliminar la opci\xF3n"
  },
  invalid_role: {
    title: "Permisos insuficientes",
    description: "Tu rol no cuenta con los permisos necesarios para realizar esta acci\xF3n"
  },
  zip_code_not_found: {
    title: "C\xF3digo postal invalido",
    description: "El c\xF3digo postal no es valido seg\xFAn el pa\xEDs y provincia ingresado"
  },
  overlapping_sla: {
    title: "Conflicto con otra versi\xF3n",
    description: "Ya existe otra versi\xF3n de SLA con la misma fecha de vigencia"
  },
  integration_auth_error: {
    title: "Error de autenticaci\xF3n de integraci\xF3n",
    description: "Se ha producido un error de autenticaci\xF3n de integraci\xF3n. Aseg\xFArate de tener una conexi\xF3n v\xE1lida y que tu usuario tenga permisos para acceder al recurso solicitado."
  },
  not_found_provider_template: {
    title: "Plantilla no encontrada",
    description: "No se pudo encontrar la plantilla seleccionada en el proveedor. Aseg\xFArate de tener una conexi\xF3n valida y que tu usuario tenga permisos para acceder a la plantilla."
  },
  unexpected_provider_error: {
    title: "Error inesperado en proveedor",
    description: "Ocurri\xF3 un error inesperado al momento de comunicarse con el proveedor. Intenta de nuevo o mas tarde."
  },
  missing_variable_definition: {
    title: "Referencia a variable invalida",
    description: "El mensaje contiene una referencia una variable inexistente"
  },
  wrong_ownership_transfer_destination_user: {
    title: "Usuario invalido",
    description: "Esta solicitud de transferencia de propiedad del reclamo le pertenece al usuario {{destination_user_email}}"
  },
  not_found_destination_user: {
    title: "Usuario no encontrado",
    description: "El correo ingresado no pertenece a ning\xFAn usuario. Aseg\xFArate de que el correo sea correcto"
  },
  wrong_recoverable_user_company: {
    title: "Empresa invalida",
    description: "No puedes registrarte con este correo ya que pertenece a un usuario de otra empresa"
  },
  unrecoverable_user_type: {
    title: "Tipo de usuario invalido",
    description: "No puedes registrarte con este correo ya que posee un rol no apto para la plataforma actual"
  },
  cannot_transfer_to_yourself: {
    title: "Usuario invalido",
    description: "No puedes transferir un reclamo a ti mismo"
  },
  invalid_field_value_from_provider: {
    title: "Error de validaci\xF3n de campo",
    description: "El proveedor ha indicado que el valor del campo '{{field_label}}' no es v\xE1lido de acuerdo a la configuraci\xF3n de la plantilla en la plataforma externa"
  },
  user_already_exists: {
    title: "Usuario ya existente",
    description: "Este usuario ya existe actualmente o se ha invitado previamente. Aseg\xFArate de ingresar un correo de un usuario que no forme parte de la plataforma"
  },
  complaint_already_exists: {
    title: "Denuncia duplicada",
    description: "Recientemente se ha creado una denuncia id\xE9ntica a la actual"
  },
  license_plate_remote_not_found: {
    title: "Patente invalida",
    description: "No pudimos corroborar correctamente los datos con la patente ingresada"
  },
  license_plate_remote_check_error: {
    title: "Error al validar el ingreso del reclamo",
    description: "{{attributeCheckErrorMessage}}"
  },
  role_name_already_exists: {
    title: "Nombre de rol existente",
    description: "El nombre de rol ya existe. Por favor, ingrese otro nombre."
  },
  company_not_found: {
    title: "Empresa no encontrada",
    description: "La empresa ingresada no fue encontrada."
  },
  role_not_found: {
    title: "Rol no encontrado",
    description: "El rol ingresado no fue encontrado."
  },
  invalid_user_type: {
    title: "Tipo de usuario inv\xE1lido",
    description: "El tipo de usuario ingresado no puede realizar esta acci\xF3n."
  },
  not_found_user: {
    title: "Usuario no encontrado",
    description: "El usuario ingresado no fue encontrado."
  },
  emails_already_exists: {
    title: "Emails existentes",
    description: "Los emails ingresados ya existen en nuestra base de datos. Por favor, ingrese otros emails."
  },
  invitations_already_exists: {
    title: "Invitaciones existentes",
    description: "Las invitaciones ingresadas ya existen en nuestra base de datos. Por favor, ingrese otras invitaciones."
  },
  invitation_not_found: {
    title: "Invitaci\xF3n no encontrada",
    description: "La invitaci\xF3n ingresada no fue encontrada."
  },
  username_already_exists: {
    title: "Nombre de usuario existente",
    description: "El nombre de usuario ya existe en nuestra base de datos. Por favor, ingrese otro nombre de usuario."
  },
  not_found_claim: {
    title: "Reclamo no encontrado",
    description: "El reclamo ingresado no fue encontrado."
  },
  derived_claim_status_locked: {
    title: "Reclamo derivado",
    description: "El estado no puede cambiarse mientras el reclamo est\xE9 derivado. Devolv\xE9 o cancel\xE1 la derivaci\xF3n primero."
  },
  claim_has_active_offer: {
    title: "Ofrecimiento activo",
    description: "Cerr\xE1 o retir\xE1 el ofrecimiento activo antes de derivar el reclamo."
  },
  claim_derived_offer_locked: {
    title: "Reclamo derivado",
    description: "No se puede enviar un ofrecimiento mientras el reclamo est\xE9 derivado. Devolv\xE9 o cancel\xE1 la derivaci\xF3n primero."
  },
  derivation_already_closed: {
    title: "Derivaci\xF3n ya cerrada",
    description: "Esta derivaci\xF3n ya fue devuelta o cancelada por otra persona."
  },
  derivation_target_not_operational: {
    title: "Usuario inactivo",
    description: "No pod\xE9s derivar a un usuario inactivo: no podr\xEDa devolver el reclamo."
  },
  derivation_target_paused: {
    title: "Usuario no disponible",
    description: "No pod\xE9s derivar a un usuario que no est\xE1 recibiendo reclamos nuevos."
  },
  responsible_target_not_operational: {
    title: "Usuario inactivo",
    description: "No pod\xE9s asignarle el reclamo a un usuario inactivo."
  },
  responsible_target_paused: {
    title: "Usuario no disponible",
    description: "No pod\xE9s asignarle el reclamo a un usuario que no est\xE1 recibiendo reclamos nuevos."
  },
  derivation_target_is_deriver: {
    title: "Derivaci\xF3n inv\xE1lida",
    description: "No pod\xE9s derivarte el reclamo a vos mismo."
  },
  derivation_target_is_titular: {
    title: "Derivaci\xF3n inv\xE1lida",
    description: "No pod\xE9s derivar el reclamo a su responsable original. Para devolv\xE9rselo, cancel\xE1 la derivaci\xF3n."
  },
  team_does_not_accept_assignments: {
    title: "Grupo no disponible",
    description: "El grupo seleccionado no acepta reclamos de otros grupos internos."
  },
  not_found_claim_derivation: {
    title: "Derivaci\xF3n no encontrada",
    description: "La derivaci\xF3n ingresada no fue encontrada en este reclamo."
  },
  not_found_claim_responsible: {
    title: "Reclamo sin responsable",
    description: "El reclamo no tiene un responsable activo."
  },
  wrong_identity_email: {
    title: "Email incorrecto",
    description: "El email ingresado no se pudo autenticar. Por favor, ingrese otro email."
  },
  identity_already_exists: {
    title: "Identity provider existente",
    description: "El IDP ya existe en nuestra base de datos. Por favor, ingrese otra identidad."
  },
  style_already_exists: {
    title: "Estilo existente",
    description: "El estilo ya existe en nuestra base de datos. Por favor, ingrese otro estilo."
  },
  style_not_found: {
    title: "Estilo no encontrado",
    description: "El estilo ingresado no fue encontrado."
  },
  not_found_entrypoint: {
    title: "Entrypoint no encontrado",
    description: "El entrypoint ingresado no fue encontrado."
  },
  not_found_ramo: {
    title: "Ramo no encontrado",
    description: "El ramo ingresado no fue encontrado."
  },
  axios_bad_request: {
    title: "Error de solicitud",
    description: "Error de solicitud"
  },
  cookie_not_found: {
    title: "Cookie no encontrada",
    description: "La cookie ingresada no fue encontrada."
  },
  not_found_fraud: {
    title: "Fraude no encontrado",
    description: "El fraude ingresado no fue encontrado."
  },
  not_found_default_status: {
    title: "Estado por defecto no encontrado",
    description: "El estado por defecto ingresado no fue encontrado."
  },
  not_found_company_status: {
    title: "Estado no encontrado",
    description: "El estado de empresa ingresado no fue encontrado."
  },
  claim_is_already_closed: {
    title: "Reclamo cerrado",
    description: "El reclamo ingresado ya se encuentra cerrado."
  },
  claim_status_not_manually_selectable: {
    title: "Estado no seleccionable",
    description: "Este estado se asigna autom\xE1ticamente a partir del ofrecimiento o de su conformidad y no puede seleccionarse manualmente."
  },
  claim_status_role_already_assigned: {
    title: "Rol ya asignado",
    description: "Otro estado de la empresa ya tiene este rol de orden de trabajo. Quit\xE1selo antes de asignarlo a este estado."
  },
  not_found_adobe_sign_connection: {
    title: "Conexi\xF3n de Adobe Sign no encontrada",
    description: "La conexi\xF3n de Adobe Sign ingresada no fue encontrada."
  },
  not_found_job: {
    title: "Tarea no encontrado",
    description: "La tarear ingresado no fue encontrado."
  },
  company_link_not_found: {
    title: "Link de empresa no encontrado",
    description: "El link de empresa ingresado no fue encontrado."
  },
  not_found_coordinator: {
    title: "Coordinador no encontrado",
    description: "El coordinador ingresado no fue encontrado."
  },
  invalid_style_scope: {
    title: "Scope inv\xE1lido",
    description: "El scope ingresado no es v\xE1lido."
  },
  invalid_file_token: {
    title: "Token de archivo inv\xE1lido",
    description: "El token de archivo ingresado no es v\xE1lido"
  },
  not_found_permissions: {
    title: "Permisos no encontrados",
    description: "Los permisos ingresados no fueron encontrados"
  },
  user_is_responsible: {
    title: "Usuario es responsable",
    description: "El usuario seleccionado es responsable de uno o mas siniestros. Por favor, reasigne los siniestros antes de eliminar el usuario"
  },
  unauthorized: {
    title: "No autorizado",
    description: "El token enviado no es valido"
  },
  empty_team: {
    title: "Grupo sin miembros disponibles",
    description: "El grupo de destino seleccionado no cuenta con usuarios que puedan ser asignados al reclamo"
  },
  case_request_repeated: {
    title: "Derivaci\xF3n ya realizada",
    description: "Ya hay una derivaci\xF3n a fraudes con el n\xFAmero de siniestro ingresado"
  },
  not_found_sinisterId: {
    title: "Siniestro no encontrado",
    description: "El siniestro ingresado no fue encontrado en la integraci\xF3n"
  },
  integration_invalid_credentials: {
    title: "Credenciales inv\xE1lidas",
    description: "Las credenciales configuradas en la integraci\xF3n no son validas"
  },
  not_found_sinister: {
    title: "Siniestro no encontrado",
    description: "El siniestro ingresado no fue encontrado en la integraci\xF3n"
  },
  not_found_policy: {
    title: "P\xF3liza no encontrada",
    description: "La p\xF3liza ingresada no fue encontrada en la integraci\xF3n"
  },
  not_found_matricula: {
    title: "Matricula no encontrada",
    description: "La matricula ingresada no fue encontrada en la integraci\xF3n"
  },
  email_mismatch: {
    title: "Cuenta incorrecta",
    description: "El correo electr\xF3nico de la cuenta seleccionada no coincide con el correo electr\xF3nico de la cuenta actual. Por favor, seleccione una cuenta diferente."
  },
  domain_not_allowed: {
    title: "Dominio no permitido",
    description: "El dominio de la direcci\xF3n de correo electr\xF3nico no pertenece a la empresa"
  },
  endpoint_already_exists: {
    title: "Endpoint ya existente",
    description: "El endpoint ya existe en nuestra base de datos. Por favor, ingrese otro endpoint."
  },
  user_already_assigned: {
    title: "Usuario ya asignado",
    description: "El usuario ya se encuentra asignado al reclamo"
  },
  user_not_verified: {
    title: "Cuenta no verificada",
    description: "Por favor, verifique su cuenta para poder continuar."
  },
  cannot_process_request: {
    title: "No se pudo procesar la solicitud",
    description: "Por favor, intente nuevamente m\xE1s tarde."
  },
  wrong_target_user: {
    title: "Usuario invalido",
    description: "Este usuario no puede acceder a esta plataforma"
  },
  inhouse_lawyer_wrong_tenant: {
    title: "Email registrado en otra empresa",
    description: "Este email est\xE1 registrado en otra empresa. Inici\xE1 sesi\xF3n en la url de la empresa que te invit\xF3."
  },
  tenant_session_mismatch: {
    title: "Sesi\xF3n de otra empresa",
    description: "Tu sesi\xF3n pertenece a otra empresa. Inici\xE1 sesi\xF3n en la url de esta empresa."
  },
  invalid_credentials: {
    title: "Credenciales incorrectas",
    description: "El email o la contrase\xF1a son incorrectos."
  },
  email_already_exists: {
    title: "Email existente",
    description: "El correo ingresado ya se encuentra en uso. Por favor, reg\xEDstrate con otro email o ingresa a la plataforma en caso de ya estar registrado."
  },
  company_name_already_exists: {
    title: "Nombre de empresa en uso",
    description: "El nombre de la empresa ya se encuentra en uso. Por favor, utilice uno diferente"
  },
  company_ein_already_exists: {
    title: "CUIT/CUIL de empresa en uso",
    description: "El CUIT/CUIL de la empresa ya se encuentra en uso. Por favor, utilice uno diferente"
  },
  company_domain_already_exists: {
    title: "Dominio de empresa en uso",
    description: "El dominio de la empresa ya se encuentra en uso. Por favor, utilice uno diferente"
  },
  user_dni_already_exists: {
    title: "Dni invalido",
    description: "Ya existe un usuario con el DNI ingresado. Por favor, utilice uno diferente"
  },
  user_email_already_exists: {
    title: "Email invalido",
    description: "Ya existe un usuario con el email ingresado. Por favor, utilice uno diferente"
  },
  user_ein_already_exists: {
    title: "CUIT/CUIL invalido",
    description: "Ya existe un usuario con el CUIT/CUIL ingresado. Por favor, utilice uno diferente"
  },
  unique_company_currency: {
    title: "No se puede eliminar",
    description: "La moneda es la \xFAnica disponible"
  },
  duplicate_file_request_placeholders: {
    title: "Documentos repetidos",
    description: "Los siguientes documentos ya fueron solicitados anteriormente: {{duplicate_tags}}"
  },
  tag_already_exists: {
    title: "Etiqueta ya existente",
    description: "Ya existe una etiqueta con este nombre"
  },
  use_case_already_exists: {
    title: "Caso de uso ya existente",
    description: "Ya existe un caso de uso con este nombre"
  },
  not_found_ravel_ai_use_case: {
    title: "Caso de uso no encontrado",
    description: "No se encontr\xF3 un caso de uso con este ID"
  },
  invalid_offer_status: {
    title: "Ofrecimiento no disponible",
    description: "El ofrecimiento ya no est\xE1 disponible"
  },
  user_not_found: {
    title: "Usuario no encontrado",
    description: "No se encontr\xF3 un usuario con este email"
  },
  total_amount_out_of_range: {
    title: "Monto fuera de rango",
    description: "El monto total de la oferta excede el valor m\xE1ximo permitido ($99.999.999,99)"
  },
  bid_already_submitted: {
    title: "Oferta ya enviada",
    description: "Ya enviaste una oferta para esta licitaci\xF3n"
  },
  internal_server_error: {
    title: "Error interno",
    description: "Ocurri\xF3 un error inesperado. Por favor, intente nuevamente m\xE1s tarde."
  },
  contact_already_exists: {
    title: "Contacto ya existente",
    description: "Ya existe un contacto con este correo electr\xF3nico"
  },
  team_has_no_assignable_user_for_delegation: {
    title: "Sin usuarios para derivar",
    description: "Ninguno de los equipos correspondientes a tus reclamos a derivar tiene usuarios elegibles"
  },
  product_import_already_running: {
    title: "Ya hay una importaci\xF3n en curso",
    description: "Esper\xE1 a que termine la importaci\xF3n actual antes de iniciar otra."
  },
  product_import_not_found: {
    title: "Importaci\xF3n no encontrada",
    description: "La importaci\xF3n que busc\xE1s no existe o pertenece a otra empresa."
  },
  product_import_invalid_file: {
    title: "No pudimos leer el archivo",
    description: "Revis\xE1 que sea un CSV v\xE1lido y volv\xE9 a intentarlo."
  },
  product_import_file_too_large: {
    title: "El archivo es demasiado grande",
    description: "Dividilo en partes m\xE1s chicas y volv\xE9 a subirlo."
  },
  product_import_has_invalid_rows: {
    title: "El archivo tiene filas con errores",
    description: "Correg\xED el archivo o confirm\xE1 que quer\xE9s importar s\xF3lo las filas v\xE1lidas."
  },
  order_proof_mechanism_mismatch: {
    title: "Acci\xF3n no disponible para esta orden",
    description: "La orden demuestra el trabajo realizado con el otro mecanismo: esta acci\xF3n no le corresponde."
  },
  field_adjuster_contact_not_found: {
    title: "Invitaci\xF3n no encontrada",
    description: "No encontramos una invitaci\xF3n de liquidador para este email. Pedile a la aseguradora que te invite."
  },
  contact_already_registered: {
    title: "El contacto ya se registr\xF3",
    description: "Este contacto ya tiene una cuenta activa, no hace falta reenviar la invitaci\xF3n."
  },
  invalid_current_password: {
    title: "Contrase\xF1a incorrecta",
    description: "La contrase\xF1a actual que ingresaste no es correcta."
  },
  password_not_set: {
    title: "Tu cuenta no tiene contrase\xF1a",
    description: 'Ingresaste con un proveedor externo. Us\xE1 "Olvid\xE9 mi contrase\xF1a" para crear una.'
  },
  agreement_rule_not_found: {
    title: "No se encontr\xF3 la regla",
    description: "La regla no existe o no pertenece a esta compa\xF1\xEDa."
  },
  agreement_rule_priority_taken: {
    title: "Prioridad repetida",
    description: "Ya hay otra regla habilitada con esa prioridad. El orden entre reglas tiene que ser expl\xEDcito."
  },
  agreement_rule_conflicts: {
    title: "Reglas en conflicto",
    description: "Otra regla habilitada tiene exactamente estas condiciones y elige otra conformidad."
  },
  agreement_rule_incomplete: {
    title: "La regla est\xE1 incompleta",
    description: "Para habilitarla, su plantilla tiene que tener una versi\xF3n publicada."
  },
  agreement_template_in_use_by_rule: {
    title: "La plantilla est\xE1 en uso",
    description: "Hay una regla habilitada que la usa. Deshabilit\xE1 la regla antes de deprecar o eliminar la plantilla."
  },
  agreement_plan_not_found: {
    title: "Sin plan de conformidad",
    description: "Todav\xEDa no se calcul\xF3 qu\xE9 conformidad corresponde a este ofrecimiento."
  },
  agreement_signature_rule_not_found: {
    title: "No se encontr\xF3 la regla de firma",
    description: "La regla de firma no existe o no pertenece a esta compa\xF1\xEDa."
  },
  agreement_rule_unknown_option: {
    title: "Valor desconocido en una condici\xF3n",
    description: "Una condici\xF3n apunta a un tipo de reclamo o plantilla que la compa\xF1\xEDa no tiene."
  },
  agreement_rule_unknown_template: {
    title: "Plantilla desconocida",
    description: "La regla apunta a una plantilla que la compa\xF1\xEDa no tiene."
  },
  agreement_signature_rule_unknown_template: {
    title: "Plantilla desconocida en el alcance",
    description: "El alcance nombra una plantilla que la compa\xF1\xEDa no tiene."
  },
  agreement_template_kind_mismatch: {
    title: "Tipo de plantilla incorrecto",
    description: "La regla apunta a una conformidad donde va un mensaje de ofrecimiento, o al rev\xE9s."
  },
  agreement_template_invalid_block_kind: {
    title: "Bloques no admitidos",
    description: "Un mensaje de ofrecimiento solo admite t\xEDtulos y p\xE1rrafos: {{kinds}}"
  },
  agreement_template_stage_not_allowed: {
    title: "Variables de la aceptaci\xF3n en el mensaje",
    description: "El mensaje de ofrecimiento se env\xEDa antes de que el reclamante acepte: no puede usar {{keys}}"
  },
  agreement_rule_kit_incomplete: {
    title: "Kit incompleto",
    description: "El mensaje de ofrecimiento y la plantilla de aceptaci\xF3n van juntos: indic\xE1 ambos o ninguno."
  },
  offer_amount_exceeds_cap: {
    title: "Monto por encima del tope",
    description: "El monto del ofrecimiento supera el tope de la estimaci\xF3n. Para ofrecer m\xE1s, actualiz\xE1 la estimaci\xF3n."
  },
  offer_cap_not_computable: {
    title: "Tope no calculable",
    description: "Carg\xE1 la responsabilidad y la estimaci\xF3n judicial del reclamo para poder ofrecer."
  },
  offer_terms_invalid: {
    title: "Condiciones de pago no permitidas",
    description: "Las cuotas, los d\xEDas, el porcentaje de honorarios o qui\xE9n cobra no corresponden a las opciones de la compa\xF1\xEDa o al reclamo."
  },
  acceptance_payee_invalid: {
    title: "Datos de cobro no v\xE1lidos",
    description: "Los datos de cobro no corresponden a una persona habilitada para cobrar este reclamo."
  },
  agreement_plan_changed: {
    title: "La configuraci\xF3n cambi\xF3",
    description: "Lo previsualizado ya no coincide con lo que se enviar\xEDa. Revis\xE1 la vista previa y volv\xE9 a enviar."
  },
  offer_message_incomplete: {
    title: "Faltan datos en el mensaje",
    description: "El mensaje de ofrecimiento tiene datos del reclamo sin cargar: {{keys}}"
  },
  acceptance_template_incompatible: {
    title: "Plantilla de aceptaci\xF3n incompatible",
    description: "La plantilla de aceptaci\xF3n exige variables que el ofrecimiento guiado no completa. Revis\xE1 el kit de la regla."
  },
  batch_claim_job_already_running: {
    title: "Ya hay un proceso en curso",
    description: "Los reclamos de esta persona ya se est\xE1n delegando o recuperando. Esper\xE1 a que termine para volver a intentarlo."
  },
  job_already_scheduled: {
    title: "Ya tiene una inactividad programada",
    description: "Cancel\xE1 o finaliz\xE1 la inactividad vigente antes de programar otra."
  },
  inactivity_not_found: {
    title: "No tiene inactividad",
    description: "Este miembro ya no tiene una inactividad programada ni en curso. Actualiz\xE1 la p\xE1gina."
  },
  inactivity_changed: {
    title: "La inactividad cambi\xF3",
    description: "La inactividad cambi\xF3 mientras tanto, por ejemplo porque ya empez\xF3. Revis\xE1 sus datos e intent\xE1 de nuevo."
  },
  inactivity_period_invalid: {
    title: "Fechas inv\xE1lidas",
    description: "La fecha Hasta tiene que ser igual o posterior a Desde."
  },
  not_found_delegated: {
    title: "Los reclamos ya no est\xE1n delegados",
    description: "Alguno de los reclamos que seleccionaste dej\xF3 de estar delegado. Actualiz\xE1 la lista y volv\xE9 a intentarlo."
  },
  offer_agreement_not_applicable: {
    title: "El ofrecimiento no lleva conformidad",
    description: "Se envi\xF3 sin una conformidad elegida, as\xED que no hay documento que generar."
  },
  offer_agreement_not_retryable: {
    title: "No hay nada que reintentar",
    description: "La generaci\xF3n de la conformidad no fall\xF3 ni qued\xF3 trabada."
  },
  manual_agreement_not_applicable: {
    title: "El ofrecimiento no admite una conformidad cargada a mano",
    description: "Solo el \xFAltimo ofrecimiento, aceptado y enviado sin conformidad, puede tener una conformidad cargada a mano."
  },
  manual_agreement_file_not_pdf: {
    title: "El archivo no es un PDF",
    description: "La conformidad tiene que cargarse en formato PDF."
  },
  manual_agreement_changed: {
    title: "La conformidad cambi\xF3",
    description: "Otra persona carg\xF3 una conformidad para este ofrecimiento mientras tanto. Revis\xE1 la versi\xF3n actual y volv\xE9 a intentarlo."
  },
  agreement_automation_disabled: {
    title: "Conformidad autom\xE1tica apagada",
    description: "La compa\xF1\xEDa tiene la conformidad autom\xE1tica apagada: no se genera ning\xFAn documento."
  },
  agreement_signature_dispatch_blocked: {
    title: "No se puede enviar a firmar",
    description: "Para enviar este ofrecimiento necesit\xE1s tu cuenta de AutoSign conectada desde Integraciones y un correo electr\xF3nico distinto para cada firmante."
  },
  agreement_signature_disabled: {
    title: "La firma digital est\xE1 apagada",
    description: "La compa\xF1\xEDa no est\xE1 enviando conformidades a firmar por AutoSign."
  },
  offer_agreement_dispatch_not_retryable: {
    title: "No hay env\xEDo para reintentar",
    description: "El env\xEDo a firmar est\xE1 en curso, ya sali\xF3 o esta conformidad no se env\xEDa por AutoSign."
  },
  offer_agreement_dispatch_account_pinned: {
    title: "Se reintenta desde otra cuenta",
    description: "La solicitud pudo haber salido desde la cuenta de AutoSign {{account_email}}: solo esa cuenta puede reintentar el env\xEDo."
  },
  offer_agreement_sync_unavailable: {
    title: "No hay nada que sincronizar",
    description: "Esta conformidad no tiene una solicitud de firma en AutoSign para consultar."
  },
  offer_agreement_sync_connection_required: {
    title: "Hace falta reconectar la cuenta",
    description: "Solo la cuenta de AutoSign {{account_email}} puede consultar esta solicitud, y su conexi\xF3n no est\xE1 disponible. Reconectala desde Integraciones."
  },
  offer_agreement_sync_provider_error: {
    title: "AutoSign no respondi\xF3",
    description: "No se pudo consultar el estado de la solicitud. Volv\xE9 a intentar en unos minutos."
  },
  not_found_integration_connection: {
    title: "No hay una cuenta conectada",
    description: "No encontramos una conexi\xF3n con esa integraci\xF3n."
  },
  not_found_integration: {
    title: "Integraci\xF3n no disponible",
    description: "La integraci\xF3n no est\xE1 configurada en Piramid."
  },
  order_export_too_many_rows: {
    title: "Demasiadas \xF3rdenes para exportar",
    description: "Los filtros aplicados abarcan {{total}} \xF3rdenes y el m\xE1ximo por exportaci\xF3n es {{max}}. Acot\xE1 los filtros e intent\xE1 de nuevo."
  },
  embedded_signing_session_invalid: {
    title: "No pudimos continuar con la firma",
    description: "Vas a recibir un email de AutoSign para firmar la conformidad."
  },
  team_member_inactive: {
    title: "Usuario en inactividad",
    description: "Mientras est\xE1 inactivo no recibe reclamos. Su disponibilidad se puede cambiar cuando vuelva."
  },
  team_member_not_managed: {
    title: "Usuario fuera de tus equipos",
    description: "Solo pod\xE9s gestionar a los miembros de los equipos que coordin\xE1s."
  },
  team_claims_not_found: {
    title: "Reclamos no encontrados",
    description: "Alguno de los reclamos seleccionados ya no existe."
  },
  team_claims_mixed_teams: {
    title: "Reclamos de distintos equipos",
    description: "Seleccion\xE1 reclamos de un mismo equipo."
  },
  team_claims_not_reassignable: {
    title: "Reclamos fuera de tus equipos",
    description: "Solo pod\xE9s reasignar reclamos de los equipos que coordin\xE1s."
  },
  team_reassignment_target_not_eligible: {
    title: "Destino no disponible",
    description: "El destino tiene que ser un miembro activo y disponible del equipo. Actualiz\xE1 la lista y eleg\xED otro."
  },
  team_claims_reassignment_conflict: {
    title: "No se reasign\xF3 ning\xFAn reclamo",
    description: "Alguno de los reclamos cambi\xF3 mientras tanto: se cerr\xF3, pas\xF3 a otro equipo o ya no lo tiene este miembro. Actualiz\xE1 la lista e intent\xE1 de nuevo."
  },
  team_reassignment_target_is_deriver: {
    title: "No se puede reasignar a quien lo deriv\xF3",
    description: "Alguno de los reclamos fue derivado por este miembro. Para devolv\xE9rselo, retorn\xE1 la derivaci\xF3n desde el reclamo."
  },
  team_delegation_claims_changed: {
    title: "Llegaron reclamos nuevos",
    description: "El tramitador recibi\xF3 reclamos mientras defin\xEDas los destinos. Eleg\xED qu\xE9 pasa con los que faltan e intent\xE1 de nuevo."
  },
  team_delegation_target_not_eligible: {
    title: "Alg\xFAn destino ya no puede recibir el reclamo",
    description: "Dej\xF3 de estar activo y disponible en el equipo del reclamo, o quien lo deleg\xF3 ya no puede recuperarlo. Revis\xE1 los destinos e intent\xE1 de nuevo."
  },
  team_delegation_not_found: {
    title: "No hay delegaci\xF3n programada",
    description: "La inactividad de esta persona ya no tiene reclamos para delegar: se dej\xF3 sin delegar o se cancel\xF3. Actualiz\xE1 la p\xE1gina."
  },
  team_delegation_member_active: {
    title: "Todav\xEDa est\xE1 activo",
    description: "Sus reclamos se delegan cuando empiece la inactividad. Pod\xE9s revisar la distribuci\xF3n desde su ficha."
  },
  team_delegated_claims_changed: {
    title: "No se movi\xF3 ning\xFAn reclamo",
    description: "Alguno de los reclamos cambi\xF3 mientras tanto: se cerr\xF3, se deriv\xF3, ya se retorn\xF3 o recuper\xF3, o lo tiene otra persona. Actualiz\xE1 la lista e intent\xE1 de nuevo."
  },
  derivation_responsible_changed: {
    title: "El reclamo cambi\xF3 de responsable",
    description: "Mientras lo retornabas, alguien se lo reasign\xF3 a otra persona. Actualiz\xE1 la p\xE1gina e intent\xE1 de nuevo."
  },
  team_derived_claims_changed: {
    title: "No se retorn\xF3 ning\xFAn reclamo",
    description: "Alguno de los reclamos ya no est\xE1 derivado a esta persona: se retorn\xF3, se recuper\xF3 o pas\xF3 a otra. Actualiz\xE1 la lista e intent\xE1 de nuevo."
  },
  team_delegation_recovery_member_unavailable: {
    title: "Todav\xEDa no puede recuperar",
    description: "Los reclamos delegados se recuperan cuando la persona est\xE1 activa y disponible."
  },
  inactivity_managed_by_team_management: {
    title: "La inactividad se gestiona desde Gesti\xF3n de equipo",
    description: "Las inactividades y sus delegaciones se programan, cambian y cancelan desde Gesti\xF3n de equipo."
  },
  release_note_not_published: {
    title: "La nota no est\xE1 publicada",
    description: "S\xF3lo una nota publicada se env\xEDa a una compa\xF1\xEDa, se avisa por mail o se oculta."
  },
  release_note_role_invalid: {
    title: "Rol inv\xE1lido",
    description: "Alguno de los roles elegidos no es de esta compa\xF1\xEDa."
  },
  release_note_unavailable_for_company: {
    title: "La compa\xF1\xEDa no puede ver la nota",
    description: "Le falta la flag que pide la nota: sus usuarios no podr\xEDan abrirla."
  },
  release_note_hidden: {
    title: "La nota est\xE1 oculta",
    description: "Hacela visible antes de enviarla o de avisar por mail: sus usuarios no podr\xEDan abrirla."
  },
  release_note_already_published: {
    title: "La nota ya est\xE1 publicada",
    description: "Una nota publicada no se reemplaza, republica ni elimina: los lectores y sus eventos cuelgan de ella."
  }
};
var legalPersonType = {
  hospital: "Hospital",
  worker_compensation_insurer: "ART",
  health_insurance_fund: "Obra social",
  insurer: "Aseguradora"
};
var claim_properties_insurance_insurer = "Aseguradora";
var claim_properties_insurance_policy_number = "N\xFAmero de p\xF3liza";
var claim_properties_driver_ownership_owner = "Due\xF1o";
var claim_properties_vehicle_type_car = "Auto";
var claim_properties_vehicle_category_with_license_plate = "Veh\xEDculo con patente";
var claim_properties_driver_owner = "Due\xF1o";
var claim_properties_vehicle_document_type_title = "T\xEDtulo";
var claim_properties_insurance_coverage_third_full = "Tercero Completo";
var claim_victim_relationship_own = "Directo";
var claim_properties_damage_driver_last_name = "Apellido";
var claim_properties_damage_driver_first_name = "Nombre";
var claim_properties_damage_hasInsurance = "\xBFTiene seguro?";
var claim_properties_damage_type = "Tipo de da\xF1o";
var claim_properties_vehicle_category = "Categor\xEDa";
var claim_properties_vehicle_type = "Tipo de veh\xEDculo";
var claim_properties_vehicle_year = "Patente";
var claim_properties_vehicle_license_plate = "Patente";
var claim_properties_vehicle_engine = "Motor";
var claim_properties_vehicle_chassis = "Chasis";
var claim_properties_vehicle_use = "Uso";
var claim_properties_vehicle_model = "Modelo";
var claim_properties_vehicle_make = "Marca";
var claim_properties_vehicle_version = "Versi\xF3n";
var claim_properties_vehicle_document_type = "Documentaci\xF3n";
var claim_properties_driver_ownership = "Propiedad";
var claim_properties_insurance_coverage = "Cobertura";
var damages_material_vehicle = "Veh\xEDculo";
var damages_material_real_property = "Inmueble";
var materialDamage = {
  vehicle: "Veh\xEDculo",
  real_property: "Inmueble"
};
var parents = {
  mother: "Madre",
  father: "Padre"
};
var claim_identification_type_label = "Tipo de documento";
var identification_type = {
  national_id_document: "DNI",
  enrollment_book: "Libreta Enrolamiento",
  civil_registry_card: "Libreta C\xEDvica",
  passport: "Pasaporte",
  cuil: "CUIL",
  cuit: "CUIT"
};
var local_insured_relationships = {
  friend: "Amigo/a",
  brother: "Hermano/a",
  couple: "Pareja",
  parent: "Padre/Madre",
  son: "Hijo/a",
  uncle: "T\xEDo/a",
  cousin: "Primo/a",
  niece: "Sobrino/a",
  rider: "Pasajero - uso comercial",
  other: "Otro",
  spouse: "Conyuge",
  concubine: "Concubina"
};
var victim_injuries_roles = {
  pedestrian: "Peat\xF3n",
  driver: "Conductor del veh\xEDculo tercero",
  rider: "Transportado en el veh\xEDculo tercero",
  policyholder_rider: "Transportado en el veh\xEDculo asegurado en {{insurerName}}"
};
var coverages = {
  civil_responsibility: "Responsabilidad Civil",
  third_robbery_fire: "Tercero, Robo e incendio",
  third_full: "Tercero Completo",
  all_risks_without_franchise: "Todo Riesgo sin Franquicia",
  all_risks_with_franchise: "Todo Riesgo con Franquicia",
  other: "Otro"
};
var driver_ownership = {
  owner: "Due\xF1o",
  third: "Tercero",
  own: "Due\xF1o"
};
var real_property = {
  ownership: {
    own: "Propietario",
    rented: "Inquilino",
    other: "Otro"
  },
  type: {
    housing: "Vivienda",
    commercial: "Local Comercial",
    building: "Edificio",
    government: "Organismo Publico",
    warehouse: "Galp\xF3n",
    other: "Otro"
  }
};
var vehicle = {
  identification_key: {
    license_plate: "N\xFAmero de chapa",
    chassis: "N\xFAmero de chasis"
  },
  bike: "Bicicleta",
  machinery: "Maquinaria",
  skateboard: "Monopat\xEDn",
  other: "Otro",
  car: "Auto",
  moto: "Motocicleta-Motoneta-Cuatriciclo",
  documents: {
    title: "T\xEDtulo",
    registration: "C\xE9dula Verde",
    other: "Otro"
  },
  category: {
    with_license_plate: "S\xED - el veh\xEDculo posee patente",
    without_license_plate: "No - el veh\xEDculo no est\xE1 patentado"
  },
  use: {
    special_school_pickup: "Servicios Especiales y Escolares (Pick Up)",
    private: "Particular",
    public: "P\xFAblico",
    taxi: "Taxi",
    remis: "Remis",
    rental: "Alquiler de Autos",
    ambulance: "Ambulancia",
    police: "Patrullero",
    school: "Escuela",
    specialService: "Sev. Especial Plataforma Electron",
    special_service: "Serv. Especiales (Excepto Pick Up)",
    goods: "Transporte de mercader\xEDas",
    persons: "Transporte de personas",
    goods_transport: "Transporte de Bienes",
    local: "Locales",
    route_service: "Ruteros",
    school_transport: "Escolares",
    electronic_platform: "Servicio Especial Plataforma Electr\xF3nica",
    delivery_service: "Servicio de Reparto y Mensajer\xEDa",
    agency: "Agencias (Con/Sin Chofer c/ chapa Particular)"
  },
  special_transport_service: "Servicio Transporte Especial",
  public_transport_service: "Servicio Transporte P\xFAblico",
  trailer_motor_home: "Trailer - Casa Rodante",
  pickup_class_a_and_b_jeep: "Pick Up Clase 'A' y 'B' - Jeep",
  truck_chassis: "Cami\xF3n - Chasis",
  hitched_semi_trailer: "Acoplado - Semiremolque",
  tractors_and_rural_machines: "Tractores y M\xE1quinas Rurales"
};
var type = {};
var claim_state_label = "Provincia";
var claim_city_label = "Ciudad";
var claim_country_label = "Pa\xEDs";
var claim_identification_label = "Identificaci\xF3n";
var claim_first_name_label = "Nombre";
var claim_last_name_label = "Apellido";
var claim_cuit_label = "CUIT";
var claim_address_label = "Direcci\xF3n";
var claim_type_label = "Tipo";
var claim_social_reason_label = "Raz\xF3n Social";
var claim_zip_code_label = "C\xF3digo Postal";
var claim_victim_relationship_label = "Relaci\xF3n con el asegurado";
var fractures = {
  upper: "Miembro superior",
  lower: "Miembro inferior",
  right: "Miembro derecho",
  left: "Miembro izquierdo"
};
var severities = {
  major: "Mayor",
  minor: "Menor",
  moderate: "Moderado"
};
var injuries = {
  abrasions: {
    label: "Escoriaciones",
    description: "Lesi\xF3n en la piel consistente en una p\xE9rdida superficial de sustancia que s\xF3lo afecta a la epidermis. Ej: rozaduras, raspones, etc."
  },
  whiplash: {
    label: "Traumatismos varios / Latigazo",
    description: "Lesi\xF3n o da\xF1o f\xEDsico que ha sido causado por una fuerza externa."
  },
  severe_had_injury: {
    label: "Traumatismo de cr\xE1neo grave",
    description: "Lesi\xF3n cerebral de origen traum\xE1tico causada por un impacto o movimiento brusco de la cabeza, que puede alterar temporal o permanentemente la funci\xF3n cerebral."
  },
  fractures: {
    label: "Fracturas"
  }
};
var claimant_victim_violation = {
  for_declared_relationship: "Para el v\xEDnculo declarado:",
  claimant_identification_must_match_victim: "El documento del reclamante deber\xEDa ser el mismo que el del damnificado.",
  claimant_email_must_match_victim: "El email del reclamante deber\xEDa ser el mismo que el del damnificado.",
  claimant_identification_must_differ_from_victim: "El documento del reclamante deber\xEDa ser diferente al del damnificado.",
  claimant_email_must_differ_from_victim: "El email del reclamante deber\xEDa ser diferente al del damnificado.",
  victim_email_must_differ_from_owner: "El email del damnificado deber\xEDa ser diferente al de la persona registrada due\xF1a del reclamo.",
  claimant_identification_must_be_cuit: "Un abogado deber\xEDa cargar su CUIT como documento de identidad.",
  consistent: "El v\xEDnculo declarado es consistente con los datos del reclamante y del damnificado."
};
var claim_ownership_transfer = {
  assign_title: "Transferir el reclamo",
  new_claimant: "Nuevo reclamante",
  assign_description: "Le vamos a enviar una invitaci\xF3n para que acepte el reclamo. El due\xF1o cambia reci\xE9n cuando la acepta, y ah\xED declara su v\xEDnculo con el damnificado.",
  assign_confirm: "Enviar invitaci\xF3n",
  assign_success: "Invitaci\xF3n enviada",
  assign_success_description: "Le enviamos la invitaci\xF3n a {{ name }}. El reclamo cambia de due\xF1o cuando la acepte.",
  accept_description: "Indic\xE1 tu v\xEDnculo con el damnificado para aceptar la transferencia.",
  victim_relationship_placeholder: "Seleccion\xE1 el v\xEDnculo",
  victim_relationship_other_placeholder: "Describ\xED el v\xEDnculo",
  identification_label: "CUIT",
  identification_placeholder: "Ingres\xE1 tu CUIT",
  identification_hint: "Como actu\xE1s en representaci\xF3n del damnificado, el reclamo se registra con tu CUIT.",
  confirm: "Confirmar transferencia"
};
var victim_relationship = {
  label: "Relaci\xF3n con el asegurado",
  mother: "Madre",
  father: "Padre",
  other_family_member: "Otro familiar",
  tutor_curator: "Tutor/Curador",
  attorney_in_fact: "Abogado apoderado",
  legal_representative: "Apoderado legal",
  attorney_representative: "Abogado patrocinante",
  other: "Otro",
  brother: "Hermano",
  producer: "Productor",
  workshopper: "Tallerista",
  own: "Reclamo en nombre propio",
  particular_victim: "Damnificado particular",
  friend: "Amigo/a",
  son: "Hijo/a",
  spouse: "C\xF3nyuge",
  concubine: "Concubino/a",
  grandparent: "Abuelo/a"
};
var sex = {
  male: "Masculino",
  female: "Femenino",
  other: "Otro"
};
var damages = {
  with_license_plate: "Con patente",
  without_license_plate: "Sin patente",
  real_property: "Inmueble",
  vehicle: "Veh\xEDculo",
  person: "Da\xF1os a personas",
  death: "Fallecido",
  injury: "Lesiones",
  recovery: "Recuperos",
  material: "Da\xF1os materiales",
  injuries: "Lesiones",
  deceased: "Fallecido",
  hospital: "Hospitales",
  healthInsuranceFund: "Obra social",
  workerCompensationInsurer: "ART",
  insurer: "Aseguradoras"
};
var company_service = {
  backends: {
    rivadavia: "Rivadavia Seguros"
  },
  claim: "Reclamo",
  complaint: "Denuncia"
};
var permissions = {
  can_create_claim: "Crear Reclamo",
  can_read_claim: "Visualizar Reclamo",
  can_update_claim: "Actualizar Reclamo",
  can_delete_claim: "Eliminar Reclamo",
  can_update_sinister: "Actualizar Siniestro",
  can_read_sinister: "Visualizar Siniestro",
  can_create_sinister: "Crear Siniestro",
  can_delete_sinister: "Eliminar Siniestro",
  can_read_team: "Visualizar Grupo Destino",
  can_create_team: "Crear Grupo Destino",
  can_delete_team: "Eliminar Grupo Destino",
  can_update_team: "Actualizar Grupo Destino",
  can_create_load_balance_rule: "Crear Regla de Distribuci\xF3n",
  can_update_load_balance_rule: "Actualizar Regla de Distribuci\xF3n",
  can_read_load_balance_rule: "Visualizar Regla de Distribuci\xF3n",
  can_delete_load_balance_rule: "Eliminar Regla de Distribuci\xF3n",
  can_read_role: "Visualizar Rol",
  can_create_role: "Crear Rol",
  can_update_role: "Actualizar Rol",
  can_delete_role: "Eliminar Rol",
  can_read_user: "Visualizar Usuario",
  can_create_user: "Crear Usuario",
  can_update_user: "Actualizar Usuario",
  can_delete_user: "Eliminar Usuario",
  can_read_complaint: "Visualizar Denuncia",
  can_create_complaint: "Crear Denuncia",
  can_update_complaint: "Actualizar Denuncia",
  can_delete_complaint: "Eliminar Denuncia",
  can_read_invitation: "Visualizar Invitaci\xF3n",
  can_create_invitation: "Crear Invitaci\xF3n",
  can_update_invitation: "Actualizar Invitaci\xF3n",
  can_delete_invitation: "Eliminar Invitaci\xF3n",
  can_read_settings: "Visualizar Configuraci\xF3n",
  can_update_settings: "Actualizar Configuraci\xF3n",
  can_read_account: "Visualizar Cuenta",
  can_update_account: "Actualizar Cuenta",
  can_read_notification: "Visualizar Notificaciones",
  can_read_claim_estimates: "Visualizar Estimaciones",
  can_read_claim_offers: "Visualizar Ofrecimientos",
  can_read_claim_agreements: "Visualizar Conformidades"
};
var company_enums_claim_status = " \u2937 Estados del reclamo";
var company_enums_claim_stage = " \u2937 Etapas del reclamo";
var company_enums_claim_reference = " \u2937 Referencias del reclamo";
var company_enums_claim_status_order_rule = " \u2937 Reglas de orden \u2014 reclamo (etapas)";
var company_enums_claim_type = "Tipos de reclamo";
var company_enums_complaint_status = "Estados de la denuncia";
var company_enums_complaint_stage = "Etapas de la denuncia";
var company_enums_complaint_reference = "Referencias de la denuncia";
var company_enums_complaint_status_order_rule = "Reglas de orden - denuncia";
var company_enums_ramos = "Ramo";
var company_enums_agencies = "Agencia";
var company_enums_complaint_public_status = "Estado publico de la denuncia";
var company_enums_claim_public_status = "Estado publico de reclamo";
var _claims = "Reclamos";
var _complaints = "Denuncias";
var _companies = "Compa\xF1ias";
var _autoinspector_inspections = "Autoinspector";
var _fraud_investigations = "Investigaciones de fraude";
var _catalog = "Cat\xE1logo";
var _document_types = "Tipos de documentos";
var _providers = "Proveedores";
var _customer_organizations = "Organizaciones";
var _provider_invitations = "Invitaciones";
var _geo = "Geo";
var _metrics = "Generales";
var _metrics_performance = "Performance";
var _metrics_experimental = "Experimental";
var _reviews = "Rese\xF1as";
var _users = "Usuarios";
var _integrations = "Integraciones";
var _recordings = "Grabaciones";
var _release_notes = "Novedades";
var recordings = {
  show_no_progress: "Mostrar los que no pasaron del primer paso"
};
var sidebar = {
  insurer: "Aseguradoras",
  customers: "Customer",
  providers: "Proveedores",
  metrics: "M\xE9tricas",
  metrics_general: "Generales",
  logout: "Cerrar sesi\xF3n",
  logout_confirm_title: "\xBFCerrar sesi\xF3n?",
  logout_confirm_description: "Se cerrar\xE1 tu sesi\xF3n y volver\xE1s a la pantalla de inicio de sesi\xF3n.",
  cancel: "Cancelar",
  session: "Sesi\xF3n iniciada"
};
var fraud_investigations = {
  title: "Investigaciones de fraude",
  description: "Casos de fraude de Kach entrelazados con Piramid, en todas las aseguradoras.",
  search_placeholder: "Buscar por N\xB0 de caso Kach o siniestro...",
  entity_label: "investigaciones",
  view: "Ver",
  files: "Archivos",
  created_after_label: "Desde",
  stats: {
    created_in_kach: "Creados desde Piramid en Kach",
    associated_existing_kach_case: "Asociados a casos existentes en Kach"
  },
  columns: {
    company: "Aseguradora",
    sinister_number: "N\xB0 Siniestro",
    external_case_id: "Caso Kach",
    creation_mode: "Modo de creaci\xF3n",
    status: "Estado interno",
    external_status: "Estado en Kach",
    result: "Resultado",
    handler: "Asignado",
    created_at: "Creado",
    closed_at: "Cerrado"
  },
  detail: {
    back: "Volver a investigaciones",
    case_section: "Datos del caso",
    affected_claims_section: "Reclamos afectados",
    news_section: "Novedades",
    events_section: "Actividad",
    no_claims: "No hay reclamos en el siniestro.",
    no_news: "No hay novedades registradas.",
    no_events: "No hay actividad registrada.",
    news_request: "Solicitud de novedades",
    news_answer: "Respuesta",
    no_annotation: "Sin anotaci\xF3n",
    attributes: {
      company: "Aseguradora",
      sinister_number: "N\xB0 Siniestro",
      external_case_id: "Caso Kach",
      status: "Estado interno",
      external_status: "Estado en Kach",
      result: "Resultado",
      case_type: "Tipo de caso",
      creation_mode: "Origen",
      reason: "Motivo",
      sinister_type: "Tipo de siniestro",
      ramo: "Ramo",
      agency: "Agencia",
      instance: "Instancia",
      handler: "Asignado",
      responsible: "Responsable",
      close_motive: "Motivo de cierre",
      created_by: "Creado por",
      created_at: "Creado el",
      closed_at: "Cerrado el"
    },
    claim_columns: {
      ref_id: "Reclamo",
      status: "Estado",
      system_status: "Sistema",
      alert: "Fraude",
      created_at: "Creado"
    }
  },
  creation_mode: {
    created_in_kach: "Creado en Kach",
    associated_existing_kach_case: "Asociado a caso existente"
  },
  status: {
    not_assigned: "Sin asignar",
    in_progress: "En curso",
    closed: "Cerrado"
  },
  result: {
    positive: "Positivo",
    negative: "Negativo",
    elements_for_rejection: "Elementos para rechazo",
    in_extension: "En pr\xF3rroga",
    canceled: "Cancelado",
    possible_prescription: "Posible prescripci\xF3n",
    without_result: "Sin resultado",
    not_defined: "Sin definir",
    not_derived: "No derivado",
    canceled_by_management: "Cancelado por gerencia"
  },
  case_type: {
    insured: "Asegurado",
    third_party: "Tercero"
  },
  system_status: {
    open: "Abierto",
    closed: "Cerrado"
  },
  alert: {
    fraud_investigation_in_progress: "En investigaci\xF3n",
    fraud_resolved_positive: "Fraude confirmado",
    fraud_related_positive_in_sinister: "Relacionado a positivo",
    none: "Sin alerta",
    resolved: "Resuelta"
  },
  no_value: "\u2014"
};
var geo = {
  search_placeholder: "Buscar por nombre...",
  nav: {
    localities: "Localidades",
    departments: "Departamentos",
    provinces: "Provincias"
  },
  localities: {
    title: "Localidades",
    description: "Localidades del dataset oficial de Georef. Datos de referencia (solo lectura).",
    entity_label: "localidades",
    name: "Localidad",
    georef_id: "ID Georef",
    province: "Provincia",
    department: "Departamento",
    latitude: "Latitud",
    longitude: "Longitud",
    created_at: "Fecha de creaci\xF3n"
  },
  departments: {
    title: "Departamentos",
    description: "Departamentos del dataset oficial de Georef. Datos de referencia (solo lectura).",
    entity_label: "departamentos",
    name: "Departamento",
    georef_id: "ID Georef",
    province: "Provincia",
    created_at: "Fecha de creaci\xF3n"
  },
  provinces: {
    title: "Provincias",
    description: "Provincias del dataset oficial de Georef. Datos de referencia (solo lectura).",
    entity_label: "provincias",
    name: "Provincia",
    georef_id: "ID Georef",
    created_at: "Fecha de creaci\xF3n"
  }
};
var catalog = {
  page_title: "Cat\xE1logo",
  page_description: "Verticales, bienes y servicios. Cat\xE1logo global administrado por Piramid.",
  columns: {
    id: "ID",
    name: "Nombre",
    slug: "Slug",
    actions: "Acciones"
  },
  verticals_entity_label: "verticales",
  detail: "Detalle",
  vertical: {
    entity_label: "vertical",
    create: "Crear vertical",
    new: "Nuevo vertical",
    edit: "Editar vertical",
    detail_title: "Detalle del vertical",
    detail_description: "Gestiona los bienes y servicios que forman parte de este vertical.",
    name_label: "Nombre",
    name_placeholder: "Cristales automotor",
    slug_label: "Slug",
    slug_placeholder: "cristales-automotor",
    slug_description: "Se genera autom\xE1ticamente a partir del nombre.",
    created_toast: "Vertical creado correctamente",
    updated_toast: "Vertical actualizado correctamente"
  },
  good: {
    singular: "bien",
    plural: "bienes",
    section_title: "Bienes"
  },
  service: {
    singular: "servicio",
    plural: "servicios",
    section_title: "Servicios"
  },
  items: {
    name_label: "Nombre",
    name_placeholder: "Ingrese el nombre",
    add: "Agregar",
    save: "Guardar",
    new: "Nuevo {{entity}}",
    edit: "Editar {{entity}}",
    list_header: "Listado de {{entity}} del vertical ({{count}})",
    empty: "Sin {{entity}}.",
    created_toast: "{{entity}} creado correctamente",
    updated_toast: "{{entity}} actualizado correctamente"
  },
  remove: {
    title: "\xBFEliminar {{entity}} \u201C{{name}}\u201D?",
    description: "Esta acci\xF3n no se puede deshacer. Revisa antes de continuar.",
    cancel: "Cancelar",
    confirm: "Eliminar",
    deleted_toast: "{{entity}} eliminado correctamente"
  },
  company_verticals: {
    section_title: "Verticales",
    empty: "No hay verticales en el cat\xE1logo. Cre\xE1 verticales en la secci\xF3n Proveedores.",
    save: "Guardar",
    updated_toast: "Verticales actualizados correctamente"
  }
};
var style_config = {
  scope: {
    insurer: "Aseguradora",
    claim: "Reclamo",
    complaint: "Denuncia"
  },
  "font-family": {
    inter: "Inter",
    roboto: "Roboto",
    roboto_mono: "Roboto mono",
    space_grotesk: "Space grotesk",
    space_mono: "Space mono",
    noto_color_emoji: "Noto Color Emoji",
    playfair_display: "Playfair Display",
    prata: "Prata",
    glegoo: "Glegoo",
    robot_flex: "Roboto flex",
    roboto_condensed: "Roboto Condensed",
    roboto_slab: "Roboto Slab",
    ibm_plex_sans_condensed: "IBM Plex Sans Condensed",
    ubuntu_condensed: "Ubuntu Condensed",
    barlow_condensed: "Barlow Condensed",
    saira_condensed: "Saira Condensed"
  }
};
var fraud_investigation_case = {
  kach_connection: {
    title: "Cuenta de Kach",
    connected_as: "Conectada como {{email}}",
    not_connected: "Todav\xEDa no conectaste tu cuenta de Kach.",
    connect: "Conectar cuenta",
    reconnect: "Reconectar",
    disconnect: "Desconectar",
    invalidated: "La conexi\xF3n dej\xF3 de ser v\xE1lida. Volv\xE9 a conectar tu cuenta.",
    connected_toast: "Cuenta de Kach conectada",
    disconnected_toast: "Cuenta de Kach desconectada",
    error_toast: "No se pudo conectar la cuenta de Kach",
    popup_blocked: "El navegador bloque\xF3 la ventana. Permit\xED ventanas emergentes para este sitio y volv\xE9 a intentar."
  },
  fields: {
    insurer: "Aseguradora",
    sinister_id: "Siniestro",
    sinister_type: "Tipo de siniestro",
    reason: "Motivo de an\xE1lisis",
    policy_id: "N\xFAmero de p\xF3liza",
    instance: "Instancia",
    matricula: "Matricula",
    description: "Indicadores o motivos espec\xEDficos de la elevaci\xF3n",
    denounced_at: "Fecha de denuncia",
    occurrence_description: "Descripci\xF3n del hecho",
    annotation: "Informaci\xF3n extra",
    annotation_confidential: "Confidencial: s\xF3lo la ve el analista de Kach, no entra en los indicadores.",
    description_placeholder: "Ej.: relato inconsistente, denuncia tard\xEDa, documentaci\xF3n dudosa\u2026",
    annotation_placeholder: "Contexto adicional que ayude al analista de Kach\u2026"
  },
  derive_disabled: {
    open_investigation: "El siniestro ya tiene una investigaci\xF3n en curso.",
    no_linked_claim: "Vincul\xE1 al menos un reclamo a una denuncia para poder derivar."
  },
  new_case: {
    title: "El siniestro #{{sinister_id}} puede derivarse a Kach.",
    description: "El caso se crear\xE1 con los datos ingresados y se asignar\xE1 a un analista."
  },
  linked_to_another_sinister: {
    description: "Ya existe un caso de fraude en kach para este siniestro, pero est\xE1 asociado a la investigaci\xF3n de otro siniestro de Piramid. Los reclamos se derivan desde ese siniestro.",
    go_to_sinister: "Ir al siniestro",
    acknowledge: "Entendido"
  },
  in_trash: {
    title: "El siniestro #{{sinister_id}} ya existe pero se encuentra en la papelera.",
    description: "No es posible crear un nuevo caso con este n\xFAmero de siniestro. Comun\xEDquese con un usuario con permisos suficientes para restaurar el caso desde la papelera.",
    acknowledge: "Entendido"
  },
  closed: {
    title: "El caso no puede derivarse porque ya fue analizado y cerrado.",
    description: "Comunicate con el responsable de la investigaci\xF3n en Kach y pedile que lo reabra.",
    acknowledge: "Entendido"
  }
};
var role = {
  permissions: {
    labels: {
      manage_case_load_balance_rule: "Gestionar Reglas de distribuci\xF3n",
      manage_team: "Gestionar Grupos destino",
      manage_sinister: "Gestionar Siniestro",
      read_sinister: "Visualizar Siniestro",
      manage_complaint: "Gestionar Denuncia",
      read_complaint: "Visualizar Denuncia",
      manage_claim: "Gestionar Reclamo",
      manage_role: "Gestionar Roles",
      manage_user: "Gestionar Usuarios",
      manage_settings: "Gestionar Settings",
      read_notification: "Visualizar Notificaciones",
      read_company_link: "Visualizar Accesos Directos",
      read_user: "Visualizar Usuarios"
    }
  }
};
var webhook = {
  events: {
    "claim#created": {
      title: "Reclamo creado"
    },
    "claim#sla#objective#instance#threshold#exceeded": {
      title: "Umbral de objetivo SLA excedido"
    },
    "claim#sla#instance#threshold#exceeded": {
      title: "Umbral de instancia SLA excedido"
    },
    "claim#ownership_transfer#created": {
      title: "Transferencia de propiedad creada"
    },
    "claim#ownership_transfer#accepted": {
      title: "Transferencia de propiedad aceptada"
    },
    "claim#ownership_transfer#rejected": {
      title: "Transferencia de propiedad rechazada"
    },
    "claim#file_request#created": {
      title: "Solicitud de archivo creada"
    },
    "claim#updated": {
      title: "Reclamo actualizado"
    },
    "claim#message#created": {
      title: "Mensaje creado"
    },
    "claim#file#uploaded": {
      title: "Archivo subido"
    },
    "claim#handler#assigned": {
      title: "Tramitador asignado"
    },
    "claim#handler#unassigned": {
      title: "Tramitador desasignado"
    },
    "claim#status#updated": {
      title: "Estado actualizado"
    },
    "claim#order#created": {
      title: "Orden creada"
    },
    "claim#order#invoice#created": {
      title: "Factura de orden creada"
    },
    "claim#order#updates#requested": {
      title: "Actualizaciones de orden solicitadas"
    },
    "claim#order#updates#published": {
      title: "Actualizaciones de orden publicadas"
    },
    "claim#order#report#created": {
      title: "Informe de orden creado"
    },
    "claim#order#report#accepted": {
      title: "Informe de orden aceptado"
    },
    "claim#order#report#rejected": {
      title: "Informe de orden rechazado"
    },
    "claim#offer#created": {
      title: "Oferta creada"
    },
    "claim#offer#accepted": {
      title: "Oferta aceptada"
    },
    "claim#offer#rejected": {
      title: "Oferta rechazada"
    },
    "claim#offer#expired": {
      title: "Oferta expirada"
    },
    "claim#offer#canceled": {
      title: "Oferta anulada"
    },
    "claim#offer#agreement#created": {
      title: "Acuerdo de oferta creado"
    },
    "claim#offer#agreement#completed": {
      title: "Acuerdo de oferta completado"
    },
    "claim#offer#agreement#rejected": {
      title: "Acuerdo de oferta rechazado"
    },
    "claim#offer#agreement#expired": {
      title: "Acuerdo de oferta expirado"
    },
    "claim#offer#agreement#canceled": {
      title: "Acuerdo de oferta cancelado"
    },
    "claim#rfp#created": {
      title: "Solicitud de propuesta creada"
    },
    "claim#rfp#closed": {
      title: "Solicitud de propuesta cerrada"
    },
    "claim#rfp#canceled": {
      title: "Solicitud de propuesta cancelada"
    },
    "claim#rfp#bid#submitted": {
      title: "Oferta de RFP enviada"
    },
    "claim#rfp#bid#selected": {
      title: "Oferta de RFP seleccionada"
    },
    "claim#estimates#updated": {
      title: "Estimaciones actualizadas"
    },
    "claim#appraisal#field_adjuster#assigned": {
      title: "Perito de campo asignado"
    },
    "claim#appraisal#invoice#uploaded": {
      title: "Factura de peritaje subida"
    },
    "claim#appraisal#report#created": {
      title: "Informe de peritaje creado"
    },
    "claim#appraisal#report#accepted": {
      title: "Informe de peritaje aceptado"
    },
    "claim#appraisal#report#rejected": {
      title: "Informe de peritaje rechazado"
    },
    "claim#appraisal#updates#requested": {
      title: "Actualizaciones de peritaje solicitadas"
    },
    "claim#appraisal#updates#published": {
      title: "Actualizaciones de peritaje publicadas"
    }
  },
  scope: {
    user: "Usuario",
    company: "Compa\xF1ia"
  }
};
var resources = {
  claims: "Reclamo",
  complaints: "Denuncia"
};
var occurrence = {
  circulation_direction: {
    unique: "Unica",
    both: "Ambas"
  }
};
var currencies = {
  labels: {
    PYG: "Guaran\xED",
    USD: "D\xF3lar",
    EUR: "Euro",
    ARS: "Peso Argentino"
  }
};
var company = {
  properties: {
    name: "Nombre",
    domain: "Dominio",
    type: "Tipo",
    country: "Pa\xEDs",
    ein: "CUIT/CUIL",
    alias: "Alias"
  }
};
var teams = {
  coordinator: {
    disclaimer: "Los reclamos no se asignan autom\xE1ticamente al coordinador, pero pueden asignarse de forma manual cuando sea necesario."
  }
};
var metrics = {
  "team-management": {
    eyebrow: "Performance del equipo",
    title: "Tablero de performance del equipo",
    tabs: {
      p1: "Estado & Alertas",
      p2: "Productividad",
      p3: "Conciliaci\xF3n"
    },
    scope: {
      label: "Alcance",
      "all-teams": "Todos mis equipos",
      members: "{{count}} miembros",
      hint: "Los datos y los filtros aplican a los equipos seleccionados."
    },
    header: {
      members: "{{count}} miembros",
      "open-claims": "{{count}} reclamos abiertos"
    },
    "scope-summary": {
      title: "Performance del equipo",
      description: "M\xE9tricas consolidadas del alcance seleccionado \xB7 se recalculan al filtrar por equipo.",
      productivity: "Productividad",
      "conciliation-rate": "Tasa de conciliaci\xF3n",
      "resolved-count": "Reclamos resueltos",
      "avg-aging-open": "Aging promedio abiertos",
      "delta-points": "{{value}} pp",
      days: "{{value}} d"
    },
    cohort: {
      "all-handlers": "Todos los tramitadores"
    }
  },
  title: "M\xE9tricas Generales",
  description: "Visualiza m\xE9tricas y estad\xEDsticas de todas las empresas",
  select_period_message: "Selecciona un per\xEDodo para ver las m\xE9tricas",
  total_claims: "Total reclamos",
  total_claimed: "Total reclamado",
  average_claimed: "Promedio reclamado",
  average_management_time: "Tiempo promedio de gesti\xF3n",
  "analysis-period": {
    title: "An\xE1lisis de per\xEDodo"
  },
  "claims-weekly-comparison": {
    title: "Comparaci\xF3n Semanal de Reclamos",
    description: "Volumen de reclamos creados: semana actual vs. semana anterior"
  },
  "select-company": {
    placeholder: "Seleccionar empresa",
    total: "Total (todas las empresas)"
  },
  companies: {
    title: "Empresas",
    rivadavia: "Rivadavia Seguros"
  },
  "current-week": "Semana actual",
  "previous-week": "\xDAltima semana",
  "week-before-last": "Ante \xFAltima semana",
  no_changes: "Sin cambios entre las \xFAltimas semanas completas",
  select_period_placeholder: "Seleccionar per\xEDodo",
  "daily-claims": {
    title: "Reclamos Diarios",
    total: "Total",
    average: "Promedio",
    max: "M\xE1ximo",
    min: "M\xEDnimo",
    claims: "Reclamos",
    "average-line": "Promedio"
  },
  "day-type": {
    working_day: "D\xEDa h\xE1bil",
    weekend: "Fin de semana",
    holiday: "Feriado"
  },
  distribution: {
    title: "Propagaci\xF3n de reclamos",
    "total-claims": "Total de reclamos",
    count: "Cantidad",
    successful: "Prereclamo creado - Vinculado",
    preclaim_error: "Errores",
    no_linking: "Prereclamo creado - No vinculado",
    local: "No propagables (Otros riesgos)",
    no_error_details: "No hay detalles de errores disponibles",
    error_breakdown: "Desglose de errores",
    and_more_errors: "Y {{count}} errores m\xE1s...",
    view_errors: "Ver errores",
    view_reasons: "Ver motivos ({{count}})"
  },
  attempts: {
    title: "Intentos de creaci\xF3n de reclamo",
    "total-attempts": "Total de intentos",
    completed: "Completados",
    recovered: "Completados con error",
    failed: "Fallidos",
    abandoned: "Abandonados",
    in_progress: "En curso",
    view_errors: "Ver errores",
    coefficient: "Coeficiente",
    people: {
      unique: "Personas \xFAnicas",
      title: "\xBFTerminaron su reclamo?",
      description: "Misma empresa y per\xEDodo que Intentos de creaci\xF3n. Cada persona cuenta una vez, aunque haya recargado o vuelto a empezar.",
      finished: "Terminaron",
      abandoned: "Abandonaron",
      in_progress: "Siguen en curso"
    },
    by_user: {
      title: "Intentos por usuario",
      user: "Usuario",
      email: "Email",
      total: "Intentos",
      failed: "Sin terminar",
      successful: "Exitosos",
      coefficient: "Coef.",
      no_name: "Sin nombre",
      no_data: "No hay intentos en el per\xEDodo",
      limited: "Se muestran los 300 usuarios con m\xE1s intentos sin terminar",
      search_placeholder: "Buscar por email...",
      export_csv: "Descargar CSV",
      coefficient_description: "Coeficiente = intentos \xF7 reclamos creados. Un intento empieza cuando se pasa del primer paso; no cuentan los que siguen en curso. Ej.: 3 intentos y 2 creados = 1,50. Cuanto m\xE1s alto, m\xE1s veces tuvo que intentar por cada reclamo creado (m\xE1s fricci\xF3n). \u221E = intent\xF3 y nunca lleg\xF3 a crear un reclamo."
    },
    error_code: {
      not_found_file: "Archivo no encontrado",
      validation_error: "Error de validaci\xF3n",
      license_plate_remote_check_error: "Validaci\xF3n para ingreso de reclamo",
      not_found_vehicle_version: "Versi\xF3n de veh\xEDculo no encontrada",
      invalid_file_token: "Token de archivo inv\xE1lido",
      unauthorized: "No autorizado",
      unknown_error: "Error desconocido"
    }
  },
  "weekly-evolution": {
    title: "Evoluci\xF3n Semanal",
    weeks: "semanas",
    week: "Semana",
    claims: "Reclamos",
    variation: "Variaci\xF3n",
    period: "Per\xEDodo"
  },
  users_stats: {
    title: "Estad\xEDsticas de Usuarios",
    third_verified: "Terceros verificados",
    third_pending: "Terceros pendientes",
    insurer_active: "Tramitadores activos",
    with_claims: "Tramitadores responsables de reclamos"
  },
  "processing-amount": {
    title: "Monto de Tramitaci\xF3n",
    claimed_amount: "Monto Reclamado",
    claimed_amount_with_accepted_offers: "Monto Reclamado (con ofertas aceptadas)",
    estimation_amount: "Monto de Estimaci\xF3n",
    offer_amount: "Monto de Ofrecimiento",
    p50: "P50 (Mediana)",
    p95: "P95",
    average: "Promedio",
    count: "Cantidad",
    claims_count: "reclamos",
    offers_count: "ofertas aceptadas",
    no_data: "Sin datos en el per\xEDodo",
    only_accepted_offers: "Solo reclamos con ofertas aceptadas"
  },
  experimental: {
    title: "Experimental",
    description: "An\xE1lisis en prueba, de uso interno. Todav\xEDa no se muestran a los clientes.",
    tabs: {
      "risk-zone": "Zona de riesgo",
      "closure-cohort": "Cohorte de cierre por etapa"
    },
    "closure-cohort": {
      title: "Cohorte de cierre por etapa",
      "description-monthly": "Cu\xE1ntos reclamos de cada cohorte cerraron en cada mes, sin sumar los meses anteriores. Con una etapa de cierre elegida, cuenta solo los que cerraron en esa etapa.",
      "description-cumulative": "Cu\xE1ntos reclamos de cada cohorte cerraron hasta cada mes, sumando los meses anteriores. Con una etapa de cierre elegida, cuenta solo los que cerraron en esa etapa.",
      "month-tooltip-one": "% del cohorte cerrado en el mes siguiente al de creaci\xF3n.",
      "month-tooltip-many": "% del cohorte cerrado {{n}} meses despu\xE9s del de creaci\xF3n, sin sumar los meses anteriores.",
      "pick-company": "Eleg\xED una empresa para ver el cohorte.",
      "outcome-filter": {
        all: "Todas las etapas",
        search: "Buscar etapa",
        empty: "No hay etapas",
        clear: "Limpiar",
        selected: "{{count}} etapas"
      },
      mode: {
        partial: "Parcial",
        cumulative: "Acumulado"
      },
      base: {
        created: {
          label: "Sobre creados",
          description: "El % es sobre el tama\xF1o del cohorte."
        },
        closed: {
          label: "Sobre cerrados",
          description: "El % es sobre el total que cerr\xF3 cada cohorte hasta hoy, en las etapas elegidas. En las cohortes recientes ese total todav\xEDa va a crecer.",
          "cell-hint": "Sobre el total cerrado de la cohorte, no sobre los creados."
        }
      },
      summary: {
        "cohort-count": {
          label: "Meses completos",
          tooltip: "Cu\xE1ntos meses de creaci\xF3n ya terminaron esa columna. Solo esos entran en las filas de abajo: la celda con * sigue en curso y queda afuera.",
          "tooltip-closed": "Cu\xE1ntos meses de creaci\xF3n ya terminaron esa columna y tienen alg\xFAn cerrado. Solo esos entran en las filas de abajo: la celda con * sigue en curso y queda afuera."
        },
        average: {
          label: "Promedio",
          tooltip: "Cerrados en esa columna sumando los meses completos, dividido por los creados de esos mismos meses. Los meses con m\xE1s reclamos pesan m\xE1s.",
          "tooltip-closed": "Cerrados en esa columna sumando los meses completos, dividido por el total cerrado de esos mismos meses. Los meses con m\xE1s reclamos pesan m\xE1s."
        },
        p25: {
          label: "P25",
          tooltip: "Un cuarto de los meses qued\xF3 por debajo de este valor. Cada mes cuenta igual, sin importar cu\xE1ntos reclamos tuvo."
        },
        median: {
          label: "Mediana",
          tooltip: "La mitad de los meses qued\xF3 por debajo y la otra mitad por arriba. Cada mes cuenta igual, sin importar cu\xE1ntos reclamos tuvo."
        },
        p75: {
          label: "P75",
          tooltip: "Tres cuartos de los meses quedaron por debajo de este valor. Cada mes cuenta igual, sin importar cu\xE1ntos reclamos tuvo."
        },
        p95: {
          label: "P95",
          tooltip: "El 95% de los meses qued\xF3 por debajo de este valor. Con pocos meses es casi el m\xE1ximo."
        }
      }
    }
  },
  "risk-zone": {
    "claim-type-selector": "Tipo de reclamo",
    "claim-types": {
      injured: "Lesionado",
      combined: "Combinado",
      material_damage: "Da\xF1o Material"
    },
    "coming-soon": "Pr\xF3ximamente",
    title: "Zona de riesgo en reclamos de {{claimType}}",
    lede: "Cada reclamo tiene un score de 0 a 100 seg\xFAn qu\xE9 tan parecido es a los que terminaron en mediaci\xF3n o juicio. A la derecha, perfil de origen m\xE1s riesgoso; arriba, gesti\xF3n m\xE1s riesgosa. Las bandas naranjas son las zonas Alto y Muy alto.",
    zones: {
      very_high: "Muy alto (+{{score}})",
      high: "Alto o m\xE1s (+{{score}})"
    },
    confusion: {
      title: "\xBFLa zona dice la verdad?",
      subtitle: "Cerrados creados entre {{from}} y {{to}}, cuando ya se sabe c\xF3mo terminaron.",
      "zone-selector": "Zona a evaluar",
      "true-positives": {
        label: "escalaron dentro de la zona",
        hint: "verdaderos positivos"
      },
      "false-positives": {
        label: "no escalaron, {{count}} de ellos conciliados",
        hint: "falsos positivos"
      },
      "false-negatives": {
        label: "escalaron fuera de la zona",
        hint: "falsos negativos"
      },
      precision: {
        label: "precisi\xF3n, atrapa {{recall}} de los escalados",
        hint: "{{count}} abiertos hoy en esta zona"
      }
    },
    "load-error": "No se pudo cargar la zona de riesgo.",
    outcomes: {
      open: "Abierto",
      mediation: "Mediaci\xF3n",
      judgment: "Juicio",
      conciliated: "Conciliado",
      rejected: "Rechazado",
      withdrawn: "Desistido",
      other: "Anulado, fraude o no prosper\xF3"
    },
    signals: {
      claimed_amount_5_20m: "Monto reclamado $5\u201320M",
      claimed_amount_over_20m: "Monto reclamado mayor a $20M",
      high_risk_province: "Provincia de alto riesgo",
      low_risk_province: "Provincia de bajo riesgo",
      massive_sinister: "Siniestro con +4 reclamos",
      attorney_claimant: "Reclama un abogado",
      volume_claimant: "Reclamante de volumen (+50 reclamos previos)",
      no_estimate: "Sin estimaci\xF3n",
      estimate_below_half_claimed: "Estimaci\xF3n menor al 50% del monto reclamado",
      estimated_without_offer: "Estimado sin oferta",
      open_over_30_days: "+30 d\xEDas abierto",
      accepted_offer: "Oferta aceptada"
    },
    map: {
      "filters-label": "Qu\xE9 reclamos mostrar",
      filters: {
        top: "Top 50",
        escalated: "Mediaci\xF3n y juicio",
        open: "Abiertos",
        conciliated: "Conciliados",
        closed_other: "Cerrados no conciliados"
      },
      "aria-label": "Dispersi\xF3n de reclamos por perfil de origen y gesti\xF3n",
      "x-axis": "Perfil de origen (puntos): qu\xE9 se reclama y qui\xE9n reclama",
      "x-axis-short": "Perfil de origen (puntos)",
      "y-axis": "Gesti\xF3n (puntos)",
      bands: {
        high: "Alto",
        very_high: "Muy alto"
      },
      "accepted-offer-strip": "Con oferta aceptada (en cierre, riesgo bajo)"
    },
    methodology: {
      "profile-title": "Perfil de origen",
      "management-title": "Gesti\xF3n",
      "reading-title": "C\xF3mo leerlo",
      points: {
        lead: "Cada se\xF1al suma o resta puntos; ",
        emphasis: "{{points}} puntos equivalen al doble de riesgo",
        rest: ". Perfil m\xE1s gesti\xF3n da el score, por eso las zonas son diagonales. El score es el percentil: {{score}} significa m\xE1s riesgoso que el {{score}}% de los reclamos hist\xF3ricos de {{claimType}}. Montos inv\xE1lidos (tipo $1.111.111.111) se toman como monto alto."
      },
      "closed-moment": "Los cerrados se ubican en su momento m\xE1s riesgoso de los primeros {{days}} d\xEDas, antes del cierre. Los abiertos, con su estado de hoy.",
      accepted: {
        lead: "Una oferta aceptada resta ",
        emphasis: "{{points}} puntos",
        rest: ": esos reclamos van en la franja inferior para no aplastar el mapa."
      },
      capped: " El peso de \u201C{{signal}}\u201D est\xE1 moderado: hubo solo {{cases}} casos, as\xED que se usa un tope conservador en lugar del valor extremo que dar\xEDa el modelo.",
      scope: "Se muestran todos los reclamos de {{claimType}}: {{closed}} cerrados ({{period}}) y {{open}} abiertos. Tasa base de escalada: {{baseRate}}.",
      period: "{{from}} a {{to}}",
      "calibrated-at": "Calibraci\xF3n del {{date}}"
    },
    "top-claims": {
      title: "Top 50 abiertos",
      lede: "Del 1 al 50, ordenados por score. Score: percentil de riesgo (0 a 100). Prob.: probabilidad estimada de escalar. Toc\xE1 uno para ubicarlo en el mapa.",
      score: "Score",
      probability: "Prob.",
      "open-days": {
        one: "1 d\xEDa abierto",
        other: "{{count}} d\xEDas abierto"
      }
    },
    tooltip: {
      score: "Score",
      "top-rank": "#{{rank}} del top 50",
      "no-reference": "Sin referencia",
      "open-days": {
        one: "Abierto hace 1 d\xEDa",
        other: "Abierto hace {{count}} d\xEDas"
      },
      evaluated: "{{stage}}, evaluado al d\xEDa {{day}}",
      probability: "Probabilidad de escalar {{probability}}",
      "claimed-amount": "Monto reclamado {{amount}}",
      "placeholder-amount": "Monto reclamado inv\xE1lido (se toma como alto)",
      claimant: "Reclama: {{relationship}}",
      "unknown-relationship": "sin dato",
      "previous-claims": {
        one: "1 reclamo previo",
        other: "{{count}} reclamos previos"
      },
      handler: "Tramitador {{name}}",
      "no-handler": "Sin tramitador",
      "days-without-response": {
        one: "1 d\xEDa sin respuesta al reclamante",
        other: "{{count}} d\xEDas sin respuesta al reclamante"
      }
    }
  },
  performance: {
    title: "Performance de las compa\xF1\xEDas",
    "title-company": "Performance de {{company}}",
    description: "Estado actual, alertas y comparaciones con per\xEDodos anteriores.",
    scope: {
      label: "Alcance",
      "all-teams": "Todos los equipos",
      "selected-teams": "{{count}} equipos",
      search: "Buscar equipo\u2026",
      empty: "Sin equipos",
      clear: "Limpiar",
      summary: "{{members}} miembros \xB7 {{openClaims}} reclamos abiertos \xB7 El filtro de equipo aplica a los bloques de esta p\xE1gina."
    },
    "pts-suffix": "pts",
    "metric-explainer": {
      numerator: "Numerador",
      denominator: "Denominador",
      "positives-title": "Desenlaces positivos",
      "negatives-title": "Desenlaces negativos"
    },
    "success-explainer": {
      title: "\xBFC\xF3mo se calcula la Eficacia operativa?",
      "info-label": "\xBFC\xF3mo se calcula la Eficacia operativa?",
      description: "Mide qu\xE9 parte de los reclamos creados en el mes evit\xF3 un desenlace negativo. Contando solo los que ya cerraron",
      "calculation-description": "Es el porcentaje de cerrados que termin\xF3 en un desenlace positivo.",
      "columns-caption": "Datos del mes actual",
      footer: "Los reclamos del mes que siguen abiertos todav\xEDa no cuentan, por eso los meses recientes se van ajustando a medida que cierran.",
      "point-detail": "{{failures}} negativos de {{closed}} cerrados"
    },
    "productivity-explainer": {
      title: "\xBFC\xF3mo se calcula la Productividad operativa?",
      "info-label": "\xBFC\xF3mo se calcula la Productividad operativa?",
      description: "Cu\xE1ntos reclamos cierra el equipo por cada d\xEDa trabajado y por tramitador. Cuanto m\xE1s alta, mejor.",
      numerator: "reclamos cerrados en el mes",
      denominator: "d\xEDas del mes \xD7 tramitadores activos (los que cerraron al menos un caso)",
      "window-previous": "{{month}}: {{resolved}} cerrados / ({{days}} d\xEDas del mes \xD7 {{handlers}} tramitadores) = {{value}}.",
      "window-current": "{{month}} (en curso): {{resolved}} cerrados / ({{days}} d\xEDas transcurridos \xD7 {{handlers}} tramitadores) = {{value}}."
    },
    "leading-explainer": {
      judicializationRate: {
        title: "\xBFC\xF3mo se calcula Judicializaci\xF3n?",
        "info-label": "\xBFC\xF3mo se calcula Judicializaci\xF3n?",
        description: "Cu\xE1ntos de los reclamos creados en el mes terminaron en juicio, cada 10.000 que ya cerraron.",
        numerator: "reclamos creados en el mes que cerraron en Juicio",
        denominator: "reclamos creados en el mes que ya est\xE1n cerrados",
        base: "Es una frecuencia, no un porcentaje: cuanto m\xE1s baja, mejor. Los meses recientes se van ajustando a medida que cierran sus reclamos."
      },
      resolutionRate: {
        title: "\xBFC\xF3mo se calcula la Tasa de resoluci\xF3n?",
        "info-label": "\xBFC\xF3mo se calcula la Tasa de resoluci\xF3n?",
        description: "De los reclamos que tuvieron movimiento en el mes (los que se crearon y los de meses anteriores que se cerraron), qu\xE9 parte qued\xF3 cerrada.",
        numerator: "reclamos cerrados en el mes",
        denominator: "reclamos creados en el mes m\xE1s los cerrados en el mes, sin contar dos veces los que se crearon y cerraron en el mismo mes",
        base: "Ejemplo: en el mes entran 100 reclamos y se cierran 90, de los cuales 30 son de los creados en el mes. La tasa es 90 / (100 + 90 \u2212 30) = 56%."
      },
      mediationRate: {
        title: "\xBFC\xF3mo se calcula Mediaci\xF3n?",
        "info-label": "\xBFC\xF3mo se calcula Mediaci\xF3n?",
        description: "Cu\xE1ntos de los reclamos creados en el mes terminaron en mediaci\xF3n, cada 10.000 que ya cerraron.",
        numerator: "reclamos creados en el mes que cerraron en Mediaci\xF3n",
        denominator: "reclamos creados en el mes que ya est\xE1n cerrados",
        base: "Es una frecuencia, no un porcentaje: cuanto m\xE1s baja, mejor. Los meses recientes se van ajustando a medida que cierran sus reclamos."
      },
      pendingOfferCount: {
        title: "\xBFC\xF3mo se calcula Reclamos con oferta pendiente?",
        "info-label": "\xBFC\xF3mo se calcula Reclamos con oferta pendiente?",
        description: "Reclamos abiertos y listos para enviar ofrecimiento (con responsabilidad y la estimaci\xF3n de cada da\xF1o cargada) desde los que todav\xEDa no se envi\xF3 ning\xFAn ofrecimiento. Cuanto m\xE1s bajo, mejor.",
        base: "Cada punto toma datos al \xFAltimo d\xEDa del mes, con la responsabilidad y la estimaci\xF3n que el reclamo ten\xEDa ese d\xEDa. El mes en curso es la situaci\xF3n actual. Un mismo reclamo puede aparecer en varios meses si sigui\xF3 sin ofrecimiento."
      }
    },
    "north-star": {
      "previous-month": "Mes anterior",
      "month-in-progress": "(en curso)",
      conciliation: {
        title: "Eficacia operativa"
      },
      productivity: {
        title: "Productividad operativa"
      }
    },
    leading: {
      judicializationRate: "Judicializaci\xF3n",
      resolutionRate: "Tasa de resoluci\xF3n",
      mediationRate: "Mediaci\xF3n",
      pendingOfferCount: "Reclamos con oferta pendiente",
      subtitle: {
        judicializationRate: "cada 10.000 casos cerrados",
        mediationRate: "cada 10.000 casos cerrados"
      },
      "pp-suffix": "pp"
    },
    focus: {
      title: "Foco del mes",
      subtitle: "M\xE1s cierres exitosos perdidos",
      metric: {
        "aging-open": "Aging promedio abiertos",
        "money-in-dispute": "$ en disputa",
        mediation: "A mediaci\xF3n",
        judgment: "A juicio"
      },
      "efficacy-drop": "Eficacia operativa {{value}} en {{month}} vs {{previousValue}} en {{previousMonth}}",
      "lost-successes": "{{count}} cierres exitosos menos",
      "month-note": "Datos de {{month}}, el \xFAltimo mes completo"
    },
    "team-table": {
      title: "Performance por equipo",
      column: {
        team: "Equipo",
        productivity: "Productividad",
        conciliation: "Conciliaci\xF3n",
        delta: "\u0394 per\xEDodo ant.",
        "delta-tooltip": "Variaci\xF3n vs per\xEDodo anterior seg\xFAn el filtro seleccionado."
      },
      "focus-tag": "foco",
      "show-inactive": "Mostrar {count} equipos sin actividad",
      "hide-inactive": "Ocultar equipos sin actividad"
    },
    aging: {
      title: "Aging de Casos Abiertos",
      average: "Promedio",
      "days-suffix": "d",
      "risk-zone": "Zona de riesgo: {count} reclamos ({pct} del total)",
      bucket: {
        "0-30": "0-30 d",
        "30-60": "31-60 d",
        "60-90": "61-90 d",
        "90+": "90+ d"
      }
    },
    "open-stock": {
      "as-of-today": "Actualizado a las {{time}} \xB7 no responde al filtro de per\xEDodo",
      "as-of-date": "Actualizado el {{date}} a las {{time}} \xB7 no responde al filtro de per\xEDodo"
    },
    "critical-status": {
      title: "Reclamos por estado cr\xEDtico",
      "snapshot-note": "Foto actual \xB7 no responde al filtro de per\xEDodo",
      "column-status": "Estado",
      "column-count": "Cantidad de reclamos",
      empty: "No hay estados cr\xEDticos configurados",
      "stage-prefix": "Etapa",
      "aging-prefix": "aging prom",
      "days-suffix": "d",
      total: "{{count}} reclamos abiertos en estados cr\xEDticos",
      "tooltip-share": "del total"
    },
    "damage-table": {
      title: "Performance por tipo de da\xF1o",
      column: {
        category: "Tipo de da\xF1o",
        resolved: "Resueltos",
        "avg-days": "D\xEDas prom.",
        mediation: "Mediaci\xF3n",
        judgment: "Juicio",
        aging: "Aging abiertos",
        "percent-of-total": "% del total",
        efficacy: "Eficacia operativa"
      },
      category: {
        Lesionado: "Lesionado",
        Fallecidos: "Fallecidos",
        "Da\xF1o Material": "Da\xF1o Material",
        Combinado: "Combinado",
        "Da\xF1o a Inmueble": "Da\xF1o a Inmueble"
      },
      "historical-badge": "Hist\xF3rico \xB7 acumulado de toda la compa\xF1\xEDa"
    },
    filters: {
      company: "Empresa",
      period: "Per\xEDodo",
      from: "Desde",
      to: "Hasta",
      preset: {
        "7d": "7 d\xEDas",
        "15d": "15 d\xEDas",
        "30d": "30 d\xEDas",
        "3m": "3 meses",
        "6m": "6 meses",
        "12m": "12 meses"
      },
      "preset-long": {
        "7d": "\xDAltimos 7 d\xEDas",
        "15d": "\xDAltimos 15 d\xEDas",
        "30d": "\xDAltimos 30 d\xEDas",
        "3m": "\xDAltimos 3 meses",
        "6m": "\xDAltimos 6 meses",
        "12m": "\xDAltimos 12 meses"
      },
      date: {
        "range-placeholder": "Seleccion\xE1 un rango",
        clear: "Limpiar",
        cancel: "Cancelar",
        apply: "Aplicar",
        "disabled-tooltip": "El filtro de fecha no aplica a Estado & Alertas",
        "disabled-notice": "El filtro de fecha no aplica a Estado & Alertas \u2014 todos los datos son foto actual o hist\xF3rico."
      },
      custom: "Personalizado",
      exclude: {
        label: "Excluir",
        none: "Ninguno",
        today: "Hoy",
        week: "Semana actual",
        month: "Mes actual",
        quarter: "Trimestre actual"
      }
    },
    "focus-hidden": "Equipo foco no encontrado en esta empresa.",
    tabs: {
      p1: "Estado & Alertas",
      p2: "Productividad",
      p3: "Conciliaci\xF3n",
      p4: "Fraude \xB7 Kach",
      p5: "Impacto al Cliente",
      "coming-soon": "Pr\xF3ximamente",
      "coming-soon-description": "Esta pesta\xF1a estar\xE1 disponible en una pr\xF3xima entrega."
    },
    p4: {
      "section-title": "Detecci\xF3n de fraude",
      "section-description": "Integraci\xF3n Piramid + Kach",
      filters: {
        "all-types": "Todos los tipos"
      },
      banner: {
        eyebrow: "Impacto del per\xEDodo",
        derived: "casos derivados",
        confirmed: "fraudes confirmados",
        saved: "valor protegido",
        "delta-suffix": "vs per\xEDodo anterior",
        "saved-note-one": "{{count}} reclamo sin estimaci\xF3n judicial cargada",
        "saved-note-other": "{{count}} reclamos sin estimaci\xF3n judicial cargada"
      },
      "in-process": {
        title: "Casos en proceso",
        subtitle: "Investigaciones abiertas hoy",
        "snapshot-tag": "Foto actual",
        "total-label": "casos abiertos en Kach",
        "breakdown-label": "Desglose por tipo de reclamo",
        "breakdown-tooltip": "Un caso puede aparecer en m\xE1s de un tipo si involucra reclamos de distintos tipos.",
        footnote: "No responde al filtro de per\xEDodo \xB7 estado en tiempo real.",
        empty: "Sin casos abiertos en Kach en este momento."
      },
      aging: {
        title: "Aging de casos abiertos",
        subtitle: "Antig\xFCedad de los casos que Kach todav\xEDa no cerr\xF3",
        "snapshot-tag": "Foto actual",
        "avg-label": "d\xEDas promedio abiertos",
        "total-label": "casos abiertos en Kach",
        "breakdown-label": "Distribuci\xF3n por antig\xFCedad",
        footnote: "No responde al filtro de per\xEDodo \xB7 estado en tiempo real.",
        empty: "Sin casos abiertos en Kach en este momento."
      },
      time: {
        title: "Tiempo de investigaci\xF3n",
        subtitle: "D\xEDas desde la derivaci\xF3n a Kach hasta el cierre del caso",
        unit: "d\xEDas",
        caption: "Cuanto antes cierra el caso, menos costo operativo consume el reclamo.",
        "breakdown-label": "Desglose \xB7 d\xEDas promedio",
        "delta-suffix": "vs per\xEDodo anterior",
        "no-previous": "Sin datos comparables en per\xEDodo anterior",
        positive: "Resultado positivo",
        "positive-note": "Fraude confirmado \xB7 cerrado",
        negative: "Resultado negativo",
        "negative-note": "Vuelve al flujo operativo",
        empty: "Sin casos cerrados en el per\xEDodo seleccionado."
      }
    },
    p2: {
      "section-title": "Diagn\xF3stico de Productividad",
      "section-description": "D\xF3nde se acumulan los reclamos y por qu\xE9 no estamos resolviendo m\xE1s r\xE1pido.",
      "stage-sla": {
        title: "Cumplimiento de SLA por etapa",
        subtitle: "% de reclamos que cerraron cada etapa dentro del SLA definido. Cerrados en el per\xEDodo seleccionado.",
        empty: {
          "no-sla": "Esta compa\xF1\xEDa no tiene SLA por etapa configurado.",
          "no-data": "No hay etapas cerradas en el per\xEDodo para el tipo de reclamo seleccionado."
        },
        kpi: {
          global: "Cumplimiento global",
          "global-delta": "{{sign}} {{n}} pts vs per\xEDodo ant.",
          "in-green": "Etapas en verde",
          "in-green-sub": "\u2265 80% cumplimiento",
          worst: "Peor etapa",
          "worst-sub": "{{pct}} cumplimiento"
        },
        stage: {
          "sla-label": "SLA: {{value}} {{unit}}",
          out: "fuera",
          avg: "Prom: {{days}} d"
        },
        footnote: "Verde \u2265 80% \xB7 Amarillo 50-79% \xB7 Rojo < 50%. Solo se muestran etapas con SLA definido en la configuraci\xF3n de la compa\xF1\xEDa."
      }
    },
    p3: {
      "section-title": "Diagn\xF3stico de Conciliaci\xF3n",
      "section-description": "Por qu\xE9 algunos reclamos terminan en mediaci\xF3n o juicio, y qu\xE9 los distingue de los que se concilian.",
      outcome: {
        reconciled: "Conciliados",
        mediation: "Mediaci\xF3n",
        judgment: "Juicio",
        notSuccessful: "No prosper\xF3",
        claimantDisinterest: "Desinter\xE9s del reclamante",
        rejected: "Rechazados",
        cancelled: "Anulados",
        fraud: "Fraude"
      },
      kpis: {
        conciliated: "Conciliados del per\xEDodo",
        mediation: "A mediaci\xF3n",
        judgment: "A juicio",
        "in-dispute": "$ en disputa",
        "vs-previous-period": "vs per\xEDodo ant."
      },
      negotiation: {
        title: "Indicadores tempranos de negociaci\xF3n",
        description: "Los reclamos que terminan en juicio suelen ofrecerse m\xE1s tarde, menos veces y por debajo de la estimaci\xF3n.",
        "days-to-first-offer": "D\xEDas al 1\xB0 ofrecimiento",
        "offers-count": "Ofrecimientos promedio",
        "gap-vs-estimation": "Gap $ vs estimaci\xF3n",
        "days-to-close": "D\xEDas al cierre",
        tooltip: {
          "days-to-first-offer": "D\xEDas entre la creaci\xF3n del reclamo y la primera oferta al reclamante. Actuar temprano correlaciona con conciliar.",
          "offers-count": "Cantidad promedio de rondas de ofrecimiento por reclamo. M\xE1s rondas suelen implicar negociaci\xF3n activa; muy pocas pueden derivar en juicio.",
          "gap-vs-estimation": "Diferencia porcentual entre el primer ofrecimiento y el monto judicial reclamado. Valores negativos indican que la primera oferta fue menor al monto reclamado. Un gap m\xE1s negativo suele conciliar mejor; un gap chico o positivo indica que ya se paga cerca de lo pedido.",
          "days-to-close": "D\xEDas totales desde la creaci\xF3n del reclamo hasta su cierre definitivo."
        },
        column: {
          indicator: "Indicador",
          diff: "\u0394 concil. \u2192 juicio"
        }
      },
      "outcome-cohort": {
        title: "Desenlace por mes de creaci\xF3n",
        description: "C\xF3mo cerraron los reclamos de cada mes de creaci\xF3n, por etapa de cierre. Los porcentajes son sobre los cerrados del cohorte y suman 100%. 'A\xFAn abiertos' se mide sobre el cohorte completo.",
        empty: "No hay cohortes en el rango seleccionado.",
        "statuses-tooltip": "Estados: {{statuses}}",
        "still-open": "A\xFAn abiertos",
        "immature-hint": "* Cohorte en curso, los valores pueden variar hasta que cierre.",
        column: {
          cohort: "Cohorte",
          size: "Tama\xF1o"
        }
      },
      "dispute-treemap": {
        title: "$ en disputa por tipo de da\xF1o",
        description: "Monto judicial total en mediaci\xF3n y juicio, por tipo de da\xF1o.",
        empty: "No hay reclamos en mediaci\xF3n o juicio en el per\xEDodo.",
        "tooltip-share": "del total en disputa"
      },
      patterns: {
        title: "Patrones agregados",
        description: "Reclamos que fueron a mediaci\xF3n o juicio, agrupados por tipo de da\xF1o y desenlace.",
        empty: "No hay patrones para el per\xEDodo seleccionado.",
        column: {
          category: "Tipo de da\xF1o",
          outcome: "Desenlace",
          count: "Q",
          "days-to-first-offer": "D\xEDas al 1\xB0 ofrec.",
          "offers-count": "Ofrec. prom.",
          gap: "Gap vs estim.",
          money: "$ involucrado"
        }
      },
      "risk-zone": {
        title: "Zona de riesgo",
        description: "Reclamos abiertos con patrones similares a los que terminaron en mediaci\xF3n o juicio en los \xFAltimos 6 meses.",
        "no-period-hint": "Esta secci\xF3n no depende del filtro de fecha de la p\xE1gina.",
        filter: {
          label: "Filtros",
          "damage-type-label": "Tipo de da\xF1o",
          "damage-type-all": "Todos los tipos",
          "amount-label": "Monto",
          "amount-all": "Todo el monto",
          "amount-gt500k": "> $ 500.000",
          "amount-gt1m": "> $ 1.000.000"
        },
        kpi: {
          "amount-sub": "acumulado del top 50 en riesgo",
          "amount-tooltip": "Suma del monto en disputa de los 50 reclamos abiertos con mayor score de riesgo hoy.",
          "aging-label": "Aging promedio",
          "aging-tooltip": "D\xEDas promedio desde la creaci\xF3n hasta hoy, sobre el top 50 en riesgo.",
          "score-label": "Score promedio",
          "score-tooltip": "Promedio del score de riesgo del top 50. Score 0-100 seg\xFAn similitud con casos que fueron a mediaci\xF3n o juicio en los \xFAltimos 6 meses.",
          "without-offer-label": "Sin ofrecimiento",
          "without-offer-sub": "abiertos sin evaluar",
          "without-offer-tooltip": "Reclamos abiertos con m\xE1s de 15 d\xEDas que a\xFAn no tienen ning\xFAn ofrecimiento registrado. No se pueden evaluar con el score, pero merecen atenci\xF3n."
        },
        table: {
          title: "Top 10 en riesgo",
          "title-selected": "Reclamo en riesgo",
          tooltip: "Score 0-100 calculado por percentil ponderado de 4 indicadores respecto a mediaciones y juicios de los \xFAltimos 6 meses: d\xEDas abiertos, d\xEDas al 1\xB0 ofrecimiento, cantidad de ofrecimientos, gap vs estimaci\xF3n.",
          "csv-btn": "CSV",
          row: {
            "days-open": "{{days}}d abierto"
          }
        },
        scatter: {
          title: "Mapa de los 50 reclamos abiertos de mayor riesgo",
          legend: {
            size: "Tama\xF1o: monto",
            number: "N\xFAmero: ofrecimientos",
            color: "Color (gap $):",
            "color-scale": "chico \u2192 grande"
          },
          "toggle-historic": "Mostrar cerrados \xFAltimos 6m (mediaci\xF3n o juicio)",
          "axis-x": "D\xEDas de vida del reclamo",
          "axis-y": "Score de riesgo",
          "risk-zone-label": "Riesgo (score \u2265 60)",
          "risk-zone-critical-label": "Riesgo cr\xEDtico (score \u2265 80)",
          tooltip: {
            open: {
              score: "Score: {{score}}/100",
              "days-open": "D\xEDas abiertos: {{days}}",
              "days-first-offer": "D\xEDas al 1\xB0 ofrec: {{days}}",
              offers: "Ofrecimientos: {{count}}",
              gap: "Gap: {{gap}}",
              amount: "Monto: {{amount}}"
            },
            historic: {
              "closed-in": "Cerrado en {{outcome}}",
              "final-score": "Score final: {{score}}/100",
              duration: "Duraci\xF3n: {{days}} d",
              amount: "Monto: {{amount}}"
            }
          }
        },
        outcome: {
          mediation: "Mediaci\xF3n",
          judgment: "Juicio"
        },
        "selected-banner": "Filtrando por reclamo seleccionado en el gr\xE1fico",
        "clear-selection": "Quitar selecci\xF3n",
        empty: {
          "no-results": "Sin reclamos en zona de riesgo con los filtros actuales",
          "no-reference": "Sin mediaciones ni juicios en los \xFAltimos 6 meses. No es posible calcular riesgo."
        },
        error: "No se pudo cargar la zona de riesgo.",
        retry: "Reintentar"
      }
    },
    funnel: {
      title: "Funnel de etapas",
      "drill-down-title": "Estados dentro de {stage}",
      back: "Volver a etapas",
      "bottleneck-tag": "Cuello de botella",
      hint: "La barra representa los d\xEDas promedio en cada etapa. La l\xEDnea negra marca el SLA; sin filtro se muestra el rango m\xEDn-m\xE1x entre tipos de da\xF1o. Si la barra supera el SLA (o el m\xEDnimo del rango), la etapa incumple SLA en promedio. Hac\xE9 clic en una etapa para ver el detalle de estados.",
      "special-section": "Estados especiales (pueden ocurrir en cualquier momento)",
      filter: {
        "damage-type-label": "Tipo de da\xF1o",
        "damage-type-all": "Todos los tipos"
      },
      sla: {
        "tooltip-single": "SLA: {{days}} d",
        "tooltip-range": "SLA: {{min}} d \u2013 {{max}} d seg\xFAn tipo de da\xF1o"
      },
      empty: "No hubo transiciones de etapa en el per\xEDodo.",
      error: "No pudimos cargar el detalle de estados.",
      "no-states": "Esta etapa no tuvo entradas de estados en el per\xEDodo.",
      column: {
        stage: "Etapa",
        count: "Reclamos",
        "count-tooltip": "Cantidad de reclamos que pasaron por esta etapa en el per\xEDodo.",
        "avg-days": "D\xEDas prom.",
        delta: "\u0394 per\xEDodo ant."
      },
      "drill-down": {
        column: {
          state: "Estado",
          count: "Reclamos",
          "count-tooltip": "Cantidad de reclamos que pasaron por este estado en el per\xEDodo.",
          "avg-days": "D\xEDas prom."
        }
      }
    },
    flow: {
      title: "Flujo entrante vs saliente",
      legend: {
        created: "Creados",
        closed: "Cerrados"
      },
      "backlog-label": "Backlog acumulado del per\xEDodo",
      "monthly-note": "Los puntos representan totales mensuales completos."
    },
    "backlog-by-age": {
      title: "Backlog abierto por edad",
      subtitle: "Distribuci\xF3n detallada del stock actual.",
      kpi: {
        stock: "Stock total",
        "stock-detail": "reclamos abiertos",
        runway: "Runway estimado",
        "runway-months": "meses",
        "runway-detail": "al ritmo neto de cierre ({{rate}}/mes)",
        "runway-null": "el backlog no se reduce ({{rate}}/mes neto)",
        critical: "Cr\xEDtico (>90 d\xEDas)",
        "critical-detail": "{{pct}} del backlog"
      },
      tooltip: {
        claims: "{{count}} reclamos",
        pct: "{{pct}} del backlog"
      },
      "foot-note": "La edad se calcula desde la fecha de creaci\xF3n de cada reclamo hasta hoy. El runway estimado divide el stock actual por la reducci\xF3n neta (cerrados \u2212 creados) del \xFAltimo mes calendario completo."
    },
    cohort: {
      title: "Cohorte de cierre por mes de creaci\xF3n",
      description: "% del cohorte que ya cerr\xF3 seg\xFAn el mes calendario en que se cerr\xF3, relativo a su mes de creaci\xF3n. Cohortes recientes pueden no estar maduros.",
      empty: "No hay reclamos creados en los \xFAltimos meses.",
      "in-progress-hint": "Bucket a\xFAn no completo \u2014 el cohorte sigue corriendo.",
      "excluded-recent-hint": "Se excluyen cohortes con menos de 15 d\xEDas desde el inicio del mes (datos no significativos).",
      filter: {
        all: "Todos los tipos",
        active: "Filtrado",
        clear: "Limpiar filtro"
      },
      column: {
        cohort: "Cohorte",
        size: "Tama\xF1o",
        "still-open": "A\xFAn abiertos",
        "total-closed": "Total cerrado",
        "month-label-current": "M0",
        "month-label": "M+{{n}}",
        "month-tooltip-current": "% del cohorte cerrado dentro del mismo mes de creaci\xF3n.",
        "month-tooltip-one": "% acumulado del cohorte cerrado hasta 1 mes despu\xE9s del de creaci\xF3n.",
        "month-tooltip-many": "% acumulado del cohorte cerrado hasta {{n}} meses despu\xE9s del de creaci\xF3n.",
        "cell-tooltip-current": "Cerrados en {{month}}: {{count}} de {{size}} ({{pct}})",
        "cell-tooltip": "Cerrados hasta {{month}}: {{count}} de {{size}} ({{pct}})"
      }
    },
    "team-extended": {
      title: "Performance por equipo (extendida)",
      column: {
        team: "Equipo",
        handler: "Tramitador",
        handlers: "Tramitadores",
        "handlers-tooltip": "Personas que atendieron reclamos del equipo en el per\xEDodo; es el divisor de la Productividad, no la dotaci\xF3n del equipo. Puede incluir colaboradores y tramitadores que ya no pertenecen al equipo.",
        resolved: "Resueltos",
        productivity: "Productividad",
        "avg-days": "D\xEDas prom.",
        open: "Abiertos",
        aging: "Aging prom.",
        delta: "\u0394 per\xEDodo ant.",
        "delta-tooltip": "Variaci\xF3n porcentual de la productividad del equipo respecto al per\xEDodo anterior seg\xFAn el filtro seleccionado. Verde: mejor\xF3 \xB7 Rojo: empeor\xF3.",
        "drill-down-tooltip": "Ver tramitadores del equipo"
      },
      "show-inactive": "Mostrar {count} equipos sin actividad",
      "hide-inactive": "Ocultar equipos sin actividad",
      hint: "Hac\xE9 click en un equipo para ver la performance de sus tramitadores.",
      empty: "Sin datos para el per\xEDodo seleccionado.",
      error: "No se pudieron cargar los tramitadores del equipo.",
      "drill-down": {
        title: "Performance de tramitadores \xB7 {team}",
        back: "Volver a equipos"
      }
    },
    "focus-explainer": {
      title: "\xBFC\xF3mo se elige el foco?",
      "info-label": "\xBFC\xF3mo se elige el foco?",
      description: "El equipo cuya ca\xEDda de Eficacia operativa le cost\xF3 m\xE1s cierres exitosos a la compa\xF1\xEDa. La pregunta es: \xBFcu\xE1ntos cierres exitosos m\xE1s habr\xEDa tenido este mes si manten\xEDa la eficacia del mes anterior?",
      base: "Se compara as\xED, y no por puntos de ca\xEDda, porque un equipo chico sube y baja varios puntos por el volumen chico de reclamos: una ca\xEDda de 2,5 puntos sobre 1.470 cierres pesa m\xE1s que una de 10 puntos sobre 45. Se comparan los dos \xFAltimos meses completos, porque contra el mes en curso todos los equipos parecer\xEDan haberse desplomado durante los primeros d\xEDas."
    },
    "vs-previous-month": "vs mes ant."
  }
};
var team_management = {
  nav: "Gesti\xF3n de equipo",
  title: "Gesti\xF3n de equipo",
  "scope-hint": "Coordinadores ven sus equipos. Administradores pueden elegir cualquier equipo.",
  header: {
    members: "{{count}} miembros",
    "open-claims": "{{count}} reclamos abiertos",
    snapshot: "Foto actual"
  },
  summary: {
    active: "Activos",
    "active-hint": "de {{total}} miembros",
    paused: "Activos no disponibles",
    "paused-hint": "sin recibir reclamos nuevos",
    inactive: "Inactivos no disponibles",
    "inactive-hint": "pr\xF3ximo regreso el {{date}}",
    "inactive-empty": "sin licencias en curso",
    scheduled: "Inactividades programadas",
    "scheduled-hint": "pr\xF3ximo inicio el {{date}}",
    "scheduled-empty": "sin licencias programadas",
    overloaded: "Usuarios sobrecargados",
    "overloaded-hint": "sobre su carga habitual"
  },
  thresholds: "Carga habitual: {{median}} \xB7 Alto desde {{high}} \xB7 Sobrepasado desde {{overloaded}}",
  "thresholds-empty": "Sin tramitadores activos para calcular la carga habitual.",
  "thresholds-per-team": "Cada miembro se compara con la carga habitual de su equipo: Alto desde un {{high}}% m\xE1s, Sobrepasado desde un {{overloaded}}% m\xE1s.",
  "thresholds-show": "Ver la carga habitual de los {{count}} equipos",
  "thresholds-dialog": {
    title: "Carga habitual por equipo",
    description: "Cada miembro se compara con la carga habitual de los tramitadores activos de su equipo, sin contar al coordinador. Es Alto desde un {{high}}% m\xE1s y Sobrepasado desde un {{overloaded}}% m\xE1s.",
    median: "Carga habitual {{median}}",
    high: "Alto desde {{value}}",
    overloaded: "Sobrepasado desde {{value}}"
  },
  empty: {
    title: "No hay equipos para gestionar",
    description: "La compa\xF1\xEDa todav\xEDa no tiene equipos configurados."
  },
  members: {
    title: "Usuarios",
    "title-team": "Usuarios - {{team}}",
    hint: "Ordenado por cr\xEDticos >90d. Click en un miembro para ver sus reclamos.",
    search: "Buscar tramitador",
    empty: "Ning\xFAn miembro coincide con la b\xFAsqueda.",
    "empty-scope": "No hay miembros en este alcance.",
    coordinator: "Coordinador",
    days: "{{value}} d",
    columns: {
      member: "Ordenar por tramitador",
      team: "Equipo",
      state: "Estado",
      assignments: "Operativo",
      open: "Abiertos",
      load: "Carga",
      aging: "Aging prom.",
      critical: "Cr\xEDticos",
      "critical-hint": "Reclamos abiertos hace m\xE1s de {{days}} d\xEDas",
      actions: "Acciones"
    },
    state: {
      active: "Activo",
      inactive: "Inactivo"
    },
    "teams-more": "+{{count}}",
    assignments: {
      available: "Disponible",
      unavailable: "No disponible",
      "paused-today": "No recibe reclamos nuevos desde hoy",
      "paused-one-day": "No recibe reclamos nuevos desde hace 1 d\xEDa",
      "paused-days": "No recibe reclamos nuevos desde hace {{days}} d\xEDas",
      "inactive-hint": "En inactividad: no recibe reclamos",
      "paused-toast": "{{name}} no recibir\xE1 reclamos nuevos",
      "resumed-toast": "{{name}} volver\xE1 a estar disponible para recibir reclamos nuevos"
    },
    load: {
      normal: "Normal",
      high: "Alto",
      overloaded: "Sobrepasado",
      median: "Carga habitual de su equipo: {{median}}",
      hint: "{{level}} \xB7 Carga habitual de su equipo: {{median}}",
      "team-hint": "{{team}} \xB7 {{level}} \xB7 Carga habitual: {{median}}",
      "team-hint-empty": "{{team}} \xB7 Sin tramitadores activos para calcular la carga habitual."
    },
    "excess-critical": "Tiene un {{percent}}% m\xE1s de cr\xEDticos que lo habitual en su equipo, o m\xE1s",
    "unmanaged-claims": "{{count}} son de equipos que no gestion\xE1s: no vas a poder reasignarlos.",
    "schedule-inactivity": "Programar inactividad",
    actions: {
      open: "Ver detalle",
      pause: "Marcar no disponible",
      resume: "Marcar disponible"
    },
    "scheduled-delegation": "Delegaci\xF3n programada",
    "returned-without-claims": "Volvi\xF3 de su inactividad sin reclamos asignados. Entr\xE1 a su detalle para recuperar los que deleg\xF3."
  },
  "member-dialog": {
    kpis: {
      open: "Abiertos",
      aging: "Aging prom.",
      critical: "Cr\xEDticos"
    },
    banner: {
      inactive: "Inactivo",
      scheduled: "Inactividad programada",
      period: "{{title}} del {{from}} al {{to}}",
      since: "{{title}} desde el {{from}}, sin fecha de regreso",
      until: "{{title}} hasta el {{to}}",
      reason: "\xB7 Motivo: {{reason}}.",
      "inactive-hint": "Las notificaciones de sus reclamos las recibe el coordinador del equipo.",
      "scheduled-hint": "Sigue recibiendo y trabajando reclamos hasta que empiece."
    },
    inactivity: {
      edit: "Editar fechas",
      cancel: "Cancelar inactividad",
      "change-return": "Cambiar fecha de regreso",
      "end-now": "Finalizar ahora",
      save: "Guardar",
      discard: "Descartar",
      back: "Volver",
      "cancel-confirm": "\xBFCancelar la inactividad de {{name}} del {{from}} al {{to}}?",
      "cancel-confirm-hint": "Sigue activo y, si hab\xEDa dejado de recibir reclamos nuevos para esta inactividad, vuelve a estar disponible.",
      "end-confirm-title": "Finalizar inactividad",
      "end-confirm": "\xBFFinalizar ahora la inactividad de {{name}}?",
      "end-confirm-hint": "Vuelve a activo y disponible en el momento. Los reclamos que deleg\xF3 siguen con quienes los recibieron.",
      "toast-rescheduled": "Inactividad de {{name}} actualizada",
      "toast-started": "{{name}} pas\xF3 a inactivo",
      "toast-return-changed": "Fecha de regreso de {{name}} actualizada",
      "toast-cancelled": "Inactividad de {{name}} cancelada",
      "toast-ended": "{{name}} volvi\xF3 a activo"
    },
    tabs: {
      responsible: "Responsable",
      delegated: "Delegados",
      derived: "Derivados"
    },
    search: "Buscar por n\xFAmero de reclamo",
    "all-stages": "Todas las etapas",
    "all-statuses": "Todos los estados",
    "no-stage": "Sin etapa",
    "option-count": "{{label}} ({{count}})",
    columns: {
      claim: "Reclamo",
      damage: "Tipo de da\xF1o",
      stage: "Etapa",
      status: "Estado",
      aging: "Aging",
      "offer-cap": "Tope"
    },
    unmanaged: "Equipo {{team}}: no lo gestion\xE1s",
    empty: "No es responsable de reclamos abiertos.",
    "empty-filtered": "Ning\xFAn reclamo coincide con los filtros.",
    "claims-not-readable": "Tu rol no permite ver los reclamos de otros miembros.",
    "select-all": "Seleccionar todos",
    "select-claim": "Seleccionar reclamo",
    "not-reassignable": "Equipo {{team}}: no pod\xE9s reasignarlo",
    "no-team": "Sin equipo",
    selection: {
      count: "{{count}} reclamos seleccionados",
      "count-one": "1 reclamo seleccionado",
      reassign: "Reasignar seleccionados",
      "mixed-teams": "Seleccion\xE1 reclamos de un mismo equipo"
    },
    delegation: {
      review: "Revisar distribuci\xF3n",
      "delegate-uncovered": "Delegar ahora",
      "delegate-all": "Delegar reclamos",
      scheduled: "Tiene una delegaci\xF3n programada de {{claims}}.",
      unplanned: "Sus reclamos no tienen una distribuci\xF3n programada.",
      uncovered: "Tiene {{claims}} en su poder sin delegar."
    },
    delegations: {
      received: "Recibidos",
      "received-hint": "Reclamos que otros le delegaron",
      delegated: "Delegados",
      "delegated-hint": "Reclamos que deleg\xF3 y hoy tiene otra persona",
      empty: "Sin reclamos",
      columns: {
        claim: "Reclamo",
        "delegated-at": "Fecha delegado",
        owner: "Tramitador original",
        "owner-team": "Equipo original",
        holder: "Responsable actual",
        "holder-team": "Equipo actual",
        action: "Acci\xF3n"
      },
      return: "Retornar",
      "return-selected": "Retornar seleccionados",
      recover: "Recuperar",
      "recover-selected": "Recuperar seleccionados",
      "open-derivation": "Con derivaci\xF3n abierta",
      "open-derivation-hint": "Se deriv\xF3 despu\xE9s de delegarlo. Se puede recuperar cuando retornen la derivaci\xF3n.",
      "recover-unavailable": "Se habilita cuando est\xE9 activo y disponible",
      "owner-inactive": "Inactivo",
      "no-holder": "Sin responsable"
    },
    derivations: {
      received: "Recibidos",
      "received-hint": "Reclamos que tiene por una derivaci\xF3n abierta",
      "not-returnable": "Lo tiene en un equipo que no coordin\xE1s: lo retorna su coordinador o desde el reclamo.",
      given: "Derivados",
      "given-hint": "Reclamos que deriv\xF3 y hoy tiene otra persona",
      "not-recoverable": "Lo deriv\xF3 desde un equipo que no coordin\xE1s: lo recupera su coordinador.",
      columns: {
        claim: "Reclamo",
        "derived-at": "Fecha derivado",
        deriver: "Tramitador original",
        "deriver-team": "Equipo original"
      }
    }
  },
  "derivation-recovery-dialog": {
    title: "Recuperar reclamos derivados",
    description: "Se le sacan a quien los tiene hoy, que recibe un aviso, y vuelven a {{name}} y a su equipo, con el estado que ten\xEDan antes de la derivaci\xF3n y su SLA reanudado. No se comunica nada al tercero.",
    reason: "Motivo",
    "reason-placeholder": "Queda en la actividad de cada reclamo",
    "deriver-paused": "({{name}} no est\xE1 disponible)",
    "substitute-hint": "Como {{name}} no est\xE1 activo y disponible, el reclamo va a otro tramitador de su equipo, en el mismo orden que los reclamos nuevos, y queda delegado: lo recupera cuando vuelva.",
    skipped: "{{claims}} ya no estaban derivados por esta persona y quedaron como estaban."
  },
  "derived-claims-dialog": {
    title: "Retornar reclamos derivados",
    description: "Vuelven a quien los deriv\xF3 y a su equipo, con el estado que ten\xEDan antes de la derivaci\xF3n y su SLA reanudado. No se comunica nada al tercero.",
    "absent-hint": "Con quien deriv\xF3 inactivo, el reclamo va a otro tramitador de su equipo, en el mismo orden que los reclamos nuevos, y queda delegado: lo recupera cuando vuelva.",
    comment: "Comentario (opcional)",
    "comment-placeholder": "Queda en la actividad de cada reclamo",
    toast: "Se retornaron {{claims}}",
    skipped: "{{claims}} ya no estaban derivados a esta persona y quedaron como estaban."
  },
  "delegated-claims-dialog": {
    "return-title": "Retornar reclamos delegados",
    "recover-title": "Recuperar reclamos delegados",
    "return-description": "Vuelven a quien los deleg\xF3 y a su equipo, y la delegaci\xF3n se cierra.",
    "recover-description": "Vuelven a {{name}} y la delegaci\xF3n se cierra. Quien los tiene hoy recibe un aviso.",
    columns: {
      claim: "Reclamo",
      holder: "Hoy lo tiene",
      to: "Vuelve a"
    },
    "owner-inactive": "({{name}} est\xE1 en inactividad)",
    "redelegated-hint": "Con el due\xF1o inactivo, el reclamo va a otro tramitador de su equipo, en el mismo orden que los reclamos nuevos, y sigue delegado: lo recupera cuando vuelva.",
    "no-destination": "Nadie de su equipo puede recibirlo: queda con {{name}}",
    cancel: "Cancelar",
    "return-confirm": "Retornar {{claims}}",
    "recover-confirm": "Recuperar {{claims}}",
    "return-toast": "Se retornaron {{claims}}",
    "recover-toast": "{{name}} recuper\xF3 {{claims}}"
  },
  "account-notice": {
    title: "No est\xE1s recibiendo reclamos nuevos desde el {{date}}",
    hint: "Segu\xEDs trabajando tus reclamos y recibiendo sus notificaciones. Tu coordinador puede volver a habilitarte."
  },
  reassign: {
    title: "Reasignar reclamos",
    description: {
      reassigning: "Est\xE1s reasignando",
      from: "de",
      "pick-target": "Eleg\xED un nuevo responsable dentro del equipo"
    },
    claims: "{{count}} reclamos",
    "claims-one": "1 reclamo",
    target: "Destino",
    "candidate-stats": "{{open}} abiertos \xB7 aging {{aging}} \xB7 {{critical}} cr\xEDticos",
    empty: "No hay otros miembros activos y disponibles en el equipo.",
    footer: "La reasignaci\xF3n es inmediata y queda registrada en la Actividad de cada reclamo.",
    cancel: "Cancelar",
    confirm: "Reasignar {{claims}}",
    toast: "{{claims}} reasignados a {{target}}",
    "toast-one": "1 reclamo reasignado a {{target}}"
  },
  activity: {
    title: "Actividad",
    subtitle: "Reasignaciones, disponibilidad, inactividades, delegaciones, derivaciones y retornos",
    empty: "Todav\xEDa no hay actividad en los equipos seleccionados.",
    "empty-category": "No hay actividad de este tipo en los equipos seleccionados.",
    categories: {
      all: "Todos los eventos",
      reassignments: "Reasignaciones",
      availability: "Disponibilidad",
      inactivities: "Inactividades",
      delegations: "Delegaciones",
      derivations: "Derivaciones"
    },
    "claims-mention": "los reclamos {{claims}}",
    "claims-mention-one": "el reclamo {{claims}}",
    "claims-more": "y {{count}} m\xE1s",
    "claims-gone": "reclamos que ya no existen",
    "delegated-claims": "Reclamos delegados: {{claims}}",
    "system-author": "Piramid",
    team_claims_reassigned: "{{author}} reasign\xF3 {{claims}} de {{from}} a {{to}}",
    "user-assignments": "{{author}} marc\xF3 como {{state}} a {{user}}",
    "paused-state": "no disponible",
    "resumed-state": "disponible",
    user_inactivity_scheduled: "Se program\xF3 inactividad de {{user}} del {{from}} al {{to}} \xB7 {{reason}} \xB7 {{delegation}}",
    "without-delegation": "sin delegar",
    "delegation-delegated": "{{count}} reclamos delegados a {{recipients}}",
    "delegation-delegated-one": "1 reclamo delegado a {{recipients}}",
    "delegation-recipients": "{{count}} tramitadores",
    "delegation-recipients-one": "1 tramitador",
    "delegation-returned": "{{count}} retornados",
    "delegation-returned-one": "1 retornado",
    "delegation-kept": "{{count}} mantenidos",
    "delegation-kept-one": "1 mantenido",
    user_inactivity_started: "{{user}} pas\xF3 a inactivo \xB7 vuelve el {{date}}",
    "user_inactivity_started-no-return": "{{user}} pas\xF3 a inactivo",
    user_inactivity_ended: "{{user}} volvi\xF3 a activo",
    "user_inactivity_ended-by": "{{author}} finaliz\xF3 la inactividad de {{user}} \xB7 volvi\xF3 a activo",
    user_inactivity_rescheduled: "{{author}} modific\xF3 la inactividad de {{user}}: {{previous}} \u2192 {{current}}",
    "reason-change": " \xB7 motivo: {{previous}} \u2192 {{current}}",
    period: "{{from}} al {{to}}",
    user_inactivity_return_changed: "{{author}} cambi\xF3 la fecha de regreso de {{user}}: {{previous}} \u2192 {{current}}",
    "no-return": "sin fecha",
    user_inactivity_cancelled: "{{author}} cancel\xF3 la inactividad programada de {{user}}",
    today: "Hoy, {{time}}",
    yesterday: "Ayer, {{time}}",
    user_inactivity_claims_delegated: "Se delegaron los reclamos de {{user}} \xB7 {{delegation}}",
    "user_inactivity_claims_delegated-by": "{{author}} deleg\xF3 los reclamos de {{user}} \xB7 {{delegation}}",
    "user_inactivity_claims_delegated-own": "{{user}} deleg\xF3 sus reclamos \xB7 {{delegation}}",
    user_inactivity_delegation_updated: "{{author}} actualiz\xF3 la delegaci\xF3n de {{user}} \xB7 {{delegation}}",
    user_inactivity_delegation_discarded: "{{author}} dej\xF3 sin delegar los reclamos de {{user}}",
    "pending-recovery": " \xB7 {{count}} reclamos delegados para recuperar",
    "pending-recovery-one": " \xB7 1 reclamo delegado para recuperar",
    "recover-link": "Recuperar sus reclamos delegados",
    user_delegated_claims_recovered: "{{author}} le recuper\xF3 {{claims}} a {{holder}} del tramitador {{user}}",
    "user_delegated_claims_recovered-unknown-holder": "{{author}} recuper\xF3 {{claims}} del tramitador {{user}}",
    "user_delegated_claims_recovered-own": "{{user}} recuper\xF3 {{claims}} que ten\xEDa {{holder}}",
    "user_delegated_claims_returned-to": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} a {{to}}",
    "user_delegated_claims_returned-to-redelegated": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} a {{to}} porque el tramitador {{owner}} est\xE1 inactivo",
    "user_delegated_claims_returned-owner": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} a su due\xF1o",
    "user_delegated_claims_returned-owner-redelegated": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} al equipo de su due\xF1o, que est\xE1 inactivo",
    user_derived_claims_returned: "{{author}} retorn\xF3 la derivaci\xF3n de {{claims}} que ten\xEDa {{user}} a {{to}}",
    user_derived_claims_recovered: "{{author}} recuper\xF3 {{claims}} que deriv\xF3 {{user}} \xB7 motivo: {{reason}}"
  },
  pagination: {
    page: "P\xE1gina {{page}} de {{pages}}",
    previous: "\u2039 Anteriores",
    next: "Siguientes \u203A"
  },
  "inactivity-reasons": {
    medical_leave: "Licencia m\xE9dica",
    vacation: "Vacaciones",
    study_day: "D\xEDa de estudio",
    training: "Capacitaci\xF3n / evento",
    personal_leave: "Licencia personal",
    other: "Otro",
    none: "Sin motivo"
  },
  leaves: {
    title: "Licencias",
    subtitle: "D\xEDas de inactividad en el a\xF1o calendario, incluidas las en curso y programadas",
    year: "A\xF1o calendario",
    days: "{{count}} d",
    segment: "{{reason}}: {{count}} d\xEDas",
    "segment-one": "{{reason}}: 1 d\xEDa",
    "without-leaves": "{{count}} miembros sin licencias en {{year}}",
    "without-leaves-one": "1 miembro sin licencias en {{year}}",
    empty: "Sin licencias en {{year}}"
  },
  "schedule-inactivity": {
    title: "Programar inactividad",
    description: "Defin\xED el per\xEDodo en el que {{name}} no estar\xE1 operativo. Durante ese rango no se le asignan reclamos nuevos.",
    steps: {
      period: "Per\xEDodo",
      delegate: "Delegar reclamos"
    },
    from: "Desde",
    to: "Hasta",
    reason: "Motivo",
    "reason-placeholder": "Eleg\xED un motivo",
    "reason-hint": "Se guarda como referencia para la Actividad del equipo. No se le notifica al tramitador.",
    "pause-now": "Dejar de asignarle reclamos nuevos desde hoy",
    "pause-now-hint": "Queda No disponible desde ahora hasta que empiece la inactividad.",
    days: "{{count}} d\xEDas",
    "days-one": "1 d\xEDa",
    "open-claims": "{{count}} reclamos abiertos",
    "open-claims-one": "1 reclamo abierto",
    summary: "{{name}} tiene {{claims}} asignados. Pod\xE9s programar sin delegar o pasar a delegar sus reclamos.",
    "summary-one": "{{name}} tiene {{claims}} asignado. Pod\xE9s programar sin delegar o pasar a delegar sus reclamos.",
    cancel: "Cancelar",
    schedule: "Programar sin delegar",
    delegate: "Delegar reclamos",
    required: "Complet\xE1 este campo",
    "from-before-today": "Eleg\xED hoy o una fecha posterior",
    "to-before-from": "Tiene que ser igual o posterior a Desde",
    "toast-started": "{{name}} pas\xF3 a inactivo",
    "toast-scheduled": "Inactividad programada para {{name}} desde el {{date}}",
    "toast-delegation": "Al empezar: {{delegation}}",
    delegation: {
      description: "Eleg\xED qu\xE9 pasa con sus reclamos durante el per\xEDodo de inactividad.",
      mode: "Distribuci\xF3n",
      modes: {
        automatic: "Autom\xE1tico",
        manual: "Manual"
      },
      "mode-hints": {
        automatic: "Los reclamos se reparten entre los tramitadores disponibles del equipo, en el mismo orden que los reclamos nuevos. El coordinador recibe solo si no queda nadie m\xE1s.",
        manual: "Eleg\xEDs a qui\xE9n va cada reclamo. Los que no definas se mantienen con el tramitador."
      },
      "by-load": "Hacer la delegaci\xF3n de acuerdo a la carga de los tramitadores disponibles",
      "by-load-hint": "Cada reclamo va al tramitador que menos abiertos tiene en ese momento. Quien ya tiene m\xE1s carga que el resto no recibe.",
      include: "Qu\xE9 incluir",
      categories: {
        own: "Reclamos propios",
        delegated: "Delegados recibidos",
        derived: "Derivados recibidos"
      },
      "own-hint": "Se delegan temporalmente. El tramitador sigue siendo el due\xF1o y los recupera cuando vuelve.",
      "delegated-returning": "{{count}} vuelven a quien se los deleg\xF3, que est\xE1 activo durante el per\xEDodo.",
      "delegated-returning-one": "1 vuelve a quien se lo deleg\xF3, que est\xE1 activo durante el per\xEDodo.",
      "delegated-staying": "{{count}} se delegan a otro del equipo porque quien se los deleg\xF3 no est\xE1 activo durante el per\xEDodo.",
      "delegated-staying-one": "1 se delega a otro del equipo porque quien se lo deleg\xF3 no est\xE1 activo durante el per\xEDodo.",
      "derived-hint": "Se delegan a otro tramitador del equipo receptor. La derivaci\xF3n sigue abierta y, cuando se retorne, vuelve a quien lo deriv\xF3.",
      distribution: "Distribuci\xF3n estimada",
      columns: {
        member: "Tramitador",
        open: "Abiertos hoy",
        total: "Carga total",
        "total-hint": "Abiertos hoy m\xE1s los que recibe en esta distribuci\xF3n",
        load: "Carga",
        owner: "Titular",
        claims: "Reclamos"
      },
      returning: "Vuelven a su titular",
      members: "{{count}} tramitadores",
      "members-one": "1 tramitador",
      overloaded: "No reciben {{members}} que ya tienen m\xE1s carga que el resto.",
      "overloaded-one": "No recibe {{members}} que ya tiene m\xE1s carga que el resto.",
      unavailable: "No participan {{members}} no disponibles.",
      "unavailable-one": "No participa {{members}} no disponible.",
      kept: "Nadie del equipo puede recibir {{claims}}: quedan con {{name}}",
      "without-team": "{{claims}} sin equipo quedan con {{name}}",
      empty: "No hay reclamos para delegar.",
      back: "Volver",
      confirm: "Confirmar y programar",
      manual: {
        progress: "{{defined}} de {{total}} reclamos con destino definido",
        "progress-hint": "Eleg\xED qu\xE9 pasa con cada reclamo. Los que no definas se mantienen con {{name}}.",
        search: "Buscar por n\xFAmero de reclamo",
        columns: {
          claim: "Reclamo",
          origin: "Origen",
          status: "Estado",
          aging: "Aging",
          destination: "Destino"
        },
        origins: {
          own: "Propio",
          delegated: "Delegado recibido",
          derived: "Derivado recibido"
        },
        from: "de {{name}}",
        "from-team": "de {{name}} \xB7 {{team}}",
        placeholder: "Elegir destino...",
        keep: "Mantener con {{name}}",
        return: "Retornar a {{name}}",
        candidate: "{{name}} \xB7 {{count}} abiertos",
        coordinator: "{{name}} (Coord.)",
        pending: "{{count}} reclamos sin destino se mantienen con el tramitador",
        "pending-one": "1 reclamo sin destino se mantiene con el tramitador",
        "empty-filtered": "Ning\xFAn reclamo coincide con la b\xFAsqueda.",
        new: "Nuevo",
        "new-undefined": "Nuevo \xB7 sin definir"
      }
    }
  },
  "manage-link": "Programar en Gesti\xF3n de equipo",
  "linked-member-not-found": {
    title: "No est\xE1 en tus equipos",
    description: "El usuario no forma parte de los equipos que gestion\xE1s."
  },
  "own-inactivity": {
    title: "Inactividad",
    "managed-by-coordinator": "La inactividad la gestiona tu coordinador",
    "managed-by-you": "Program\xE1 o cambi\xE1 tu inactividad desde Gesti\xF3n de equipo",
    inactivity: "Inactividad",
    none: "No ten\xE9s una inactividad programada ni en curso.",
    assignments: "Reclamos nuevos",
    receiving: "Est\xE1s recibiendo reclamos nuevos"
  },
  "own-delegations": {
    title: "Reclamos delegados",
    description: "Los reclamos que delegaste y qui\xE9n los tiene hoy. Cuando vuelvas, recuperalos desde ac\xE1.",
    section: "Delegados",
    "section-hint": "Reclamos que delegaste y hoy tiene otra persona",
    "recover-unavailable": "Se habilita cuando est\xE9s activo y disponible",
    "recover-description": "Vuelven a vos y la delegaci\xF3n se cierra. Quien los tiene hoy recibe un aviso.",
    "recover-toast": "Recuperaste {{claims}}",
    delegate: "Delegar reclamos",
    "delegate-title": "Delegar tus reclamos",
    "delegate-description": "Tus reclamos abiertos se reparten entre los tramitadores disponibles de tu equipo, en el mismo orden que los reclamos nuevos. Los que te delegaron vuelven a su due\xF1o si est\xE1 activo.",
    "delegate-plan": "Se van a mover: {{delegation}}.",
    "delegate-nothing": "No ten\xE9s reclamos abiertos para delegar.",
    "delegate-confirm": "Delegar",
    "delegate-toast": "Delegando tus reclamos",
    "delegate-toast-description": "{{delegation}}. La lista se actualiza cuando termine.",
    delegating: "Delegando\u2026"
  },
  "delegation-dialog": {
    "review-title": "Revisar distribuci\xF3n",
    "review-starts-tomorrow": "Ma\xF1ana empieza la inactividad de {{name}}.",
    "review-starts-on": "La inactividad de {{name}} empieza el {{date}}.",
    "review-scheduled-on": "La inactividad programada el {{planned}} para {{name}} empieza el {{date}}.",
    "review-scheduled-tomorrow": "La inactividad programada el {{planned}} para {{name}} empieza ma\xF1ana.",
    "review-load-changed": "Al programarla ten\xEDa {{planned}}; hoy tiene {{current}}.",
    "review-unplanned": "Se program\xF3 sin delegar: pod\xE9s definir la distribuci\xF3n de sus reclamos antes de que se ejecute.",
    cancel: "Cancelar",
    "leave-undelegated": "Dejar sin delegar",
    save: "Guardar distribuci\xF3n",
    "toast-saved": "Distribuci\xF3n de {{name}} actualizada",
    "toast-discarded": "Los reclamos de {{name}} quedan sin delegar",
    "delegate-title": "Delegar reclamos",
    "delegate-uncovered": "{{name}} est\xE1 inactivo y tiene {{claims}} en su poder sin delegar.",
    "delegate-all": "{{name}} est\xE1 inactivo. Sus reclamos se delegan en el momento.",
    "delegate-now": "Delegar ahora",
    "toast-delegated": "Se est\xE1n delegando los reclamos de {{name}}"
  },
  "delegation-notices": {
    "review-starts-tomorrow": "Ma\xF1ana empieza la inactividad de {{name}}.",
    "review-starts-on": "El {{date}} empieza la inactividad de {{name}}.",
    "review-load-changed": "Su carga cambi\xF3 desde que la programaste ({{planned}} \u2192 {{current}} reclamos).",
    "review-hint": "Pod\xE9s revisar la distribuci\xF3n de sus reclamos antes de que se ejecute.",
    "review-action": "Revisar distribuci\xF3n",
    uncovered: "{{name}} est\xE1 inactivo y tiene {{claims}} en su poder sin delegar.",
    "uncovered-action": "Delegar ahora",
    dismiss: "Cerrar aviso"
  }
};
var claims_table = {
  customer_organization: "Empresa Customer",
  fraud_status: "Estado de fraude",
  notifications: "Notificaciones",
  last_user_activity: "\xDAltima actividad",
  no_unread_notifications: "Sin notificaciones pendientes",
  mark_all_read: "Marcar todo como le\xEDdo"
};
var review = {
  form: {
    title: "\xBFC\xF3mo calificarias tu experiencia completando el formulario?",
    subtitle: "Tu opini\xF3n nos ayuda a mejorar la experiencia de nuestros usuarios.",
    commentLabel: "\xBFQuieres contarnos m\xE1s sobre tu experiencia?",
    commentPlaceholder: "M\xE1x. {{max}} caracteres",
    submit: "Enviar",
    skip: "Omitir"
  },
  resolution: {
    title: "Califica tu experiencia con Piramid en la resoluci\xF3n de tu reclamo.",
    subtitle: "Tu opini\xF3n nos ayuda a mejorar la experiencia de nuestros usuarios.",
    commentLabel: "\xBFQuieres contarnos m\xE1s sobre tu experiencia?",
    commentPlaceholder: "M\xE1x. {{max}} caracteres",
    submit: "Enviar",
    thanksTitle: "\xA1Gracias!",
    thanksBody: "Tu opini\xF3n nos ayuda a mejorar.",
    alreadyAnswered: "Ya registramos tu respuesta. \xA1Gracias!",
    invalid: "Este enlace no es v\xE1lido o expir\xF3."
  }
};
var reviews = {
  title: "Rese\xF1as",
  description: "Satisfacci\xF3n de los usuarios seg\xFAn sus rese\xF1as.",
  distribution: {
    title: "Distribuci\xF3n de puntajes",
    total: "Rese\xF1as",
    claims_created: "Reclamos creados en el per\xEDodo",
    average: "Promedio",
    score: "Puntaje",
    empty: "No hay rese\xF1as en el per\xEDodo seleccionado."
  },
  export: {
    button: "Descargar CSV",
    tooltip: "Descarga las rese\xF1as para analizarlas con tu LLM. Pr\xF3ximamente podr\xE1s hacerlo con RavelAI.",
    error: "No se pudieron exportar las rese\xF1as."
  },
  table: {
    title: "Rese\xF1as",
    search_placeholder: "Buscar por email del reclamante...",
    entity_label: "Rese\xF1as",
    comment_modal_title: "Comentario",
    score_filter: {
      placeholder: "Puntaje",
      all: "Todas"
    },
    type_filter: {
      placeholder: "Tipo de rese\xF1a",
      all: "Todos"
    },
    columns: {
      email: "Email",
      type: "Tipo",
      score: "Puntaje",
      claim_type: "Tipo de reclamo",
      third_party_relationship: "Tipo de reclamante",
      zone: "Zona",
      time: "Tiempo",
      comment: "Comentario",
      answered: "Respondida",
      more: "M\xE1s datos",
      handler: "Tramitador",
      claims_count: "Reclamos"
    },
    third_party_relationship: {
      particular: "Particular"
    },
    summary: {
      requested: "Rese\xF1as solicitadas",
      answered: "Rese\xF1as respondidas"
    },
    more_modal: {
      trigger: "Ver",
      title: "Datos del reclamo",
      external_claim_id: "Nro Reclamo externo",
      ref_id: "RefID",
      claim_id: "ID del reclamo",
      sinister_id: "ID del siniestro",
      recording_id: "Recording ID",
      company: "Empresa",
      date: "Fecha",
      detail_link: "Ver detalle en Piramid"
    }
  },
  type: {
    claim_creation_form: "Formulario de creaci\xF3n",
    claim_resolution: "Resoluci\xF3n de reclamo"
  },
  review: {
    title: "Impacto al Cliente",
    subtitle: {
      form: "Rese\xF1as del formulario de creaci\xF3n (CES).",
      close: "Rese\xF1as post-cierre del reclamo (CSAT)."
    },
    tabs: {
      form: "Valoraci\xF3n Formulario",
      close: "Valoraci\xF3n de Resoluci\xF3n"
    },
    filters: {
      claim_type: "Tipo de reclamo",
      team: "Equipo",
      zone: "Zona",
      all_types: "Todos los tipos",
      all_teams: "Todos los equipos",
      all_zones: "Todas las zonas",
      all_relationships: "Todos los reclamantes",
      all_insured: "Socios y no socios",
      insured: "Solo socios",
      not_insured: "Solo no socios",
      all_handlers: "Todos los tramitadores",
      all_cities: "Todas las ciudades",
      search: "Buscar\u2026",
      empty: "Sin resultados",
      selected: "{{count}} seleccionados",
      clear: "Limpiar",
      clear_all: "Limpiar filtros"
    },
    kpis: {
      previous_month: "mes anterior: {{value}}",
      no_comparable: "sin mes anterior comparable",
      empty: "Sin datos en el per\xEDodo",
      score_avg: {
        label: "Score promedio",
        footnote: "Sobre {{count}} respuestas del mes \xB7 escala 1 a 5"
      },
      response_rate: {
        label: "Tasa de respuesta",
        footnote_form: "{{respondents}} respondidas / {{universe}} creados en el mes",
        footnote_close: "{{respondents}} respondidas / {{universe}} enviadas en el mes"
      },
      detractors: {
        label: "Detractores",
        footnote: "{{count}} personas puntuaron 1 o 2 en el mes"
      },
      satisfied: {
        label: "Satisfechos",
        footnote: "{{count}} puntuaron 3, 4 o 5 en el mes \xB7 {{noReply}} sin responder"
      }
    },
    states: {
      empty: "Sin datos en el per\xEDodo"
    },
    distribution: {
      title: "Distribuci\xF3n de puntajes",
      subtitle: "Distribuci\xF3n de las respuestas del per\xEDodo seleccionado",
      tooltip: "Al hacer clic en un puntaje del gr\xE1fico o en la leyenda, se filtra la tabla de rese\xF1as de abajo por esa valoraci\xF3n. Volv\xE9 a hacer clic para quitar el filtro.",
      stats: {
        reviews: "Rese\xF1as",
        avg: "Promedio",
        universe: {
          form: "Reclamos creados",
          close: "Encuestas enviadas"
        }
      },
      includeNoReply: "Incluir no respondidas en los porcentajes",
      noReply: "Sin respuesta"
    },
    monthly: {
      title: "Evoluci\xF3n mensual",
      subtitle: "Volumen por puntaje seg\xFAn el per\xEDodo seleccionado",
      absolutes: "Absoluto",
      percentage: "Porcentaje",
      tooltip: "Total: {{total}} \xB7 Promedio: {{avg}}"
    },
    heatmap: {
      title: "Score por dimensi\xF3n",
      subtitle: "Detect\xE1 d\xF3nde bajan los puntajes seg\xFAn cada dimensi\xF3n",
      dim: {
        type: "Tipo de reclamo",
        team: "Equipo",
        zone: "Zona",
        outcome: "Desenlace",
        relationship: "Tipo de reclamante"
      },
      col: {
        responses: "Respuestas",
        average: "Promedio"
      },
      foot: "La intensidad del color refleja la cantidad de rese\xF1as. Clic en las columnas 1-5 para ordenar."
    },
    resolutionTime: {
      reviews: "{{count}} rese\xF1as",
      title_form: "Score seg\xFAn tiempo de creaci\xF3n",
      subtitle_form: "\xBFLos formularios que llevan m\xE1s tiempo se punt\xFAan peor?",
      foot_form: "Cada barra promedia los puntajes de reclamos cuyo formulario de creaci\xF3n tard\xF3 lo indicado. Correlaci\xF3n: {{max}} \u2192 {{min}}.",
      title_close: "Score seg\xFAn tiempo de resoluci\xF3n",
      subtitle_close: "\xBFLos reclamos que tardan m\xE1s se punt\xFAan peor?",
      foot_close: "Cada barra promedia los puntajes de reclamos con tiempo total (creaci\xF3n \u2192 cierre) dentro del bucket. Correlaci\xF3n: {{max}} \u2192 {{min}}.",
      dim_time: "Por tiempo",
      dim_handler: "Por tramitador",
      title_handler: "Score por tramitador",
      subtitle_handler: "\xBFC\xF3mo punt\xFAan los reclamantes a cada tramitador?",
      foot_handler: "Cada barra promedia los puntajes de las rese\xF1as de los reclamos que tramit\xF3. Ordenado por cantidad de rese\xF1as."
    },
    outcomeDistribution: {
      title: "Distribuci\xF3n de puntajes por desenlace",
      subtitle: "C\xF3mo se distribuye cada valoraci\xF3n seg\xFAn c\xF3mo cerr\xF3 el reclamo"
    },
    keywords: {
      title: "Temas frecuentes en comentarios negativos",
      subtitle: "Palabras m\xE1s repetidas en rese\xF1as con puntaje 1 o 2 ({{count}} comentarios analizados)",
      foot: "An\xE1lisis simple por frecuencia (excluye stopwords). Clic en un tema para filtrar la tabla y ver los comentarios donde aparece."
    },
    reviews: {
      title: "Rese\xF1as",
      subtitle: "Detalle de cada respuesta recibida en el per\xEDodo",
      search: "Buscar por email del reclamante\u2026",
      empty: "Sin rese\xF1as con estos filtros.",
      crossFilter: "Filtrado desde gr\xE1fico: {{label}}",
      filter: {
        rating: "Valoraci\xF3n",
        allRatings: "Todas las valoraciones"
      },
      lead_potencial: {
        label: "Lead Potencial",
        tooltip: "Filtra rese\xF1as con 5 estrellas que adem\xE1s dejaron un comentario, excluyendo a los socios de la compa\xF1\xEDa. \xDAtiles para pedir testimonios o captar clientes.",
        blocked_tooltip: 'No disponible con el filtro "Solo socios": un lead es, por definici\xF3n, alguien que todav\xEDa no es socio de la compa\xF1\xEDa.'
      },
      col: {
        days: "D\xEDas al cierre"
      }
    }
  }
};
var home = {
  greeting: {
    morning: "Buenos d\xEDas",
    afternoon: "Buenas tardes",
    evening: "Buenas noches"
  },
  subtitle: "Recib\xED nuevas \xF3rdenes, organiz\xE1 tus tareas y gestion\xE1 cada trabajo desde un solo lugar.",
  invitations: {
    title: "Invitaciones pendientes ({{count}})",
    description: "Ten\xE9s invitaciones de compa\xF1\xEDas esperando tu respuesta.",
    cta: "Ver invitaciones"
  },
  actionRequired: {
    badge: "Acci\xF3n requerida",
    title: "{{count}} \xF3rdenes esperan tu respuesta",
    titleOne: "1 orden espera tu respuesta",
    description: "Aceptalas o rechazalas para que puedan avanzar.",
    cta: "Ver \xF3rdenes pendientes"
  },
  month: {
    title: "Resumen del mes",
    inProgress: "En curso",
    inProgressSub: "Aceptadas y en ejecuci\xF3n",
    completed: "Cerradas este mes",
    rejected: "Rechazadas este mes"
  },
  inbox: {
    title: "Tareas pendientes",
    awaitingInsurer: "{{count}} esperando a la aseguradora",
    empty: "No ten\xE9s acciones pendientes. Todo lo abierto est\xE1 del lado de la aseguradora.",
    seeAll: "Ver todas mis \xF3rdenes"
  },
  activity: {
    title: "Actividad reciente",
    empty: "Todav\xEDa no ten\xE9s novedades.",
    seeAll: "Ver todas las notificaciones"
  }
};
var onboarding = {
  title: "Perfil de la empresa",
  description: "Administr\xE1 la informaci\xF3n p\xFAblica y operativa de tu empresa.",
  unavailable: "El perfil de empresa no est\xE1 disponible para esta cuenta.",
  alert: {
    completedTitle: "Perfil completo",
    completedDescription: "La informaci\xF3n de tu empresa est\xE1 actualizada y lista para ser consultada.",
    pendingTitle: "Perfil incompleto",
    pendingDescription: "Complet\xE1 las secciones pendientes para mantener actualizado el perfil de tu empresa.",
    pendingCta: "Completar perfil"
  },
  banner: {
    title: "Complet\xE1 tu perfil",
    progress: "Progreso",
    cta: "Continuar"
  },
  status: {
    completed: "Completo",
    pending: "Pendiente"
  },
  steps: {
    company_data: "Datos de la empresa",
    company_data_subtitle: "Complet\xE1 la informaci\xF3n b\xE1sica de tu empresa.",
    documentation: "Documentaci\xF3n",
    documentation_subtitle: "Sub\xED la documentaci\xF3n requerida para validar tu perfil.",
    capabilities: "Capacidades",
    capabilities_subtitle: "Indic\xE1 los servicios que ofrec\xE9s y los bienes con los que trabaj\xE1s.",
    coverage: "Cobertura",
    coverage_subtitle: "Seleccion\xE1 las zonas donde brind\xE1s tus servicios."
  },
  companyData: {
    logo: "Imagen de perfil de la empresa",
    logoUpdated: "Imagen de perfil actualizada",
    legalName: "Raz\xF3n social",
    legalNamePlaceholder: "Raz\xF3n social de la empresa",
    ein: "CUIT de la empresa",
    einPlaceholder: "CUIT de la empresa",
    firstName: "Nombre responsable",
    firstNamePlaceholder: "Nombre responsable",
    lastName: "Apellido responsable",
    lastNamePlaceholder: "Apellido responsable",
    phone: "Tel\xE9fono de la empresa",
    phonePlaceholder: "Tel\xE9fono de la empresa",
    contactEmail: "Email de la empresa",
    contactEmailPlaceholder: "Email de la empresa",
    address: "Domicilio de la empresa",
    addressPlaceholder: "Domicilio de la empresa",
    locality: "Localidad",
    localityPlaceholder: "Busc\xE1 tu localidad",
    noResults: "No se encontraron resultados",
    description: "Descripci\xF3n de la empresa",
    descriptionPlaceholder: "Descripci\xF3n de la empresa",
    save: "Guardar datos",
    saved: "Datos guardados",
    branches: {
      title: "Sucursales de la empresa",
      description: "La ubicaci\xF3n de tu empresa se determina por sus sucursales. Necesit\xE1s al menos una para completar este paso.",
      emptyTitle: "Todav\xEDa no registraste sucursales",
      empty: "Registr\xE1 al menos una sucursal con su ubicaci\xF3n para completar los datos de la empresa.",
      emptyCta: "Registrar sucursales"
    }
  },
  capabilities: {
    empty: "Todav\xEDa no cargaste capacidades.",
    loading: "Cargando cat\xE1logo\u2026",
    emptyCatalog: "No hay rubros disponibles.",
    noServices: "Sin servicios en este rubro.",
    allGoods: "Todos los bienes",
    someGoods: "{{count}} bien(es) seleccionado(s)",
    verticalPlaceholder: "Eleg\xED un rubro",
    selectVertical: "Eleg\xED tu rubro",
    selectServices: "Eleg\xED tus servicios",
    servicePlaceholder: "Eleg\xED un servicio",
    noResults: "No se encontraron resultados",
    add: "Agregar",
    save: "Guardar capacidades",
    saved: "Capacidades guardadas"
  },
  coverage: {
    empty: "Todav\xEDa no cargaste zonas de cobertura.",
    level: {
      province: "Provincia",
      department: "Departamento",
      locality: "Localidad"
    },
    group: {
      province: "Provincias",
      department: "Departamentos",
      locality: "Localidades"
    },
    searchPlaceholder: {
      province: "Busc\xE1 una provincia",
      department: "Busc\xE1 un departamento",
      locality: "Busc\xE1 una localidad"
    },
    noResults: "No se encontraron resultados",
    add: "Agregar",
    save: "Guardar cobertura",
    saved: "Cobertura guardada"
  }
};
var documents = {
  required: "Obligatorio",
  uploadedBadge: "Cargado",
  missing: "Falta cargar",
  view: "Ver",
  replace: "Reemplazar",
  upload: "Subir documento",
  delete: "Eliminar documento",
  uploaded: "Documento subido",
  deleted: "Documento eliminado",
  empty: "No hay documentos solicitados por el momento."
};
var documentTypes = {
  title: "Tipos de documentos",
  description: "Cat\xE1logo global de tipos documentales que los proveedores deben cargar.",
  entityLabel: "tipos",
  search: "Buscar por nombre...",
  columns: {
    id: "ID",
    name: "Nombre",
    description: "Descripci\xF3n",
    required: "Obligatorio",
    active: "Activo",
    documents: "Documentos"
  },
  actions: {
    create: "Nuevo tipo",
    edit: "Editar",
    created: "Tipo creado",
    updated: "Tipo actualizado"
  },
  form: {
    name: "Nombre",
    namePlaceholder: "Nombre del tipo de documento",
    description: "Descripci\xF3n",
    descriptionPlaceholder: "Descripci\xF3n del tipo de documento",
    isRequired: "Obligatorio para todos los proveedores",
    isActive: "Activo",
    save: "Guardar",
    cancel: "Cancelar"
  },
  yes: "S\xED",
  no: "No"
};
var products = {
  title: "Productos",
  description: "Cat\xE1logo de productos de tu empresa.",
  entityLabel: "productos",
  search: "Buscar por nombre, marca o c\xF3digo SKU...",
  columns: {
    sku: "C\xF3digo SKU",
    name: "Nombre del producto",
    brand: "Marca",
    description: "Descripci\xF3n",
    unit_price: "Precio unitario",
    status: "Estado"
  },
  status: {
    active: "Activo",
    inactive: "Inactivo"
  },
  actions: {
    create: "Nuevo producto",
    edit: "Editar",
    delete: "Eliminar",
    created: "Producto creado",
    updated: "Producto actualizado",
    deleted: "Producto eliminado"
  },
  form: {
    createHint: "Complet\xE1 los datos del producto que quer\xE9s agregar al cat\xE1logo.",
    editHint: "Modific\xE1 los datos del producto.",
    save: "Guardar",
    cancel: "Cancelar",
    activeLabel: "Producto activo",
    activeHint: "Los productos inactivos siguen en el listado, pero no podr\xE1n seleccionarse al crear una orden.",
    placeholders: {
      sku: "COD-1234",
      name: "Nombre del producto",
      brand: "Bosch, Saint-Gobain, ...",
      description: "Detalle o especificaciones del producto",
      unit_price: "$ 0.00"
    }
  },
  detail: {
    title: "Detalle del producto",
    sku: "SKU",
    name: "Nombre",
    brand: "Marca",
    description: "Descripci\xF3n",
    unit_price: "Precio unitario",
    status: "Estado",
    created_at: "Creado el",
    empty: "\u2014"
  },
  remove: {
    title: '\xBFEliminar el producto "{{name}}"?',
    description: "Esta acci\xF3n es irreversible. El producto dejar\xE1 de estar disponible."
  }
};
var providerGroups = {
  title: "Grupos de proveedores",
  description: "Agrup\xE1 proveedores de tu red (por zona, categor\xEDa, etc.) para filtrarlos al derivar una orden.",
  entityLabel: "grupos",
  search: "Buscar por nombre...",
  columns: {
    name: "Nombre del grupo",
    description: "Descripci\xF3n",
    member_count: "N\xB0 proveedores",
    members: "Proveedores"
  },
  actions: {
    create: "Nuevo grupo",
    edit: "Editar",
    members: "Miembros",
    delete: "Eliminar",
    created: "Grupo creado",
    updated: "Grupo actualizado",
    deleted: "Grupo eliminado"
  },
  form: {
    createHint: "Complet\xE1 los datos del grupo que quer\xE9s crear.",
    editHint: "Modific\xE1 los datos del grupo.",
    save: "Guardar",
    cancel: "Cancelar",
    placeholders: {
      name: "Nombre del grupo",
      description: "Detalle o notas sobre el grupo"
    }
  },
  members: {
    title: "Miembros del grupo",
    description: "Agreg\xE1 o quit\xE1 proveedores de tu red activa. Solo los proveedores activos pueden formar parte de un grupo. Los cambios se aplican al guardar.",
    pluralLabel: "proveedores",
    placeholder: "Busc\xE1 y agreg\xE1 proveedores",
    empty: "No se encontraron proveedores activos",
    currentTitle: "Proveedores en el grupo",
    emptyList: "A\xFAn no hay proveedores en este grupo",
    save: "Guardar cambios",
    cancel: "Cancelar",
    saved: "Miembros actualizados"
  },
  detail: {
    description: "Detalle del grupo y estado de la red de cada proveedor.",
    membersTitle: "Proveedores en el grupo",
    empty: "Este grupo no tiene proveedores"
  },
  remove: {
    title: '\xBFEliminar el grupo "{{name}}"?',
    description: "Esta acci\xF3n es irreversible. El grupo debe estar vac\xEDo para poder eliminarlo."
  }
};
var test_environment = {
  title: "Entorno de prueba",
  description: "Este es un entorno de prueba de Piramid. Los reclamos cargados aqu\xED no se procesan. Si necesitas denunciar un siniestro, comun\xEDcate con tu aseguradora."
};
var productImport = {
  title: "Importar productos",
  steps: {
    "1": "Sub\xED un archivo CSV con tu listado de productos.",
    "2": "Eleg\xED qu\xE9 columna del archivo corresponde a cada campo. Las que dejes sin asignar no se importan.",
    "3": "Revis\xE1 el resumen antes de confirmar. Todav\xEDa no se modific\xF3 nada."
  },
  fields: {
    sku: "C\xF3digo SKU",
    name: "Nombre del producto",
    brand: "Marca",
    description: "Descripci\xF3n",
    unit_price: "Precio unitario",
    is_active: "Estado"
  },
  upload: {
    title: "Formato del archivo",
    description: "Aceptamos archivos CSV. Detectamos autom\xE1ticamente el separador (coma, punto y coma o tabulaci\xF3n) y la codificaci\xF3n, as\xED que pod\xE9s guardarlo directo desde Excel o Google Sheets.",
    dropzone: "Arrastr\xE1 el CSV o hac\xE9 clic para elegirlo",
    analyzing: "Analizando el archivo...",
    downloadTemplate: "Descargar plantilla"
  },
  mapping: {
    required: "Obligatorio",
    notImported: "No importar",
    numberFormat: "Formato de los precios",
    numberFormatHint: "En tu archivo: {{ samples }}",
    fileSummary: "{{ file }} \u2014 {{ rows }} fila(s), {{ columns }} columna(s)",
    invalidTitle: "Revis\xE1 el mapeo de columnas"
  },
  summary: {
    toCreate: "Se crear\xE1n",
    toUpdate: "Se actualizar\xE1n",
    errors: "Con errores",
    blankRows: "Filas vac\xEDas",
    readyTitle: "El archivo est\xE1 listo",
    readyDescription: "Se procesar\xE1n {{ total }} fila(s). S\xF3lo se modifican los campos que mapeaste.",
    errorsTitle: "El archivo tiene filas con errores",
    errorsDescription: "{{ errors }} fila(s) no se pueden importar. Correg\xED el archivo y volv\xE9 a subirlo, o import\xE1 s\xF3lo las {{ valid }} fila(s) v\xE1lidas.",
    skipInvalidLabel: "Importar las {{ valid }} filas v\xE1lidas y omitir las {{ errors }} con error",
    skipInvalidHint: "Las filas omitidas quedan registradas en el historial para que puedas corregirlas despu\xE9s."
  },
  errors: {
    title: "Errores de la importaci\xF3n",
    download: "Descargar errores CSV",
    truncated: "Mostrando {{ shown }} de {{ total }} errores (se guardan hasta {{ max }}).",
    columns: {
      row: "Fila",
      sku: "SKU",
      column: "Columna",
      received: "Valor recibido",
      reason: "Motivo"
    }
  },
  rowErrors: {
    empty_required: "Falta un valor obligatorio",
    empty_required_field: "\xAB{{ field }}\xBB es obligatorio y la celda est\xE1 vac\xEDa",
    invalid_number: "\xAB{{ value }}\xBB no es un n\xFAmero v\xE1lido",
    ambiguous_number: "\xAB{{ value }}\xBB no se puede leer con el formato de precios elegido",
    too_many_decimals: "\xAB{{ value }}\xBB tiene m\xE1s de dos decimales",
    invalid_boolean: "\xAB{{ value }}\xBB no es un estado v\xE1lido: us\xE1 SI o NO",
    invalid_value: "\xAB{{ value }}\xBB no es un valor v\xE1lido",
    duplicate_sku_in_file: "El SKU se repite en el archivo",
    sku_deleted: "El SKU corresponde a un producto eliminado",
    sku_already_exists: "Otro proceso cre\xF3 un producto con ese SKU mientras se importaba"
  },
  status: {
    pending: "En cola",
    processing: "Procesando",
    completed: "Completada",
    completed_with_errors: "Completada con errores",
    failed: "Fallida"
  },
  history: {
    title: "Importaciones recientes",
    description: "Historial de importaciones masivas de productos de tu empresa.",
    inProgress: "{{ done }} de {{ total }} procesadas",
    result: "{{ created }} creados, {{ updated }} actualizados, {{ errors }} con error",
    failedFallback: "La importaci\xF3n fall\xF3. Volv\xE9 a subir el archivo.",
    viewErrors: "Ver errores",
    columns: {
      date: "Fecha",
      file: "Archivo",
      status: "Estado",
      result: "Resultado",
      user: "Usuario"
    },
    entityLabel: "importaciones",
    empty: "Todav\xEDa no importaste productos."
  },
  actions: {
    open: "Importar",
    export: "Exportar",
    back: "Volver",
    validate: "Validar archivo",
    confirm: "Confirmar importaci\xF3n",
    queuedTitle: "Importaci\xF3n en cola",
    queuedDescription: "La estamos procesando en segundo plano. Vas a ver el resultado en \xABImportaciones recientes\xBB.",
    history: "Importaciones"
  }
};
var orderDocumentRequirements = {
  title: "Documentaci\xF3n de \xF3rdenes",
  description: "Documentos que las \xF3rdenes de trabajo de esta compa\xF1\xEDa pueden o deben tener para poder finalizarse. Los cambios aplican solo a las \xF3rdenes nuevas.",
  empty: "Todav\xEDa no hay documentos configurados.",
  columns: {
    name: "Nombre",
    uploader: "Qui\xE9n lo carga",
    required: "Obligatoriedad",
    review: "Revisi\xF3n",
    status: "Estado"
  },
  uploader: {
    insurer: "Aseguradora",
    provider: "Proveedor"
  },
  required: {
    yes: "Obligatorio",
    no: "Opcional"
  },
  review: {
    yes: "Requiere revisi\xF3n",
    no: "Sin revisi\xF3n"
  },
  status: {
    active: "Activo",
    inactive: "Inactivo",
    deleted: "Eliminado"
  },
  actions: {
    create: "Nuevo documento",
    edit: "Editar",
    delete: "Eliminar",
    created: "Documento creado",
    updated: "Documento actualizado",
    deleted: "Documento eliminado"
  },
  form: {
    createHint: "Complet\xE1 los datos del documento. Se aplicar\xE1 a las \xF3rdenes que la compa\xF1\xEDa cree de ac\xE1 en adelante.",
    editHint: "Modific\xE1 los datos del documento. Las \xF3rdenes ya creadas conservan su configuraci\xF3n original.",
    save: "Guardar",
    cancel: "Cancelar",
    nameLabel: "Nombre",
    descriptionLabel: "Descripci\xF3n",
    uploaderLabel: "\xBFQui\xE9n debe cargarlo?",
    requiredLabel: "Obligatorio",
    requiredHint: "Bloquea la finalizaci\xF3n de la orden hasta que el documento se cargue (y se apruebe, si corresponde).",
    reviewLabel: "Requiere revisi\xF3n",
    reviewHint: "El documento del proveedor debe ser aprobado por la aseguradora.",
    reviewDisabledHint: "Solo los documentos del proveedor pueden requerir revisi\xF3n.",
    activeLabel: "Activo",
    activeHint: "Los documentos inactivos no se aplican a las \xF3rdenes nuevas.",
    placeholders: {
      name: "Ej: Factura del taller",
      description: "Instrucciones para quien carga el documento\u2026"
    }
  },
  remove: {
    title: '\xBFEliminar el documento "{{name}}"?',
    description: "Las \xF3rdenes existentes conservan su documentaci\xF3n y el documento deja de aplicarse a las \xF3rdenes nuevas. Queda listado ac\xE1 como historial, y su nombre vuelve a estar disponible."
  }
};
var offerAgreement = {
  title: "Conformidad",
  description: "Configuraci\xF3n del ofrecimiento y la conformidad de la compa\xF1\xEDa: el simulador, la carta que lee el reclamante, las plantillas del documento, las reglas que eligen la plantilla, las que deciden c\xF3mo se firma y los ajustes del env\xEDo.",
  back: "Volver a las compa\xF1\xEDas",
  open: "Configurar conformidad",
  tabs: {
    simulator: "Simulador",
    "offer-messages": "Mensajes de ofrecimiento",
    "agreement-templates": "Plantillas de conformidad",
    rules: "Reglas de generaci\xF3n",
    signature: "Reglas de firma",
    variables: "Variables de conformidad",
    settings: "Configuraci\xF3n"
  },
  pendingTitle: "Todav\xEDa no disponible",
  pending: {
    rules: "Ac\xE1 se van a definir las reglas que eligen qu\xE9 template se usa, con qu\xE9 acci\xF3n y qui\xE9nes firman.",
    settings: "Ac\xE1 se van a configurar la automatizaci\xF3n, la cuenta remitente y los valores por defecto de la compa\xF1\xEDa."
  }
};
var agreementVariables = {
  title: "Variables de conformidad",
  description: "Cat\xE1logo de datos que puede imprimir una conformidad, variables din\xE1micas de las plantillas de ofrecimiento de la compa\xF1\xEDa y vinculaci\xF3n de conceptos por nombre. Solo lectura y diagn\xF3stico.",
  catalog: {
    title: "Cat\xE1logo de datos y variables",
    columns: {
      key: "Clave",
      label: "Etiqueta",
      group: "Grupo",
      type: "Tipo",
      stage: "Etapa"
    },
    stage: {
      send: "Al enviar",
      accept: "Al aceptar",
      document: "Al generar"
    },
    type: {
      text: "Texto",
      money: "Importe",
      number: "N\xFAmero",
      percent: "Porcentaje",
      date: "Fecha",
      words: "Importe en letras",
      boolean: "S\xED/No",
      enum: "Opci\xF3n",
      list: "Lista"
    }
  },
  dynamic: {
    title: "Variables de las plantillas de ofrecimiento",
    offer: "Del ofrecimiento (compile_time)",
    acceptance: "De la aceptaci\xF3n (runtime)",
    empty: "La compa\xF1\xEDa no tiene plantillas de ofrecimiento.",
    columns: {
      key: "Clave",
      name: "Nombre",
      type: "Tipo",
      templates: "Plantillas"
    }
  },
  bindings: {
    title: "Conceptos vinculados por nombre",
    concept: "Concepto",
    names: "Nombres aceptados",
    source: {
      default: "Convenci\xF3n",
      company: "Compa\xF1\xEDa"
    },
    matched: "Plantillas que lo definen",
    unbound: "Sin vincular",
    concepts: {
      amount: "Importe",
      amount_in_words: "Importe en letras",
      installments: "Cuotas",
      fee_percentage: "Honorarios",
      payment_days: "Plazo de pago",
      payment_method: "Medio de pago",
      cbu: "CBU",
      cuit: "CUIT",
      lawyer_cbu: "CBU del letrado",
      lawyer_cuit: "CUIT del letrado",
      identification: "Documento declarado"
    }
  },
  resolve: {
    title: "Diagn\xF3stico",
    description: "Resuelve las variables de un reclamo real \u2014con su ofrecimiento aceptado, el indicado o ninguno\u2014 sin modificar nada.",
    claim: "ID del reclamo",
    offer: "ID del ofrecimiento (opcional)",
    acceptance: "Aceptaci\xF3n",
    acceptancePersisted: "Usar la aceptaci\xF3n persistida",
    acceptanceNone: "Ignorar la aceptaci\xF3n",
    submit: "Resolver",
    columns: {
      key: "Variable",
      status: "Estado",
      value: "Valor impreso",
      reason: "Motivo"
    },
    status: {
      resolved: "Resuelta",
      missing: "Falta",
      not_applicable: "No aplica"
    },
    warnings: "Advertencias",
    parties: "Partes",
    claimantRule: "Reclamante principal por",
    lawyerRule: "Abogado por",
    empty: "Todav\xEDa no se resolvi\xF3 ning\xFAn reclamo.",
    withoutOffer: "Resolver sin ofrecimiento (como antes del primer env\xEDo)"
  }
};
var agreementTemplates = {
  pages: {
    agreement: {
      title: "Plantillas de conformidad",
      description: "El documento que se firma, redactado por bloques, con versiones publicadas inmutables, vista previa con datos de ejemplo y PDF de prueba sobre un reclamo real.",
      empty: "La compa\xF1\xEDa todav\xEDa no tiene plantillas de conformidad.",
      create: "Nueva conformidad"
    },
    offer_message: {
      title: "Mensajes de ofrecimiento",
      description: "La carta que lee el reclamante cuando recibe el ofrecimiento. Las variantes (cuotas, honorarios) se resuelven adentro con condicionales: la compa\xF1\xEDa usa una sola.",
      empty: "La compa\xF1\xEDa todav\xEDa no tiene cartas de ofrecimiento.",
      create: "Nueva carta"
    }
  },
  activeLetter: {
    title: "Carta activa",
    description: "La que sale con cada ofrecimiento nuevo. Sin carta activa y publicada, el wizard sigue por el flujo manual.",
    label: "Mensaje de ofrecimiento de la compa\xF1\xEDa",
    none: "Sin carta activa",
    notPublished: "La carta elegida no tiene versi\xF3n publicada",
    disabled: "La conformidad autom\xE1tica est\xE1 apagada: el wizard sigue manual aunque haya carta."
  },
  clone: {
    title: "Clonar a otra compa\xF1\xEDa",
    description: "La copia queda como borrador: no se publica, no queda como carta activa y ninguna regla la elige todav\xEDa.",
    targetCompany: "Compa\xF1\xEDa destino",
    chooseCompany: "Eleg\xED la compa\xF1\xEDa",
    noCompanies: "No hay otra compa\xF1\xEDa",
    name: "Nombre en el destino",
    namePlaceholder: "El mismo, o el primero libre",
    includeRules: "Clonar tambi\xE9n las reglas de generaci\xF3n (llegan deshabilitadas)",
    review: "Revisar",
    submit: "Clonar",
    cloned: "Plantilla clonada como borrador",
    willCreate: "Se va a crear \xAB{{name}}\xBB en {{company}}",
    rulesToClone: "{{count}} regla(s) se clonan deshabilitadas",
    references: "Referencias a resolver",
    resolvedAutomatically: "{{count}} resueltas autom\xE1ticamente por nombre",
    chooseEquivalent: "Eleg\xED el equivalente",
    noEquivalent: "La compa\xF1\xEDa destino no tiene ning\xFAn equivalente para elegir",
    usageBlock: "Bloque {{block}}",
    usageRule: "Regla {{rule}}",
    missingVariables: "El texto usa variables que la compa\xF1\xEDa destino no define: {{keys}}",
    acceptMissing: "Clonar igual y dejarlas como hueco"
  },
  table: {
    columns: {
      name: "Plantilla",
      published: "Publicada",
      draft: "Borrador",
      updated: "Actualizada",
      actions: "Acciones"
    },
    noPublished: "Sin publicar",
    noDraft: "\u2014",
    version: "v{{version}}",
    open: "Abrir",
    duplicate: "Duplicar",
    duplicated: "Plantilla duplicada como borrador",
    clone: "Clonar a otra compa\xF1\xEDa"
  },
  create: {
    name: "Nombre",
    namePlaceholder: "Nombre de la plantilla",
    descriptionField: "Descripci\xF3n",
    descriptionPlaceholder: "Descripci\xF3n de la plantilla",
    kindHint: {
      agreement: "El documento de conformidad que se firma: bloques, cl\xE1usulas numeradas y recuadros de firma.",
      offer_message: "La carta del ofrecimiento que lee el reclamante: solo texto, con variables y condicionales para cuotas y honorarios."
    },
    fromExample: "Utilizar plantilla de ejemplo",
    fromExampleHint: "Carga un texto provisorio de conformidad con variables del cat\xE1logo, listo para corregir.",
    submit: "Crear",
    created: "Plantilla creada"
  },
  editor: {
    back: "Volver a las plantillas",
    version: "Versi\xF3n {{version}}",
    status: {
      draft: "Borrador",
      published: "Publicada",
      deprecated: "Deprecada"
    },
    readOnly: "Esta versi\xF3n est\xE1 congelada. Para cambiar el texto, cre\xE1 una versi\xF3n nueva.",
    save: "Guardar borrador",
    saved: "Borrador guardado",
    editButton: "Editar",
    publish: "Publicar",
    published: "Versi\xF3n publicada",
    newVersion: "Nueva versi\xF3n",
    newVersionCreated: "Borrador creado a partir de la versi\xF3n {{version}}",
    deprecate: "Deprecar",
    deprecated: "Versi\xF3n deprecada",
    delete: "Eliminar plantilla",
    deleted: "Plantilla eliminada",
    render: "PDF de prueba",
    preview: "Vista previa",
    previewNote: "La conformidad compilada sobre un ofrecimiento de ejemplo. Eleg\xED el escenario para ver cada rama de los condicionales; las referencias sin valor se listan debajo.",
    previewMissing: "Referencias sin valor en el ejemplo",
    previewInvalid: "Complet\xE1 los campos obligatorios de los bloques para ver la vista previa.",
    messagePreviewNote: "La carta compilada sobre un ofrecimiento de ejemplo. Eleg\xED el escenario para ver cada rama de los condicionales.",
    sampleScenario: "Escenario de ejemplo",
    scenarios: {
      guidedSinglePayment: "Pago \xFAnico, sin honorarios",
      guidedSinglePaymentWithFees: "Pago \xFAnico, con honorarios (12 %)",
      guidedInstallments: "3 cuotas, sin honorarios",
      guidedInstallmentsWithFees: "3 cuotas, con honorarios (12 %)"
    },
    versions: "Versiones",
    versionPlaceholder: "Seleccionar versi\xF3n",
    details: "Datos de la plantilla",
    name: "Nombre",
    description: "Descripci\xF3n",
    saveDetails: "Guardar datos",
    detailsSaved: "Datos guardados"
  },
  blocks: {
    title: "Bloques",
    add: "Agregar bloque",
    empty: "Agreg\xE1 el primer bloque.",
    kind: {
      title: "T\xEDtulo",
      paragraph: "P\xE1rrafo",
      clause: "Cl\xE1usula",
      key_values: "Datos clave",
      signatures: "Firmas",
      page_break: "Salto de p\xE1gina"
    },
    text: "Texto",
    clauseTitle: "T\xEDtulo de la cl\xE1usula (opcional)",
    format: "Formato: *negrita*, _cursiva_, __subrayado__.",
    items: "Datos",
    addItem: "Agregar dato",
    label: "Etiqueta",
    variable: "Variable",
    signers: "Recuadros a imprimir",
    moveUp: "Subir",
    moveDown: "Bajar",
    remove: "Quitar",
    copy: "Copiar bloque",
    copied: "Bloque copiado",
    paste: "Pegar bloque",
    pasteRejected: {
      unreadable: "No hay ning\xFAn bloque copiado",
      kind_not_allowed: "Ese tipo de bloque no se puede usar en esta plantilla"
    },
    hint: "Mencion\xE1 variables con @ (cat\xE1logo y variables din\xE1micas de la compa\xF1\xEDa). Condicionales: [[#if @variable]] \u2026 [[else]] \u2026 [[/if]]. Un bloque cuyo texto queda vac\xEDo no se imprime.",
    messageHint: "La carta se env\xEDa antes de que el reclamante acepte: solo t\xEDtulos y p\xE1rrafos, sin variables de la aceptaci\xF3n. Para cuotas y honorarios us\xE1 [[#if @Cantidad de cuotas]] \u2026 [[else]] \u2026 [[/if]] y [[#if @Porcentaje de honorarios]] \u2026 [[/if]].",
    condition: {
      title: "Condici\xF3n del bloque",
      description: "Si no se cumple, el bloque no se imprime. Sin condiciones, se imprime siempre."
    }
  },
  signers: {
    title: "Recuadros de firma",
    add: "Agregar recuadro",
    empty: "Sin recuadros: el documento se imprime sin firmas.",
    key: "Clave",
    keyHint: "min\xFAsculas, n\xFAmeros y guion bajo; es el ancla [[SIG:clave]]",
    label: "Etiqueta impresa",
    party: "Parte",
    parties: {
      company_sender: "Compa\xF1\xEDa (remitente)",
      victim: "Damnificado",
      claimant: "Reclamante",
      lawyer: "Abogado",
      heirs: "Sucesores"
    },
    optional: "Opcional",
    withDate: "Con fecha",
    withName: "Con aclaraci\xF3n",
    remove: "Quitar"
  },
  render: {
    title: "PDF de prueba",
    description: "Genera el documento con esta versi\xF3n sobre un reclamo real, sin efectos sobre el reclamo: crea un documento de tipo muestra con marca de agua y ubica las anclas de firma.",
    claim: "Reclamo",
    offer: "Ofrecimiento",
    acceptance: "Aceptaci\xF3n",
    acceptancePersisted: "Usar la aceptaci\xF3n persistida",
    acceptanceNone: "Ignorar la aceptaci\xF3n",
    submit: "Generar",
    status: {
      rendering: "Generando",
      ready: "Listo",
      invalid: "Inv\xE1lido",
      failed: "Fall\xF3"
    },
    open: "Abrir PDF",
    renderMs: "Render: {{ms}} ms",
    anchors: "Anclas de firma",
    anchor: {
      key: "Recuadro",
      page: "P\xE1gina",
      position: "Posici\xF3n (x, y)",
      size: "Tama\xF1o (ancho \xD7 alto)",
      found: "Encontrada",
      missing: "No encontrada"
    },
    variables: "Variables resueltas",
    missing: "Referencias sin valor",
    syntaxErrors: "Bloques que no se imprimieron",
    missingRequired: "obligatoria",
    missingOptional: "opcional",
    warnings: "Advertencias"
  },
  missingStatus: {
    missing: "sin valor",
    not_applicable: "no aplica",
    unknown_key: "clave desconocida"
  },
  confirm: {
    publish: {
      title: "\xBFPublicar esta versi\xF3n?",
      description: "La versi\xF3n queda congelada y reemplaza a la publicada actual."
    },
    deprecate: {
      title: "\xBFDeprecar la versi\xF3n publicada?",
      description: "La plantilla queda sin versi\xF3n publicada hasta que publiques otra."
    },
    delete: {
      title: "\xBFEliminar la plantilla?",
      description: "Deja de aparecer en el listado. Solo se puede eliminar si no tiene una versi\xF3n publicada."
    },
    cancel: "Cancelar",
    confirm: "Confirmar"
  }
};
var orderClaimStatusMappings = {
  title: "Sincronizaci\xF3n orden - reclamo",
  description: "Cuando la orden vigente alcanza un momento configurado, el reclamo pasa autom\xE1ticamente al estado definido. La etapa, referencia y condici\xF3n contin\xFAan deriv\xE1ndose de las Equivalencias.",
  empty: "Todav\xEDa no hay sincronizaciones configuradas. Los cambios de las \xF3rdenes no modifican el reclamo.",
  columns: {
    trigger: "Momento de la orden",
    claimStatus: "Estado del reclamo"
  },
  derived: "Etapa {{stage}} \xB7 Referencia {{reference}}",
  deletedStatus: "Estado eliminado",
  trigger: {
    accepted: {
      awaiting_provider: "Orden derivada \u2014 esperando respuesta del proveedor",
      rejected: "El proveedor rechaz\xF3 la orden"
    },
    scheduling: {
      awaiting_provider: "Orden aceptada \u2014 coordinaci\xF3n de turno pendiente"
    },
    work_proof: {
      awaiting_provider: "Inspecci\xF3n pendiente de captura",
      in_progress: "Inspecci\xF3n en an\xE1lisis",
      rejected: "Inspecci\xF3n no completada (bloqueada o vencida)"
    },
    documentation: {
      awaiting_provider: "Documentaci\xF3n pendiente del proveedor",
      awaiting_insurer: "Documentaci\xF3n pendiente de la aseguradora",
      rejected: "Documentaci\xF3n rechazada \u2014 debe rehacerse"
    },
    completed: {
      awaiting_insurer: "Orden lista para finalizar",
      done: "Orden finalizada",
      canceled: "Orden anulada"
    }
  },
  actions: {
    create: "Nueva sincronizaci\xF3n",
    edit: "Editar",
    delete: "Eliminar",
    saved: "Sincronizaci\xF3n guardada",
    deleted: "Sincronizaci\xF3n eliminada"
  },
  form: {
    hint: "Eleg\xED un momento del ciclo de la orden y el estado interno al que debe pasar el reclamo. Aplica solo a la orden vigente (la m\xE1s reciente) del reclamo.",
    schedulingHint: "El turno coordinado no es un momento propio: al registrarse el turno, la orden pasa al siguiente momento pendiente (inspecci\xF3n, documentaci\xF3n o finalizaci\xF3n). Configur\xE1 ese momento.",
    triggerLabel: "Momento de la orden",
    claimStatusLabel: "Estado del reclamo",
    triggerPlaceholder: "Seleccion\xE1 un momento",
    claimStatusPlaceholder: "Seleccion\xE1 un estado",
    save: "Guardar",
    cancel: "Cancelar"
  },
  remove: {
    title: "\xBFEliminar la sincronizaci\xF3n?",
    description: 'El momento "{{trigger}}" dejar\xE1 de actualizar autom\xE1ticamente el estado del reclamo.'
  }
};
var claimCurrentOrder = {
  title: "Orden de trabajo vigente",
  viewOrder: "Ver orden"
};
var customerClaims = {
  externalClaimId: "Reclamo externo",
  licensePlate: "Patente",
  createdBy: "Creado por"
};
var customerAccountSettings = {
  profilePhoto: {
    title: "Foto de perfil",
    description: "Se muestra en el men\xFA lateral y en tus reclamos.",
    updated: "Foto de perfil actualizada",
    updatedDescription: "La foto de perfil se actualiz\xF3 correctamente"
  }
};
var claimantPendingActions = {
  inbox: {
    titleOne: "Ten\xE9s una acci\xF3n pendiente en un reclamo",
    titleMany: "Ten\xE9s acciones pendientes en {{count}} reclamos",
    description: "Resolvelas para que tu reclamo pueda avanzar.",
    viewOne: "Ver acci\xF3n",
    viewMany: "Ver acciones",
    dialog: {
      title: "Acciones pendientes",
      description: "Eleg\xED un reclamo para resolver lo que falta."
    }
  },
  actions: {
    offer_response: {
      label: "Ofrecimiento pendiente de respuesta",
      title: "Recibiste un ofrecimiento",
      description: "Revisalo y respondelo para que tu reclamo pueda avanzar.",
      cta: "Ver ofrecimiento",
      section: "Ofrecimientos por responder"
    },
    agreement_signature: {
      label: "Conformidad pendiente de firma",
      title: "Tu conformidad est\xE1 lista para firmar",
      description: "Firmala para terminar el proceso del ofrecimiento que aceptaste.",
      cta: "Firmar conformidad",
      section: "Conformidades por firmar"
    },
    documentation_upload: {
      label: "Documentaci\xF3n pendiente de subir",
      title: "Ten\xE9s documentaci\xF3n pendiente",
      description: "Sub\xED la documentaci\xF3n solicitada para que tu reclamo pueda avanzar.",
      cta: "Subir documentaci\xF3n",
      section: "Documentaci\xF3n por subir"
    }
  }
};
var claimOrderTracking = {
  title: "Orden de trabajo vigente",
  viewDetail: "Ver detalle",
  nextAppointment: "Turno coordinado: {{at}}",
  modal: {
    title: "Orden {{refId}}",
    description: "Tramitaci\xF3n de la orden de trabajo con {{provider}}"
  },
  sections: {
    progress: "Estado de la orden",
    schedulingHistory: "Historial de coordinaci\xF3n de turnos"
  },
  tabs: {
    info: "Informaci\xF3n",
    scheduling: "Coordinaci\xF3n turno",
    workProof: "Inspecciones"
  },
  info: {
    name: "Descripci\xF3n de la orden",
    service: "Servicio",
    good: "Bien",
    provider: "Proveedor asignado",
    location: "Localidad o zona del servicio",
    createdAt: "Fecha de creaci\xF3n",
    vehicle: "Veh\xEDculo",
    description: "Informaci\xF3n adicional",
    rejectedReason: "Motivo del rechazo",
    canceledReason: "Motivo de la anulaci\xF3n"
  },
  scheduling: {
    empty: "Todav\xEDa no hay un turno coordinado.",
    notified: "Se avis\xF3 al reclamante",
    recordedAt: "Registrado el {{at}}",
    canceledAt: "Anulado el {{at}}",
    phones: "Tel\xE9fonos"
  },
  workProof: {
    empty: "Todav\xEDa no hay inspecciones para esta orden."
  },
  list: {
    tab: "\xD3rdenes",
    title: "\xD3rdenes de trabajo",
    description: "Todas las \xF3rdenes de trabajo asociadas al reclamo.",
    empty: "Todav\xEDa no hay \xF3rdenes de trabajo para este reclamo.",
    current: "Vigente",
    columns: {
      reference: "Orden",
      provider: "Proveedor",
      service: "Servicio",
      status: "Estado",
      createdAt: "Creaci\xF3n"
    }
  }
};
var field_adjuster_registration = {
  title: "Complet\xE1 tu registro en Piramid.",
  description: "Cre\xE1 tu cuenta de liquidador para acceder a tus reclamos.",
  invitedEmail: "Te registr\xE1s con el email al que lleg\xF3 la invitaci\xF3n.",
  emailLabel: "Email",
  emailPlaceholder: "liquidador@empresa.com",
  passwordLabel: "Contrase\xF1a",
  passwordPlaceholder: "M\xEDnimo 8 caracteres",
  confirmPasswordLabel: "Confirmar contrase\xF1a",
  confirmPasswordPlaceholder: "Repet\xED la contrase\xF1a",
  passwordsDontMatch: "Las contrase\xF1as no coinciden",
  submit: "Crear cuenta",
  alreadyHaveAccount: "\xBFYa ten\xE9s una cuenta?",
  login: "Inici\xE1 sesi\xF3n",
  backToLogin: "Volver al inicio de sesi\xF3n"
};
var claimSharedDocuments = {
  tabClaimant: "Del reclamante",
  tabTramitation: "De tramitaci\xF3n (interna)",
  tabShared: "Compartida con el reclamante",
  customerTabOwn: "Tu documentaci\xF3n",
  customerTabShared: "Compartida por la compa\xF1\xEDa",
  empty: "Todav\xEDa no compartiste documentaci\xF3n con el reclamante.",
  customerEmpty: "La compa\xF1\xEDa todav\xEDa no comparti\xF3 documentaci\xF3n.",
  removeAction: "Dejar de compartir documento",
  removeTitle: "Dejar de compartir documento",
  removeDescription: '"{{name}}" dejar\xE1 de estar disponible para el reclamante.',
  removeConfirm: "Dejar de compartir",
  removed: "El documento dej\xF3 de compartirse",
  cancel: "Cancelar"
};
var providerAccountSettings = {
  password: {
    title: "Cambiar contrase\xF1a",
    description: "Actualiz\xE1 la contrase\xF1a con la que ingres\xE1s a tu cuenta.",
    currentPassword: "Contrase\xF1a actual",
    newPassword: "Nueva contrase\xF1a",
    confirmPassword: "Confirmar nueva contrase\xF1a",
    submit: "Cambiar contrase\xF1a",
    updated: "Contrase\xF1a actualizada",
    updatedDescription: "Tu contrase\xF1a se cambi\xF3 correctamente."
  }
};
var provider_signin_as = {
  loading: "Iniciando sesi\xF3n...",
  error_title: "Error de autenticaci\xF3n",
  error_description: "No pudimos iniciar la sesi\xF3n. El enlace puede haber vencido: ped\xED uno nuevo desde el Backoffice.",
  go_to_login: "Ir al login"
};
var agreementSettings = {
  title: "Configuraci\xF3n de la conformidad",
  description: "Interruptor general de la compa\xF1\xEDa y los nombres con que llama a cada concepto de las plantillas de ofrecimiento.",
  enabled: {
    label: "Conformidad autom\xE1tica habilitada",
    description: "Con esto apagado, el sistema no elige ninguna conformidad: el circuito manual sigue igual."
  },
  validateBankData: {
    label: "Validar CBU y CUIT contra Interbanking",
    description: "Al aceptar, se verifica que la cuenta del tercero exista. Si el servicio no responde, el reclamante no puede aceptar: encenderlo solo con el servicio configurado."
  },
  validateAcceptancePayee: {
    label: "Validar qui\xE9n puede cobrar",
    description: "Al aceptar, se verifica que el DNI y el CUIT de la cuenta de cobro correspondan a una persona habilitada por el reclamo: el damnificado, su padre o madre si es menor, o un sucesor si falleci\xF3. Si el reclamo no alcanza para decidirlo, el ofrecimiento no se puede enviar ni aceptar."
  },
  bindings: {
    title: "Nombres de las variables",
    description: "Una fila por concepto. Vac\xEDo = se usan los nombres por convenci\xF3n. Separ\xE1 varios nombres con coma.",
    placeholder: "Nombres por convenci\xF3n"
  },
  offerTerms: {
    title: "Condiciones de pago del ofrecimiento",
    description: "Las opciones que ofrece el wizard guiado. Vac\xEDo = las del producto. Separ\xE1 los valores con coma.",
    installment_options: "Cuotas",
    fee_percentage_options: "Honorarios (%)",
    payment_days_options: "D\xEDas a pagar"
  },
  save: "Guardar",
  saved: "Configuraci\xF3n guardada",
  signatureEnabled: {
    label: "Firma de la conformidad por AutoSign",
    description: "Al aceptarse, la conformidad sale a firmar por AutoSign desde la cuenta del tramitador que envi\xF3 el ofrecimiento, as\xED que enviarlo exige esa cuenta conectada. Apagado, el PDF se genera igual y se firma por fuera. Se congela en cada ofrecimiento al enviarlo; apagarlo pausa los env\xEDos pendientes."
  },
  embeddedSigningEnabled: {
    label: "Firma inmediata al aceptar",
    description: "Si el reclamante es el primer firmante, firma la conformidad dentro de Piramid apenas acepta, sin esperar el email de AutoSign. Necesita la firma por AutoSign encendida. Se aplica en vivo: apagarlo corta tambi\xE9n las firmas en preparaci\xF3n y el reclamante firma por email."
  }
};
var agreementRules = {
  title: "Reglas de generaci\xF3n",
  description: "Qu\xE9 plantilla corresponde a cada reclamo, mirando solo sus datos. Se eval\xFAan en orden de prioridad y gana la primera que coincide; la simulaci\xF3n muestra por qu\xE9.",
  empty: "Todav\xEDa no hay reglas. Cre\xE1 la primera para que el sistema pueda elegir una conformidad.",
  add: "Nueva regla",
  columns: {
    priority: "Orden prioridad",
    name: "Nombre",
    template: "Plantilla",
    conditions: "Condiciones",
    signers: "Firmantes",
    health: "Estado",
    enabled: "Estado"
  },
  catchAll: "Sin condiciones (aplica siempre)",
  conditionsCount: "{{count}} condiciones",
  healthy: "Lista",
  moveUp: "Subir",
  moveDown: "Bajar",
  form: {
    createTitle: "Nueva regla",
    editTitle: "Editar regla",
    name: "Nombre",
    namePlaceholder: "Ej: Fallecidos con sucesores",
    description: "Notas",
    descriptionPlaceholder: "Para qu\xE9 casos se usa esta regla\u2026",
    priority: "Prioridad",
    priorityHint: "Menor n\xFAmero, se eval\xFAa antes.",
    template: "Plantilla",
    templateHint: "Se usa siempre su versi\xF3n publicada.",
    enabled: "Habilitada",
    enabledHint: "Una regla deshabilitada no se eval\xFAa.",
    save: "Guardar regla",
    saved: "Regla guardada",
    removed: "Regla eliminada"
  },
  conditions: {
    title: "Condiciones",
    description: 'Se tienen que cumplir todas. Para un "o", us\xE1 "es alguno de" o escrib\xED otra regla. Solo datos del reclamo: lo del ofrecimiento se resuelve con condiciones por bloque en la plantilla.',
    add: "Agregar condici\xF3n",
    remove: "Quitar",
    attribute: "Atributo",
    operator: "Operador",
    value: "Valor",
    variableName: "Nombre de la variable",
    variableNamePlaceholder: "Ej: metodo de pago",
    listHint: "Separ\xE1 los valores con coma.",
    searchPlaceholder: "Buscar",
    empty: "Sin condiciones: la regla aplica a todo reclamo que llegue hasta ella."
  },
  recipients: {
    title: "Orden de firma",
    description: "La plantilla ya dice qu\xE9 recuadros hay y qu\xE9 parte firma cada uno. Ac\xE1 va s\xF3lo en qu\xE9 orden se firman.",
    add: "Agregar recuadro",
    signerKey: "Recuadro",
    index: "Orden",
    empty: "Sin filas: se usa el orden de la plantilla y todos firman."
  },
  remove: {
    title: '\xBFEliminar la regla "{{name}}"?',
    description: "Deja de evaluarse. Los planes que ya decidi\xF3 siguen apuntando a ella."
  },
  simulator: {
    title: "Simulador",
    description: "Sobre un reclamo real: qu\xE9 plantilla gana, c\xF3mo se firma, por qu\xE9 las otras reglas no y qu\xE9 falta. No escribe nada.",
    claimId: "ID del reclamo",
    offerId: "ID del ofrecimiento (opcional)",
    acceptance: "Aceptaci\xF3n",
    run: "Simular",
    outcome: "Resultado",
    trace: "Reglas evaluadas",
    recipients: "Firmantes",
    missing: "Faltantes",
    warnings: "Advertencias",
    noConditions: "Sin condiciones",
    actual: "Valor del reclamo",
    empty: "Ingres\xE1 un reclamo y simul\xE1 para ver la decisi\xF3n.",
    signature: "Firma",
    signatureTrace: "Reglas de firma evaluadas",
    withoutOffer: "Simular sin ofrecimiento (como antes del primer env\xEDo)",
    outOfScope: "Fuera de alcance",
    message: {
      title: "Mensaje del ofrecimiento",
      description: "Lo que ver\xEDa el tramitador en el wizard para este reclamo: el modo, la carta de la compa\xF1\xEDa con las condiciones tipeadas y qu\xE9 se le va a pedir al reclamante. No escribe nada.",
      amount: "Importe",
      installments: "Cuotas",
      feePercentage: "Honorarios (%)",
      paymentDays: "D\xEDas",
      payee: "Qui\xE9n cobra",
      payeeNone: "Sin elegir",
      run: "Previsualizar mensaje",
      mode: "Modo del wizard",
      letter: "Carta",
      noLetter: "La compa\xF1\xEDa no tiene carta publicada",
      acceptance: "Se le pedir\xE1",
      gaps: "Faltantes del mensaje",
      fingerprint: "Huella",
      empty: "Ingres\xE1 un reclamo arriba y previsualiz\xE1 para ver la carta.",
      optional: "opcional"
    }
  },
  enabledBadge: "Habilitada",
  disabledBadge: "Deshabilitada"
};
var agreementSignatureRules = {
  title: "Reglas de firma",
  description: "C\xF3mo se firma la conformidad una vez elegida la plantilla: digital o presencial. Se eval\xFAan en orden de prioridad entre las que alcanzan a la plantilla elegida y gana la primera que coincide.",
  empty: "Todav\xEDa no hay reglas de firma: ning\xFAn plan tiene m\xE9todo de firma hasta que exista al menos una.",
  add: "Nueva regla de firma",
  columns: {
    priority: "Orden prioridad",
    name: "Nombre",
    method: "M\xE9todo",
    scope: "Alcance",
    conditions: "Condiciones",
    health: "Estado",
    enabled: "Estado"
  },
  scopeAll: "Todas las plantillas",
  scopeCount: "{{count}} plantillas",
  form: {
    createTitle: "Nueva regla de firma",
    editTitle: "Editar regla de firma",
    name: "Nombre",
    namePlaceholder: "Ej: Monto alto, presencial",
    description: "Notas",
    descriptionPlaceholder: "Para qu\xE9 casos se usa esta regla\u2026",
    priority: "Prioridad",
    priorityHint: "Menor n\xFAmero, se eval\xFAa antes.",
    method: "M\xE9todo de firma",
    enabled: "Habilitada",
    enabledHint: "Una regla deshabilitada no se eval\xFAa.",
    scope: "Alcance",
    scopeAll: "Aplica a todas las plantillas de la compa\xF1\xEDa.",
    scopeTemplates: "Solo a estas plantillas:",
    scopeEmpty: "Eleg\xED al menos una plantilla.",
    conditionsHint: "Se tienen que cumplir todas. Puede mirar el reclamo, el ofrecimiento y la aceptaci\xF3n; lo que todav\xEDa no existe deja la regla pendiente, no falsa.",
    save: "Guardar regla",
    saved: "Regla de firma guardada",
    removed: "Regla de firma eliminada"
  },
  remove: {
    title: '\xBFEliminar la regla de firma "{{name}}"?',
    description: "Deja de evaluarse. Los planes que ya decidi\xF3 siguen apuntando a ella."
  }
};
var idCardScan = {
  offerTitle: "\xBFTen\xE9s el DNI a mano?",
  offerDescription: "Escanealo y completamos los datos por vos.",
  filledTitle: "Le\xEDmos el DNI",
  filledDescription: "Completamos {{count}} campos. Revisalos y correg\xED lo que haga falta.",
  title: "Escane\xE1 el DNI",
  starting: "Abriendo la c\xE1mara\u2026",
  scanning: "Buscando el c\xF3digo\u2026",
  searchingMrz: "Probando tambi\xE9n la banda del dorso\u2026",
  denied: "No pudimos usar la c\xE1mara. Revis\xE1 los permisos del navegador y volv\xE9 a intentar.",
  failed: "No pudimos leer el documento. Prob\xE1 de nuevo con mejor luz, o carg\xE1 una foto.",
  failedUpload: "No pudimos leer ese archivo. Prob\xE1 con una foto m\xE1s n\xEDtida, enfocada sobre el c\xF3digo y sin reflejos.",
  uploadPhoto: "Cargar una foto",
  useCamera: "Prefiero usar la c\xE1mara",
  cantScan: "No puedo escanearlo",
  cancel: "Cancelar",
  retry: "Escanear de nuevo",
  attachedNotice: "Adem\xE1s guardamos la foto como {{side}}.",
  discardedNotice: "No pudimos leer con seguridad {{fields}}: completalos a mano.",
  signal: {
    barcodeRead: "{{format}} le\xEDdo",
    barcodeUnknown: "{{format}} detectado, no es un DNI"
  },
  sideFront: "DNI (frente)",
  sideBack: "DNI (dorso)",
  field: {
    first_name: "Nombre",
    last_name: "Apellido",
    document_number: "Documento",
    sex: "G\xE9nero",
    birth_date: "Fecha de nacimiento",
    nationality: "Nacionalidad"
  },
  document: {
    dni: {
      trigger: "Escanear DNI",
      offerTitle: "\xBFTen\xE9s el DNI a mano?",
      hint: "Mostr\xE1 el frente, el lado del c\xF3digo de barras",
      title: "Escane\xE1 el DNI",
      uploadHint: "Sub\xED una foto del frente del DNI, del lado del c\xF3digo de barras."
    },
    licence: {
      trigger: "Escanear licencia",
      offerTitle: "\xBFTen\xE9s la licencia de conducir?",
      hint: "Sosten\xE9 la licencia en vertical, con el c\xF3digo de barras dentro del recuadro",
      title: "Escane\xE1 la licencia",
      uploadHint: "Sub\xED una foto del dorso de la licencia, donde est\xE1 el c\xF3digo de barras."
    },
    passport: {
      trigger: "Escanear pasaporte",
      offerTitle: "\xBFTen\xE9s el pasaporte?",
      hint: "Mostr\xE1 la p\xE1gina de datos, con las dos l\xEDneas de abajo dentro del recuadro",
      title: "Escane\xE1 el pasaporte",
      uploadHint: "Sub\xED una foto de la p\xE1gina de datos del pasaporte, con las dos l\xEDneas de abajo bien visibles."
    }
  }
};
var integrations = {
  kach_user: {
    connect: "Conectar cuenta",
    reconnect: "Reconectar",
    disconnect: "Desconectar cuenta",
    invalidated: "La conexi\xF3n dej\xF3 de ser v\xE1lida. Volv\xE9 a conectar tu cuenta."
  },
  autosign: {
    disconnect_disabled: "La cuenta de AutoSign no se puede desconectar: las conformidades de tus ofrecimientos se env\xEDan a firmar con ella. Si necesit\xE1s volver a autorizarla o cambiar de cuenta, us\xE1 \xABReconectar\xBB."
  },
  oauth: {
    connect: "Conectar cuenta",
    reconnect: "Reconectar",
    connected: {
      title: "Integraci\xF3n conectada",
      description: "Se estableci\xF3 correctamente la conexi\xF3n con {{name}}"
    }
  },
  agreementRules: {
    back: "Volver a Integraciones",
    title: "Reglas de conformidad",
    description: "Reglas que deciden qu\xE9 conformidad se genera y c\xF3mo se firma en AutoSign. Las configura el equipo de Piramid; ac\xE1 pod\xE9s consultarlas.",
    tabs: {
      generation: "Generaci\xF3n",
      signature: "Firma",
      templates: "Plantillas"
    },
    entityLabel: "Reglas",
    empty: "La compa\xF1\xEDa no tiene reglas configuradas.",
    error: "No se pudieron cargar las reglas.",
    retry: "Reintentar",
    columns: {
      priority: "Prioridad",
      name: "Nombre",
      template: "Plantilla",
      method: "M\xE9todo de firma",
      scope: "Alcance",
      conditions: "Condiciones",
      status: "Estado",
      createdAt: "Creada",
      publishedVersion: "Versi\xF3n publicada",
      publishedAt: "Publicada el",
      signers: "Recuadros de firma"
    },
    status: {
      enabled: "Habilitada",
      disabled: "Deshabilitada"
    },
    conditionsCount: "{{count}} condici\xF3n(es)",
    allCases: "Todos los casos",
    allTemplates: "Todas las plantillas",
    scopeUnavailable: "Plantillas que ya no existen",
    templatesEntityLabel: "Plantillas",
    emptyTemplates: "La compa\xF1\xEDa no tiene plantillas de conformidad publicadas.",
    templateDetail: {
      publishedVersion: "Versi\xF3n publicada v{{version}} \xB7 {{date}}",
      loadError: "No se pudo cargar la plantilla."
    },
    noPublishedVersion: "Sin versi\xF3n publicada",
    templateVersion: "{{name}} \xB7 v{{version}}",
    detail: {
      loadError: "No se pudo cargar el detalle de la regla.",
      general: "General",
      priority: "Prioridad",
      template: "Plantilla",
      method: "M\xE9todo de firma",
      scope: "Alcance",
      createdAt: "Creada",
      updatedAt: "Actualizada",
      conditions: "Condiciones",
      conditionsHint: "La regla aplica cuando se cumplen todas las condiciones.",
      noConditions: "Sin condiciones: aplica a todos los casos.",
      recipients: "Firmantes",
      recipientsHint: "Orden en que se env\xEDa la conformidad a firmar.",
      noRecipients: "Sin firmantes configurados.",
      unknownSigner: "Recuadro no encontrado en la versi\xF3n publicada"
    }
  }
};
var activity = {
  offer_agreement_created: {
    own: "Enviaste la conformidad a firmar por AutoSign",
    other: "envi\xF3 la conformidad a firmar por AutoSign"
  },
  offer_agreement_dispatch_failed: "notifica que no se pudo enviar la conformidad a firmar",
  offer_agreement_recipient_submitted: "notifica que {{name}} firm\xF3 la conformidad",
  claim_derivation_restore_status_updated: 'actualiz\xF3 el estado que se restaurar\xE1 al devolver la derivaci\xF3n: de "{{previous}}" a "{{status}}"',
  claim_sinister_changed: "movi\xF3 el reclamo {{ref_id}} al siniestro que agrupa los reclamos de la denuncia {{complaint}}",
  claim_delegated_by_owner: {
    self: "Delegaste este reclamo a {{responsible}}",
    other: "deleg\xF3 este reclamo a {{responsible}}"
  },
  offer_agreement_completed: "notifica que la conformidad fue firmada por todas las partes",
  offer_agreement_expired: "notifica que la conformidad expir\xF3 sin firmarse",
  offer_agreement_rejected: "notifica que la conformidad fue rechazada",
  offer_agreement_cancelled: {
    own: "Anulaste la conformidad",
    other: "anul\xF3 la conformidad",
    provider: "notifica que la conformidad fue cancelada en AutoSign"
  },
  offer_rejected_on_behalf: {
    own: "Registraste el rechazo del reclamante al ofrecimiento",
    other: "registr\xF3 el rechazo del reclamante al ofrecimiento",
    claimant: "registr\xF3 tu rechazo del"
  }
};
var _orders = "\xD3rdenes de trabajo";
var backofficeOrders = {
  title: "\xD3rdenes de trabajo",
  description: "\xD3rdenes de trabajo de todas las compa\xF1\xEDas",
  searchPlaceholder: "Buscar por N\xB0 de orden, descripci\xF3n o reclamo",
  searchTooltip: "Busca por n\xFAmero de orden, descripci\xF3n de la orden o n\xFAmero de reclamo",
  dateField: {
    label: "Aplicar sobre",
    created_at: "Fecha de derivaci\xF3n",
    accepted_at: "Fecha de aceptaci\xF3n",
    completed_at: "Fecha de finalizaci\xF3n"
  },
  export: {
    button: "Exportar",
    title: "Exportar \xF3rdenes de trabajo",
    description: "Los filtros de la tabla aplicar\xE1n tambi\xE9n al exportar las \xF3rdenes. S\xF3lo se exportan \xF3rdenes de reclamos.",
    recipient: "Enviar a",
    recipientPlaceholder: "nombre@revelaciondata.com.ar",
    recipientDomain: "S\xF3lo casillas @revelaciondata.com.ar",
    submit: "Exportar",
    successTitle: "Reporte enviado",
    successDescription: "Enviamos {{total}} \xF3rdenes a {{email}}. El link de descarga vence en 3 d\xEDas."
  }
};
var release_notes = {
  nav: "Novedades",
  brand: "PIRAMID",
  back: "Volver a Piramid",
  index: {
    empty: "Todav\xEDa no hay novedades para mostrar.",
    dateline: "Todo lo que cambia en Piramid",
    "no-match": "No hay novedades con ese filtro.",
    "show-all": "Ver todas",
    search: "Buscar una novedad",
    "new-unread": "Nueva, sin leer",
    unread: "Sin leer",
    latest: "\xDAltima novedad",
    open: "Ver la novedad",
    reopen: "Volver a verla",
    "read-on": "Le\xEDda el {{date}}",
    "in-this-note": "En esta novedad",
    filter: {
      label: "Filtrar novedades",
      all: "Todas",
      unread: "Sin leer",
      mine: "Para m\xED"
    },
    "sent-to": "Enviada a"
  },
  viewers: {
    one: "1 persona la vio",
    many: "{{count}} personas la vieron",
    title: "Vieron esta novedad",
    aria: "Vieron esta novedad: {{count}} personas",
    more: "y {{count}} personas m\xE1s",
    "more-one": "y 1 persona m\xE1s",
    you: "Vos",
    "your-user": "Tu usuario",
    "just-now": "hace un momento",
    today: "hoy {{time}}"
  },
  sidebar: {
    new: "Novedad",
    open: "Ver la novedad",
    dismiss: "Ocultar",
    unread: "{{count}} sin leer"
  },
  kind: {
    feature: "Funcionalidad nueva",
    improvement: "Mejora",
    fix: "Correcci\xF3n"
  },
  published: "Publicada el {{date}}",
  article: {
    contents: "En esta nota",
    overview: "Antes y ahora",
    item: "Novedad {{number}}",
    toc: "Contenido",
    all: "Todas las novedades",
    "read-on": "La le\xEDste el {{date}}",
    progress: "Progreso de lectura",
    byline: "Por el equipo de producto de Piramid",
    "reading-time": {
      one: "1 minuto de lectura",
      many: "{{count}} minutos de lectura"
    },
    "must-know": "Lo que hay que saber",
    "try-it": "Ya est\xE1 disponible en Piramid",
    more: "M\xE1s en Novedades"
  },
  demo: {
    badge: "Demo interactiva",
    sandbox: "Datos de ejemplo: nada de lo que hagas ac\xE1 afecta a tu equipo.",
    "sample-data": "Datos de ejemplo",
    restart: "Reiniciar demo",
    credit: "Demo con datos de ejemplo",
    team: "Siniestros",
    "toast-description": "Es una demo: no cambi\xF3 nada en tu equipo.",
    member: {
      description: "En Gesti\xF3n de equipo, ac\xE1 ves sus reclamos y pod\xE9s reasignarlos, retornarlos o recuperarlos.",
      open: "Abiertos",
      aging: "Aging prom.",
      critical: "Cr\xEDticos",
      "received-delegated": "Delegados recibidos",
      "received-derived": "Derivados recibidos",
      "schedule-hint": "En la versi\xF3n real, ac\xE1 program\xE1s la licencia: desde, hasta, motivo y c\xF3mo delegar sus reclamos."
    },
    "preview-only": "La demo interactiva se ve en la app del insurer.",
    names: {
      team_members_table: "Tabla de miembros del equipo"
    }
  },
  cover: {
    member: "Tramitador"
  },
  feedback: {
    title: "\xBFTe result\xF3 \xFAtil esta nota?",
    subtitle: "Tu respuesta nos ayuda a mejorar las pr\xF3ximas novedades.",
    yes: "S\xED, me sirvi\xF3",
    no: "No mucho",
    thanks: "\xA1Gracias! Nos ayuda a escribir mejor las pr\xF3ximas."
  },
  cta: {
    "team-management": "Ir a Gesti\xF3n de equipo"
  },
  decision: {
    yes: "S\xED",
    no: "No"
  },
  error: {
    title: "No pudimos cargar las novedades",
    retry: "Reintentar"
  },
  peek: {
    read: "Leer la novedad",
    all: "Ver todas las novedades",
    "more-unread": "Y {{count}} m\xE1s sin leer.",
    empty: "Todav\xEDa no hay novedades."
  },
  crumbs: {
    label: "Ubicaci\xF3n",
    home: "Portada"
  }
};
var openai_decision = {
  email_name_match: {
    tooltip: "Coincidencia estimada entre nombre y correo: {{percentage}}%. No bloquea el env\xEDo.",
    tiers: {
      strong: "Alta coincidencia",
      partial: "Coincidencia posible",
      weak: "Recomendamos revisar"
    }
  }
};
var es_default = {
  claim_status_locked_by_derivation,
  autoinspectorInspections,
  documentAnalysis,
  providerInvitations,
  backofficeCustomerOrganizations,
  backofficeReleaseNotes,
  backofficeProviders,
  customer_signin_as,
  customer_organization_invitation,
  provider_registration,
  engagements,
  branches,
  network,
  use_cases,
  field_mapping_config,
  message_template,
  stats,
  chart,
  distribution,
  "trigger-mappings": trigger_mappings,
  sla,
  "working-days": working_days,
  "payment-method": payment_method,
  "estimates-definition": estimates_definition,
  person,
  entrypoint,
  demoempleo,
  gamma,
  "target-group": target_group,
  actions,
  operators,
  delta,
  offer,
  orders,
  variable,
  "inhouse-lawyer": inhouse_lawyer,
  load_balance_rule,
  document,
  circulation,
  license,
  contract,
  cost,
  bid,
  rfp,
  contact,
  filters,
  filtersPanel,
  legal_person,
  user,
  zod,
  inspection,
  professions,
  "exported-report": exported_report,
  claims,
  notifications,
  fraud,
  breadcrumb,
  complaint,
  "validation-pattern": validation_pattern,
  frequency,
  claimants,
  claim,
  events,
  fileRequest,
  entities,
  validations,
  entrypoints,
  backends,
  file_types,
  sinister,
  errors,
  legalPersonType,
  "claim.properties.insurance.insurer": claim_properties_insurance_insurer,
  "claim.properties.insurance.policy_number": claim_properties_insurance_policy_number,
  "claim.properties.driver.ownership.owner": claim_properties_driver_ownership_owner,
  "claim.properties.vehicle.type.car": claim_properties_vehicle_type_car,
  "claim.properties.vehicle.category.with_license_plate": claim_properties_vehicle_category_with_license_plate,
  "claim.properties.driver.owner": claim_properties_driver_owner,
  "claim.properties.vehicle.document_type.title": claim_properties_vehicle_document_type_title,
  "claim.properties.insurance.coverage.third_full": claim_properties_insurance_coverage_third_full,
  "claim.victim_relationship.own": claim_victim_relationship_own,
  "claim.properties.damage.driver.last_name": claim_properties_damage_driver_last_name,
  "claim.properties.damage.driver.first_name": claim_properties_damage_driver_first_name,
  "claim.properties.damage.hasInsurance": claim_properties_damage_hasInsurance,
  "claim.properties.damage.type": claim_properties_damage_type,
  "claim.properties.vehicle.category": claim_properties_vehicle_category,
  "claim.properties.vehicle.type": claim_properties_vehicle_type,
  "claim.properties.vehicle.year": claim_properties_vehicle_year,
  "claim.properties.vehicle.license_plate": claim_properties_vehicle_license_plate,
  "claim.properties.vehicle.engine": claim_properties_vehicle_engine,
  "claim.properties.vehicle.chassis": claim_properties_vehicle_chassis,
  "claim.properties.vehicle.use": claim_properties_vehicle_use,
  "claim.properties.vehicle.model": claim_properties_vehicle_model,
  "claim.properties.vehicle.make": claim_properties_vehicle_make,
  "claim.properties.vehicle.version": claim_properties_vehicle_version,
  "claim.properties.vehicle.document_type": claim_properties_vehicle_document_type,
  "claim.properties.driver.ownership": claim_properties_driver_ownership,
  "claim.properties.insurance.coverage": claim_properties_insurance_coverage,
  "damages.material.vehicle": damages_material_vehicle,
  "damages.material.real_property": damages_material_real_property,
  materialDamage,
  parents,
  "claim.identification_type.label": claim_identification_type_label,
  "identification-type": identification_type,
  "local-insured-relationships": local_insured_relationships,
  "victim-injuries-roles": victim_injuries_roles,
  coverages,
  "driver-ownership": driver_ownership,
  real_property,
  vehicle,
  type,
  "claim.state.label": claim_state_label,
  "claim.city.label": claim_city_label,
  "claim.country.label": claim_country_label,
  "claim.identification.label": claim_identification_label,
  "claim.first_name.label": claim_first_name_label,
  "claim.last_name.label": claim_last_name_label,
  "claim.cuit.label": claim_cuit_label,
  "claim.address.label": claim_address_label,
  "claim.type.label": claim_type_label,
  "claim.social_reason.label": claim_social_reason_label,
  "claim.zip_code.label": claim_zip_code_label,
  "claim.victim_relationship.label": claim_victim_relationship_label,
  fractures,
  severities,
  injuries,
  claimant_victim_violation,
  claim_ownership_transfer,
  victim_relationship,
  sex,
  damages,
  "company-service": company_service,
  permissions,
  "company-enums.claim_status": company_enums_claim_status,
  "company-enums.claim_stage": company_enums_claim_stage,
  "company-enums.claim_reference": company_enums_claim_reference,
  "company-enums.claim_status_order_rule": company_enums_claim_status_order_rule,
  "company-enums.claim_type": company_enums_claim_type,
  "company-enums.complaint_status": company_enums_complaint_status,
  "company-enums.complaint_stage": company_enums_complaint_stage,
  "company-enums.complaint_reference": company_enums_complaint_reference,
  "company-enums.complaint_status_order_rule": company_enums_complaint_status_order_rule,
  "company-enums.ramos": company_enums_ramos,
  "company-enums.agencies": company_enums_agencies,
  "company-enums.complaint_public_status": company_enums_complaint_public_status,
  "company-enums.claim_public_status": company_enums_claim_public_status,
  "/claims": _claims,
  "/complaints": _complaints,
  "/companies": _companies,
  "/autoinspector-inspections": _autoinspector_inspections,
  "/fraud-investigations": _fraud_investigations,
  "/catalog": _catalog,
  "/document-types": _document_types,
  "/providers": _providers,
  "/customer-organizations": _customer_organizations,
  "/provider-invitations": _provider_invitations,
  "/geo": _geo,
  "/metrics": _metrics,
  "/metrics/performance": _metrics_performance,
  "/metrics/experimental": _metrics_experimental,
  "/reviews": _reviews,
  "/users": _users,
  "/integrations": _integrations,
  "/recordings": _recordings,
  "/release-notes": _release_notes,
  recordings,
  sidebar,
  fraud_investigations,
  geo,
  catalog,
  "style-config": style_config,
  "fraud-investigation-case": fraud_investigation_case,
  role,
  webhook,
  resources,
  occurrence,
  currencies,
  company,
  teams,
  metrics,
  "team-management": team_management,
  claims_table,
  review,
  reviews,
  home,
  onboarding,
  documents,
  documentTypes,
  products,
  providerGroups,
  test_environment,
  productImport,
  orderDocumentRequirements,
  offerAgreement,
  agreementVariables,
  agreementTemplates,
  orderClaimStatusMappings,
  claimCurrentOrder,
  customerClaims,
  customerAccountSettings,
  claimantPendingActions,
  claimOrderTracking,
  field_adjuster_registration,
  claimSharedDocuments,
  providerAccountSettings,
  provider_signin_as,
  agreementSettings,
  agreementRules,
  agreementSignatureRules,
  idCardScan,
  integrations,
  activity,
  "/orders": _orders,
  backofficeOrders,
  "release-notes": release_notes,
  openai_decision
};

// src/translate.ts
var translate = (key = "", data, fallback) => {
  const word = (0, import_lodash.default)(es_exports, key);
  if (!word) return fallback || "";
  const regex = /{{\s*([^{}]+)\s*}}/g;
  const final = String(word || key || "");
  return final.replace(
    regex,
    (_, match) => String((0, import_lodash.default)(data, match.trim()))
  ) || "" || key;
};

// src/useTranslations.ts
var useTranslations = (namespace, _fallback) => (key, data, fallback) => translate(
  namespace ? `${namespace}.${key}` : key,
  data,
  fallback || _fallback
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  translate,
  useTranslations
});
